(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
window.Backbone = require('backbone');

window.Backbone.$ = window.$;

require('../../modules/tracking/frontend/initializer');

require('../../modules/buy_button/frontend/buy_button');

require('../../modules/buy_button/frontend/multi_option_modal');

require('../../modules/cash_back/frontend/cash_back');

require('../../modules/deal/frontend/channel_tabs');

require('../../modules/deal/frontend/controller');

require('../../modules/deal/frontend/external_links');

require('../../modules/deal_types/frontend/deal_type');

require('../../modules/gift_button/frontend/gift');

require('../../modules/g_map/frontend/main');

require('../../modules/external_deal/frontend/external_deal');

require('../../modules/sharing/frontend/facebook');

require('../../modules/deal/frontend/deal_lazy_loader');

require('../../modules/header/frontend/main');

require('../../modules/variations/frontend/variations-widget');

require('../../modules/inline_variations/frontend/inline_variations');

require('../../modules/doubleclick/frontend/dfp_ads');

require('../../modules/deal_widget/frontend/deal_widgets');

require('../../modules/urgency_messaging/frontend/countdown_timer');

require('../../modules/urgency_messaging/frontend/urgency_messaging');

require('../../modules/ad_unit/frontend/ad_unit_lazy_loader');

require('groupon-iframe-login');

require('../../node_modules/widget-layout-assets/coffee/wls');

require('../../modules/groupon-deal-timer/common/helpers');

require('../../modules/groupon-deal-timer/frontend/models/countdown_timer');

require('../../modules/groupon-deal-timer/frontend/views/countdown_timer');

require('../../modules/groupon-deal-timer/frontend/countdown_timer');

require('hogan.js');

require('../../modules/groupon-deal-carousel/frontend/swfobject-2.2');

require('../../modules/groupon-deal-carousel/frontend/detect-flash');

require('../../modules/groupon-deal-carousel/frontend/templates/main');

require('../../modules/groupon-deal-carousel/frontend/helpers');

require('../../modules/groupon-deal-carousel/frontend/models/media');

require('../../modules/groupon-deal-carousel/frontend/views/carousel');

require('../../modules/groupon-deal-carousel/frontend/carousel');

$(window).load(function() {
  var ref, ref1;
  Groupon.Performance.pageReady();
  if ((ref = Groupon.DFPAds) != null) {
    if (typeof ref.load === "function") {
      ref.load();
    }
  }
  if ((ref1 = Groupon.DFPAds) != null) {
    if (typeof ref1.showAds === "function") {
      ref1.showAds();
    }
  }
  return typeof AdUnitLazyLoader !== "undefined" && AdUnitLazyLoader !== null ? AdUnitLazyLoader.load() : void 0;
});



},{"../../modules/ad_unit/frontend/ad_unit_lazy_loader":4,"../../modules/buy_button/frontend/buy_button":86,"../../modules/buy_button/frontend/multi_option_modal":87,"../../modules/cash_back/frontend/cash_back":90,"../../modules/deal/frontend/channel_tabs":91,"../../modules/deal/frontend/controller":92,"../../modules/deal/frontend/deal_lazy_loader":93,"../../modules/deal/frontend/external_links":95,"../../modules/deal_types/frontend/deal_type":98,"../../modules/deal_widget/frontend/deal_widgets":101,"../../modules/doubleclick/frontend/dfp_ads":103,"../../modules/external_deal/frontend/external_deal":104,"../../modules/g_map/frontend/main":106,"../../modules/gift_button/frontend/gift":109,"../../modules/groupon-deal-carousel/frontend/carousel":171,"../../modules/groupon-deal-carousel/frontend/detect-flash":172,"../../modules/groupon-deal-carousel/frontend/helpers":173,"../../modules/groupon-deal-carousel/frontend/models/media":174,"../../modules/groupon-deal-carousel/frontend/swfobject-2.2":175,"../../modules/groupon-deal-carousel/frontend/templates/main":176,"../../modules/groupon-deal-carousel/frontend/views/carousel":177,"../../modules/groupon-deal-timer/common/helpers":178,"../../modules/groupon-deal-timer/frontend/countdown_timer":179,"../../modules/groupon-deal-timer/frontend/models/countdown_timer":180,"../../modules/groupon-deal-timer/frontend/views/countdown_timer":181,"../../modules/header/frontend/main":183,"../../modules/inline_variations/frontend/inline_variations":186,"../../modules/sharing/frontend/facebook":204,"../../modules/tracking/frontend/initializer":206,"../../modules/urgency_messaging/frontend/countdown_timer":208,"../../modules/urgency_messaging/frontend/urgency_messaging":210,"../../modules/variations/frontend/variations-widget":215,"../../node_modules/widget-layout-assets/coffee/wls":253,"backbone":220,"groupon-iframe-login":224,"hogan.js":248}],2:[function(require,module,exports){
var BookingTemplates, base;

if (window.Backbone == null) {
  window.Backbone = require('backbone');
}

if ((base = window.Backbone).$ == null) {
  base.$ = window.$;
}

BookingTemplates = window.BookingTemplates != null ? window.BookingTemplates : window.BookingTemplates = {};

_.extend(BookingTemplates, {
  "booking_frontend_templates_book": require('../../modules/booking/frontend/templates/book.html.mustache'),
  "booking_frontend_templates_calendar": require('../../modules/booking/frontend/templates/calendar.html.mustache'),
  "booking_frontend_templates_datetimepicker": require('../../modules/booking/frontend/templates/datetimepicker.html.mustache'),
  "booking_frontend_templates_datepicker": require('../../modules/booking/frontend/templates/datepicker.html.mustache'),
  "booking_frontend_templates_deal_booker": require('../../modules/booking/frontend/templates/deal/booker.html.mustache'),
  "booking_frontend_templates_info": require('../../modules/booking/frontend/templates/info.html.mustache'),
  "booking_frontend_templates_option": require('../../modules/booking/frontend/templates/option.html.mustache'),
  "booking_frontend_templates_optionpicker": require('../../modules/booking/frontend/templates/optionpicker.html.mustache'),
  "booking_frontend_templates_partysize": require('../../modules/booking/frontend/templates/partysize.html.mustache'),
  "booking_frontend_templates_partysizepicker": require('../../modules/booking/frontend/templates/partysizepicker.html.mustache'),
  "booking_frontend_templates_partysizes": require('../../modules/booking/frontend/templates/partysizes.html.mustache'),
  "booking_frontend_templates_picker_notice": require('../../modules/booking/frontend/templates/picker_notice.html.mustache'),
  "booking_frontend_templates_phone": require('../../modules/booking/frontend/templates/phone.html.mustache'),
  "booking_frontend_templates_question": require('../../modules/booking/frontend/templates/question.html.mustache'),
  "booking_frontend_templates_time": require('../../modules/booking/frontend/templates/time.html.mustache'),
  "booking_frontend_templates_timebubble": require('../../modules/booking/frontend/templates/timebubble.html.mustache'),
  "booking_frontend_templates_timebubbles": require('../../modules/booking/frontend/templates/timebubbles.html.mustache'),
  "booking_frontend_templates_timepicker": require('../../modules/booking/frontend/templates/timepicker.html.mustache'),
  "booking_frontend_templates_times": require('../../modules/booking/frontend/templates/times.html.mustache'),
  "booking_frontend_templates_tooltip": require('../../modules/booking/frontend/templates/tooltip.html.mustache'),
  "booking_frontend_templates_text_notifications": require('../../modules/booking/frontend/templates/text_notifications.html.mustache'),
  "glive-booking_frontend_templates_deal_booker": require('../../modules/glive-booking/frontend/templates/deal/booker.html.mustache'),
  "glive-booking_frontend_templates_gliveinfo": require('../../modules/glive-booking/frontend/templates/gliveinfo.html.mustache'),
  "glive-booking_frontend_templates_book": require('../../modules/glive-booking/frontend/templates/book.html.mustache'),
  "glive-booking_frontend_templates_calendar": require('../../modules/glive-booking/frontend/templates/calendar.html.mustache'),
  "glive-booking_frontend_templates_datepicker": require('../../modules/glive-booking/frontend/templates/datepicker.html.mustache'),
  "glive-booking_frontend_templates_time": require('../../modules/glive-booking/frontend/templates/time.html.mustache'),
  "glive-booking_frontend_templates_timepicker": require('../../modules/glive-booking/frontend/templates/timepicker.html.mustache'),
  "glive-booking_frontend_templates_times": require('../../modules/glive-booking/frontend/templates/times.html.mustache'),
  "glive-booking_frontend_templates_quantity": require('../../modules/glive-booking/frontend/templates/quantity.html.mustache'),
  "glive-booking_frontend_templates_quantities": require('../../modules/glive-booking/frontend/templates/quantities.html.mustache'),
  "glive-booking_frontend_templates_quantitypicker": require('../../modules/glive-booking/frontend/templates/quantitypicker.html.mustache'),
  "glive-booking_frontend_templates_section": require('../../modules/glive-booking/frontend/templates/section.html.mustache'),
  "glive-booking_frontend_templates_sectionpicker": require('../../modules/glive-booking/frontend/templates/sectionpicker.html.mustache'),
  "glive-booking_frontend_templates_price": require('../../modules/glive-booking/frontend/templates/price.html.mustache'),
  "glive-booking_frontend_templates_pricepicker": require('../../modules/glive-booking/frontend/templates/pricepicker.html.mustache')
});

window.moment = require('../../node_modules/moment/moment.js');

window.CLNDR = require('../../node_modules/booking-components/node_modules/online-booking-clndr/src/clndr.js');

window.autosize = require('../../node_modules/booking-components/modules/booking/frontend/vendor/jquery.autosize.js');

require('../../node_modules/moment-timezone/moment-timezone.js');

window.Backbone.Obscura = require('../../node_modules/glive-booking-components/node_modules/backbone.obscura/backbone.obscura.js');

require('../../modules/booking/frontend/base');

require('../../modules/booking/frontend/helpers');

require('../../modules/booking/frontend/models/base');

require('../../modules/booking/frontend/collections/base');

require('../../modules/booking/frontend/models/attribute');

require('../../modules/booking/frontend/collections/attributes');

require('../../modules/booking/frontend/models/local_booking_settings');

require('../../modules/booking/frontend/models/option');

require('../../modules/booking/frontend/collections/options');

require('../../modules/booking/frontend/models/time');

require('../../modules/booking/frontend/collections/availability');

require('../../modules/booking/frontend/models/partysize');

require('../../modules/booking/frontend/collections/partysizes');

require('../../modules/booking/frontend/models/possible_segment');

require('../../modules/booking/frontend/collections/possible_segments');

require('../../modules/booking/frontend/models/reservation');

require('../../modules/booking/frontend/collections/reservations');

require('../../modules/booking/frontend/models/booker');

require('../../modules/booking/frontend/presenters/base');

require('../../modules/booking/frontend/presenters/booker');

require('../../modules/booking/frontend/presenters/info');

require('../../modules/booking/frontend/presenters/picker');

require('../../modules/booking/frontend/presenters/option');

require('../../modules/booking/frontend/presenters/optionpicker');

require('../../modules/booking/frontend/presenters/calendar');

require('../../modules/booking/frontend/presenters/timebubble');

require('../../modules/booking/frontend/presenters/timebubbles');

require('../../modules/booking/frontend/presenters/datetimepicker');

require('../../modules/booking/frontend/presenters/partysize');

require('../../modules/booking/frontend/presenters/partysizepicker');

require('../../modules/booking/frontend/presenters/picker_notice');

require('../../modules/booking/frontend/presenters/question');

require('../../modules/booking/frontend/presenters/phone');

require('../../modules/booking/frontend/presenters/text_notifications');

require('../../modules/booking/frontend/presenters/book');

require('../../modules/booking/frontend/views/base');

require('../../modules/booking/frontend/views/book');

require('../../modules/booking/frontend/views/collection');

require('../../modules/booking/frontend/views/tooltip');

require('../../modules/booking/frontend/views/drawers/info');

require('../../modules/booking/frontend/views/drawers/phone');

require('../../modules/booking/frontend/views/drawers/pickers');

require('../../modules/booking/frontend/views/drawers/question');

require('../../modules/booking/frontend/views/drawers/text_notifications');

require('../../modules/booking/frontend/views/pickers/picker/picker_collection');

require('../../modules/booking/frontend/views/pickers/picker/picker_element');

require('../../modules/booking/frontend/views/pickers/picker/picker_notice');

require('../../modules/booking/frontend/views/pickers/picker/picker');

require('../../modules/booking/frontend/views/pickers/datetime/calendar');

require('../../modules/booking/frontend/views/pickers/datetime/timebubble');

require('../../modules/booking/frontend/views/pickers/datetime/timebubbles');

require('../../modules/booking/frontend/views/pickers/datetime/datetimepicker');

require('../../modules/booking/frontend/views/pickers/option/option');

require('../../modules/booking/frontend/views/pickers/option/options');

require('../../modules/booking/frontend/views/pickers/option/optionpicker');

require('../../modules/booking/frontend/views/pickers/partysize/partysize');

require('../../modules/booking/frontend/views/pickers/partysize/partysizes');

require('../../modules/booking/frontend/views/pickers/partysize/partysizepicker');

require('../../modules/booking/frontend/views/booker');

require('../../modules/booking/frontend/initializers/deal/booker');

require('../../modules/deal/frontend/local_booking_wrapper');

require('../../modules/glive-booking/bc_bundle');

require('../../modules/glive-booking/frontend/base');

require('../../modules/glive-booking/frontend/models/time');

require('../../modules/glive-booking/frontend/collections/times');

require('../../modules/glive-booking/frontend/models/section');

require('../../modules/glive-booking/frontend/collections/sections');

require('../../modules/glive-booking/frontend/models/price');

require('../../modules/glive-booking/frontend/collections/prices');

require('../../modules/glive-booking/frontend/models/event');

require('../../modules/glive-booking/frontend/collections/events');

require('../../modules/glive-booking/frontend/filtered_collections/base');

require('../../modules/glive-booking/frontend/filtered_collections/events');

require('../../modules/glive-booking/frontend/models/booker');

require('../../modules/glive-booking/frontend/presenters/booker');

require('../../modules/glive-booking/frontend/presenters/info');

require('../../modules/glive-booking/frontend/views/info');

require('../../modules/glive-booking/frontend/views/picker');

require('../../modules/glive-booking/frontend/presenters/datepicker');

require('../../modules/glive-booking/frontend/presenters/calendar');

require('../../modules/glive-booking/frontend/views/calendar');

require('../../modules/glive-booking/frontend/views/datepicker');

require('../../modules/glive-booking/frontend/presenters/time');

require('../../modules/glive-booking/frontend/presenters/timepicker');

require('../../modules/glive-booking/frontend/views/time');

require('../../modules/glive-booking/frontend/views/times');

require('../../modules/glive-booking/frontend/views/timepicker');

require('../../modules/glive-booking/frontend/presenters/quantitypicker');

require('../../modules/glive-booking/frontend/presenters/quantity');

require('../../modules/glive-booking/frontend/views/quantity');

require('../../modules/glive-booking/frontend/views/quantities');

require('../../modules/glive-booking/frontend/views/quantitypicker');

require('../../modules/glive-booking/frontend/presenters/sectionpicker');

require('../../modules/glive-booking/frontend/presenters/section');

require('../../modules/glive-booking/frontend/views/section');

require('../../modules/glive-booking/frontend/views/sections');

require('../../modules/glive-booking/frontend/views/sectionpicker');

require('../../modules/glive-booking/frontend/presenters/pricepicker');

require('../../modules/glive-booking/frontend/presenters/price');

require('../../modules/glive-booking/frontend/views/price');

require('../../modules/glive-booking/frontend/views/prices');

require('../../modules/glive-booking/frontend/views/pricepicker');

require('../../modules/glive-booking/frontend/presenters/book');

require('../../modules/glive-booking/frontend/views/book');

require('../../modules/glive-booking/frontend/views/booker');

require('../../modules/glive-booking/frontend/initializers/deal/glive-booker');



},{"../../modules/booking/frontend/base":5,"../../modules/booking/frontend/collections/attributes":6,"../../modules/booking/frontend/collections/availability":7,"../../modules/booking/frontend/collections/base":8,"../../modules/booking/frontend/collections/options":9,"../../modules/booking/frontend/collections/partysizes":10,"../../modules/booking/frontend/collections/possible_segments":11,"../../modules/booking/frontend/collections/reservations":12,"../../modules/booking/frontend/helpers":13,"../../modules/booking/frontend/initializers/deal/booker":14,"../../modules/booking/frontend/models/attribute":15,"../../modules/booking/frontend/models/base":16,"../../modules/booking/frontend/models/booker":17,"../../modules/booking/frontend/models/local_booking_settings":18,"../../modules/booking/frontend/models/option":19,"../../modules/booking/frontend/models/partysize":20,"../../modules/booking/frontend/models/possible_segment":21,"../../modules/booking/frontend/models/reservation":22,"../../modules/booking/frontend/models/time":23,"../../modules/booking/frontend/presenters/base":24,"../../modules/booking/frontend/presenters/book":25,"../../modules/booking/frontend/presenters/booker":26,"../../modules/booking/frontend/presenters/calendar":27,"../../modules/booking/frontend/presenters/datetimepicker":28,"../../modules/booking/frontend/presenters/info":29,"../../modules/booking/frontend/presenters/option":30,"../../modules/booking/frontend/presenters/optionpicker":31,"../../modules/booking/frontend/presenters/partysize":32,"../../modules/booking/frontend/presenters/partysizepicker":33,"../../modules/booking/frontend/presenters/phone":34,"../../modules/booking/frontend/presenters/picker":35,"../../modules/booking/frontend/presenters/picker_notice":36,"../../modules/booking/frontend/presenters/question":37,"../../modules/booking/frontend/presenters/text_notifications":38,"../../modules/booking/frontend/presenters/timebubble":39,"../../modules/booking/frontend/presenters/timebubbles":40,"../../modules/booking/frontend/templates/book.html.mustache":41,"../../modules/booking/frontend/templates/calendar.html.mustache":42,"../../modules/booking/frontend/templates/datepicker.html.mustache":43,"../../modules/booking/frontend/templates/datetimepicker.html.mustache":44,"../../modules/booking/frontend/templates/deal/booker.html.mustache":45,"../../modules/booking/frontend/templates/info.html.mustache":46,"../../modules/booking/frontend/templates/option.html.mustache":47,"../../modules/booking/frontend/templates/optionpicker.html.mustache":48,"../../modules/booking/frontend/templates/partysize.html.mustache":49,"../../modules/booking/frontend/templates/partysizepicker.html.mustache":50,"../../modules/booking/frontend/templates/partysizes.html.mustache":51,"../../modules/booking/frontend/templates/phone.html.mustache":52,"../../modules/booking/frontend/templates/picker_notice.html.mustache":53,"../../modules/booking/frontend/templates/question.html.mustache":54,"../../modules/booking/frontend/templates/text_notifications.html.mustache":55,"../../modules/booking/frontend/templates/time.html.mustache":56,"../../modules/booking/frontend/templates/timebubble.html.mustache":57,"../../modules/booking/frontend/templates/timebubbles.html.mustache":58,"../../modules/booking/frontend/templates/timepicker.html.mustache":59,"../../modules/booking/frontend/templates/times.html.mustache":60,"../../modules/booking/frontend/templates/tooltip.html.mustache":61,"../../modules/booking/frontend/views/base":62,"../../modules/booking/frontend/views/book":63,"../../modules/booking/frontend/views/booker":64,"../../modules/booking/frontend/views/collection":65,"../../modules/booking/frontend/views/drawers/info":66,"../../modules/booking/frontend/views/drawers/phone":67,"../../modules/booking/frontend/views/drawers/pickers":68,"../../modules/booking/frontend/views/drawers/question":69,"../../modules/booking/frontend/views/drawers/text_notifications":70,"../../modules/booking/frontend/views/pickers/datetime/calendar":71,"../../modules/booking/frontend/views/pickers/datetime/datetimepicker":72,"../../modules/booking/frontend/views/pickers/datetime/timebubble":73,"../../modules/booking/frontend/views/pickers/datetime/timebubbles":74,"../../modules/booking/frontend/views/pickers/option/option":75,"../../modules/booking/frontend/views/pickers/option/optionpicker":76,"../../modules/booking/frontend/views/pickers/option/options":77,"../../modules/booking/frontend/views/pickers/partysize/partysize":78,"../../modules/booking/frontend/views/pickers/partysize/partysizepicker":79,"../../modules/booking/frontend/views/pickers/partysize/partysizes":80,"../../modules/booking/frontend/views/pickers/picker/picker":81,"../../modules/booking/frontend/views/pickers/picker/picker_collection":82,"../../modules/booking/frontend/views/pickers/picker/picker_element":83,"../../modules/booking/frontend/views/pickers/picker/picker_notice":84,"../../modules/booking/frontend/views/tooltip":85,"../../modules/deal/frontend/local_booking_wrapper":97,"../../modules/glive-booking/bc_bundle":110,"../../modules/glive-booking/frontend/base":111,"../../modules/glive-booking/frontend/collections/events":112,"../../modules/glive-booking/frontend/collections/prices":113,"../../modules/glive-booking/frontend/collections/sections":114,"../../modules/glive-booking/frontend/collections/times":115,"../../modules/glive-booking/frontend/filtered_collections/base":116,"../../modules/glive-booking/frontend/filtered_collections/events":117,"../../modules/glive-booking/frontend/initializers/deal/glive-booker":118,"../../modules/glive-booking/frontend/models/booker":119,"../../modules/glive-booking/frontend/models/event":120,"../../modules/glive-booking/frontend/models/price":121,"../../modules/glive-booking/frontend/models/section":122,"../../modules/glive-booking/frontend/models/time":123,"../../modules/glive-booking/frontend/presenters/book":124,"../../modules/glive-booking/frontend/presenters/booker":125,"../../modules/glive-booking/frontend/presenters/calendar":126,"../../modules/glive-booking/frontend/presenters/datepicker":127,"../../modules/glive-booking/frontend/presenters/info":128,"../../modules/glive-booking/frontend/presenters/price":129,"../../modules/glive-booking/frontend/presenters/pricepicker":130,"../../modules/glive-booking/frontend/presenters/quantity":131,"../../modules/glive-booking/frontend/presenters/quantitypicker":132,"../../modules/glive-booking/frontend/presenters/section":133,"../../modules/glive-booking/frontend/presenters/sectionpicker":134,"../../modules/glive-booking/frontend/presenters/time":135,"../../modules/glive-booking/frontend/presenters/timepicker":136,"../../modules/glive-booking/frontend/templates/book.html.mustache":137,"../../modules/glive-booking/frontend/templates/calendar.html.mustache":138,"../../modules/glive-booking/frontend/templates/datepicker.html.mustache":139,"../../modules/glive-booking/frontend/templates/deal/booker.html.mustache":140,"../../modules/glive-booking/frontend/templates/gliveinfo.html.mustache":141,"../../modules/glive-booking/frontend/templates/price.html.mustache":142,"../../modules/glive-booking/frontend/templates/pricepicker.html.mustache":143,"../../modules/glive-booking/frontend/templates/quantities.html.mustache":144,"../../modules/glive-booking/frontend/templates/quantity.html.mustache":145,"../../modules/glive-booking/frontend/templates/quantitypicker.html.mustache":146,"../../modules/glive-booking/frontend/templates/section.html.mustache":147,"../../modules/glive-booking/frontend/templates/sectionpicker.html.mustache":148,"../../modules/glive-booking/frontend/templates/time.html.mustache":149,"../../modules/glive-booking/frontend/templates/timepicker.html.mustache":150,"../../modules/glive-booking/frontend/templates/times.html.mustache":151,"../../modules/glive-booking/frontend/views/book":152,"../../modules/glive-booking/frontend/views/booker":153,"../../modules/glive-booking/frontend/views/calendar":154,"../../modules/glive-booking/frontend/views/datepicker":155,"../../modules/glive-booking/frontend/views/info":156,"../../modules/glive-booking/frontend/views/picker":157,"../../modules/glive-booking/frontend/views/price":158,"../../modules/glive-booking/frontend/views/pricepicker":159,"../../modules/glive-booking/frontend/views/prices":160,"../../modules/glive-booking/frontend/views/quantities":161,"../../modules/glive-booking/frontend/views/quantity":162,"../../modules/glive-booking/frontend/views/quantitypicker":163,"../../modules/glive-booking/frontend/views/section":164,"../../modules/glive-booking/frontend/views/sectionpicker":165,"../../modules/glive-booking/frontend/views/sections":166,"../../modules/glive-booking/frontend/views/time":167,"../../modules/glive-booking/frontend/views/timepicker":168,"../../modules/glive-booking/frontend/views/times":169,"../../node_modules/booking-components/modules/booking/frontend/vendor/jquery.autosize.js":221,"../../node_modules/booking-components/node_modules/online-booking-clndr/src/clndr.js":222,"../../node_modules/glive-booking-components/node_modules/backbone.obscura/backbone.obscura.js":223,"../../node_modules/moment-timezone/moment-timezone.js":251,"../../node_modules/moment/moment.js":252,"backbone":220}],3:[function(require,module,exports){
require('./base');

require('../../modules/merchant/frontend/subtitle_tooltip');

require('../../modules/tips/frontend/tips_controller');

require('../../modules/offers/frontend/offers_timer');

require('../../modules/goods_v2/frontend/read_more');

require('../../modules/wishlist_button/frontend/wishlist');

require('../../node_modules/grpn-tip-widget/frontend/coffeescripts/tip_widget');

require('./booking');

require('../../modules/deal/frontend/glive_booking_wrapper');

require('../../modules/merchant/frontend/lazy_load');



},{"../../modules/deal/frontend/glive_booking_wrapper":96,"../../modules/goods_v2/frontend/read_more":170,"../../modules/merchant/frontend/lazy_load":192,"../../modules/merchant/frontend/subtitle_tooltip":193,"../../modules/offers/frontend/offers_timer":195,"../../modules/tips/frontend/tips_controller":205,"../../modules/wishlist_button/frontend/wishlist":219,"../../node_modules/grpn-tip-widget/frontend/coffeescripts/tip_widget":230,"./base":1,"./booking":2}],4:[function(require,module,exports){
var AdUnitLazyLoader;

AdUnitLazyLoader = window.AdUnitLazyLoader = {
  load: function() {
    return $('.ad-widget iframe').attr('src', function() {
      return $(this).attr('data-src');
    });
  }
};

module.exports = AdUnitLazyLoader;



},{}],5:[function(require,module,exports){
var base, base1, base2, base3, base4, base5;

if (window.Booking == null) {
  window.Booking = {};
}

if ((base = window.Booking).rootUrl == null) {
  base.rootUrl = "/booking";
}

if ((base1 = window.Booking).Collections == null) {
  base1.Collections = {};
}

if ((base2 = window.Booking).Helpers == null) {
  base2.Helpers = {};
}

if ((base3 = window.Booking).Models == null) {
  base3.Models = {};
}

if ((base4 = window.Booking).Presenters == null) {
  base4.Presenters = {};
}

if ((base5 = window.Booking).Views == null) {
  base5.Views = {};
}



},{}],6:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.Attributes = (function(superClass) {
  extend(Attributes, superClass);

  function Attributes() {
    return Attributes.__super__.constructor.apply(this, arguments);
  }

  Attributes.prototype.model = Booking.Models.Attribute;

  Attributes.prototype.getPhone = function() {
    return this.find(function(attribute) {
      return attribute.isPhone();
    });
  };

  Attributes.prototype.getTextNotifications = function() {
    return this.find(function(attribute) {
      return attribute.isTextNotifications();
    });
  };

  Attributes.prototype.getPartySize = function() {
    return this.find(function(attribute) {
      return attribute.isPartySize();
    });
  };

  Attributes.prototype.getQuestions = function() {
    return this.filter(function(attribute) {
      return attribute.isQuestion();
    });
  };

  Attributes.prototype.getAdditionalFields = function() {
    return this.filter(function(attribute) {
      return attribute.isPhone() || attribute.isQuestion();
    });
  };

  return Attributes;

})(Booking.Collections.Base);



},{}],7:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.Availability = (function(superClass) {
  extend(Availability, superClass);

  function Availability() {
    return Availability.__super__.constructor.apply(this, arguments);
  }

  Availability.prototype.model = Booking.Models.Time;

  Availability.prototype.url = function() {
    return Booking.rootUrl + "/availability";
  };

  Availability.prototype.parse = function(arg) {
    var segments;
    segments = arg.segments;
    this.meta('browserInMerchantTimezone', moment().utcOffset() === moment().tz(this.getTimezone()).utcOffset());
    return segments;
  };

  Availability.prototype.getTimesByDate = function(day) {
    var end, ref, start;
    ref = Booking.Helpers.getTimestampDayRange(day), start = ref.start, end = ref.end;
    return this.chain().filter(function(time) {
      var ref1;
      return (start <= (ref1 = time.start().unix()) && ref1 <= end);
    }).sortBy(function(model) {
      return model.start().unix();
    }).value();
  };

  Availability.prototype.hasTimesAtDate = function(day) {
    var end, ref, start, time;
    ref = Booking.Helpers.getTimestampDayRange(day), start = ref.start, end = ref.end;
    time = this.find(function(time) {
      var ref1;
      return (start <= (ref1 = time.start().unix()) && ref1 <= end);
    });
    return time != null;
  };

  Availability.prototype.hasTimesInMonth = function(month) {
    var end, hasTimes, ref, start;
    ref = Booking.Helpers.getTimestampMonthRange(moment(month).startOf('month')), start = ref.start, end = ref.end;
    hasTimes = this.some(function(time) {
      var ref1;
      return (start <= (ref1 = time.start().unix()) && ref1 <= end);
    });
    return hasTimes;
  };

  Availability.prototype.hasTime = function(timestamp) {
    var time;
    if (!_.isFinite(timestamp)) {
      throw new Error('Booking.Helpers.hasTime expects a timestamp');
    }
    time = this.find(function(time) {
      return time.start().unix() === timestamp;
    });
    return time != null;
  };

  Availability.prototype.getSelectedDates = function() {
    return this.chain().filter(function(time) {
      return time.isSelected();
    }).map(function(time) {
      return time.start().format('YYYY-MM-DD');
    }).uniq().value();
  };

  Availability.prototype.getSelectedTimes = function() {
    return this.filter(function(model) {
      return model.isSelected();
    });
  };

  Availability.prototype.getSelectedTimesByDate = function(day) {
    var end, ref, start;
    ref = Booking.Helpers.getTimestampDayRange(day), start = ref.start, end = ref.end;
    return this.chain().filter(function(time) {
      var ref1;
      return time.isSelected() && (start <= (ref1 = time.start().unix()) && ref1 <= end);
    }).sortBy(function(model) {
      return model.start().unix();
    }).value();
  };

  Availability.prototype.getNextDateWithAvailability = function() {
    var date, i, num;
    date = Booking.Helpers.getNowInTimezone(this.getTimezone());
    for (num = i = 1; i < 90; num = ++i) {
      if (this.hasTimesAtDate(date)) {
        return date;
      }
      date.add(1, 'days');
    }
    return null;
  };

  Availability.prototype.getNextDateWithAvailabilityAtTime = function(timeString) {
    var dateMoment, i, num, timestamp, today;
    today = Booking.Helpers.getNowInTimezone(this.getTimezone()).format('YYYY-MM-DD');
    dateMoment = Booking.Helpers.timezonedDatetime(today + "T" + timeString, this.getTimezone()).add(1, 'day');
    timestamp = dateMoment.unix();
    for (num = i = 1; i < 90; num = ++i) {
      if (this.hasTime(timestamp)) {
        return dateMoment;
      }
      dateMoment.add(1, 'days');
      timestamp = dateMoment.unix();
    }
    return null;
  };

  Availability.prototype.getNextDateWithAvailabilityAtTimeFromSpecificDate = function(date, timeString) {
    var dateMoment, i, num, timestamp;
    dateMoment = date.add(1, 'day');
    timestamp = dateMoment.unix();
    for (num = i = 1; i < 90; num = ++i) {
      if (this.hasTime(timestamp)) {
        return dateMoment;
      }
      dateMoment.add(1, 'days');
      timestamp = dateMoment.unix();
    }
    return null;
  };

  return Availability;

})(Booking.Collections.Base);



},{}],8:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Collection.apply(this, arguments);
    this._meta = {};
    this.on('request', this.loading);
    this.on('sync', this.loaded);
    this.on('error', this.loaded);
  }

  Base.prototype.meta = function(prop, value) {
    if (value !== void 0) {
      this._meta[prop] = value;
    }
    return this._meta[prop];
  };

  Base.prototype.loading = function() {
    return this.meta('loaded', false);
  };

  Base.prototype.loaded = function() {
    return this.meta('loaded', true);
  };

  Base.prototype.isLoading = function() {
    return this.meta('loaded') === false;
  };

  Base.prototype.isLoaded = function() {
    return this.meta('loaded') === true;
  };

  return Base;

})(Backbone.Collection);



},{}],9:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.Options = (function(superClass) {
  extend(Options, superClass);

  function Options() {
    return Options.__super__.constructor.apply(this, arguments);
  }

  Options.prototype.model = Booking.Models.Option;

  Options.prototype.comparator = function(model) {
    return model.getPrice();
  };

  Options.prototype.selectable = function() {
    return this.filter(function(option) {
      return option.isSoldOut() === false;
    });
  };

  Options.prototype.cheapest = function() {
    return this.sortBy(function(option) {
      return option.getPrice();
    })[0];
  };

  return Options;

})(Booking.Collections.Base);



},{}],10:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  function PartySizes() {
    return PartySizes.__super__.constructor.apply(this, arguments);
  }

  PartySizes.prototype.model = Booking.Models.PartySize;

  return PartySizes;

})(Booking.Collections.Base);



},{}],11:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.PossibleSegments = (function(superClass) {
  extend(PossibleSegments, superClass);

  function PossibleSegments() {
    return PossibleSegments.__super__.constructor.apply(this, arguments);
  }

  PossibleSegments.prototype.model = Booking.Models.PossibleSegment;

  return PossibleSegments;

})(Booking.Collections.Base);



},{}],12:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Collections.Reservations = (function(superClass) {
  extend(Reservations, superClass);

  function Reservations() {
    return Reservations.__super__.constructor.apply(this, arguments);
  }

  Reservations.prototype.model = Booking.Models.Reservation;

  Reservations.prototype.url = function() {
    return Booking.rootUrl + "/reservations";
  };

  return Reservations;

})(Booking.Collections.Base);



},{}],13:[function(require,module,exports){
Booking.Helpers = {
  timezonedDatetime: function(datetime, timezone) {
    return moment.tz(datetime, timezone);
  },
  objectInTimezone: function(obj, timezone) {
    if (moment.isMoment(obj)) {
      return moment(obj).tz(timezone);
    } else if (_.isFinite(obj)) {
      return moment.unix(obj).tz(timezone);
    } else {
      return Booking.Helpers.timezonedDatetime(obj, timezone);
    }
  },
  getNowInTimezone: function(timezone) {
    return moment().tz(timezone);
  },
  isDateInFuture: function(dateMoment, timezone) {
    return dateMoment.unix() > Booking.Helpers.getNowInTimezone(timezone).unix();
  },
  getNowToEndOfMonthRange: function(start) {
    var end;
    end = moment(start).endOf('month');
    return {
      start: start,
      end: end
    };
  },
  getNowtoNextMonthRange: function(start) {
    var end;
    end = moment(start).add(1, 'M').endOf('month');
    return {
      start: start,
      end: end
    };
  },
  getFullMonthRange: function(start, timezone) {
    var end, now;
    now = Booking.Helpers.getNowInTimezone(timezone);
    if (moment(start).isSame(now, 'months')) {
      start = now;
      end = moment(start).endOf('month');
      return {
        start: start,
        end: end
      };
    } else {
      start = moment(start).startOf('month');
      end = moment(start).endOf('month');
      return {
        start: start,
        end: end
      };
    }
  },
  getDayRange: function(day) {
    return {
      start: moment(day).startOf('day'),
      end: moment(day).endOf('day')
    };
  },
  getTimestampMonthRange: function(month) {
    var end, ref, start;
    ref = Booking.Helpers.getNowToEndOfMonthRange(month), start = ref.start, end = ref.end;
    start = start.unix();
    end = end.unix();
    return {
      start: start,
      end: end
    };
  },
  getTimestampDayRange: function(day) {
    var end, ref, start;
    ref = Booking.Helpers.getDayRange(day), start = ref.start, end = ref.end;
    start = start.unix();
    end = end.unix();
    return {
      start: start,
      end: end
    };
  },
  addTimezoneToMoment: function(timezoneData) {
    if (timezoneData != null) {
      return moment.tz.add(timezoneData);
    }
  }
};



},{}],14:[function(require,module,exports){
Booking.dealBookerInit = function(payload, done) {
  var deal, el, error, failed, isDTF, metasSettings, model, overlapWith, partialIntent, preset, showAdditionalAttributes, showDTF, textNotifications, timezoneData, view;
  if (done == null) {
    done = function() {};
  }
  if (!payload) {
    return done();
  }
  Booking.bhw = 'BookingEngineDealBooker';
  deal = payload.deal, timezoneData = payload.timezoneData, el = payload.el, failed = payload.failed, error = payload.error, overlapWith = payload.overlapWith, metasSettings = payload.metasSettings, preset = payload.preset, textNotifications = payload.textNotifications, showDTF = payload.showDTF, isDTF = payload.isDTF;
  moment.tz.add(timezoneData);
  if (preset != null) {
    partialIntent = preset.partialIntent;
  }
  showAdditionalAttributes = !showDTF;
  model = new Booking.Models.Booker({
    deal: deal,
    bookAndBuy: true,
    textNotifications: textNotifications,
    partialIntent: partialIntent,
    isDTF: isDTF,
    showAdditionalAttributes: showAdditionalAttributes
  });
  model.preset(preset);
  if (!model.get('options').selectable().length) {
    return done();
  }
  view = new Booking.Views.Booker({
    optionSelectable: true,
    el: el || '#deal-booker',
    overlapWith: overlapWith || '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card',
    model: model,
    templateName: 'deal_booker',
    metasSettings: metasSettings,
    showInfo: true
  });
  model.get('availability').on('error', function() {
    return failed != null ? failed.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('error', function() {
    return error != null ? error.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('sync', function(reservation) {
    var option;
    option = model.get('options').get(reservation.getOption().id);
    return view.trigger('buy', option, reservation);
  });
  model.on('buy', function(model) {
    var option;
    option = model.getSelectedOption();
    return view.trigger('buy', option);
  });
  view.on('buy', function(option, reservation) {
    var buyUrl, separator;
    buyUrl = option.get('buyUrl');
    separator = buyUrl.match(/\?/) ? '&' : '?';
    if (reservation) {
      buyUrl += separator + "booking_reservation_id=" + (reservation.get('id'));
      if (isDTF) {
        buyUrl += "&dtf=" + isDTF;
      }
    } else {
      buyUrl += separator + "book_later=true";
      if (isDTF) {
        buyUrl += "&dtf=" + isDTF;
      }
    }
    return window.location = buyUrl;
  });
  return $(function() {
    if (!$('#purchase-cluster .buy').length) {
      view.setOpenAndLocked();
    }
    view.render();
    return done();
  });
};



},{}],15:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.Attribute = (function(superClass) {
  extend(Attribute, superClass);

  function Attribute() {
    return Attribute.__super__.constructor.apply(this, arguments);
  }

  Attribute.prototype.getLabel = function() {
    return this.get('label');
  };

  Attribute.prototype.getName = function() {
    return this.get('name');
  };

  Attribute.prototype.getType = function() {
    return this.get('type');
  };

  Attribute.prototype.getValidation = function() {
    return this.get('validation') || false;
  };

  Attribute.prototype.isRequired = function() {
    return true;
  };

  Attribute.prototype.validate = function(value) {
    return value.match(this.getValidation()) != null;
  };

  Attribute.prototype.isPhone = function() {
    return this.getName() === 'phone_number';
  };

  Attribute.prototype.isTextNotifications = function() {
    return this.getName() === 'text_notifications';
  };

  Attribute.prototype.isPartySize = function() {
    return this.getName() === 'party_size';
  };

  Attribute.prototype.isQuestion = function() {
    return this.getType() === 'question';
  };

  Attribute.prototype.allowedValues = function() {
    var ref, ref1, values;
    values = (ref = this.getType().match(/^enumeration\((.*)\)$/)) != null ? (ref1 = ref[1]) != null ? ref1.split(';') : void 0 : void 0;
    if (this.isPartySize()) {
      return _.map(values, function(value) {
        return parseInt(value, 10);
      });
    } else {
      return values;
    }
  };

  return Attribute;

})(Booking.Models.Base);



},{}],16:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Model.apply(this, arguments);
    if (typeof this.error === 'function') {
      this.on('error', this.error, this);
    }
  }

  Base.prototype.sync = function(method, model, options) {
    var beforeSend;
    beforeSend = function(xhr) {
      if (Booking.csrf) {
        xhr.setRequestHeader('x-csrf-token', Booking.csrf);
      }
      if (Booking.authToken) {
        return xhr.setRequestHeader('x-auth-token', Booking.authToken);
      }
    };
    options = _.extend({}, options, {
      beforeSend: beforeSend
    });
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  };

  return Base;

})(Backbone.Model);



},{}],17:[function(require,module,exports){
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Booking.Models.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype._loading = {};

  Booker.prototype.initializeSubCollections = function() {
    var availability, options, partySizes, reservations;
    options = new Booking.Collections.Options;
    availability = new Booking.Collections.Availability;
    reservations = new Booking.Collections.Reservations;
    partySizes = new Booking.Collections.PartySizes;
    availability.getTimezone = (function(_this) {
      return function() {
        return _this.getTimezone();
      };
    })(this);
    this.listenTo(reservations, 'request', _.bind(this.booking, this));
    this.listenTo(reservations, 'sync', _.bind(this.booked, this));
    this.listenTo(reservations, 'error', _.bind(this.handleError, this));
    this.listenTo(availability, 'sync', _.bind(this.clearLoadings, this));
    this.listenTo(availability, 'request', _.bind(this.showDateTimeLoading, this));
    return this.set({
      options: options,
      availability: availability,
      reservations: reservations,
      partySizes: partySizes
    });
  };

  function Booker(arg) {
    var deal, optionId;
    deal = arg.deal, optionId = arg.optionId;
    this.buildPresetWithParams = bind(this.buildPresetWithParams, this);
    Booking.Models.Base.apply(this, arguments);
    Booking.Helpers.addTimezoneToMoment(this.get('timezoneData'));
    this.initializeSubCollections();
    this.on('change:selectedOption', this.selectedOptionChanged, this);
    this.resetOptions(deal.options);
  }

  Booker.prototype.checkAvailabilityWithNewOption = function(arg) {
    var date, datetime, end, presetWithParams, ref, ref1, ref2, start;
    date = arg.date, datetime = arg.datetime;
    if (datetime || date) {
      presetWithParams = this.buildPresetWithParams({
        datetime: datetime,
        date: date
      });
      this.getAvailability().once('sync', presetWithParams);
    }
    if (this.isBookerDeal()) {
      ref = Booking.Helpers.getDayRange(datetime || date), start = ref.start, end = ref.end;
    } else {
      if (datetime || date) {
        ref1 = Booking.Helpers.getFullMonthRange(datetime || date, this.getTimezone()), start = ref1.start, end = ref1.end;
      } else {
        ref2 = Booking.Helpers.getNowtoNextMonthRange(Booking.Helpers.getNowInTimezone(this.getTimezone())), start = ref2.start, end = ref2.end;
      }
    }
    return this.loadAvailability(start, end);
  };

  Booker.prototype.checkAvailabilityWithNewOptionAndPreset = function(arg) {
    var date, dateMoment, datetime, end, ref, ref1, ref2, start, time;
    date = arg.date, datetime = arg.datetime, time = arg.time;
    if (this.isBookerDeal()) {
      ref = Booking.Helpers.getDayRange(datetime || date), start = ref.start, end = ref.end;
    } else {
      if (datetime || date) {
        dateMoment = Booking.Helpers.objectInTimezone(datetime || date, this.getTimezone());
        ref1 = Booking.Helpers.getFullMonthRange(dateMoment, this.getTimezone()), start = ref1.start, end = ref1.end;
      } else if (time && !date) {
        ref2 = Booking.Helpers.getNowtoNextMonthRange(Booking.Helpers.getNowInTimezone(this.getTimezone())), start = ref2.start, end = ref2.end;
      }
    }
    return this.loadAvailability(start, end);
  };

  Booker.prototype.selectedOptionChanged = function(model, value, options) {
    if (!value) {
      return;
    }
    this.resetPartySize();
    if (!model.previous('selectedOption') && this.getPreset()) {
      return this.checkAvailabilityWithNewOptionAndPreset(this.getPreset());
    } else {
      return this.checkAvailabilityWithNewOption(this.getAvailabilityParameters());
    }
  };

  Booker.prototype.getAvailabilityParameters = function() {
    var date, datetime, times;
    times = this.getSelectedTimes();
    if (times.length > 0) {
      datetime = times[0].start();
    }
    date = this.getSelectedDate();
    return {
      date: date,
      datetime: datetime
    };
  };

  Booker.prototype.selectDate = function(selectedDate) {
    if (moment.isMoment(selectedDate)) {
      return this.setSelectedDate(selectedDate);
    }
  };

  Booker.prototype.findAndSelectTime = function(timestamp, events) {
    var timeFound;
    timeFound = _.find(events, function(time) {
      return time.start().unix() === timestamp;
    });
    if (timeFound != null) {
      return this.selectTimes([timeFound]);
    } else {
      return this.showNotice('time_not_available');
    }
  };

  Booker.prototype.loadAvailability = function(initialTime, finalTime) {
    var optionAvailability, selectedOption;
    selectedOption = this.getSelectedOption();
    if (!selectedOption) {
      return;
    }
    optionAvailability = selectedOption.getAvailability();
    if ((optionAvailability != null ? optionAvailability.length : void 0) && !this.isBookerDeal()) {
      this.getAvailability().set(optionAvailability);
      return this.getAvailability().trigger('sync');
    } else {
      return this.fetchAvailability(initialTime, finalTime);
    }
  };

  Booker.prototype.fetchAvailability = function(initialTime, finalTime, resetAndRemove, alwaysCallback) {
    var params;
    if (resetAndRemove == null) {
      resetAndRemove = true;
    }
    params = {
      reset: resetAndRemove,
      remove: resetAndRemove,
      data: {
        initialTime: initialTime.format(),
        finalTime: finalTime.format(),
        optionId: this.getSelectedOption().get('uuid')
      }
    };
    if (alwaysCallback != null) {
      params.always = alwaysCallback;
    }
    return this.getAvailability().fetch(params);
  };

  Booker.prototype.getNextDate = function(date, isDateTime) {
    var events, hasTime, nextDate, notice;
    notice = nextDate = events = void 0;
    events = this.getAvailability().getTimesByDate(date);
    hasTime = isDateTime ? this.getAvailability().hasTime(date.unix()) : true;
    if (Booking.Helpers.isDateInFuture(date, this.getTimezone()) && events.length > 0 && hasTime) {
      return {
        date: date,
        events: events,
        notice: notice
      };
    } else {
      if (isDateTime) {
        nextDate = this.getAvailability().getNextDateWithAvailabilityAtTimeFromSpecificDate(date, date.format('HH:mm'));
        if (nextDate) {
          events = this.getAvailability().getTimesByDate(nextDate);
        }
        notice = 'next_available_with_time';
      }
      if (nextDate == null) {
        nextDate = this.getAvailability().getNextDateWithAvailability();
        if (nextDate) {
          notice = 'next_available';
          events = this.getAvailability().getTimesByDate(nextDate);
        } else {
          notice = 'date_not_available';
          events = [];
        }
      }
      return {
        date: nextDate,
        events: events,
        notice: notice
      };
    }
  };

  Booker.prototype._selectDateTime = function(datetime) {
    var date, events, notice, ref;
    ref = this.getNextDate(Booking.Helpers.objectInTimezone(datetime, this.getTimezone()), true), date = ref.date, events = ref.events, notice = ref.notice;
    if (date) {
      this.selectDate(date);
      this.findAndSelectTime(date.unix(), events);
    } else {
      this.resetDateTime();
    }
    return this.showNotice(notice);
  };

  Booker.prototype._selectDate = function(dateString) {
    var date, events, notice, ref;
    ref = this.getNextDate(moment.tz(dateString, 'YYYY-MM-DD', this.getTimezone()), false), date = ref.date, events = ref.events, notice = ref.notice;
    if (date) {
      this.selectDate(date);
      this.resetTime();
    } else {
      this.resetDateTime();
    }
    return this.showNotice(notice);
  };

  Booker.prototype._selectTime = function(time) {
    var events, nextDateTime;
    nextDateTime = this.getAvailability().getNextDateWithAvailabilityAtTime(time);
    if (nextDateTime != null) {
      events = this.getAvailability().getTimesByDate(nextDateTime);
      this.selectDate(nextDateTime);
      this.findAndSelectTime(nextDateTime.unix(), events);
      return this.showNotice('next_available_with_time');
    } else {
      this.resetDateTime();
      return this.showNotice('time_not_available');
    }
  };

  Booker.prototype.buildPresetWithParams = function(arg) {
    var date, datetime, time;
    date = arg.date, time = arg.time, datetime = arg.datetime;
    return (function(_this) {
      return function() {
        if (datetime) {
          return _this._selectDateTime(datetime);
        }
        if (date && !time) {
          return _this._selectDate(date);
        }
        if (time && !date) {
          return _this._selectTime(time);
        }
        return _this.resetDateTime();
      };
    })(this);
  };

  Booker.prototype.presetDateTime = function(arg) {
    var date, datetime, option, presetWithParams, time;
    datetime = arg.datetime, date = arg.date, time = arg.time;
    presetWithParams = this.buildPresetWithParams({
      date: date,
      time: time,
      datetime: datetime
    });
    option = this.getSelectedOption();
    if (option != null ? option.getAvailability() : void 0) {
      return presetWithParams();
    } else {
      return this.getAvailability().once('sync', presetWithParams);
    }
  };

  Booker.prototype.selectTimes = function(times) {
    var i, len, time;
    if (times == null) {
      times = [];
    }
    this.clearLoading('selectedTimes');
    for (i = 0, len = times.length; i < len; i++) {
      time = times[i];
      time.select();
    }
    return this.setSelectedTimes(times);
  };

  Booker.prototype.isDealNotYetOpen = function() {
    var ref;
    return ((ref = this.getDeal()) != null ? ref.status : void 0) === 'not_yet';
  };

  Booker.prototype.isARSE = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.isARSE() : void 0;
  };

  Booker.prototype.isG3 = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.isG3() : void 0;
  };

  Booker.prototype.booked = function() {
    if (!this.getBookAndBuy()) {
      return this.notBooking();
    }
  };

  Booker.prototype.hasSelectedTime = function() {
    return this.getSelectedTimes().length > 0;
  };

  Booker.prototype.needQuestionsAnswers = function() {
    return this.requireQuestion() && !this.getQuestionsAnswer();
  };

  Booker.prototype.isReadyToBook = function() {
    var needPartySize, needPhoneNumber;
    if (this.isDealNotYetOpen()) {
      return false;
    }
    needPhoneNumber = this.requirePhone() && !this.getPhoneNumber();
    needPartySize = this.requirePartySize() && !this.getSelectedPartySize();
    return this.hasSelectedTime() && (this.getSelectedOption() != null) && !needPhoneNumber && !this.needQuestionsAnswers() && !needPartySize;
  };

  Booker.prototype.showNotice = function(notice) {
    if (notice != null) {
      return this.getAvailability().trigger('error', notice);
    }
  };

  Booker.prototype.handleError = function() {
    return this.notBooking();
  };

  Booker.prototype.clearError = function() {
    this.unset('error');
    return this;
  };

  Booker.prototype.resetReservations = function(reservations) {
    if (reservations == null) {
      reservations = [];
    }
    this.getReservations().reset(reservations);
    return this;
  };

  Booker.prototype.createReservation = function() {
    this.setReservation(new Booking.Models.Reservation);
    return this.getReservation();
  };

  Booker.prototype.setReservation = function(reservation) {
    this.resetReservations([reservation]);
    return this;
  };

  Booker.prototype.unsetReservation = function() {
    this.resetReservations();
    return this;
  };

  Booker.prototype.getMerchantPhoneNumber = function() {
    var ref, ref1;
    return (ref = this.getSelectedOption()) != null ? (ref1 = ref.getRedemptionLocation()) != null ? ref1.phoneNumber : void 0 : void 0;
  };

  Booker.prototype.getTimezone = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getLocalBookingSettings().getTimezone() : void 0;
  };

  Booker.prototype.getSettingsDefinitionVersion = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getLocalBookingSettings().getDefinitionVersion() : void 0;
  };

  Booker.prototype.getMinLeadTime = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getLocalBookingSettings().getMinLeadTime() : void 0;
  };

  Booker.prototype.getMaxLeadTime = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getLocalBookingSettings().getMaxLeadTime() : void 0;
  };

  Booker.prototype.getPartySizeSettings = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getPartySizeSettings() : void 0;
  };

  Booker.prototype.getPhoneSettings = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getPhoneSettings() : void 0;
  };

  Booker.prototype.getTextNotificationsSettings = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getTextNotificationsSettings() : void 0;
  };

  Booker.prototype.getQuestionsSettings = function() {
    var ref;
    return (ref = this.getSelectedOption()) != null ? ref.getQuestionsSettings() : void 0;
  };

  Booker.prototype.getQuestion = function() {
    var ref;
    return (ref = this.getFirstQuestionSettings()) != null ? ref.getLabel() : void 0;
  };

  Booker.prototype.requirePartySize = function() {
    var ref;
    return (ref = this.getPartySizeSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requirePhone = function() {
    var ref;
    return ((ref = this.getPhoneSettings()) != null ? ref.isRequired() : void 0) && this.getShowAdditionalAttributes();
  };

  Booker.prototype.requireTextNotifications = function() {
    var ref;
    return (ref = this.getTextNotificationsSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requireQuestion = function() {
    var ref;
    return ((ref = this.getFirstQuestionSettings()) != null ? ref.isRequired() : void 0) && this.getShowAdditionalAttributes();
  };

  Booker.prototype.resetOptions = function(options) {
    return this.getOptions().reset(options, {
      silent: true
    });
  };

  Booker.prototype.resetOption = function() {
    var defaultOption;
    defaultOption = this.hasMultipleOptions() ? null : this.getOptions().first();
    return this.setSelectedOption(defaultOption);
  };

  Booker.prototype.resetPartySize = function() {
    var currentSelection, partySizes;
    if (this.requirePartySize()) {
      currentSelection = this.getSelectedPartySize();
      partySizes = this.getPartySizeSettings().allowedValues();
      this.getPartySizes().reset(_.map(partySizes, function(partySize) {
        return {
          partySize: partySize
        };
      }));
      if (indexOf.call(partySizes, currentSelection) >= 0) {
        return this.setSelectedPartySize(currentSelection);
      } else {
        return this.setSelectedPartySize(null);
      }
    }
  };

  Booker.prototype.hasSelection = function() {
    return !!(this.getSelectedDate() || this.getSelectedTimes().length > 0);
  };

  Booker.prototype.clearLoadings = function() {
    this.clearLoading('selectedTimes');
    this.clearLoading('selectedDate');
    return this.trigger('loadingEvent');
  };

  Booker.prototype.resetDateTime = function() {
    this.resetDate();
    return this.resetTime();
  };

  Booker.prototype.resetDate = function() {
    this.setSelectedDate(void 0);
    return this;
  };

  Booker.prototype.resetTime = function() {
    this.selectTimes([]);
    return this;
  };

  Booker.prototype.getReservation = function() {
    return this.getReservations().first();
  };

  Booker.prototype.getFirstQuestionSettings = function() {
    var ref;
    return (ref = this.getQuestionsSettings()) != null ? ref[0] : void 0;
  };

  Booker.prototype.presetOption = function(optionId) {
    var option;
    option = this.getOptions().get(optionId);
    if (option) {
      return this.setSelectedOption(option);
    } else {
      return this.resetOption();
    }
  };

  Booker.prototype.preset = function(arg) {
    var date, datetime, optionId, partySize, phoneNumber, questionsAnswer, textNotifications, time;
    optionId = arg.optionId, datetime = arg.datetime, date = arg.date, time = arg.time, partySize = arg.partySize, questionsAnswer = arg.questionsAnswer, phoneNumber = arg.phoneNumber, textNotifications = arg.textNotifications;
    if ((datetime != null) || (date != null) || (time != null)) {
      this.setPreset({
        datetime: datetime,
        date: date,
        time: time
      });
      this.presetDateTime({
        datetime: datetime,
        date: date,
        time: time
      });
    }
    this.presetOption(optionId);
    if (partySize != null) {
      this.setSelectedPartySize(partySize);
    }
    if (phoneNumber != null) {
      this.setPhoneNumber(phoneNumber);
    }
    this.trigger('phoneNumber:preset');
    if (questionsAnswer != null) {
      this.setQuestionsAnswer(questionsAnswer);
    }
    if (questionsAnswer != null) {
      this.trigger('questionsAnswer:preset');
    }
    if (textNotifications != null) {
      return this.setTextNotifications(textNotifications);
    }
  };

  Booker.prototype.isReadyToBuy = function() {
    return this.getSelectedOption() != null;
  };

  Booker.prototype.isBookerDeal = function() {
    var ref;
    return _.some((ref = this.getDeal()) != null ? ref.options : void 0, this.isBookerOption);
  };

  Booker.prototype.isBookerOption = function(option) {
    var ref, ref1;
    return ((ref = option.localBookingSettings) != null ? (ref1 = ref.flags) != null ? ref1.third_party_name : void 0 : void 0) === Booking.Models.Booker.BOOKER_THIRD_PARTY_NAME;
  };

  Booker.prototype.isMultiWindow = function() {
    var ref;
    return _.some((ref = this.getDeal()) != null ? ref.options : void 0, this.isMultiWindowOption);
  };

  Booker.prototype.isMultiWindowOption = function(option) {
    var ref, ref1;
    return ref = Booking.Models.Booker.MULTIWINDOW_FLAG, indexOf.call(((ref1 = option.schedulerOptions) != null ? ref1.enabledFeatures : void 0) || [], ref) >= 0;
  };

  Booker.prototype.reset = function() {
    this.resetOption();
    return this.resetTime();
  };

  Booker.prototype.hasMultipleOptions = function() {
    return this.getOptions().length > 1;
  };

  Booker.prototype.booking = function() {
    return this.setIsBooking(true);
  };

  Booker.prototype.notBooking = function() {
    return this.setIsBooking(false);
  };

  Booker.prototype.isPartialIntent = function() {
    var partialIntent;
    partialIntent = this.getPartialIntent();
    if (partialIntent != null) {
      return partialIntent;
    } else {
      return true;
    }
  };

  Booker.prototype.showDateTimeLoading = function() {
    this.setLoading('selectedTimes');
    this.setLoading('selectedDate');
    return this.trigger('loadingEvent');
  };

  Booker.prototype.isDateTimeLoading = function() {
    return !!(this.getLoading('selectedDate') || this.getLoading('selectedTimes'));
  };

  Booker.prototype.getLoading = function(attribute) {
    return this._loading[attribute];
  };

  Booker.prototype.setLoading = function(attribute) {
    return this._loading[attribute] = true;
  };

  Booker.prototype.clearLoading = function(attribute) {
    return delete this._loading[attribute];
  };

  Booker.prototype.toggleTextNotifications = function() {
    return this.setTextNotifications(this.getTextNotifications() === 'true' ? 'false' : 'true');
  };

  Booker.prototype.isFoodAndDrink = function() {
    var ref;
    return (ref = this.getDeal()) != null ? ref.isFoodAndDrink : void 0;
  };

  Booker.prototype.isHBW = function() {
    var ref;
    return (ref = this.getDeal()) != null ? ref.isHBW : void 0;
  };

  Booker.prototype.setSelectedOption = function(selectedOption, options) {
    return this.set({
      selectedOption: selectedOption
    }, options);
  };

  Booker.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Booker.prototype.setIsBooking = function(isBooking) {
    return this.set({
      isBooking: isBooking
    });
  };

  Booker.prototype.setPartialIntent = function(partialIntent) {
    return this.set({
      partialIntent: partialIntent
    });
  };

  Booker.prototype.setPhoneNumber = function(phoneNumber) {
    return this.set({
      phoneNumber: phoneNumber
    });
  };

  Booker.prototype.setQuestionsAnswer = function(questionsAnswer) {
    return this.set({
      questionsAnswer: questionsAnswer
    });
  };

  Booker.prototype.setSelectedDate = function(selectedDate) {
    return this.set({
      selectedDate: selectedDate
    });
  };

  Booker.prototype.setSelectedPartySize = function(selectedPartySize) {
    return this.set({
      selectedPartySize: selectedPartySize != null ? parseInt(selectedPartySize, 10) : void 0
    });
  };

  Booker.prototype.setSelectedTimes = function(selectedTimes) {
    return this.set({
      selectedTimes: selectedTimes
    });
  };

  Booker.prototype.setShowAdditionalAttributes = function(showAdditionalAttributes) {
    return this.set({
      showAdditionalAttributes: showAdditionalAttributes
    });
  };

  Booker.prototype.setTextNotifications = function(textNotifications) {
    return this.set({
      textNotifications: textNotifications
    });
  };

  Booker.prototype.setPreset = function(preset) {
    return this.set({
      preset: preset
    });
  };

  Booker.prototype.getAvailability = function() {
    return this.get('availability');
  };

  Booker.prototype.getBookAndBuy = function() {
    return this.get('bookAndBuy');
  };

  Booker.prototype.getDeal = function() {
    return this.get('deal');
  };

  Booker.prototype.getError = function() {
    return this.get('error');
  };

  Booker.prototype.getGrouponId = function() {
    return this.get('grouponId');
  };

  Booker.prototype.getIsBooking = function() {
    return this.get('isBooking');
  };

  Booker.prototype.getIsDTF = function() {
    return this.get('isDTF');
  };

  Booker.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Booker.prototype.getOptions = function() {
    return this.get('options');
  };

  Booker.prototype.getOrderId = function() {
    return this.get('orderId');
  };

  Booker.prototype.getPartialIntent = function() {
    return this.get('partialIntent');
  };

  Booker.prototype.getPartySizes = function() {
    return this.get('partySizes');
  };

  Booker.prototype.getPhoneNumber = function() {
    return this.get('phoneNumber');
  };

  Booker.prototype.getQuestionsAnswer = function() {
    return this.get('questionsAnswer');
  };

  Booker.prototype.getReschedule = function() {
    return this.get('reschedule');
  };

  Booker.prototype.getReservations = function() {
    return this.get('reservations');
  };

  Booker.prototype.getSelectedDate = function() {
    return this.get('selectedDate');
  };

  Booker.prototype.getSelectedOption = function() {
    return this.get('selectedOption');
  };

  Booker.prototype.getSelectedPartySize = function() {
    return this.get('selectedPartySize');
  };

  Booker.prototype.getSelectedTimes = function() {
    return this.get('selectedTimes') || [];
  };

  Booker.prototype.getShowAdditionalAttributes = function() {
    return this.get('showAdditionalAttributes');
  };

  Booker.prototype.getTextNotifications = function() {
    return this.get('textNotifications');
  };

  Booker.prototype.getUserId = function() {
    return this.get('userId');
  };

  Booker.prototype.getPreset = function() {
    return this.get('preset');
  };

  Booker.prototype.book = function() {
    var possibleSegments, possibleSegmentsCollection, reservation, reservationData, selectedOption;
    if (this.isReadyToBook()) {
      this.booking();
      reservation = this.getReservation() || this.createReservation();
      selectedOption = this.getSelectedOption();
      possibleSegments = _.map(this.getSelectedTimes(), Booking.Models.PossibleSegment.prototype.createFromTimeModel);
      possibleSegmentsCollection = new Booking.Collections.PossibleSegments(possibleSegments);
      possibleSegmentsCollection.getTimezone = (function(_this) {
        return function() {
          return _this.getTimezone();
        };
      })(this);
      reservationData = {
        possibleSegments: possibleSegmentsCollection,
        dealId: this.getDeal().id,
        optionId: selectedOption.id,
        orderId: this.getOrderId(),
        userId: this.getUserId(),
        definitionVersion: this.getSettingsDefinitionVersion()
      };
      if (this.requirePartySize()) {
        reservationData[this.getPartySizeSettings().getName()] = this.getSelectedPartySize();
      }
      if (this.requirePhone()) {
        reservationData[this.getPhoneSettings().getName()] = this.getPhoneNumber();
      }
      if (this.requireTextNotifications()) {
        reservationData[this.getTextNotificationsSettings().getName()] = this.getTextNotifications();
      }
      if (this.requireQuestion()) {
        reservationData[this.getFirstQuestionSettings().getName()] = this.getQuestionsAnswer();
      }
      reservation.set(reservationData);
      if (!reservationData.orderId) {
        reservation.unset('id');
      }
      return reservation.save();
    } else {
      return this.trigger('buy', this);
    }
  };

  return Booker;

})(Booking.Models.Base);

Booking.Models.Booker.BOOKER_THIRD_PARTY_NAME = 'booker';

Booking.Models.Booker.MULTIWINDOW_FLAG = 'multiWindow';



},{}],18:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.LocalBookingSettings = (function(superClass) {
  extend(LocalBookingSettings, superClass);

  function LocalBookingSettings(attributes, options) {
    options = _.extend({}, options, {
      parse: true
    });
    Booking.Models.Base.call(this, attributes, options);
  }

  LocalBookingSettings.prototype.parse = function(raw) {
    if ((raw != null ? raw.additional_attributes : void 0) && !(raw.additional_attributes instanceof Booking.Collections.Attributes)) {
      raw.additional_attributes = new Booking.Collections.Attributes(raw.additional_attributes);
    }
    if (raw != null ? raw.duration : void 0) {
      raw.duration = parseInt(raw.duration, 10);
    }
    return raw;
  };

  LocalBookingSettings.prototype.getDefinitionVersion = function() {
    return this.get('definition_version');
  };

  LocalBookingSettings.prototype.getDuration = function() {
    return this.get('duration');
  };

  LocalBookingSettings.prototype.getTimezone = function() {
    return this.get('time_zone');
  };

  LocalBookingSettings.prototype.getAdditionalAttributes = function() {
    return this.get('additional_attributes');
  };

  LocalBookingSettings.prototype.getAvailability = function() {
    return this.get('availability');
  };

  LocalBookingSettings.prototype.getMinLeadTime = function() {
    return this.get('min_lead_time');
  };

  LocalBookingSettings.prototype.getMaxLeadTime = function() {
    return this.get('max_lead_time');
  };

  return LocalBookingSettings;

})(Booking.Models.Base);



},{}],19:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Booking.Models.Option = (function(superClass) {
  extend(Option, superClass);

  Option.prototype.idAttribute = 'uuid';

  function Option(attributes, options) {
    options = _.extend({}, options, {
      parse: true
    });
    Booking.Models.Base.call(this, attributes, options);
  }

  Option.prototype.parse = function(raw) {
    if (raw != null ? raw.localBookingSettings : void 0) {
      return _.extend({}, raw, {
        localBookingSettings: new Booking.Models.LocalBookingSettings(raw.localBookingSettings)
      });
    } else {
      return raw;
    }
  };

  Option.prototype.getTitle = function() {
    return this.get('title');
  };

  Option.prototype.getShowDiscount = function() {
    return this.get('showDiscount');
  };

  Option.prototype.getShowQuantity = function() {
    return this.get('showQuantity');
  };

  Option.prototype.getRedemptionLocation = function() {
    return this.get('redemptionLocations')[0];
  };

  Option.prototype.getLocationName = function() {
    var ref;
    return (ref = this.getRedemptionLocation()) != null ? ref.name : void 0;
  };

  Option.prototype.getPrice = function() {
    var ref;
    return (ref = this.get('price')) != null ? ref.amount : void 0;
  };

  Option.prototype.getFormattedPrice = function() {
    return this.get('price').formattedAmount;
  };

  Option.prototype.getFormattedValue = function() {
    return this.get('value').formattedAmount;
  };

  Option.prototype.isSoldOut = function() {
    return this.get('isSoldOut');
  };

  Option.prototype.getDiscount = function() {
    return this.get('discount');
  };

  Option.prototype.getLocalBookingSettings = function() {
    return this.get('localBookingSettings');
  };

  Option.prototype.getSchedulerOptions = function() {
    return this.get('schedulerOptions');
  };

  Option.prototype.getPricingMetadata = function() {
    return this.get('pricingMetadata');
  };

  Option.prototype.getSoldQuantity = function() {
    return this.get('soldQuantity');
  };

  Option.prototype.getSoldQuantityMessage = function() {
    return this.get('soldQuantityMessage');
  };

  Option.prototype.getEnabledFeatures = function() {
    var ref;
    return ((ref = this.getSchedulerOptions()) != null ? ref.enabledFeatures : void 0) || [];
  };

  Option.prototype.reservesAvailability = function() {
    var ref;
    return ref = Booking.Models.Option.RESERVED_AVAILABILITY, indexOf.call(this.getEnabledFeatures(), ref) >= 0;
  };

  Option.prototype.getProviderName = function() {
    var ref;
    return (ref = this.getSchedulerOptions()) != null ? ref.bookingProviderName : void 0;
  };

  Option.prototype.getAvailability = function() {
    return this.getLocalBookingSettings().getAvailability();
  };

  Option.prototype.getAdditionalAttributes = function() {
    return this.getLocalBookingSettings().getAdditionalAttributes();
  };

  Option.prototype.isG3 = function() {
    return this.reservesAvailability() === true;
  };

  Option.prototype.isARSE = function() {
    return !this.reservesAvailability() && !this.getProviderName();
  };

  Option.prototype.getPartySizeSettings = function() {
    return this.getAdditionalAttributes().getPartySize();
  };

  Option.prototype.getPhoneSettings = function() {
    return this.getAdditionalAttributes().getPhone();
  };

  Option.prototype.getTextNotificationsSettings = function() {
    return this.getAdditionalAttributes().getTextNotifications();
  };

  Option.prototype.getQuestionsSettings = function() {
    return this.getAdditionalAttributes().getQuestions();
  };

  return Option;

})(Booking.Models.Base);

Booking.Models.Option.RESERVED_AVAILABILITY = 'reservedAvailability';



},{}],20:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.getPartySize = function() {
    return this.get('partySize');
  };

  return PartySize;

})(Booking.Models.Base);



},{}],21:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.PossibleSegment = (function(superClass) {
  extend(PossibleSegment, superClass);

  PossibleSegment.prototype.idAttribute = 'start_datetime';

  function PossibleSegment() {
    Booking.Models.Base.apply(this, arguments);
  }

  PossibleSegment.prototype.getTimezone = function() {
    return this.collection.getTimezone();
  };

  PossibleSegment.prototype.start = function() {
    return Booking.Helpers.objectInTimezone(this.get('start_datetime'), this.getTimezone());
  };

  PossibleSegment.prototype.end = function() {
    return Booking.Helpers.objectInTimezone(this.get('end_datetime'), this.getTimezone());
  };

  PossibleSegment.prototype.id = function() {
    return this.get('id');
  };

  PossibleSegment.prototype.getSegmentId = function() {
    return this.get('segment_id');
  };

  return PossibleSegment;

})(Booking.Models.Base);

Booking.Models.PossibleSegment.prototype.createFromTimeModel = function(model) {
  var segment;
  segment = {};
  segment['start_datetime'] = model.start();
  segment['end_datetime'] = model.end();
  segment['segment_id'] = model.get('id');
  return new Booking.Models.PossibleSegment(segment);
};



},{}],22:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  Reservation.prototype.statuses = {
    locked: 'locked',
    requested: 'requested',
    confirmed: 'confirmed',
    expired: 'expired',
    canceled: 'user_declined'
  };

  Reservation.prototype.errors = {
    0: 'timeout',
    404: 'not_found',
    409: 'conflict',
    410: 'gone',
    504: 'timeout'
  };

  function Reservation(attributes, options) {
    options = _.extend({}, options, {
      parse: true
    });
    Booking.Models.Base.call(this, attributes, options);
    this.on('error', this.handleError, this);
    this.on('request', this.loading, this);
    this.on('sync', this.loaded, this);
  }

  Reservation.prototype.parse = function(raw) {
    var additionalAttributes, option, possibleSegments, selectedSegment;
    if (!raw) {
      return;
    }
    additionalAttributes = raw.additionalAttributes, option = raw.option, possibleSegments = raw.possibleSegments, selectedSegment = raw.selectedSegment;
    if (possibleSegments != null ? possibleSegments.length : void 0) {
      raw.possibleSegments = new Booking.Collections.PossibleSegments(possibleSegments);
      raw.possibleSegments.getTimezone = (function(_this) {
        return function() {
          return _this.getTimezone();
        };
      })(this);
    }
    if (selectedSegment) {
      raw.selectedSegment = new Booking.Models.PossibleSegment(selectedSegment);
      raw.selectedSegment.getTimezone = (function(_this) {
        return function() {
          return _this.getTimezone();
        };
      })(this);
    }
    if (additionalAttributes) {
      raw.additionalAttributes = new Booking.Collections.Attributes(additionalAttributes);
    }
    if (option) {
      raw.option = new Booking.Models.Option(option, {
        parse: true
      });
    }
    return raw;
  };

  Reservation.prototype.handleError = function(model, response) {
    var error;
    error = this.errors[response.status] || 'server';
    return this.setError(error);
  };

  Reservation.prototype.toJSON = function(options) {
    var attrPossibleSegments, clonedAttributes, possibleSegments;
    clonedAttributes = _.clone(this.attributes);
    possibleSegments = [];
    attrPossibleSegments = clonedAttributes.possibleSegments;
    attrPossibleSegments.each(function(possibleSegModel) {
      return possibleSegments.push({
        segment_id: possibleSegModel.get('segment_id')
      });
    });
    clonedAttributes.possibleSegments = possibleSegments;
    return clonedAttributes;
  };

  Reservation.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Reservation.prototype.getError = function() {
    return this.get('error');
  };

  Reservation.prototype.clearError = function() {
    return this.unset('error');
  };

  Reservation.prototype.getOption = function() {
    return this.get('option');
  };

  Reservation.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Reservation.prototype.getUserId = function() {
    return this.get('userId');
  };

  Reservation.prototype.getStatus = function() {
    return this.get('status');
  };

  Reservation.prototype.getIsDTF = function() {
    return this.get('isDTF');
  };

  Reservation.prototype.getBookingData = function() {
    return this.get('bookingData');
  };

  Reservation.prototype.getStartDatetime = function() {
    return this.get('startDatetime');
  };

  Reservation.prototype.getEndDatetime = function() {
    return this.get('endDatetime');
  };

  Reservation.prototype.getDuration = function() {
    return this.get('duration');
  };

  Reservation.prototype.isAppointmentRequest = function() {
    var ref;
    return (ref = this.getOption()) != null ? ref.isARSE() : void 0;
  };

  Reservation.prototype.getCancellationValidUntil = function() {
    return this.get('cancellationValidUntil');
  };

  Reservation.prototype.getCancellationValidUntilDatetimeMoment = function() {
    if (this.getCancellationValidUntil() != null) {
      return moment(this.getCancellationValidUntil()).tz(this.getTimezone());
    }
  };

  Reservation.prototype.canBeRescheduled = function() {
    if ((this.getCancellationValidUntilDatetimeMoment() != null) && (this.isCanceled() || this.isConfirmed())) {
      return this.getCancellationValidUntilDatetimeMoment().isAfter();
    }
    return true;
  };

  Reservation.prototype.getTimezone = function() {
    return this.getOption().getLocalBookingSettings().getTimezone();
  };

  Reservation.prototype.getLocationName = function() {
    return this.getOption().getLocationName();
  };

  Reservation.prototype.getMerchantName = function() {
    return this.getMerchant().name;
  };

  Reservation.prototype.getAttributes = function() {
    return this.get('additionalAttributes');
  };

  Reservation.prototype.getPartySize = function() {
    var partySize, ref;
    partySize = this.get((ref = this.getAttributes().getPartySize()) != null ? ref.getName() : void 0);
    if (_.isFinite(partySize)) {
      partySize = parseInt(partySize, 10);
    }
    return partySize;
  };

  Reservation.prototype.getQuestion = function() {
    var ref, ref1;
    return this.get((ref = this.getAttributes().getQuestions()) != null ? (ref1 = ref[0]) != null ? ref1.getName() : void 0 : void 0);
  };

  Reservation.prototype.getPhone = function() {
    var ref;
    return this.get((ref = this.getAttributes().getPhone()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.getTextNotifications = function() {
    var ref;
    return this.get((ref = this.getAttributes().getTextNotifications()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.getNextReachableHour = function() {
    return this.get('optionsNextReachableHour').next;
  };

  Reservation.prototype.isFoodAndDrink = function() {
    return this.get('isFoodAndDrink');
  };

  Reservation.prototype.isHBW = function() {
    return this.get('isHBW');
  };

  Reservation.prototype.isReservedAvailability = function() {
    return this.get('reservedAvailability');
  };

  Reservation.prototype.isThirdParty = function() {
    return this.get('thirdParty');
  };

  Reservation.prototype.isMultiWindow = function() {
    return this.get('multiWindow');
  };

  Reservation.prototype.isLocked = function() {
    return this.getStatus() === this.statuses.locked;
  };

  Reservation.prototype.isRequested = function() {
    return this.getStatus() === this.statuses.requested;
  };

  Reservation.prototype.isConfirmed = function() {
    return this.getStatus() === this.statuses.confirmed;
  };

  Reservation.prototype.isExpired = function() {
    return this.getStatus() === this.statuses.expired;
  };

  Reservation.prototype.isCanceled = function() {
    return this.getStatus() === this.statuses.canceled;
  };

  Reservation.prototype.isBooked = function() {
    return this.isRequested() || this.isConfirmed() || this.isLocked();
  };

  Reservation.prototype.loaded = function() {
    return this.set('loaded', true);
  };

  Reservation.prototype.loading = function() {
    return this.set('loaded', false);
  };

  Reservation.prototype.isLoaded = function() {
    return this.get('loaded') === true;
  };

  Reservation.prototype.isLoading = function() {
    return this.get('loaded') === false;
  };

  Reservation.prototype.cancel = function() {
    this.set({
      status: this.statuses.canceled
    });
    return this.save();
  };

  Reservation.prototype.getSelectedSegment = function() {
    return this.get('selectedSegment');
  };

  Reservation.prototype.getPossibleSegments = function() {
    return this.get('possibleSegments');
  };

  return Reservation;

})(Booking.Models.Base);



},{}],23:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Models.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    var clndrTimeMoment, finalTimeMoment, initialTimeMoment;
    Booking.Models.Base.apply(this, arguments);
    initialTimeMoment = clndrTimeMoment = moment.unix(this.get('initial_time'));
    finalTimeMoment = moment.unix(this.get('final_time'));
    if (this.collection && !this.collection.meta('browserInMerchantTimezone')) {
      initialTimeMoment = initialTimeMoment.tz(this.collection.getTimezone());
      finalTimeMoment = finalTimeMoment.tz(this.collection.getTimezone());
    }
    this.set({
      initialTimeMoment: initialTimeMoment,
      finalTimeMoment: finalTimeMoment,
      clndrTimeMoment: clndrTimeMoment
    });
  }

  Time.prototype.start = function() {
    return this.get('initialTimeMoment');
  };

  Time.prototype.end = function() {
    return this.get('finalTimeMoment');
  };

  Time.prototype.isSelected = function() {
    return this.get('selected');
  };

  Time.prototype.isDisabled = function() {
    return this.get('disabled');
  };

  Time.prototype.setSelected = function(selected, disabled, options) {
    return this.set({
      selected: selected,
      disabled: disabled
    }, options);
  };

  Time.prototype.select = function(disabled, options) {
    if (disabled == null) {
      disabled = false;
    }
    if (options == null) {
      options = {};
    }
    return this.setSelected(true, disabled, options);
  };

  Time.prototype.deselect = function(disabled, options) {
    if (disabled == null) {
      disabled = false;
    }
    if (options == null) {
      options = {};
    }
    return this.setSelected(false, disabled, options);
  };

  Time.prototype.toggle = function() {
    if (this.isSelected()) {
      return this.deselect();
    } else {
      return this.select();
    }
  };

  return Time;

})(Booking.Models.Base);



},{}],24:[function(require,module,exports){
Booking.Presenters.Base = (function() {
  Base.prototype.module = 'booking';

  function Base(options, templateName) {
    var ref, ref1, ref2, ref3;
    this.options = options;
    this.templateName = templateName;
    if (this.module == null) {
      this.module = (ref = this.options) != null ? ref.module : void 0;
    }
    this.model = (ref1 = this.options) != null ? ref1.model : void 0;
    this.parentModel = (ref2 = this.options) != null ? ref2.parentModel : void 0;
    this.collection = (ref3 = this.options) != null ? ref3.collection : void 0;
  }

  Base.prototype.localesBasePath = function() {
    return "modules." + this.module + "." + this.templateName;
  };

  Base.prototype.toHash = function() {};

  Base.prototype.merchantCategoryKey = function() {
    if (this.model.isFoodAndDrink()) {
      return 'food_and_drink';
    } else if (this.model.isHBW()) {
      return 'health_and_beauty';
    } else {
      return 'default';
    }
  };

  Base.prototype.loadPreviousData = function(key) {
    var previousData, ref;
    previousData = (ref = this.model.getBookingData()) != null ? ref.additionalFields : void 0;
    return (previousData != null ? previousData[key] : void 0) || '';
  };

  Base.prototype.getSchedulingNoun = function(args) {
    var capitalized, noun, nounDecorator, plural, withDeterminer;
    if (args == null) {
      args = {};
    }
    plural = args.plural, capitalized = args.capitalized, withDeterminer = args.withDeterminer;
    nounDecorator = plural ? 'plural' : withDeterminer ? 'single_with_determiner' : 'single';
    noun = this.getI18n().t("js.modules.booking.scheduling_noun." + (this.merchantCategoryKey()) + "." + nounDecorator);
    if (!capitalized) {
      noun = noun.toLowerCase();
    }
    return noun;
  };

  Base.prototype.getI18n = function(scope) {
    if (scope == null) {
      scope = this.localesBasePath();
    }
    if (scope != null) {
      return I18n.scoped(scope);
    }
    return I18n;
  };

  Base.prototype.toHashWithHelpers = function() {
    return I18n.mixin(this.toHash(), this.getI18n());
  };

  Base.prototype.generateLink = function(i18nKey, href) {
    var label;
    label = this.getI18n().t(i18nKey);
    return "<a href='" + href + "'>" + label + "</a>";
  };

  Base.prototype.imageUrl = function(assetName) {
    return Booking.imageUrls[assetName] || '';
  };

  return Base;

})();



},{}],25:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.toHash = function() {
    var bookAndBuy, isDisabled, isG3, isPartialIntent, notYet, poweredByImageUrl, requestAppointment, reschedule, schedulingNounCapitalized, showPoweredBy;
    notYet = this.model.isDealNotYetOpen();
    bookAndBuy = this.model.getBookAndBuy();
    reschedule = this.model.getReschedule();
    requestAppointment = this.model.isARSE();
    isG3 = this.model.isG3();
    schedulingNounCapitalized = this.getSchedulingNoun({
      capitalized: true
    });
    isPartialIntent = this.model.isPartialIntent();
    showPoweredBy = this.model.isBookerDeal() && bookAndBuy;
    poweredByImageUrl = this.imageUrl('booking-powered-by-booker.png');
    if (bookAndBuy && !window.mobileHelper) {
      isDisabled = this.model.getIsBooking() === true || !this.model.isReadyToBuy();
    } else {
      isDisabled = this.model.getIsBooking() === true || !this.model.isReadyToBook();
    }
    return {
      isDisabled: isDisabled,
      notYet: notYet,
      bookAndBuy: bookAndBuy,
      reschedule: reschedule,
      requestAppointment: requestAppointment,
      schedulingNounCapitalized: schedulingNounCapitalized,
      isPartialIntent: isPartialIntent,
      showPoweredBy: showPoweredBy,
      poweredByImageUrl: poweredByImageUrl,
      isG3: isG3
    };
  };

  return Book;

})(Booking.Presenters.Base);



},{}],26:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Booker = (function(superClass) {
  extend(Booker, superClass);

  function Booker() {
    return Booker.__super__.constructor.apply(this, arguments);
  }

  Booker.prototype.userPageHref = function(page) {
    return "/users/" + (this.model.getUserId()) + "/" + page;
  };

  Booker.prototype.toHash = function() {
    var error, hash, ref;
    error = this.model.getError();
    hash = {
      error: error,
      errorLoading: error === 'loading' || error === 'timeout',
      errorBooking: error === 'server' || error === 'not_found',
      errorSegmentNotAvailable: error === 'conflict',
      errorSegmentExpired: error === 'gone',
      myReservationsLink: this.generateLink('.my_reservations', this.userPageHref('reservations')),
      myGrouponsLink: this.generateLink('.my_groupons', this.userPageHref('groupons')),
      isLocked: this.options.isLocked,
      phoneRequired: this.model.requirePhone(),
      textNotificationsRequired: this.model.requireTextNotifications(),
      questionRequired: this.model.requireQuestion(),
      isARSE: this.model.isARSE(),
      isDTF: this.model.getIsDTF(),
      isMW: this.model.isMultiWindow(),
      showNewOverlay: this.options.showNewOverlay,
      hasReservation: ((ref = this.model.getReservation()) != null ? ref.id : void 0) != null,
      merchantPhone: this.model.getMerchantPhoneNumber(),
      schedulingNoun: this.getSchedulingNoun({}),
      schedulingNounPlural: this.getSchedulingNoun({
        plural: true
      }),
      schedulingNounCapitalized: this.getSchedulingNoun({
        capitalized: true
      }),
      schedulingNounWithDeterminer: this.getSchedulingNoun({
        withDeterminer: true
      }),
      schedulingNounCapitalizedWithDeterminer: this.getSchedulingNoun({
        capitalized: true,
        withDeterminer: true
      })
    };
    return hash;
  };

  Booker.prototype.localesBasePath = function() {
    if (this.model.isARSE()) {
      return "modules." + this.module + "." + this.templateName + "_arse";
    } else {
      return "modules." + this.module + "." + this.templateName;
    }
  };

  return Booker;

})(Booking.Presenters.Base);



},{}],27:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Calendar = (function(superClass) {
  var getDayBHC, getDayLabel;

  extend(Calendar, superClass);

  function Calendar() {
    return Calendar.__super__.constructor.apply(this, arguments);
  }

  getDayLabel = function(day, isBookerDeal, diff) {
    if ((diff != null) && diff < 0) {
      return 'unavailable';
    } else {
      if (day.events.length || isBookerDeal) {
        return 'available';
      } else {
        return 'unavailable';
      }
    }
  };

  getDayBHC = function(idx, days, diff) {
    var at, value;
    if (diff != null) {
      if (diff === 0) {
        return value = 'today';
      } else {
        at = diff > 0 ? 'ahead' : 'behind';
        return value = at + "-" + (Math.abs(diff)) + "-days";
      }
    } else {
      return value = idx < days / 2 ? 'last-month' : 'next-month';
    }
  };

  Calendar.prototype.toHash = function() {
    var calendarData, days, firstDayIndex, i, isBookerDeal, lastDayIndex, lastMonthAvailable, momentEndOfMonth, momentStartOfMonth, nextMonthAvailable, now, numberOfColumns, numberOfRows, ref, row, rows;
    isBookerDeal = this.model.isBookerDeal();
    calendarData = this.options.calendarData;
    numberOfColumns = calendarData.days.length / calendarData.numberOfRows;
    numberOfRows = calendarData.numberOfRows;
    rows = [];
    now = moment();
    days = _.map(calendarData.days, function(day, idx) {
      var diff, value;
      if (moment.isMoment(day.date)) {
        diff = day.date.diff(now, 'days');
      }
      day.label = getDayLabel(day, isBookerDeal, diff);
      value = getDayBHC(idx, calendarData.days.length, diff);
      day.bhc = day.label + ":" + value;
      return day;
    });
    for (row = i = 0, ref = numberOfRows - 1; 0 <= ref ? i <= ref : i >= ref; row = 0 <= ref ? ++i : --i) {
      firstDayIndex = row * numberOfColumns;
      lastDayIndex = (row + 1) * numberOfColumns - 1;
      rows[row] = {
        days: days.slice(firstDayIndex, +lastDayIndex + 1 || 9e9)
      };
    }
    momentStartOfMonth = moment(calendarData.month + " " + calendarData.year, 'MMM YYYY').startOf('month');
    momentEndOfMonth = moment(momentStartOfMonth).endOf('month');
    lastMonthAvailable = momentStartOfMonth > now;
    nextMonthAvailable = momentEndOfMonth < now.add(this.model.getMaxLeadTime(), 'seconds');
    return {
      loaded: this.collection.isLoaded(),
      rows: rows,
      month: calendarData.month,
      year: calendarData.year,
      daysOfTheWeek: calendarData.daysOfTheWeek,
      lastMonthAvailable: lastMonthAvailable,
      nextMonthAvailable: nextMonthAvailable,
      bhcPrevious: 'navigateTo:previous-month',
      bhcNext: 'navigateTo:next-month'
    };
  };

  return Calendar;

})(Booking.Presenters.Base);



},{}],28:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.DateTimePicker = (function(superClass) {
  extend(DateTimePicker, superClass);

  function DateTimePicker() {
    return DateTimePicker.__super__.constructor.apply(this, arguments);
  }

  DateTimePicker.prototype.selected = function() {
    return this.model.getSelectedTimes();
  };

  DateTimePicker.prototype.isSelectable = function() {
    return true;
  };

  DateTimePicker.prototype.toHash = function() {
    var date, hash, loading, multiple, selectedTimes;
    selectedTimes = this.selected();
    loading = this.isLoading();
    if ((selectedTimes != null ? selectedTimes.length : void 0) && !loading) {
      date = selectedTimes[0].start();
      multiple = selectedTimes.length > 1;
    }
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (loading) {
      hash.loading = loading;
    }
    hash.multiple = multiple;
    if (!loading && date) {
      hash.selectedDate = {
        day: date.format('ddd'),
        month: date.format('MMM'),
        date: date.format('D'),
        time: date.format('h:mm A')
      };
    }
    return hash;
  };

  return DateTimePicker;

})(Booking.Presenters.Picker);



},{}],29:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.toHash = function() {
    var option, selectedOption;
    selectedOption = this.model.getSelectedOption();
    option = selectedOption || this.model.getOptions().cheapest();
    return {
      optionSelected: selectedOption != null,
      price: option.getFormattedPrice()
    };
  };

  return Info;

})(Booking.Presenters.Base);



},{}],30:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.isUrgencyPricingOption = function(pricingMetadata) {
    var now, offerBeginsAt, offerEndsAt, urgencyPricingEndsAt, urgencyPricingStartsAt;
    if (!(pricingMetadata && pricingMetadata !== {} && pricingMetadata.offerType !== 'BWF')) {
      return false;
    }
    offerBeginsAt = pricingMetadata.offerBeginsAt, offerEndsAt = pricingMetadata.offerEndsAt;
    now = new Date();
    if (offerBeginsAt != null) {
      urgencyPricingStartsAt = new Date(offerBeginsAt);
    }
    if (offerEndsAt != null) {
      urgencyPricingEndsAt = new Date(offerEndsAt);
    }
    return ((urgencyPricingStartsAt <= now && now <= urgencyPricingEndsAt)) || ((urgencyPricingEndsAt == null) && urgencyPricingStartsAt <= now) || ((urgencyPricingStartsAt == null) && urgencyPricingEndsAt >= now);
  };

  Option.prototype.getSoldQuantityMessageLocalesString = function(showQuantity, quantity, quantityMessage) {
    if (!showQuantity) {
      return null;
    }
    if (quantityMessage.slice(-1) !== '+') {
      return {
        localesString: 'quantity_bought',
        quantity: quantity
      };
    }
    if (quantityMessage.indexOf(quantity) + 1) {
      return {
        localesString: 'over_quantity_bought',
        quantity: quantity
      };
    } else {
      return {
        localesString: 'quantity_bought',
        quantity: quantityMessage
      };
    }
  };

  Option.prototype.toHash = function() {
    var discount, isUrgencyPricing, localesBasePath, optionId, price, pricingMetadata, quantityNumber, ref, selectedOptionId, showDiscount, showQuantity, showUrgencyPricingMessage, soldQuantity, soldQuantityMessage, soldQuantityMessageLocalesString, soldQuantityMessageText;
    pricingMetadata = this.model.getPricingMetadata();
    optionId = this.model.id;
    selectedOptionId = (ref = this.parentModel.getSelectedOption()) != null ? ref.id : void 0;
    discount = this.model.getDiscount();
    showDiscount = this.model.getShowDiscount() && (discount != null ? discount.amount : void 0) > 0;
    showQuantity = this.model.getShowQuantity();
    soldQuantity = this.model.getSoldQuantity();
    soldQuantityMessage = this.model.getSoldQuantityMessage();
    price = this.model.getFormattedPrice();
    isUrgencyPricing = this.isUrgencyPricingOption(pricingMetadata);
    showUrgencyPricingMessage = isUrgencyPricing && (price != null) && showDiscount;
    localesBasePath = this.localesBasePath();
    quantityNumber = this.getI18n().toNumber(soldQuantity);
    soldQuantityMessageLocalesString = this.getSoldQuantityMessageLocalesString(showQuantity, quantityNumber, soldQuantityMessage);
    if (soldQuantityMessageLocalesString) {
      soldQuantityMessageText = this.getI18n().t("js." + localesBasePath + "." + soldQuantityMessageLocalesString.localesString, {
        quantity: soldQuantityMessageLocalesString.quantity
      });
    }
    return {
      optionId: optionId,
      title: this.model.getTitle(),
      selected: selectedOptionId === optionId,
      isSoldOut: this.model.isSoldOut(),
      price: price,
      value: this.model.getFormattedValue(),
      isUrgencyPricing: isUrgencyPricing,
      showUrgencyPricingMessage: showUrgencyPricingMessage,
      offerLabel: pricingMetadata != null ? pricingMetadata.offerLabel : void 0,
      discount: discount != null ? discount.formattedAmount : void 0,
      showDiscount: showDiscount,
      soldQuantityMessageText: soldQuantityMessageText
    };
  };

  Option.prototype.bhc = function() {
    return "dealoption:" + (this.model.getTitle());
  };

  return Option;

})(Booking.Presenters.Base);



},{}],31:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.selected = function() {
    return this.model.getSelectedOption();
  };

  OptionPicker.prototype.toHash = function() {
    var hash, selectedOption;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    selectedOption = this.selected();
    if (selectedOption != null) {
      hash.selectedOption = {
        title: selectedOption.getTitle()
      };
    }
    return hash;
  };

  return OptionPicker;

})(Booking.Presenters.Picker);



},{}],32:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.toHash = function() {
    var partySize, selected;
    partySize = this.model.getPartySize();
    selected = this.parentModel.getSelectedPartySize() === partySize;
    return {
      partySize: partySize,
      selected: selected
    };
  };

  PartySize.prototype.bhc = function() {
    return "partysize:" + (this.model.getPartySize());
  };

  return PartySize;

})(Booking.Presenters.Base);



},{}],33:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.PartyPicker = (function(superClass) {
  extend(PartyPicker, superClass);

  function PartyPicker() {
    return PartyPicker.__super__.constructor.apply(this, arguments);
  }

  PartyPicker.prototype.selected = function() {
    return this.model.getSelectedPartySize();
  };

  PartyPicker.prototype.toHash = function() {
    var hash, selectedPartySize;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    selectedPartySize = this.selected();
    if (selectedPartySize != null) {
      hash.selectedpartySize = {
        partySize: selectedPartySize
      };
    }
    return hash;
  };

  return PartyPicker;

})(Booking.Presenters.Picker);



},{}],34:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Phone = (function(superClass) {
  extend(Phone, superClass);

  function Phone() {
    return Phone.__super__.constructor.apply(this, arguments);
  }

  Phone.prototype.toHash = function() {
    return {
      customerPhone: this.model.getPhoneNumber(),
      maxLength: this.options.customerPhoneMaxLength,
      bhc: 'input:phone',
      bhcPhone: 'icon:DeletePhoneNumber'
    };
  };

  return Phone;

})(Booking.Presenters.Base);



},{}],35:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Picker = (function(superClass) {
  extend(Picker, superClass);

  function Picker() {
    return Picker.__super__.constructor.apply(this, arguments);
  }

  Picker.prototype.selected = function() {
    throw new Error('should implement');
  };

  Picker.prototype.isLoading = function() {
    return this.model.isDateTimeLoading();
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1 || this.model.isBookerDeal();
  };

  Picker.prototype.toHash = function() {
    return {
      icon: this.options.icon,
      expanded: this.options.expanded,
      selectable: this.isSelectable() || !this.selected(),
      disabled: !this.isPreviousSelected(),
      bhcTime: 'icon:ReEnterTime',
      bhcDate: 'icon:ReEnterDate'
    };
  };

  Picker.prototype.isPreviousSelected = function() {
    if (this.options.previous && this.options.previous.length > 0) {
      return this.options.previous.slice(-1)[0].selected();
    } else {
      return true;
    }
  };

  return Picker;

})(Booking.Presenters.Base);



},{}],36:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.PickerNotice = (function(superClass) {
  extend(PickerNotice, superClass);

  function PickerNotice() {
    return PickerNotice.__super__.constructor.apply(this, arguments);
  }

  PickerNotice.prototype.toHash = function() {
    return {
      notice: this.getI18n().t("js.modules.booking.picker_notice." + this.options.notice)
    };
  };

  return PickerNotice;

})(Booking.Presenters.Base);



},{}],37:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.prototype.toHash = function() {
    return {
      question: this.model.getQuestion(),
      answer: this.model.getQuestionsAnswer(),
      maxLength: this.options.maxLength,
      bhc: "input:question",
      bhcNotes: "icon:DeleteNotes"
    };
  };

  return Question;

})(Booking.Presenters.Base);



},{}],38:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.TextNotifications = (function(superClass) {
  extend(TextNotifications, superClass);

  function TextNotifications() {
    return TextNotifications.__super__.constructor.apply(this, arguments);
  }

  TextNotifications.prototype.toHash = function() {
    var checked, ref, reservationId, schedulingNoun, schedulingNounWithDeterminer, tooltipId;
    tooltipId = 'text-notification';
    if (typeof this.model.getReservation === 'function') {
      reservationId = (ref = this.model.getReservation()) != null ? ref.id : void 0;
    }
    if (reservationId != null) {
      tooltipId = tooltipId + "-" + reservationId;
    }
    checked = this.model.getTextNotifications() === 'true';
    schedulingNoun = this.getSchedulingNoun({});
    schedulingNounWithDeterminer = this.getSchedulingNoun({
      withDeterminer: true
    });
    return {
      tooltipId: tooltipId,
      checked: checked,
      schedulingNoun: schedulingNoun,
      schedulingNounWithDeterminer: schedulingNounWithDeterminer
    };
  };

  return TextNotifications;

})(Booking.Presenters.Base);



},{}],39:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.TimeBubble = (function(superClass) {
  extend(TimeBubble, superClass);

  function TimeBubble() {
    return TimeBubble.__super__.constructor.apply(this, arguments);
  }

  TimeBubble.prototype.toHash = function() {
    var timeFormat;
    timeFormat = this.getI18n().t('.timeFormat');
    return {
      time: this.model.start().format(timeFormat),
      selected: this.model.isSelected(),
      disabled: this.model.isDisabled(),
      bhc: 'li:timeBubble'
    };
  };

  return TimeBubble;

})(Booking.Presenters.Base);



},{}],40:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Presenters.TimeBubbles = (function(superClass) {
  extend(TimeBubbles, superClass);

  function TimeBubbles() {
    return TimeBubbles.__super__.constructor.apply(this, arguments);
  }

  TimeBubbles.prototype.toHash = function() {
    return {
      isMultiWindow: this.model.isMultiWindow(),
      bhcAnytime: 'input:anytimeBubble'
    };
  };

  return TimeBubbles;

})(Booking.Presenters.Base);



},{}],41:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<");if(_.s(_.f("bookAndBuy",c,p,1),c,p,0,16,22,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("button");});c.pop();}if(!_.s(_.f("bookAndBuy",c,p,1),c,p,1,0,0,"")){_.b("input");};_.b("\n" + i);_.b("  type=\"submit\"");_.b("\n" + i);_.b("  tabindex=\"0\" class=\"");if(_.s(_.f("bookAndBuy",c,p,1),c,p,0,126,182,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("btn-buy-big ");if(_.s(_.f("isDisabled",c,p,1),c,p,0,153,167,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("state-disabled");});c.pop();}});c.pop();}if(!_.s(_.f("bookAndBuy",c,p,1),c,p,1,0,0,"")){_.b("btn");};_.b("\"");_.b("\n" + i);_.b("  ");if(_.s(_.f("isDisabled",c,p,1),c,p,0,249,257,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("disabled");});c.pop();}_.b("\n" + i);_.b("  ");if(!_.s(_.f("bookAndBuy",c,p,1),c,p,1,0,0,"")){_.b("value=\"");if(_.s(_.f("reschedule",c,p,1),c,p,0,312,335,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,318,329,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".reschedule");});c.pop();}});c.pop();}if(!_.s(_.f("reschedule",c,p,1),c,p,1,0,0,"")){if(!_.s(_.f("requestAppointment",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,394,403,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".schedule");});c.pop();}};if(_.s(_.f("requestAppointment",c,p,1),c,p,0,455,525,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,461,519,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".request, \"nounCapitalized\": ");_.b(_.v(_.f("schedulingNounCapitalized",c,p,0)));});c.pop();}});c.pop();}};_.b("\"");};_.b(">");_.b("\n" + i);_.b("  ");if(_.s(_.f("bookAndBuy",c,p,1),c,p,0,598,687,"{{ }}")){_.rs(c,p,function(c,p,_){if(!_.s(_.f("notYet",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,615,619,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".buy");});c.pop();}};if(_.s(_.f("notYet",c,p,1),c,p,0,647,667,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,653,661,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".not_yet");});c.pop();}});c.pop();}_.b("</button>");});c.pop();}_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("showPoweredBy",c,p,1),c,p,0,722,778,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <img class=\"powered-by\" src=\"");_.b(_.v(_.f("poweredByImageUrl",c,p,0)));_.b("\">");_.b("\n");});c.pop();}_.b("\n");return _.fl();;},"<{{#bookAndBuy}}button{{/bookAndBuy}}{{^bookAndBuy}}input{{/bookAndBuy}}\n  type=\"submit\"\n  tabindex=\"0\" class=\"{{#bookAndBuy}}btn-buy-big {{#isDisabled}}state-disabled{{/isDisabled}}{{/bookAndBuy}}{{^bookAndBuy}}btn{{/bookAndBuy}}\"\n  {{#isDisabled}}disabled{{/isDisabled}}\n  {{^bookAndBuy}}value=\"{{#reschedule}}{{#t}}.reschedule{{/t}}{{/reschedule}}{{^reschedule}}{{^requestAppointment}}{{#t}}.schedule{{/t}}{{/requestAppointment}}{{#requestAppointment}}{{#t}}.request, \"nounCapitalized\": {{schedulingNounCapitalized}}{{/t}}{{/requestAppointment}}{{/reschedule}}\"{{/bookAndBuy}}>\n  {{#bookAndBuy}}{{^notYet}}{{#t}}.buy{{/t}}{{/notYet}}{{#notYet}}{{#t}}.not_yet{{/t}}{{/notYet}}</button>{{/bookAndBuy}}\n\n{{#showPoweredBy}}\n  <img class=\"powered-by\" src=\"{{poweredByImageUrl}}\">\n{{/showPoweredBy}}\n\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],42:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<table class=\"calendar\">");_.b("\n" + i);_.b("  <thead>");_.b("\n" + i);_.b("    <tr>");_.b("\n" + i);_.b("      <th colspan=\"7\">");_.b("\n" + i);_.b("        <span data-bhc=\"");_.b(_.v(_.f("bhcPrevious",c,p,0)));_.b("\" class=\"previous icon-arrow-left-large");if(!_.s(_.f("lastMonthAvailable",c,p,1),c,p,1,0,0,"")){_.b(" disabled");};_.b("\"><span>&lt;</span></span>");_.b("\n" + i);_.b("        <span data-bhc=\"");_.b(_.v(_.f("bhcNext",c,p,0)));_.b("\" class=\"next icon-arrow-right-large");if(!_.s(_.f("nextMonthAvailable",c,p,1),c,p,1,0,0,"")){_.b(" disabled");};_.b("\"><span>&gt;</span></span>");_.b("\n" + i);_.b("        ");_.b(_.v(_.f("month",c,p,0)));_.b(" ");_.b(_.v(_.f("year",c,p,0)));_.b("\n" + i);_.b("      </th>");_.b("\n" + i);_.b("    </tr>");_.b("\n" + i);_.b("  </thead>");_.b("\n" + i);_.b("  <tbody>");_.b("\n" + i);_.b("    <tr class=\"week-titles\">");_.b("\n" + i);if(_.s(_.f("daysOfTheWeek",c,p,1),c,p,0,503,531,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <td>");_.b(_.v(_.d(".",c,p,0)));_.b("</td>");_.b("\n");});c.pop();}_.b("    </tr>");_.b("\n" + i);if(_.s(_.f("rows",c,p,1),c,p,0,573,754,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <tr class=\"week\">");_.b("\n" + i);if(_.s(_.f("days",c,p,1),c,p,0,611,730,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <td class=\"");_.b(_.v(_.f("classes",c,p,0)));_.b(" ");_.b(_.v(_.f("label",c,p,0)));_.b("\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);_.b("        <div><span>");_.b(_.v(_.f("day",c,p,0)));_.b("</span></div>");_.b("\n" + i);_.b("      </td>");_.b("\n");});c.pop();}_.b("    </tr>");_.b("\n");});c.pop();}_.b("  </tbody>");_.b("\n" + i);_.b("</table>");_.b("\n" + i);_.b("<div class=\"loading csspseudoanimations\">");_.b("\n" + i);_.b("  <div class=\"overlay\"></div>");_.b("\n" + i);_.b("  <div class=\"icon-loading\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<table class=\"calendar\">\n  <thead>\n    <tr>\n      <th colspan=\"7\">\n        <span data-bhc=\"{{bhcPrevious}}\" class=\"previous icon-arrow-left-large{{^lastMonthAvailable}} disabled{{/lastMonthAvailable}}\"><span>&lt;</span></span>\n        <span data-bhc=\"{{bhcNext}}\" class=\"next icon-arrow-right-large{{^nextMonthAvailable}} disabled{{/nextMonthAvailable}}\"><span>&gt;</span></span>\n        {{month}} {{year}}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class=\"week-titles\">\n      {{#daysOfTheWeek}}\n      <td>{{.}}</td>\n      {{/daysOfTheWeek}}\n    </tr>\n    {{#rows}}\n    <tr class=\"week\">\n      {{#days}}\n      <td class=\"{{classes}} {{label}}\" data-bhc=\"{{bhc}}\">\n        <div><span>{{day}}</span></div>\n      </td>\n      {{/days}}\n    </tr>\n    {{/rows}}\n  </tbody>\n</table>\n<div class=\"loading csspseudoanimations\">\n  <div class=\"overlay\"></div>\n  <div class=\"icon-loading\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],43:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper ");if(_.s(_.f("disabled",c,p,1),c,p,0,33,42,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" disabled");});c.pop();}_.b("\">");_.b("\n" + i);_.b("  <div class=\"dropdown");if(_.s(_.f("selectable",c,p,1),c,p,0,95,106,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" selectable");});c.pop();}_.b("\">");_.b("\n" + i);_.b("    <span class=\"icon-calendar icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection");if(_.s(_.f("loading",c,p,1),c,p,0,207,215,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" loading");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("loading",c,p,1),c,p,0,248,268,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,254,262,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".loading");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("loading",c,p,1),c,p,1,0,0,"")){_.b("        ");if(!_.s(_.f("selectedDate",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,331,338,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);_.b("        ");if(_.s(_.f("selectedDate",c,p,1),c,p,0,387,464,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,393,458,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected, \"month\": ");_.b(_.v(_.f("month",c,p,0)));_.b(", \"date\": ");_.b(_.v(_.f("date",c,p,0)));_.b(", \"year\": ");_.b(_.v(_.f("year",c,p,0)));});c.pop();}});c.pop();}_.b("\n");};_.b("    </span>");_.b("\n" + i);if(_.s(_.f("selectable",c,p,1),c,p,0,532,695,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("      <span data-bhc=\"");_.b(_.v(_.f("bhcDate",c,p,0)));_.b("\" class=\"icon-arrow-up-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper {{#disabled}} disabled{{/disabled}}\">\n  <div class=\"dropdown{{#selectable}} selectable{{/selectable}}\">\n    <span class=\"icon-calendar icon\"></span>\n    <span class=\"selection{{#loading}} loading{{/loading}}\">\n      {{#loading}}{{#t}}.loading{{/t}}{{/loading}}\n      {{^loading}}\n        {{^selectedDate}}{{#t}}.select{{/t}}{{/selectedDate}}\n        {{#selectedDate}}{{#t}}.selected, \"month\": {{month}}, \"date\": {{date}}, \"year\": {{year}}{{/t}}{{/selectedDate}}\n      {{/loading}}\n    </span>\n    {{#selectable}}\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n      <span data-bhc=\"{{bhcDate}}\" class=\"icon-arrow-up-large\"></span>\n    </span>\n    {{/selectable}}\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],44:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper ");if(_.s(_.f("disabled",c,p,1),c,p,0,33,42,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" disabled");});c.pop();}_.b("\">");_.b("\n" + i);_.b("  <div class=\"dropdown");if(_.s(_.f("selectable",c,p,1),c,p,0,95,106,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" selectable");});c.pop();}_.b("\">");_.b("\n" + i);_.b("    <span class=\"icon-calendar icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection");if(_.s(_.f("loading",c,p,1),c,p,0,207,215,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" loading");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("loading",c,p,1),c,p,0,248,268,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,254,262,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".loading");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("loading",c,p,1),c,p,1,0,0,"")){_.b("        ");if(_.s(_.f("multiple",c,p,1),c,p,0,321,348,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,327,342,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".multiple_times");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("multiple",c,p,1),c,p,1,0,0,"")){_.b("          ");if(!_.s(_.f("selectedDate",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,417,424,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);_.b("          ");if(_.s(_.f("selectedDate",c,p,1),c,p,0,475,568,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,481,562,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected, \"day\": ");_.b(_.v(_.f("day",c,p,0)));_.b(", \"month\": ");_.b(_.v(_.f("month",c,p,0)));_.b(", \"date\": ");_.b(_.v(_.f("date",c,p,0)));_.b(", \"time\": ");_.b(_.v(_.f("time",c,p,0)));});c.pop();}});c.pop();}_.b("\n");};};_.b("    </span>");_.b("\n" + i);if(_.s(_.f("selectable",c,p,1),c,p,0,658,798,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("      <span class=\"icon-arrow-up-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper {{#disabled}} disabled{{/disabled}}\">\n  <div class=\"dropdown{{#selectable}} selectable{{/selectable}}\">\n    <span class=\"icon-calendar icon\"></span>\n    <span class=\"selection{{#loading}} loading{{/loading}}\">\n      {{#loading}}{{#t}}.loading{{/t}}{{/loading}}\n      {{^loading}}\n        {{#multiple}}{{#t}}.multiple_times{{/t}}{{/multiple}}\n        {{^multiple}}\n          {{^selectedDate}}{{#t}}.select{{/t}}{{/selectedDate}}\n          {{#selectedDate}}{{#t}}.selected, \"day\": {{day}}, \"month\": {{month}}, \"date\": {{date}}, \"time\": {{time}}{{/t}}{{/selectedDate}}\n        {{/multiple}}\n      {{/loading}}\n    </span>\n    {{#selectable}}\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n      <span class=\"icon-arrow-up-large\"></span>\n    </span>\n    {{/selectable}}\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],45:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(!_.s(_.f("error",c,p,1),c,p,1,0,0,"")){_.b("  <form class=\"booking-component\">");_.b("\n" + i);_.b("    <div data-info-content class=\"info\"></div>");_.b("\n" + i);_.b("    <div data-pickers-content class=\"pickers\"></div>");_.b("\n" + i);_.b("    <div data-phone-content class=\"text\"></div>");_.b("\n" + i);_.b("    <div data-question-content class=\"text\"></div>");_.b("\n" + i);_.b("    <div data-book-content class=\"book\"></div>");_.b("\n" + i);_.b("  </form>");_.b("\n");};if(_.s(_.f("error",c,p,1),c,p,0,323,974,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"open\" data-bhw=\"BookingEngineDealBookerError\">");_.b("\n" + i);_.b("    <div class=\"notification error\" data-bhc=\"error:");_.b(_.v(_.f("error",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("errorLoading",c,p,1),c,p,0,472,514,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,487,501,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".error.loading");});c.pop();}_.b("\n");});c.pop();}if(_.s(_.f("errorBooking",c,p,1),c,p,0,555,642,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,570,629,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".error.booking, \"break\": \"<br>\", \"noun\": ");_.b(_.v(_.f("schedulingNoun",c,p,0)));});c.pop();}_.b("\n");});c.pop();}if(_.s(_.f("errorSegmentNotAvailable",c,p,1),c,p,0,695,779,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,710,766,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".error.segment_not_available, \"noun\": ");_.b(_.v(_.f("schedulingNoun",c,p,0)));});c.pop();}_.b("\n");});c.pop();}if(_.s(_.f("errorSegmentExpired",c,p,1),c,p,0,839,929,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,854,916,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".error.segment_expired, \"nounPlural\": ");_.b(_.v(_.f("schedulingNounPlural",c,p,0)));});c.pop();}_.b("\n");});c.pop();}_.b("    </div>");_.b("\n" + i);_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{^error}}\n  <form class=\"booking-component\">\n    <div data-info-content class=\"info\"></div>\n    <div data-pickers-content class=\"pickers\"></div>\n    <div data-phone-content class=\"text\"></div>\n    <div data-question-content class=\"text\"></div>\n    <div data-book-content class=\"book\"></div>\n  </form>\n{{/error}}\n{{#error}}\n  <div class=\"open\" data-bhw=\"BookingEngineDealBookerError\">\n    <div class=\"notification error\" data-bhc=\"error:{{error}}\">\n      {{#errorLoading}}\n        {{#t}}.error.loading{{/t}}\n      {{/errorLoading}}\n      {{#errorBooking}}\n        {{#t}}.error.booking, \"break\": \"<br>\", \"noun\": {{schedulingNoun}}{{/t}}\n      {{/errorBooking}}\n      {{#errorSegmentNotAvailable}}\n        {{#t}}.error.segment_not_available, \"noun\": {{schedulingNoun}}{{/t}}\n      {{/errorSegmentNotAvailable}}\n      {{#errorSegmentExpired}}\n        {{#t}}.error.segment_expired, \"nounPlural\": {{schedulingNounPlural}}{{/t}}\n      {{/errorSegmentExpired}}\n    </div>\n  </div>\n{{/error}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],46:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<span class=\"price-label\">");_.b("\n" + i);if(_.s(_.f("optionSelected",c,p,1),c,p,0,46,67,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,52,61,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".subtotal");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("optionSelected",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,112,117,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".from");});c.pop();}};_.b("\n" + i);_.b("</span>");_.b("\n" + i);_.b("<span class=\"price\">");_.b("\n" + i);_.b(_.v(_.f("price",c,p,0)));_.b("\n" + i);_.b("</span>");_.b("\n");return _.fl();;},"<span class=\"price-label\">\n{{#optionSelected}}{{#t}}.subtotal{{/t}}{{/optionSelected}}\n{{^optionSelected}}{{#t}}.from{{/t}}{{/optionSelected}}\n</span>\n<span class=\"price\">\n{{price}}\n</span>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],47:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"");if(_.s(_.f("isSoldOut",c,p,1),c,p,0,26,34,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("sold-out");});c.pop();}_.b(" ");if(_.s(_.f("selected",c,p,1),c,p,0,62,70,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("selected");});c.pop();}_.b("\" data-bhc=\"booking:deal-option-");_.b(_.v(_.f("optionId",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  <div class=\"description\">");_.b(_.v(_.f("title",c,p,0)));_.b("</div>");_.b("\n" + i);_.b("  <div class=\"price-wrap\">");_.b("\n" + i);if(_.s(_.f("isSoldOut",c,p,1),c,p,0,218,251,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      ");if(_.s(_.f("t",c,p,1),c,p,0,231,240,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".sold_out");});c.pop();}_.b("\n");});c.pop();}if(!_.s(_.f("isSoldOut",c,p,1),c,p,1,0,0,"")){_.b("    <p class=\"option-pricing-wrap\">");_.b("\n" + i);_.b("      <span class=\"option-price ");if(_.s(_.f("isUrgencyPricing",c,p,1),c,p,0,374,391,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" urgency-pricing\"");});c.pop();}_.b("\">");_.b(_.v(_.f("price",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("value",c,p,1),c,p,0,448,516,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        <span class=\"option-price-original\">");_.b(_.v(_.f("value",c,p,0)));_.b("</span>");_.b("\n");});c.pop();}if(_.s(_.f("showDiscount",c,p,1),c,p,0,550,682,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        |");_.b("\n" + i);_.b("        <span class=\"option-discount\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,614,653,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".save_message, \"discount\": ");_.b(_.v(_.f("discount",c,p,0)));});c.pop();}_.b("\n" + i);_.b("        </span>");_.b("\n");});c.pop();}_.b("\n" + i);if(_.s(_.f("showUrgencyPricingMessage",c,p,1),c,p,0,737,835,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        <br>");_.b("\n" + i);_.b("        <span class=\"option-offerlabel urgency-pricing\">");_.b(_.v(_.f("offerLabel",c,p,0)));_.b("</span>");_.b("\n");});c.pop();}_.b("    </p>");_.b("\n" + i);if(_.s(_.f("soldQuantityMessageText",c,p,1),c,p,0,907,985,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <p class=\"option-sold-quantity\">");_.b(_.v(_.f("soldQuantityMessageText",c,p,0)));_.b("\n" + i);_.b("    </p>");_.b("\n");});c.pop();}};_.b("  </div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"{{#isSoldOut}}sold-out{{/isSoldOut}} {{#selected}}selected{{/selected}}\" data-bhc=\"booking:deal-option-{{optionId}}\">\n  <div class=\"description\">{{title}}</div>\n  <div class=\"price-wrap\">\n    {{#isSoldOut}}\n      {{#t}}.sold_out{{/t}}\n    {{/isSoldOut}}\n    {{^isSoldOut}}\n    <p class=\"option-pricing-wrap\">\n      <span class=\"option-price {{#isUrgencyPricing}} urgency-pricing\"{{/isUrgencyPricing}}\">{{price}}</span>\n\n      {{#value}}\n        <span class=\"option-price-original\">{{value}}</span>\n      {{/value}}\n      {{#showDiscount}}\n        |\n        <span class=\"option-discount\">\n        {{#t}}.save_message, \"discount\": {{discount}}{{/t}}\n        </span>\n      {{/showDiscount}}\n\n      {{#showUrgencyPricingMessage}}\n        <br>\n        <span class=\"option-offerlabel urgency-pricing\">{{offerLabel}}</span>\n      {{/showUrgencyPricingMessage}}\n    </p>\n    {{#soldQuantityMessageText}}\n    <p class=\"option-sold-quantity\">{{soldQuantityMessageText}}\n    </p>\n    {{/soldQuantityMessageText}}\n    {{/isSoldOut}}\n  </div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],48:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown");if(_.s(_.f("selectable",c,p,1),c,p,0,59,70,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" selectable");});c.pop();}_.b("\">");_.b("\n" + i);_.b("    <span class=\"icon-tag icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection\">");_.b("\n" + i);_.b("      ");if(!_.s(_.f("selectedOption",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,188,195,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);_.b("      ");if(_.s(_.f("selectedOption",c,p,1),c,p,0,246,255,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.v(_.f("title",c,p,0)));});c.pop();}_.b("\n" + i);_.b("    </span>");_.b("\n" + i);if(_.s(_.f("selectable",c,p,1),c,p,0,306,446,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("      <span class=\"icon-arrow-up-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown{{#selectable}} selectable{{/selectable}}\">\n    <span class=\"icon-tag icon\"></span>\n    <span class=\"selection\">\n      {{^selectedOption}}{{#t}}.select{{/t}}{{/selectedOption}}\n      {{#selectedOption}}{{title}}{{/selectedOption}}\n    </span>\n    {{#selectable}}\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n      <span class=\"icon-arrow-up-large\"></span>\n    </span>\n    {{/selectable}}\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],49:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div");if(_.s(_.f("selected",c,p,1),c,p,0,17,34,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" class=\"selected\"");});c.pop();}_.b(">");_.b("\n" + i);_.b("  ");_.b(_.v(_.f("partySize",c,p,0)));_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div{{#selected}} class=\"selected\"{{/selected}}>\n  {{partySize}}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],50:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper ");if(_.s(_.f("disabled",c,p,1),c,p,0,33,42,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" disabled");});c.pop();}_.b("\">");_.b("\n" + i);_.b("  <div class=\"dropdown");if(_.s(_.f("selectable",c,p,1),c,p,0,95,106,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" selectable");});c.pop();}_.b("\">");_.b("\n" + i);_.b("    <span class=\"icon-user icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection\">");_.b("\n" + i);_.b("      ");if(!_.s(_.f("selectedpartySize",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,228,235,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);if(_.s(_.f("selectedpartySize",c,p,1),c,p,0,292,354,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,307,341,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".partySize, \"count\": ");_.b(_.v(_.f("partySize",c,p,0)));});c.pop();}_.b("\n");});c.pop();}_.b("    </span>");_.b("\n" + i);if(_.s(_.f("selectable",c,p,1),c,p,0,408,548,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("      <span class=\"icon-arrow-up-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper {{#disabled}} disabled{{/disabled}}\">\n  <div class=\"dropdown{{#selectable}} selectable{{/selectable}}\">\n    <span class=\"icon-user icon\"></span>\n    <span class=\"selection\">\n      {{^selectedpartySize}}{{#t}}.select{{/t}}{{/selectedpartySize}}\n      {{#selectedpartySize}}\n        {{#t}}.partySize, \"count\": {{partySize}}{{/t}}\n      {{/selectedpartySize}}\n    </span>\n    {{#selectable}}\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n      <span class=\"icon-arrow-up-large\"></span>\n    </span>\n    {{/selectable}}\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],51:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<ul yield></ul>");_.b("\n");return _.fl();;},"<ul yield></ul>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],52:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper phone-container\">");_.b("\n" + i);_.b("  <span class=\"icon-mobile icon\"></span>");_.b("\n" + i);_.b("  <span class=\"phone-container-inner\">");_.b("\n" + i);_.b("    <input type=\"tel\" name=\"phone\" placeholder=\"");if(_.s(_.f("t",c,p,1),c,p,0,172,196,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".enter_your_phone_number");});c.pop();}_.b("\" autocomplete=\"off\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\" value=\"");_.b(_.v(_.f("customerPhone",c,p,0)));_.b("\" maxlength=\"");_.b(_.v(_.f("maxLength",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  </span>");_.b("\n" + i);_.b("  <span data-bhc=\"");_.b(_.v(_.f("bhcPhone",c,p,0)));_.b("\" class=\"icon-close icon clear\"></span>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper phone-container\">\n  <span class=\"icon-mobile icon\"></span>\n  <span class=\"phone-container-inner\">\n    <input type=\"tel\" name=\"phone\" placeholder=\"{{#t}}.enter_your_phone_number{{/t}}\" autocomplete=\"off\" data-bhc=\"{{bhc}}\" value=\"{{customerPhone}}\" maxlength=\"{{maxLength}}\">\n  </span>\n  <span data-bhc=\"{{bhcPhone}}\" class=\"icon-close icon clear\"></span>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],53:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b(_.v(_.f("notice",c,p,0)));_.b("\n" + i);_.b("<span class=\"arrow\"></span>");_.b("\n");return _.fl();;},"{{notice}}\n<span class=\"arrow\"></span>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],54:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper row\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  <span class=\"icon-pencil icon\">");_.b("\n" + i);_.b("    <svg version=\"1.1\" id=\"pencil-1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"");_.b("\n" + i);_.b("       width=\"15px\" height=\"15px\" viewBox=\"0 0 18 18\" xml:space=\"preserve\">");_.b("\n" + i);_.b("    <path d=\"M9.97,9.063C9.655,9.377,9.104,9.339,8.743,8.978l0,0C8.38,8.615,8.341,8.064,8.656,7.748");_.b("\n" + i);_.b("      l0.926-0.925c0.314-0.316,0.867-0.276,1.229,0.086l0,0c0.362,0.361,0.402,0.912,0.086,1.227L9.97,9.063z M16.753,4.699");_.b("\n" + i);_.b("      c0,0.133-0.053,0.26-0.146,0.354L6.412,15.247c-0.07,0.069-0.16,0.107-0.255,0.127c-0.065,0.102-0.152,0.187-0.271,0.221");_.b("\n" + i);_.b("      l-4.383,1.253c-0.045,0.014-0.091,0.02-0.137,0.02c-0.13,0-0.258-0.051-0.353-0.146c-0.128-0.128-0.177-0.315-0.128-0.49");_.b("\n" + i);_.b("      l1.237-4.388c0.035-0.122,0.122-0.21,0.227-0.275c0.018-0.094,0.055-0.186,0.128-0.259L12.669,1.117");_.b("\n" + i);_.b("      c0.195-0.195,0.512-0.195,0.707,0l3.23,3.229C16.7,4.439,16.753,4.566,16.753,4.699z M4.792,14.867l-1.939-1.933l-0.36,1.278");_.b("\n" + i);_.b("      l1.022,1.02L4.792,14.867z M13.357,6.887l-2.522-2.523l-7.298,7.299l2.522,2.523L13.357,6.887z M15.546,4.699l-2.523-2.522");_.b("\n" + i);_.b("      l-1.48,1.48l2.522,2.523L15.546,4.699z\"/>");_.b("\n" + i);_.b("    </svg>");_.b("\n" + i);_.b("  </span>");_.b("\n" + i);_.b("\n" + i);_.b("  <span class=\"question-ans text-content\">");_.b("\n" + i);_.b("    <span class=\"label\">");_.b(_.v(_.f("question",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("    <input class=\"not-visible focus-from-previous\">");_.b("\n" + i);_.b("    <input class=\"not-visible focus-from-field\">");_.b("\n" + i);_.b("    <textarea name=\"question\" placeholder=\"");if(_.s(_.f("t",c,p,1),c,p,0,1414,1422,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".caption");});c.pop();}_.b("\" autocomplete=\"off\" rows=\"1\" maxlength=\"");_.b(_.v(_.f("maxLength",c,p,0)));_.b("\">");_.b(_.v(_.f("answer",c,p,0)));_.b("</textarea>");_.b("\n" + i);_.b("  </span>");_.b("\n" + i);_.b("  <span data-bhc=\"");_.b(_.v(_.f("bhcNotes",c,p,0)));_.b("\" class=\"icon-close icon clear\"></span>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper row\" data-bhc=\"{{bhc}}\">\n  <span class=\"icon-pencil icon\">\n    <svg version=\"1.1\" id=\"pencil-1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n       width=\"15px\" height=\"15px\" viewBox=\"0 0 18 18\" xml:space=\"preserve\">\n    <path d=\"M9.97,9.063C9.655,9.377,9.104,9.339,8.743,8.978l0,0C8.38,8.615,8.341,8.064,8.656,7.748\n      l0.926-0.925c0.314-0.316,0.867-0.276,1.229,0.086l0,0c0.362,0.361,0.402,0.912,0.086,1.227L9.97,9.063z M16.753,4.699\n      c0,0.133-0.053,0.26-0.146,0.354L6.412,15.247c-0.07,0.069-0.16,0.107-0.255,0.127c-0.065,0.102-0.152,0.187-0.271,0.221\n      l-4.383,1.253c-0.045,0.014-0.091,0.02-0.137,0.02c-0.13,0-0.258-0.051-0.353-0.146c-0.128-0.128-0.177-0.315-0.128-0.49\n      l1.237-4.388c0.035-0.122,0.122-0.21,0.227-0.275c0.018-0.094,0.055-0.186,0.128-0.259L12.669,1.117\n      c0.195-0.195,0.512-0.195,0.707,0l3.23,3.229C16.7,4.439,16.753,4.566,16.753,4.699z M4.792,14.867l-1.939-1.933l-0.36,1.278\n      l1.022,1.02L4.792,14.867z M13.357,6.887l-2.522-2.523l-7.298,7.299l2.522,2.523L13.357,6.887z M15.546,4.699l-2.523-2.522\n      l-1.48,1.48l2.522,2.523L15.546,4.699z\"/>\n    </svg>\n  </span>\n\n  <span class=\"question-ans text-content\">\n    <span class=\"label\">{{question}}</span>\n    <input class=\"not-visible focus-from-previous\">\n    <input class=\"not-visible focus-from-field\">\n    <textarea name=\"question\" placeholder=\"{{#t}}.caption{{/t}}\" autocomplete=\"off\" rows=\"1\" maxlength=\"{{maxLength}}\">{{answer}}</textarea>\n  </span>\n  <span data-bhc=\"{{bhcNotes}}\" class=\"icon-close icon clear\"></span>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],55:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"notification-wrap\">");_.b("\n" + i);_.b("  <input id=\"text-notifications\" type=\"checkbox\" name=\"text_notifications\"");if(_.s(_.f("checked",c,p,1),c,p,0,118,126,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" checked");});c.pop();}_.b(">");_.b("\n" + i);_.b("  <label for=\"text-notifications\">");_.b("\n" + i);_.b("  ");if(_.s(_.f("t",c,p,1),c,p,0,183,191,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".caption");});c.pop();}_.b("\n" + i);_.b("  <a class=\"tooltip-trigger\" data-trigger-event=\"click\" data-tooltip-id=\"");_.b(_.v(_.f("tooltipId",c,p,0)));_.b("\" data-position=\"left\">");if(_.s(_.f("t",c,p,1),c,p,0,313,323,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".whatsthis");});c.pop();}_.b("</a>");_.b("\n" + i);_.b("  </label>");_.b("\n" + i);_.b("</div>");_.b("\n" + i);_.b("<div id=\"");_.b(_.v(_.f("tooltipId",c,p,0)));_.b("\" class=\"tooltip\">");_.b("\n" + i);_.b("  <div class=\"indicator\"></div>");_.b("\n" + i);_.b("  <div class=\"tooltip-content\">");_.b("\n" + i);_.b("    <div class=\"chat\"></div>");_.b("\n" + i);_.b("    <h2>");if(_.s(_.f("t",c,p,1),c,p,0,500,514,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".tooltip.title");});c.pop();}_.b("</h2>");_.b("\n" + i);_.b("    <p>");if(_.s(_.f("t",c,p,1),c,p,0,539,686,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".tooltip.body, \"strong\": \"<strong>\", \"strongClose\": \"</strong>\", \"noun\": ");_.b(_.v(_.f("schedulingNoun",c,p,0)));_.b(", \"nounWithDeterminer\": ");_.b(_.v(_.f("schedulingNounWithDeterminer",c,p,0)));});c.pop();}_.b("</p>");_.b("\n" + i);_.b("    <hr class=\"dotted-border\">");_.b("\n" + i);_.b("    <small>");if(_.s(_.f("t",c,p,1),c,p,0,745,867,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".tooltip.details, \"strong\": \"<strong>\", \"strongClose\": \"</strong>\", \"nounWithDeterminer\": ");_.b(_.v(_.f("schedulingNounWithDeterminer",c,p,0)));});c.pop();}_.b("</small>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"notification-wrap\">\n  <input id=\"text-notifications\" type=\"checkbox\" name=\"text_notifications\"{{#checked}} checked{{/checked}}>\n  <label for=\"text-notifications\">\n  {{#t}}.caption{{/t}}\n  <a class=\"tooltip-trigger\" data-trigger-event=\"click\" data-tooltip-id=\"{{tooltipId}}\" data-position=\"left\">{{#t}}.whatsthis{{/t}}</a>\n  </label>\n</div>\n<div id=\"{{tooltipId}}\" class=\"tooltip\">\n  <div class=\"indicator\"></div>\n  <div class=\"tooltip-content\">\n    <div class=\"chat\"></div>\n    <h2>{{#t}}.tooltip.title{{/t}}</h2>\n    <p>{{#t}}.tooltip.body, \"strong\": \"<strong>\", \"strongClose\": \"</strong>\", \"noun\": {{schedulingNoun}}, \"nounWithDeterminer\": {{schedulingNounWithDeterminer}}{{/t}}</p>\n    <hr class=\"dotted-border\">\n    <small>{{#t}}.tooltip.details, \"strong\": \"<strong>\", \"strongClose\": \"</strong>\", \"nounWithDeterminer\": {{schedulingNounWithDeterminer}}{{/t}}</small>\n  </div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],56:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("time",c,p,1),c,p,0,9,457,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div");if(_.s(_.f("selected",c,p,1),c,p,0,29,46,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" class=\"selected\"");});c.pop();}_.b(">");_.b("\n" + i);if(!_.s(_.f("isRange",c,p,1),c,p,1,0,0,"")){_.b("      ");if(_.s(_.f("t",c,p,1),c,p,0,90,191,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".default, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));});c.pop();}_.b("\n");};if(_.s(_.f("isRange",c,p,1),c,p,0,231,435,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      ");if(_.s(_.f("t",c,p,1),c,p,0,244,424,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".range, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));_.b(", \"toHours\": ");_.b(_.v(_.d("to.hours",c,p,0)));_.b(", \"toMinutes\": ");_.b(_.v(_.d("to.minutes",c,p,0)));_.b(", \"toPeriod\": ");_.b(_.v(_.d("to.period",c,p,0)));});c.pop();}_.b("\n");});c.pop();}_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{#time}}\n  <div{{#selected}} class=\"selected\"{{/selected}}>\n    {{^isRange}}\n      {{#t}}.default, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}{{/t}}\n    {{/isRange}}\n    {{#isRange}}\n      {{#t}}.range, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}, \"toHours\": {{to.hours}}, \"toMinutes\": {{to.minutes}}, \"toPeriod\": {{to.period}}{{/t}}\n    {{/isRange}}\n  </div>\n{{/time}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],57:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<label class=\"time ");if(_.s(_.f("selected",c,p,1),c,p,0,32,40,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("selected");});c.pop();}_.b("\">");_.b("\n" + i);_.b("  <input data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\" type=\"checkbox\" name=\"timevalue\" ");if(_.s(_.f("disabled",c,p,1),c,p,0,130,138,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("disabled");});c.pop();}_.b(">");_.b("\n" + i);_.b("  ");_.b(_.v(_.f("time",c,p,0)));_.b("\n" + i);_.b("</label>");_.b("\n");return _.fl();;},"<label class=\"time {{#selected}}selected{{/selected}}\">\n  <input data-bhc=\"{{bhc}}\" type=\"checkbox\" name=\"timevalue\" {{#disabled}}disabled{{/disabled}}>\n  {{time}}\n</label>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],58:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<ul class=\"time-bubbles");if(_.s(_.f("isMultiWindow",c,p,1),c,p,0,41,53,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" multiwindow");});c.pop();}_.b("\" yield>");_.b("\n" + i);if(_.s(_.f("isMultiWindow",c,p,1),c,p,0,100,350,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <li class=\"time-bubble anytime-bubble\">");_.b("\n" + i);_.b("    <label class=\"time ");if(_.s(_.f("anytimeSelected",c,p,1),c,p,0,186,194,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("selected");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      <input data-bhc=\"");_.b(_.v(_.f("bhcAnytime",c,p,0)));_.b("\" type=\"checkbox\" class=\"anytime\" name=\"timevalue\">");if(_.s(_.f("t",c,p,1),c,p,0,311,320,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".alltimes");});c.pop();}_.b("\n" + i);_.b("    </label>");_.b("\n" + i);_.b("  </li>");_.b("\n");});c.pop();}_.b("</ul>");_.b("\n" + i);_.b("<div yield-empty>");_.b("\n" + i);_.b("  We’re so sorry, there appears to be no times available for this date. Try another.");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<ul class=\"time-bubbles{{#isMultiWindow}} multiwindow{{/isMultiWindow}}\" yield>\n  {{#isMultiWindow}}\n  <li class=\"time-bubble anytime-bubble\">\n    <label class=\"time {{#anytimeSelected}}selected{{/anytimeSelected}}\">\n      <input data-bhc=\"{{bhcAnytime}}\" type=\"checkbox\" class=\"anytime\" name=\"timevalue\">{{#t}}.alltimes{{/t}}\n    </label>\n  </li>\n  {{/isMultiWindow}}\n</ul>\n<div yield-empty>\n  We’re so sorry, there appears to be no times available for this date. Try another.\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],59:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper ");if(_.s(_.f("disabled",c,p,1),c,p,0,33,42,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" disabled");});c.pop();}_.b("\">");_.b("\n" + i);_.b("  <div class=\"dropdown");if(_.s(_.f("selectable",c,p,1),c,p,0,95,106,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" selectable");});c.pop();}_.b("\">");_.b("\n" + i);_.b("    <span class=\"icon-now icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection");if(_.s(_.f("loading",c,p,1),c,p,0,202,210,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" loading");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("loading",c,p,1),c,p,0,243,263,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,249,257,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".loading");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("loading",c,p,1),c,p,1,0,0,"")){if(!_.s(_.f("isRange",c,p,1),c,p,1,0,0,"")){_.b("          ");if(!_.s(_.f("selection",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,346,358,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select_time");});c.pop();}};_.b("\n" + i);_.b("          ");if(_.s(_.f("selection",c,p,1),c,p,0,403,522,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,409,516,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected_time, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));});c.pop();}});c.pop();}_.b("\n");};if(_.s(_.f("isRange",c,p,1),c,p,0,578,891,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          ");if(!_.s(_.f("selection",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,609,622,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select_range");});c.pop();}};_.b("\n" + i);_.b("          ");if(_.s(_.f("selection",c,p,1),c,p,0,667,868,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,673,862,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected_range, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));_.b(", \"toHours\": ");_.b(_.v(_.d("to.hours",c,p,0)));_.b(", \"toMinutes\": ");_.b(_.v(_.d("to.minutes",c,p,0)));_.b(", \"toPeriod\": ");_.b(_.v(_.d("to.period",c,p,0)));});c.pop();}});c.pop();}_.b("\n");});c.pop();}};_.b("    </span>");_.b("\n" + i);if(_.s(_.f("selectable",c,p,1),c,p,0,954,1117,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("      <span data-bhc=\"");_.b(_.v(_.f("bhcTime",c,p,0)));_.b("\" class=\"icon-arrow-up-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper {{#disabled}} disabled{{/disabled}}\">\n  <div class=\"dropdown{{#selectable}} selectable{{/selectable}}\">\n    <span class=\"icon-now icon\"></span>\n    <span class=\"selection{{#loading}} loading{{/loading}}\">\n      {{#loading}}{{#t}}.loading{{/t}}{{/loading}}\n      {{^loading}}\n        {{^isRange}}\n          {{^selection}}{{#t}}.select_time{{/t}}{{/selection}}\n          {{#selection}}{{#t}}.selected_time, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}{{/t}}{{/selection}}\n        {{/isRange}}\n        {{#isRange}}\n          {{^selection}}{{#t}}.select_range{{/t}}{{/selection}}\n          {{#selection}}{{#t}}.selected_range, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}, \"toHours\": {{to.hours}}, \"toMinutes\": {{to.minutes}}, \"toPeriod\": {{to.period}}{{/t}}{{/selection}}\n        {{/isRange}}\n      {{/loading}}\n    </span>\n    {{#selectable}}\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n      <span data-bhc=\"{{bhcTime}}\" class=\"icon-arrow-up-large\"></span>\n    </span>\n    {{/selectable}}\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],60:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<ul yield></ul>");_.b("\n" + i);_.b("<div yield-empty>");_.b("\n" + i);_.b("  We’re so sorry, there appears to be no times available for this date. Try another.");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<ul yield></ul>\n<div yield-empty>\n  We’re so sorry, there appears to be no times available for this date. Try another.\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],61:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"ob-tooltip-content\">");_.b("\n" + i);_.b("  ");if(_.s(_.f("t",c,p,1),c,p,0,41,60,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select_times_note ");});c.pop();}_.b("\n" + i);_.b("</div>");_.b("\n" + i);_.b("<span class=\"ob-tooltip-close\"></span>");_.b("\n" + i);_.b("<div class=\"arrow\"></div>");_.b("\n");return _.fl();;},"<div class=\"ob-tooltip-content\">\n  {{#t}}.select_times_note {{/t}}\n</div>\n<span class=\"ob-tooltip-close\"></span>\n<div class=\"arrow\"></div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],62:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Base = (function(superClass) {
  extend(Base, superClass);

  Base.prototype.module = 'booking';

  function Base(options) {
    this.options = options != null ? options : {};
    _.extend(this, _.pick(this.options, ['templateName', 'module', 'presenter', 'validationHandler']));
    Backbone.View.apply(this, arguments);
    _.bindAll(this, 'beforeRender', 'render', 'afterRender');
    this.render = _.wrap(this.render, (function(_this) {
      return function(render) {
        _this.beforeRender();
        render();
        _this.afterRender();
        return _this;
      };
    })(this));
  }

  Base.prototype.beforeRender = function() {};

  Base.prototype.afterRender = function() {};

  Base.prototype.template = function() {
    if (!this.templateName) {
      throw new Error("View is missing templateName");
    }
    return window.BookingTemplates[this.module + "_frontend_templates_" + this.templateName];
  };

  Base.prototype.getPresenter = function() {
    if (this.presenter) {
      if (this._presenter == null) {
        this._presenter = new this.presenter(this.options, this.templateName);
      }
      return this._presenter;
    }
  };

  Base.prototype.templateAttributes = function() {
    if (this.presenter) {
      return this.getPresenter().toHashWithHelpers();
    } else {
      return this.options;
    }
  };

  Base.prototype.toHtml = function() {
    var errorMessage;
    if (this.template()) {
      return this.template().render(this.templateAttributes());
    } else {
      errorMessage = "Error: Template Not Found (" + this.module + "_frontend_templates_" + this.templateName + ")";
      return "<span style='color:red;'>" + errorMessage + "</span>";
    }
  };

  Base.prototype.render = function() {
    this.$el.html(this.toHtml());
    return this;
  };

  Base.prototype.bhw = function(widget) {
    var ref;
    return (ref = this.$el) != null ? ref.attr('data-bhw', widget) : void 0;
  };

  Base.prototype.bhc = function($el, content) {
    return $el != null ? $el.attr('data-bhc', content) : void 0;
  };

  Base.prototype.translate = function() {
    var i18n;
    i18n = this.getPresenter().getI18n();
    return i18n.translate.apply(i18n, arguments);
  };

  return Base;

})(Backbone.View);



},{}],63:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.presenter = Booking.Presenters.Book;

  Book.prototype.templateName = 'book';

  Book.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "BookButton"
    };
  };

  Book.prototype.setElement = function() {
    Booking.Views.Base.prototype.setElement.apply(this, arguments);
    return this.$el.attr(this.attributes());
  };

  return Book;

})(Booking.Views.Base);



},{}],64:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.presenter = Booking.Presenters.Booker;

  Booker.prototype.className = 'booking-component';

  Booker.prototype.events = {
    'submit form': 'book'
  };

  Booker.prototype.viewClasses = {
    question: Booking.Views.Question,
    phone: Booking.Views.Phone,
    textNotifications: Booking.Views.TextNotifications,
    pickers: Booking.Views.Pickers,
    info: Booking.Views.Info,
    book: Booking.Views.Book,
    partysizepicker: Booking.Views.PartySizePicker,
    datetimepicker: Booking.Views.DateTimePicker,
    optionpicker: Booking.Views.OptionPicker
  };

  function Booker() {
    Booking.Views.Base.apply(this, arguments);
    this.views = {};
    this.listenTo(this.model.getAvailability(), 'error', this.errorLoading);
    this.listenTo(this.model.getReservations(), 'error', this.errorBooking);
    this.bhw(Booking.bhw + "Widget");
    this.listenTo(this.model, 'change:selectedOption', this.renderInfo);
    this.listenTo(this.model, 'change:selectedOption', this.renderPickers);
    this.listenTo(this.model, 'change:selectedOption', this.renderQuestion);
    this.listenTo(this.model, 'change:selectedOption', this.renderPhone);
    this.listenTo(this.model, 'change:selectedOption', this.renderBookButton);
    this.listenTo(this.model, 'change:selectedOption', this.renderTextNotifications);
    this.listenTo(this.model, 'change:selectedTimes', this.renderBookButton);
    this.listenTo(this.model, 'change:selectedPartySize', this.renderBookButton);
    this.listenTo(this.model, 'change:phoneNumber', this.renderBookButton);
    this.listenTo(this.model, 'change:questionsAnswer', this.renderBookButton);
    this.listenTo(this.model, 'change:isBooking', this.renderBookButton);
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.createView({
      name: 'info'
    });
    this.createPickers();
    this.createDrawers();
    this.createView({
      name: 'book'
    });
  }

  Booker.prototype.createDrawers = function() {
    this.createView({
      name: 'phone',
      options: {
        customerPhoneMaxLength: this.options.metasSettings.customerPhoneMaxLength
      },
      events: {
        complete: this.phoneInputComplete
      }
    });
    this.createView({
      name: 'question',
      options: {
        maxLength: this.options.metasSettings.answerMaxLength
      }
    });
    return this.createView({
      name: 'textNotifications',
      events: {
        toggle: this.toggleTextNotifications
      }
    });
  };

  Booker.prototype.createPickers = function() {
    var pickersView;
    pickersView = this.createView({
      name: 'pickers'
    });
    if (this.canRenderOptions()) {
      pickersView.add({
        view: this.viewClasses['optionpicker'],
        model: this.model,
        collection: 'options',
        pickerAttributes: ['selectedOption']
      });
    }
    pickersView.add({
      view: this.viewClasses['partysizepicker'],
      model: this.model,
      collection: 'partySizes',
      pickerAttributes: ['selectedPartySize']
    });
    pickersView.add({
      view: this.viewClasses['datetimepicker'],
      model: this.model,
      collection: 'availability',
      pickerAttributes: ['selectedDate', 'selectedTimes']
    });
    pickersView.on('pickers:collapse', (function(_this) {
      return function() {
        return _this.pickersCollapsed();
      };
    })(this));
    return pickersView.once('pickers:expanded', (function(_this) {
      return function() {
        return _this.trigger('ready');
      };
    })(this));
  };

  Booker.prototype.pickersCollapsed = function() {
    if (this.model.requirePhone() && !this.model.getPhoneNumber()) {
      return this.views['phone'].focus();
    } else if (this.model.requireQuestion() && !this.model.getQuestionsAnswer()) {
      return this.views['question'].focus();
    }
  };

  Booker.prototype.renderInfo = function() {
    return this.renderView('info', this.options.showInfo === true);
  };

  Booker.prototype.renderPickers = function() {
    return this.renderView('pickers');
  };

  Booker.prototype.renderQuestion = function() {
    return this.renderView('question');
  };

  Booker.prototype.renderPhone = function() {
    return this.renderView('phone');
  };

  Booker.prototype.renderTextNotifications = function() {
    return this.renderView('textNotifications');
  };

  Booker.prototype.renderBookButton = function() {
    return this.renderView('book', true);
  };

  Booker.prototype.setOpen = function() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    return this.options.isOpen = true;
  };

  Booker.prototype.setOpenAndLocked = function() {
    this.setOpen();
    return this.options.isLocked = true;
  };

  Booker.prototype.setClosed = function() {
    return this.options.isOpen = false;
  };

  Booker.prototype.open = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-opened", null);
    this.setOpen();
    this.model.reset();
    return this.render({
      fadeIn: true
    });
  };

  Booker.prototype.close = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-closed", null);
    this.setClosed();
    return this.$el.fadeOut((function(_this) {
      return function() {
        _this.render({
          show: true
        });
        if (_this.options.overlapWith) {
          $(_this.options.overlapWith).fadeIn();
        }
        return _this.model.resetOption();
      };
    })(this));
  };

  Booker.prototype.canBeClosed = function() {
    return this.options.isOpen && !this.options.keepOpen;
  };

  Booker.prototype.render = function() {
    var ref, ref1;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (!this.model.getError()) {
      this.renderInfo();
      this.renderPickers();
      this.renderQuestion();
      this.renderPhone();
      this.renderTextNotifications();
      this.renderBookButton();
    }
    if (((ref = arguments[0]) != null ? ref.fadeIn : void 0) === true) {
      this.$el.fadeIn();
    }
    if (((ref1 = arguments[0]) != null ? ref1.show : void 0) === true) {
      this.$el.show();
    }
    this.setOpen();
    return this;
  };

  Booker.prototype.canRenderOptions = function() {
    return this.options.optionSelectable && this.model.hasMultipleOptions();
  };

  Booker.prototype.phoneInputComplete = function() {
    var ref;
    if (this.model.requireQuestion()) {
      return (ref = this.views['question']) != null ? ref.focus() : void 0;
    }
  };

  Booker.prototype.book = function(event) {
    event.stopPropagation();
    this.showInvalidIfNeeded();
    this.model.book();
    return false;
  };

  Booker.prototype.showInvalidIfNeeded = function() {
    var picker, ref, results, view, viewName;
    ref = this.views;
    results = [];
    for (viewName in ref) {
      view = ref[viewName];
      if (viewName === 'pickers') {
        results.push((function() {
          var i, len, ref1, results1;
          ref1 = view.pickers;
          results1 = [];
          for (i = 0, len = ref1.length; i < len; i++) {
            picker = ref1[i];
            if (picker.shouldShowInvalid()) {
              results1.push(picker.showInvalid());
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      } else {
        if (typeof view.showInvalid === 'function') {
          if (view.shouldShowInvalid()) {
            results.push(view.showInvalid());
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
    }
    return results;
  };

  Booker.prototype.errorLoading = function(type) {
    if (type == null) {
      return this.error('loading');
    }
  };

  Booker.prototype.errorBooking = function(reservation) {
    return this.error(reservation.getError());
  };

  Booker.prototype.error = function(error) {
    this.model.setError(error);
    if (this.canBeClosed()) {
      return this.close();
    } else {
      return this.render();
    }
  };

  Booker.prototype.renderView = function(name, force) {
    var view, viewEl;
    if (force == null) {
      force = false;
    }
    view = this.views[name];
    viewEl = this.viewEl(name);
    if (force || view.canRender()) {
      view.setElement(viewEl);
      return view.render();
    } else {
      return viewEl.html('');
    }
  };

  Booker.prototype.viewEl = function(name) {
    return this.$el.find("[data-" + (name.toLowerCase()) + "-content]");
  };

  Booker.prototype.createView = function(arg) {
    var eventCb, eventName, events, name, options;
    name = arg.name, options = arg.options, events = arg.events;
    this.views[name] = new this.viewClasses[name](_.extend({
      el: this.viewEl(name),
      model: this.model
    }, options));
    for (eventName in events) {
      eventCb = events[eventName];
      this.listenTo(this.views[name], eventName, eventCb);
    }
    return this.views[name];
  };

  return Booker;

})(Booking.Views.Base);



},{}],65:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Collection = (function(superClass) {
  extend(Collection, superClass);

  Collection.prototype.containerSelector = '[yield]';

  Collection.prototype.emptyContainerSelector = '[yield-empty]';

  function Collection() {
    Booking.Views.Base.apply(this, arguments);
    this.listenTo(this.collection, 'reset', (function(_this) {
      return function() {
        return _this.render();
      };
    })(this));
    this.listenTo(this.collection, 'sort', (function(_this) {
      return function() {
        return _this.render();
      };
    })(this));
  }

  Collection.prototype.container = function() {
    return this._container(this.containerSelector, this.$el);
  };

  Collection.prototype.emptyContainer = function() {
    return this._container(this.emptyContainerSelector, null);
  };

  Collection.prototype._container = function(selector, defaultElement) {
    var container;
    container = this.$el.find(selector);
    if (container.length) {
      return container;
    } else {
      return defaultElement;
    }
  };

  Collection.prototype.render = function() {
    var i, len, limit, model, models, ref, ref1, ref2;
    if (this.templateName) {
      Booking.Views.Base.prototype.render.apply(this, arguments);
    }
    this.clearContainer();
    models = this.getModels();
    if (models.length > 0) {
      if ((ref = this.emptyContainer()) != null) {
        ref.hide();
      }
      this.container().show();
      limit = Math.min(this.options.limit || models.length, models.length);
      ref1 = models.slice(0, limit);
      for (i = 0, len = ref1.length; i < len; i++) {
        model = ref1[i];
        this.appendChildView(model);
      }
    } else {
      this.container().hide();
      if ((ref2 = this.emptyContainer()) != null) {
        ref2.show();
      }
    }
    return this;
  };

  Collection.prototype.getModels = function() {
    return this.collection.models;
  };

  Collection.prototype.clearContainer = function() {
    return this.container().html('');
  };

  Collection.prototype.appendChildView = function(model) {
    return this.renderChildView('append', model);
  };

  Collection.prototype.renderChildView = function(insert, model) {
    var childView, options;
    options = {
      model: model,
      id: model != null ? model.id : void 0,
      parentModel: this.options.model ? this.options.model : void 0
    };
    childView = new this.childView(_.extend({}, _.omit(this.options, 'el'), options));
    childView.on('all', this.bubbleUpEvent, this);
    this.container()[insert](childView.render().el);
    return this;
  };

  Collection.prototype.bubbleUpEvent = function() {
    return this.trigger.apply(this, arguments);
  };

  return Collection;

})(Booking.Views.Base);



},{}],66:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.presenter = Booking.Presenters.Info;

  Info.prototype.templateName = 'info';

  Info.prototype.canRender = function() {
    return false;
  };

  return Info;

})(Booking.Views.Base);



},{}],67:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Phone = (function(superClass) {
  extend(Phone, superClass);

  Phone.prototype.presenter = Booking.Presenters.Phone;

  Phone.prototype.templateName = 'phone';

  Phone.prototype.maxDigitCount = 10;

  Phone.prototype.events = {
    'keypress input': 'formatPhoneNumber',
    'paste input': 'dismissPasteEvent',
    'keyup input': 'triggerEvents',
    'change input': 'clearable',
    'keydown input': 'clearable',
    'click .clear': 'clear'
  };

  function Phone() {
    Booking.Views.Base.apply(this, arguments);
    this.listenTo(this.model, "phoneNumber:preset", function() {
      if (this.canRender()) {
        return this.render();
      }
    });
  }

  Phone.prototype.canRender = function() {
    return this.model.requirePhone();
  };

  Phone.prototype.render = function() {
    var base;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$input = this.$el.find('input');
    this.input = this.$input.get(0);
    if (typeof (base = this.$input).PlaceholderField === "function") {
      base.PlaceholderField();
    }
    this.clearable();
    return this;
  };

  Phone.prototype.isntDigitOrControlKey = function(charCode) {
    return charCode > 31 && (charCode < 48 || charCode > 57);
  };

  Phone.prototype.formatPhoneNumber = function(e) {
    var digit, length, re, value;
    if (this.isntDigitOrControlKey(e.which)) {
      return false;
    }
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return true;
    }
    value = this.input.value;
    length = (value.replace(/\D/g, '') + digit).length;
    if (length > this.maxDigitCount) {
      e.preventDefault();
      this.input.value = value;
      return;
    }
    if ((this.$input.prop('selectionStart') != null) && this.$input.prop('selectionStart') !== value.length) {
      return;
    }
    re = /^(\d{3}|\d{3}\-\d{3})$/;
    if (re.test(value)) {
      e.preventDefault();
      return this.input.value = value + "-" + digit;
    } else if (re.test(value + digit)) {
      e.preventDefault();
      return this.input.value = "" + value + digit + "-";
    }
  };

  Phone.prototype.isValidLength = function(value) {
    if (value == null) {
      value = '';
    }
    return value.length === this.options.customerPhoneMaxLength;
  };

  Phone.prototype.triggerEvents = function() {
    var event, value;
    value = this.$input.val();
    if (this.isValidLength(value)) {
      event = 'complete';
      if (this.model.setPhoneNumber) {
        this.model.setPhoneNumber(value);
      }
      this.hideInvalid();
    } else {
      event = 'incomplete';
      if (this.model.setPhoneNumber) {
        this.model.setPhoneNumber(void 0);
      }
    }
    return this.trigger(event, value);
  };

  Phone.prototype.dismissPasteEvent = function() {
    return false;
  };

  Phone.prototype.focus = function() {
    return this.input.focus();
  };

  Phone.prototype.clearable = function() {
    var method, ref, ref1;
    method = ((ref = this.input) != null ? (ref1 = ref.value) != null ? ref1.length : void 0 : void 0) ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Phone.prototype.clear = function() {
    this.input.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  Phone.prototype.shouldShowInvalid = function() {
    return !this.isValidLength(this.model.getPhoneNumber());
  };

  Phone.prototype.showInvalid = function() {
    return this.$('.wrapper').addClass('invalid');
  };

  Phone.prototype.hideInvalid = function() {
    return this.$('.wrapper').removeClass('invalid');
  };

  return Phone;

})(Booking.Views.Base);



},{}],68:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Pickers = (function(superClass) {
  extend(Pickers, superClass);

  function Pickers() {
    Booking.Views.Base.apply(this, arguments);
    this.pickers = [];
  }

  Pickers.prototype.add = function(arg) {
    var collection, model, picker, pickerAttributes, view;
    view = arg.view, model = arg.model, collection = arg.collection, pickerAttributes = arg.pickerAttributes;
    picker = new view({
      model: model,
      collection: model.get(collection),
      pickerAttributes: pickerAttributes
    });
    this.pickers.push(picker);
    this.listenTo(picker, 'picker:selected', this.pickerSelected);
    this.listenTo(picker, 'picker:expanded', (function(_this) {
      return function() {
        return _this.trigger('pickers:expanded');
      };
    })(this));
    this.listenTo(picker, 'picker:collapsed', (function(_this) {
      return function() {
        return _this.trigger('pickers:collapsed');
      };
    })(this));
    return picker;
  };

  Pickers.prototype.canRender = function() {
    return true;
  };

  Pickers.prototype.pickerSelected = function(arg) {
    var picker, selection;
    picker = arg.picker, selection = arg.selection;
    picker.hide(true);
    return this.unselectedPickerPromise().done((function(_this) {
      return function(nextPicker) {
        if (nextPicker != null) {
          return nextPicker.show();
        } else {
          return _this.trigger('pickers:collapse');
        }
      };
    })(this));
  };

  Pickers.prototype.render = function() {
    var i, len, picker, ref;
    if (this.pickers.length === 0) {
      return this;
    }
    ref = this.pickers;
    for (i = 0, len = ref.length; i < len; i++) {
      picker = ref[i];
      if (picker.canRender()) {
        this.$el.append(picker.render().el);
        picker.delegateEvents();
      }
    }
    this.unselectedPickerPromise().done((function(_this) {
      return function(picker) {
        if (picker) {
          return picker.show();
        } else if (_this.model.getPartialIntent() === true) {
          return _.last(_this.pickers).show();
        }
      };
    })(this));
    return this;
  };

  Pickers.prototype.unselectedPickerPromise = function() {
    var intervalId, promise, resolveWithPicker;
    promise = $.Deferred();
    resolveWithPicker = (function(_this) {
      return function(promise) {
        var picker;
        picker = _this.firstNotSelected();
        if (picker && !picker.isLoading()) {
          promise.resolve(picker);
          return true;
        } else {
          return false;
        }
      };
    })(this);
    if (!resolveWithPicker(promise)) {
      intervalId = setInterval((function(_this) {
        return function() {
          if (resolveWithPicker(promise)) {
            return clearInterval(intervalId);
          }
        };
      })(this), 50);
    }
    return promise;
  };

  Pickers.prototype.firstNotSelected = function() {
    return _.find(this.pickers, function(picker) {
      return picker.canRender() && !picker.selected();
    });
  };

  Pickers.prototype.nextUnselectedPicker = function() {
    var i, len, picker, ref;
    ref = this.pickers;
    for (i = 0, len = ref.length; i < len; i++) {
      picker = ref[i];
      if (picker.selected()) {
        picker.hideDisable();
      } else {
        return picker;
      }
    }
    return void 0;
  };

  return Pickers;

})(Booking.Views.Base);



},{}],69:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Booking.Views.Question = (function(superClass) {
  extend(Question, superClass);

  Question.prototype.presenter = Booking.Presenters.Question;

  Question.prototype.templateName = 'question';

  Question.prototype.events = {
    'focus .focus-from-previous': 'focus',
    'focus .focus-from-field': 'focusPrevious',
    'click .label': 'focus',
    'blur textarea': 'willBlur',
    'change textarea': 'refreshStatus',
    'keyup textarea': 'refreshStatus',
    'keydown textarea': 'refreshStatus',
    'keypress textarea': 'newText',
    'paste textarea': 'truncatePaste',
    'click .clear': 'clear'
  };

  function Question() {
    Booking.Views.Base.apply(this, arguments);
    this.listenTo(this.model, "questionsAnswer:preset", function() {
      if (this.canRender()) {
        return this.render();
      }
    });
  }

  Question.prototype.canRender = function() {
    return this.model.requireQuestion();
  };

  Question.prototype.render = function() {
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$textarea = this.$el.find('textarea');
    this.textarea = this.$textarea.get(0);
    this.$textarea.autosize();
    this.updateLabel(this.$textarea.val());
    return this.refreshStatus();
  };

  Question.prototype.focus = function() {
    clearTimeout(this.willBlurTimer);
    this.updateLabel();
    this.$el.addClass('expanded');
    $(':focus').blur();
    return this.$textarea.focus();
  };

  Question.prototype.focusPrevious = function() {
    return this.trigger('focusPrevious');
  };

  Question.prototype.willBlur = function() {
    this.trimValue();
    return this.willBlurTimer = setTimeout((function(_this) {
      return function() {
        return _this.blur();
      };
    })(this), 10);
  };

  Question.prototype.blur = function() {
    this.$el.removeClass('expanded');
    this.updateLabel(this.$textarea.val());
    return this.triggerEvents();
  };

  Question.prototype.updateLabel = function(value) {
    if (!value) {
      value = this.model.getQuestion();
    }
    return this.$el.find('.label').html(value);
  };

  Question.prototype.refreshStatus = function() {
    this.clearable();
    return this.triggerEvents();
  };

  Question.prototype.trimValue = function() {
    return this.textarea.value = this.textarea.value.trim();
  };

  Question.prototype.newText = function() {
    var maxLength;
    this.refreshStatus();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      if (this.textarea.value.length >= maxLength) {
        this.textarea.value = this.textarea.value.slice(0, maxLength);
        return false;
      }
    }
  };

  Question.prototype.truncatePaste = function(e) {
    var maxLength, paste;
    this.clearable();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      paste = e.originalEvent.clipboardData.getData('Text');
      if (this.textarea.value.length + paste.length >= maxLength) {
        this.textarea.value += paste.slice(0, maxLength - this.textarea.value.length);
        return false;
      }
    }
  };

  Question.prototype.clearable = function() {
    var method;
    method = this.textarea.value.length ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Question.prototype.clear = function() {
    clearTimeout(this.willBlurTimer);
    this.textarea.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  Question.prototype.triggerEvents = function() {
    var event, value;
    value = this.textarea.value;
    if (value != null ? value.length : void 0) {
      event = 'complete';
      this.hideInvalid();
      this.model.setQuestionsAnswer(value);
    } else {
      event = 'incomplete';
      this.model.setQuestionsAnswer(void 0);
    }
    return this.trigger(event, value);
  };

  Question.prototype.shouldShowInvalid = function() {
    return this.model.needQuestionsAnswers();
  };

  Question.prototype.showInvalid = function() {
    return this.$('.wrapper').addClass('invalid');
  };

  Question.prototype.hideInvalid = function() {
    return this.$('.wrapper').removeClass('invalid');
  };

  return Question;

})(Booking.Views.Base);



},{}],70:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.TextNotifications = (function(superClass) {
  extend(TextNotifications, superClass);

  function TextNotifications() {
    return TextNotifications.__super__.constructor.apply(this, arguments);
  }

  TextNotifications.prototype.presenter = Booking.Presenters.TextNotifications;

  TextNotifications.prototype.templateName = 'text_notifications';

  TextNotifications.prototype.events = {
    'change input[type=checkbox]': 'toggle'
  };

  TextNotifications.prototype.canRender = function() {
    return this.model.requireTextNotifications();
  };

  TextNotifications.prototype.render = function() {
    var ref;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (typeof GIG !== "undefined" && GIG !== null) {
      if ((ref = GIG.Tooltip) != null) {
        ref.reloadBindings(document.body);
      }
    }
    return this;
  };

  TextNotifications.prototype.toggle = function() {
    if (typeof this.model.toggleTextNotifications === 'function') {
      return this.model.toggleTextNotifications();
    }
  };

  return TextNotifications;

})(Booking.Views.Base);



},{}],71:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  Calendar.prototype.presenter = Booking.Presenters.Calendar;

  Calendar.prototype.templateName = 'calendar';

  Calendar.prototype.selectedClass = 'selected';

  Calendar.prototype.previouslySelectedClass = 'previously-selected';

  function Calendar() {
    Booking.Views.Base.apply(this, arguments);
    this.collection.on('sync', this.setEvents, this);
  }

  Calendar.prototype.setEvents = function() {
    var ref;
    if (this.model.isBookerDeal()) {
      return;
    }
    return (ref = this.calendar) != null ? ref.setEvents(this.collection.toJSON()) : void 0;
  };

  Calendar.prototype.render = function() {
    if (this.calendar) {
      this.$el.off();
      this.calendar.bindEvents();
    } else {
      this.calendar = this.$el.clndr(this.CLNDRparams());
    }
    return this;
  };

  Calendar.prototype.selectDate = function(selection) {
    if (selection.events.length > 0 || this.model.isBookerDeal()) {
      this.markDates(selection.date);
      return this.trigger('select', selection.date, this);
    }
  };

  Calendar.prototype.renderCalendar = function(data) {
    var presenter;
    presenter = new this.presenter({
      model: this.model,
      calendarData: data,
      collection: this.collection
    });
    return this.template().render(presenter.toHashWithHelpers());
  };

  Calendar.prototype.CLNDRparams = function() {
    var ref, startWithMonth, timeMomentField;
    timeMomentField = 'clndrTimeMoment';
    startWithMonth = this.model.getSelectedDate() || ((ref = this.collection.first()) != null ? ref.get(timeMomentField) : void 0);
    return {
      showAdjacentMonths: false,
      dateParameter: timeMomentField,
      startWithMonth: startWithMonth,
      timezoneOffset: this.model.getTimezone(),
      events: this.collection.toJSON(),
      render: _.bind(this.renderCalendar, this),
      clickEvents: {
        click: _.bind(this.selectDate, this),
        onMonthChange: _.bind(this.changeMonth, this)
      },
      targets: {
        nextButton: 'next',
        previousButton: 'previous',
        day: 'day',
        empty: 'unavailable'
      }
    };
  };

  Calendar.prototype.changeMonth = function() {
    this.model.resetDate();
    this.fetchAvailabilityIfNeeded();
    return this.markDates(this.model.getSelectedDate());
  };

  Calendar.prototype.fetchAvailabilityIfNeeded = function() {
    if (this.model.isBookerDeal() || this.collection.hasTimesInMonth(this.calendar.month)) {
      return;
    }
    return this.fetchAvailabilityForCurrentMonth();
  };

  Calendar.prototype.fetchAvailabilityForCurrentMonth = function() {
    var alwaysCallback, finalTime, initialTime;
    initialTime = moment(this.calendar.month).startOf('month');
    finalTime = moment(this.calendar.month).endOf('month');
    this.$('.loading').show();
    alwaysCallback = (function(_this) {
      return function() {
        return _this.$('.loading').hide();
      };
    })(this);
    return this.model.fetchAvailability(initialTime, finalTime, false, alwaysCallback);
  };

  Calendar.prototype.afterRender = function() {
    return this.markDates(this.model.getSelectedDate());
  };

  Calendar.prototype.markDates = function(selectedDate) {
    var date, i, len, ref;
    this.unselect();
    if (!this.model.isBookerDeal()) {
      ref = this.collection.getSelectedDates();
      for (i = 0, len = ref.length; i < len; i++) {
        date = ref[i];
        this.markDateAsSelected(date, this.previouslySelectedClass);
      }
    }
    if (selectedDate) {
      return this.markDateAsSelected(selectedDate.format('YYYY-MM-DD'), this.selectedClass);
    }
  };

  Calendar.prototype.markDateAsSelected = function(date, cssClass) {
    return this.calendar.element.find(".calendar-day-" + date).addClass(cssClass);
  };

  Calendar.prototype.unselect = function() {
    this.calendar.element.find("." + this.previouslySelectedClass).removeClass(this.previouslySelectedClass);
    return this.calendar.element.find("." + this.selectedClass).removeClass(this.selectedClass);
  };

  return Calendar;

})(Booking.Views.Base);



},{}],72:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.DateTimePicker = (function(superClass) {
  extend(DateTimePicker, superClass);

  DateTimePicker.prototype.presenter = Booking.Presenters.DateTimePicker;

  DateTimePicker.prototype.templateName = 'datetimepicker';

  DateTimePicker.prototype.viewClasses = {
    calendar: Booking.Views.Calendar,
    times: Booking.Views.TimeBubbles
  };

  DateTimePicker.prototype.styleClassName = 'dates datestimes';

  DateTimePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "Dates"
    };
  };

  function DateTimePicker() {
    Booking.Views.Picker.apply(this, arguments);
    this.createViews();
    this.listenTo(this.model, 'loadingEvent', this.render);
  }

  DateTimePicker.prototype.clearSelection = function() {
    return this.render();
  };

  DateTimePicker.prototype.createViews = function() {
    this.views = {};
    this.createView({
      name: 'calendar',
      options: {
        collection: this.collection
      },
      events: {
        select: this.selectDates,
        calendarRendered: this.calendarRender
      }
    });
    return this.createView({
      name: 'times',
      options: {
        collection: this.collection
      },
      events: {
        select: this.selectTimes
      }
    });
  };

  DateTimePicker.prototype.detachContent = function() {
    this.views['calendar'].$el.detach();
    return this.views['times'].$el.detach();
  };

  DateTimePicker.prototype.attachContent = function() {
    this.views['calendar'].$el.appendTo(this.container());
    return this.views['times'].$el.appendTo(this.container());
  };

  DateTimePicker.prototype.createView = function(arg) {
    var eventCb, eventName, events, name, options;
    name = arg.name, options = arg.options, events = arg.events;
    this.views[name] = new this.viewClasses[name](_.extend({
      model: this.model
    }, options));
    for (eventName in events) {
      eventCb = events[eventName];
      this.listenTo(this.views[name], eventName, eventCb);
    }
    return this.views[name];
  };

  DateTimePicker.prototype.isLoading = function() {
    return this.model.isDateTimeLoading();
  };

  DateTimePicker.prototype.show = function() {
    this.renderContent();
    return Booking.Views.Picker.prototype.show.apply(this, arguments);
  };

  DateTimePicker.prototype.renderContent = function() {
    this.views['calendar'].render();
    this.views['times'].render();
    return this.views['times'].delegateEvents();
  };

  DateTimePicker.prototype.dateSelected = function(date) {
    var end, ref, start;
    if (this.model.isBookerDeal()) {
      this.$('.loading').show();
      ref = Booking.Helpers.getDayRange(date), start = ref.start, end = ref.end;
      return this.model.loadAvailability(start, end).done((function(_this) {
        return function() {
          _this.model.setSelectedTimes([]);
          return _this.views['times'].trigger('picker:date:selected', date);
        };
      })(this)).always((function(_this) {
        return function() {
          return _this.$('.loading').hide();
        };
      })(this));
    } else {
      return this.views['times'].trigger('picker:date:selected', date);
    }
  };

  DateTimePicker.prototype.selectDates = function(date) {
    this.model.selectDate(date);
    this.closeTooltip();
    return this.showHideValidation();
  };

  DateTimePicker.prototype.selectTimes = function(time) {
    var element, selectedTimes, silent, targetType, timebubbles, timetext;
    targetType = '';
    if (!this.tooltip && this.model.isMultiWindow() && !this.anyTimeBubbleSelected()) {
      if (time === null) {
        element = this.$el.find(".calendar-day-" + (this.model.getSelectedDate().format('YYYY-MM-DD')));
        targetType = 'day';
      } else {
        timetext = "" + (time.start().format('h:mm A'));
        timebubbles = this.$el.find(".time-bubble");
        element = $(timebubbles).filter(function(index, item) {
          return $(item).text().replace(/\n/g, '').trim() === timetext;
        });
        targetType = 'bubble';
      }
      this.openTooltip(element, targetType);
    }
    selectedTimes = this.collection.getSelectedTimes();
    this.select(selectedTimes, silent = this.model.isMultiWindow());
    return this.hideInvalid();
  };

  DateTimePicker.prototype.anyTimeBubbleSelected = function() {
    return this.$el.find(".anytime-bubble .time.selected").length;
  };

  DateTimePicker.prototype.prefill = function() {};

  DateTimePicker.prototype.isSelectable = function() {
    if (this.model.isBookerDeal()) {
      return true;
    } else {
      return Booking.Views.Picker.prototype.isSelectable.apply(this, arguments);
    }
  };

  DateTimePicker.prototype.setSelection = function(selection) {
    this.hideNotice();
    return this.model.setSelectedTimes(selection);
  };

  DateTimePicker.prototype.optionSelected = function(attribute) {
    this.render();
    if (attribute === 'selectedDate') {
      return this.dateSelected(this.model.getSelectedDate());
    }
  };

  DateTimePicker.prototype.selected = function() {
    return this.model.getSelectedTimes().length > 0 && !this.notice;
  };

  DateTimePicker.prototype.openTooltip = function(target, targetType) {
    var $target, ref;
    $target = $(target);
    if ((ref = this.tooltip) != null) {
      ref.remove();
    }
    if ($target.length > 0) {
      this.tooltip = new Booking.Views.Tooltip();
      this.$el.find('tbody').append(this.tooltip.render().el);
      return this.tooltip.open($target, targetType);
    }
  };

  DateTimePicker.prototype.closeTooltip = function() {
    var ref;
    return (ref = this.tooltip) != null ? ref.close() : void 0;
  };

  return DateTimePicker;

})(Booking.Views.Picker);



},{}],73:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.TimeBubble = (function(superClass) {
  extend(TimeBubble, superClass);

  TimeBubble.prototype.presenter = Booking.Presenters.TimeBubble;

  TimeBubble.prototype.templateName = 'timebubble';

  TimeBubble.prototype.tagName = 'li';

  TimeBubble.prototype.events = {
    'change input[type=checkbox]': 'select'
  };

  function TimeBubble() {
    Booking.Views.PickerElement.apply(this, arguments);
    this.listenTo(this.model, 'change:selected', this.render);
  }

  TimeBubble.prototype.attributes = function() {
    return {
      'class': 'time-bubble'
    };
  };

  return TimeBubble;

})(Booking.Views.PickerElement);



},{}],74:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.TimeBubbles = (function(superClass) {
  extend(TimeBubbles, superClass);

  TimeBubbles.prototype.presenter = Booking.Presenters.TimeBubbles;

  TimeBubbles.prototype.templateName = 'timebubbles';

  TimeBubbles.prototype.allTimesClass = 'anytime-bubble';

  TimeBubbles.prototype.childView = Booking.Views.TimeBubble;

  TimeBubbles.prototype.events = {
    'change .anytime-bubble input': 'allTimesClicked'
  };

  function TimeBubbles() {
    Booking.Views.PickerCollection.apply(this, arguments);
    this.on('picker:date:selected', (function(_this) {
      return function() {
        return _this.render();
      };
    })(this));
  }

  TimeBubbles.prototype.render = function() {
    var template;
    if (!this.model.getSelectedDate()) {
      this.clearContainer();
      return this;
    }
    Booking.Views.PickerCollection.prototype.render.apply(this, arguments);
    if (this.model.isMultiWindow()) {
      template = this.childView.prototype.template();
      this.container().prepend($("<li class='time-bubble " + this.allTimesClass + "'>").html(template.render({
        bhc: 'input:anytimeBubble',
        selected: false,
        disabled: false,
        time: this.translate('.alltimes')
      })));
      this.toggleAllTimesBubble(this.getSelectedModelsByDate().length === this.getModels().length);
    }
    return this;
  };

  TimeBubbles.prototype.select = function(model) {
    if (!model) {
      return;
    }
    if (this.model.isMultiWindow()) {
      model.toggle();
      if (model.isSelected()) {
        this.toggleAllTimesBubble(this.getSelectedModelsByDate().length === this.getModels().length);
      } else {
        this.toggleAllTimesBubble(false);
      }
    } else {
      this.getSelectedModels().map(function(model) {
        return model.deselect();
      });
      model.select();
    }
    return this.trigger('select', model);
  };

  TimeBubbles.prototype.allTimesBubble = function() {
    return this.$el.find("." + this.allTimesClass);
  };

  TimeBubbles.prototype.toggleAllTimesBubble = function(value) {
    return this.allTimesBubble().find('label').toggleClass('selected', value);
  };

  TimeBubbles.prototype.getModels = function() {
    return this.collection.getTimesByDate(this.model.getSelectedDate());
  };

  TimeBubbles.prototype.getSelectedModels = function() {
    return this.collection.getSelectedTimes();
  };

  TimeBubbles.prototype.getSelectedModelsByDate = function() {
    return this.collection.getSelectedTimesByDate(this.model.getSelectedDate());
  };

  TimeBubbles.prototype.allTimesClicked = function() {
    var allTimesBubbleSelected, method;
    if (!this.model.isMultiWindow()) {
      return false;
    }
    allTimesBubbleSelected = this.allTimesBubble().find('label').hasClass('selected');
    method = allTimesBubbleSelected ? 'deselect' : 'select';
    _.map(this.getModels(), function(model) {
      return model[method]();
    });
    this.toggleAllTimesBubble(!allTimesBubbleSelected);
    this.trigger('select', null);
    return true;
  };

  return TimeBubbles;

})(Booking.Views.PickerCollection);



},{}],75:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.presenter = Booking.Presenters.Option;

  Option.prototype.templateName = 'option';

  Option.prototype.tagName = 'li';

  Option.prototype.select = function() {
    if (this.model.isSoldOut()) {
      return;
    }
    return Booking.Views.PickerElement.prototype.select.apply(this, arguments);
  };

  return Option;

})(Booking.Views.PickerElement);



},{}],76:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.presenter = Booking.Presenters.OptionPicker;

  OptionPicker.prototype.contentView = Booking.Views.Options;

  OptionPicker.prototype.templateName = 'optionpicker';

  OptionPicker.prototype.styleClassName = 'options';

  OptionPicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "DealOptions"
    };
  };

  OptionPicker.prototype.setSelection = function(selection) {
    return this.model.setSelectedOption(selection);
  };

  OptionPicker.prototype.selected = function() {
    return this.model.getSelectedOption();
  };

  return OptionPicker;

})(Booking.Views.Picker);



},{}],77:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Options = (function(superClass) {
  extend(Options, superClass);

  function Options() {
    return Options.__super__.constructor.apply(this, arguments);
  }

  Options.prototype.tagName = 'ul';

  Options.prototype.childView = Booking.Views.Option;

  return Options;

})(Booking.Views.PickerCollection);



},{}],78:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.presenter = Booking.Presenters.PartySize;

  PartySize.prototype.templateName = 'partysize';

  PartySize.prototype.tagName = 'li';

  return PartySize;

})(Booking.Views.PickerElement);



},{}],79:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PartySizePicker = (function(superClass) {
  extend(PartySizePicker, superClass);

  function PartySizePicker() {
    return PartySizePicker.__super__.constructor.apply(this, arguments);
  }

  PartySizePicker.prototype.presenter = Booking.Presenters.PartyPicker;

  PartySizePicker.prototype.contentView = Booking.Views.PartySizes;

  PartySizePicker.prototype.templateName = 'partysizepicker';

  PartySizePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "PartySizes"
    };
  };

  PartySizePicker.prototype.styleClassName = 'party-sizes';

  PartySizePicker.prototype.setSelection = function(partySize) {
    return this.model.setSelectedPartySize(partySize.getPartySize());
  };

  PartySizePicker.prototype.canRender = function() {
    return this.model.requirePartySize();
  };

  PartySizePicker.prototype.selected = function() {
    return this.model.getSelectedPartySize();
  };

  return PartySizePicker;

})(Booking.Views.Picker);



},{}],80:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  function PartySizes() {
    return PartySizes.__super__.constructor.apply(this, arguments);
  }

  PartySizes.prototype.templateName = 'partysizes';

  PartySizes.prototype.childView = Booking.Views.PartySize;

  return PartySizes;

})(Booking.Views.PickerCollection);



},{}],81:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Picker = (function(superClass) {
  extend(Picker, superClass);

  Picker.prototype.templateName = 'picker';

  Picker.prototype.expandedClassName = 'expanded';

  Picker.prototype.collapsedClassName = 'collapsed';

  Picker.prototype.styleClassName = '';

  Picker.prototype.transitionDuration = 300;

  Picker.prototype._valid = true;

  Picker.prototype.events = {
    'click .dropdown': 'toggle'
  };

  Picker.prototype.canRender = function() {
    return true;
  };

  Picker.prototype.className = function() {
    return "picker " + this.collapsedClassName + " " + this.styleClassName;
  };

  function Picker() {
    var attribute, fn, i, len, ref;
    Booking.Views.Base.apply(this, arguments);
    this.listenTo(this.collection, 'reset', (function(_this) {
      return function() {
        return _this.clearSelection();
      };
    })(this));
    this.listenTo(this.collection, 'request', (function(_this) {
      return function() {
        return _this.clearSelection();
      };
    })(this));
    this.listenTo(this.collection, 'error', (function(_this) {
      return function(error) {
        return _this.showNotice(error);
      };
    })(this));
    ref = this.options.pickerAttributes || [];
    fn = (function(_this) {
      return function(attribute) {
        return _this.listenTo(_this.model, "change:" + attribute, function() {
          return _this.optionSelected(attribute);
        });
      };
    })(this);
    for (i = 0, len = ref.length; i < len; i++) {
      attribute = ref[i];
      fn(attribute);
    }
  }

  Picker.prototype.optionSelected = function(attribute) {
    this.content().render();
    return this.render();
  };

  Picker.prototype.detachContent = function() {
    return this.content().$el.detach();
  };

  Picker.prototype.attachContent = function() {
    this.content().$el.appendTo(this.container());
    return this.content().delegateEvents();
  };

  Picker.prototype.render = function() {
    this.detachContent();
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.attachContent();
    this.prefill();
    return this;
  };

  Picker.prototype.prefill = function() {
    if (!this.isSelectable() && this.collection.first()) {
      return this.setSelection(this.collection.first());
    }
  };

  Picker.prototype.setSelection = function(selection) {
    throw new Error('Should implement setSelection');
  };

  Picker.prototype.select = function(selection, silent) {
    if (silent == null) {
      silent = false;
    }
    this.setSelection(selection);
    if (!silent) {
      this.trigger('picker:selected', {
        picker: this,
        selection: selection
      });
    }
    return this.hideInvalid();
  };

  Picker.prototype.selected = function() {
    throw new Error('Should implement selected');
  };

  Picker.prototype.isLoading = function() {
    return false;
  };

  Picker.prototype.show = function() {
    var transitionEndHandler;
    if (this.isVisible()) {
      return false;
    }
    this.hideDisable();
    this.redraw();
    this.trigger('picker:expand', {
      picker: this
    });
    transitionEndHandler = (function(_this) {
      return function() {
        return _this.trigger('picker:expanded', {
          picker: _this
        });
      };
    })(this);
    setTimeout(transitionEndHandler, this.transitionDuration);
    this.$el.removeClass(this.collapsedClassName).addClass(this.expandedClassName);
    this.showHideValidation();
    return true;
  };

  Picker.prototype.hide = function(force) {
    var transitionEndHandler;
    if (!this.isVisible()) {
      return false;
    }
    this.redraw();
    this.trigger('picker:collapse', {
      picker: this
    });
    transitionEndHandler = (function(_this) {
      return function() {
        _this.trigger('picker:collapsed', {
          picker: _this
        });
        return _this.$el.addClass(_this.collapsedClassName);
      };
    })(this);
    setTimeout(transitionEndHandler, this.transitionDuration);
    this.$el.removeClass(this.expandedClassName);
    return true;
  };

  Picker.prototype.toggle = function() {
    if (this.isSelectable()) {
      if (this.isVisible()) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  };

  Picker.prototype.hideNotice = function() {
    if (!this.notice) {
      return;
    }
    this.notice.remove();
    return this.notice = void 0;
  };

  Picker.prototype.showNotice = function(notice) {
    var ref;
    if ((ref = this.notice) != null) {
      ref.remove();
    }
    this.notice = new Booking.Views.PickerNotice({
      notice: notice
    });
    this.container().prepend(this.notice.render().el);
    return this.notice.open();
  };

  Picker.prototype.clearSelection = function() {
    return this.content().render();
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1;
  };

  Picker.prototype.content = function() {
    if (!this._content) {
      this._content = new this.contentView({
        collection: this.collection,
        model: this.model
      });
      this.listenTo(this._content, 'picker:select', this.select);
      this._content.render();
    }
    return this._content;
  };

  Picker.prototype.isVisible = function() {
    return this.$el.hasClass(this.expandedClassName);
  };

  Picker.prototype.isValid = function() {
    return this._valid;
  };

  Picker.prototype.showInvalid = function() {
    this._valid = false;
    return this.$('.wrapper').addClass('invalid');
  };

  Picker.prototype.hideInvalid = function() {
    this._valid = true;
    return this.$('.wrapper').removeClass('invalid');
  };

  Picker.prototype.showHideValidation = function() {
    if (this.isValid()) {
      return this.hideInvalid();
    } else {
      return this.showInvalid();
    }
  };

  Picker.prototype.shouldShowInvalid = function() {
    return !this.selected();
  };

  Picker.prototype.container = function() {
    return this.$el.find('.content');
  };

  Picker.prototype.showDisable = function() {
    return this.$('.wrapper').addClass('disabled');
  };

  Picker.prototype.hideDisable = function() {
    return this.$('.wrapper').removeClass('disabled');
  };

  Picker.prototype.redraw = function() {
    return this.$el.get(0).offsetHeight;
  };

  return Picker;

})(Booking.Views.Base);



},{}],82:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PickerCollection = (function(superClass) {
  extend(PickerCollection, superClass);

  function PickerCollection() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('picker:element:select', this.select, this);
  }

  PickerCollection.prototype.select = function(selection) {
    return this.trigger('picker:select', selection);
  };

  return PickerCollection;

})(Booking.Views.Collection);



},{}],83:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PickerElement = (function(superClass) {
  extend(PickerElement, superClass);

  PickerElement.prototype.events = {
    'click': 'select'
  };

  function PickerElement() {
    Booking.Views.Base.apply(this, arguments);
  }

  PickerElement.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  PickerElement.prototype.select = function() {
    return this.trigger('picker:element:select', this.model);
  };

  return PickerElement;

})(Booking.Views.Base);



},{}],84:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.PickerNotice = (function(superClass) {
  extend(PickerNotice, superClass);

  function PickerNotice() {
    return PickerNotice.__super__.constructor.apply(this, arguments);
  }

  PickerNotice.prototype.presenter = Booking.Presenters.PickerNotice;

  PickerNotice.prototype.templateName = 'picker_notice';

  PickerNotice.prototype.className = 'notice';

  PickerNotice.prototype.open = function() {
    return this.$el.show();
  };

  PickerNotice.prototype.close = function() {
    return this.$el.remove();
  };

  return PickerNotice;

})(Booking.Views.Base);



},{}],85:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Booking.Views.Tooltip = (function(superClass) {
  extend(Tooltip, superClass);

  function Tooltip() {
    return Tooltip.__super__.constructor.apply(this, arguments);
  }

  Tooltip.prototype.presenter = Booking.Presenters.Base;

  Tooltip.prototype.templateName = 'tooltip';

  Tooltip.prototype.className = 'ob-tooltip';

  Tooltip.prototype.events = {
    'click': 'close'
  };

  Tooltip.prototype.open = function($target, targetType) {
    this.setPosition($target, targetType);
    return this.$el.show();
  };

  Tooltip.prototype.close = function() {
    return this.$el.remove();
  };

  Tooltip.prototype.setPosition = function($target, targetType) {
    var DEFAULT_VERTICALOFFSET, TOP_ARROW_VERTICALOFFSET, isDefaultType, padding, top, type;
    top = $target.position().top;
    type = this.getTypeOfTooltip(top);
    isDefaultType = type === 'default';
    DEFAULT_VERTICALOFFSET = targetType === 'day' ? 12 : 42;
    TOP_ARROW_VERTICALOFFSET = 11;
    this.setArrowPosition($target, type);
    padding = isDefaultType ? -this.$el.height() - DEFAULT_VERTICALOFFSET : $target.height() + TOP_ARROW_VERTICALOFFSET;
    top = top + padding;
    return this.$el.css('top', top);
  };

  Tooltip.prototype.setArrowPosition = function($target, type) {
    var position, width;
    position = $target.position();
    width = $target.width();
    this.$el.find('.arrow').css('left', position.left + width / 2);
    return this.$el.addClass(type);
  };

  Tooltip.prototype.getTypeOfTooltip = function(top) {
    var type;
    switch (false) {
      case !(top < 123):
        return type = 'top-arrow';
      default:
        return type = 'default';
    }
  };

  return Tooltip;

})(Booking.Views.Base);



},{}],86:[function(require,module,exports){
var BuyButton, MagicEventBus, resetMultiOptionLink;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

MagicEventBus = require('magic-event-bus/lib/frizzle.js');

BuyButton.View = require('./views/buy_button');

resetMultiOptionLink = function() {
  return $(window).on('pageshow', function() {
    var $buyLink, $wrapper;
    if ($('.multi-option-breakout').length) {
      $wrapper = '.multi-option-breakout';
      $buyLink = $('#buy-link').attr('href');
    } else {
      $wrapper = '#options';
      $buyLink = $('#options a.buy-button').attr('href');
    }
    return $($wrapper + ' input[value="' + $buyLink + '"]').prop('checked', true);
  });
};

BuyButton.init = function(arg, done) {
  var buyButton, handleBuyButton, iframeLogin;
  buyButton = arg.buyButton, iframeLogin = arg.iframeLogin;
  this.eventBus = new MagicEventBus();
  if ((iframeLogin != null) && !iframeLogin.authenticated && !iframeLogin.disabledOnBuyButton) {
    handleBuyButton = function() {
      IframeLogin.openModal(BuyButton.view.$buyButton.attr('href'));
      return {
        stopTheBus: true
      };
    };
    this.eventBus.board('buy_button_clicked', handleBuyButton)(999);
  }
  return $((function(_this) {
    return function() {
      if (buyButton.multiOptionEnabled) {
        resetMultiOptionLink();
      }
      _this.view = new BuyButton.View({
        multiOptionEnabled: buyButton.multiOptionEnabled,
        multiOptionInline: buyButton.multiOptionInline
      });
      return done();
    };
  })(this));
};

module.exports = BuyButton;



},{"./views/buy_button":88,"magic-event-bus/lib/frizzle.js":250}],87:[function(require,module,exports){
var GIFT_MODAL_OFFSET, Gift, MODAL_OFFSET, OFFERS_MODAL_OFFSET, TABLET_MQ_WIDTH;

Gift = require('../../gift_button/frontend/gift');

MODAL_OFFSET = {
  left: 112,
  top: -130
};

GIFT_MODAL_OFFSET = {
  left: 60,
  top: -145
};

OFFERS_MODAL_OFFSET = {
  left: 136,
  top: -118
};

TABLET_MQ_WIDTH = 768;

if (window.MultiOptionModal == null) {
  window.MultiOptionModal = {};
}

MultiOptionModal.init = function(payload, done) {
  var openMultiOptionModal;
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : void 0)) {
    return done();
  }
  openMultiOptionModal = function(e) {
    var $modal, $otherTooltip, $tooltipTrigger, firstAvailableOption, modalSelector;
    if (e != null) {
      e.preventDefault();
    }
    modalSelector = BuyButton.view.offersClicked ? '#offer-options' : '#options';
    $modal = $(modalSelector);
    if (!$modal.length) {
      return;
    }
    if ($modal.hasClass('tooltip')) {
      $otherTooltip = modalSelector === '#options' ? $('#offer-options') : $('#options');
      if ($otherTooltip.is(':visible')) {
        $otherTooltip.find('.tooltip-close').click();
      }
      $tooltipTrigger = (e != null ? e.delegateTarget : void 0) ? $(e.delegateTarget) : BuyButton.view.offersClicked ? $('.offer-buy-button') : Gift.cookieCreated ? $('.gift-button') : $('.buy-button');
      $tooltipTrigger.attr({
        'data-position': 'bottom',
        'data-tooltip-id': modalSelector.slice(1),
        'data-trigger-event': 'js-trigger'
      });
      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom');
      GIG.Tooltip.helpers.tooltip.apply($tooltipTrigger[0], [
        {
          preventDefault: function() {}
        }
      ]);
    } else {
      if ($modal.hasClass('show-modal')) {
        return;
      }
      if ($(".header-row-sticky").is(":visible") && !payload.buyButton.multiOptionInline) {
        return;
      }
      if (!BuyButton.view.$multiOptions.filter('.selected').length) {
        firstAvailableOption = BuyButton.view.$multiOptions.not(function(i, el) {
          return $(el).parents('.multi-option-overlay-item-disabled').length;
        })[0];
        BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: firstAvailableOption
        });
      }
      GIG.Modal.open({
        el: $modal
      });
    }
    return {
      stopTheBus: true
    };
  };
  if (payload.buyButton.multiOptionInline) {
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998);
  }
  return $(function() {
    var $body, $tooltipCloser, $triggers;
    $triggers = $(".show-multi-option-modal");
    $triggers.click(openMultiOptionModal);
    $body = $(document.body);
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    GIG.Modal.onClose(Gift.removeCookie, 'options');
    GIG.Modal.onClose(Gift.removeCookie, 'offer-options');
    $('#options, #offer-options').on('click', '.tooltip-close', Gift.removeCookie);
    return done();
  });
};

module.exports = MultiOptionModal;



},{"../../gift_button/frontend/gift":109}],88:[function(require,module,exports){
var BuyButton, DealEventPipe;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

BuyButton.View = Backbone.View.extend({
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster",
  events: {
    "click a.buy-button:not(.external-buy)": "buyButtonClicked",
    "click .view-options a": "viewAllOptions",
    "click a.offer-buy-button": "offersBuyButtonClicked",
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton",
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton"
  },
  initialize: function(arg) {
    var multiOptionEnabled, multiOptionInline, processLink;
    multiOptionEnabled = arg.multiOptionEnabled, multiOptionInline = arg.multiOptionInline;
    this.$buyContainer = this.$(".buy");
    this.$buyButton = this.$("a.buy-button");
    this.$offersBuyButton = this.$("a.offer-buy-button");
    this.$dealHeroPrice = this.$("#deal-hero-price, .multi-option-overlay-cluster-price");
    this.$mainBtnPrice = this.$("#main-button-formatted-price");
    this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price");
    this.$priceLabel = this.$(".price-label, .multi-option-overlay-cluster-price-label");
    this.$value = this.$("#discount-value, .discount-value");
    this.$smallPrice = this.$('.price-small, .discount-value');
    this.$multiOptionBreakout = this.$('.multi-option-breakout, .modal-body');
    this.$multiOptionOverlay = this.$el.filter('.multi-option-overlay');
    this.$multiOptions = this.$('.multi-option-breakout input, .multi-option-overlay-item input');
    this.$buyButtonLoader = this.$buyButton.siblings('.order-processing-loader');
    this.$finePrintDesc = $(".fine-print-description");
    this.$headerTitles = $(".header-title-item");
    this.$headerUrgencyPrice = $(".header-urgency-pricing");
    this.$headerOptions = $(".header-options");
    if (this.$multiOptionOverlay.length) {
      this.$discountPercent = this.$('#discount-percent, .discount-percent');
      this.$discountYouSave = this.$('#discount-you-save, .discount-you-save');
      this.$qtyBought = this.$('.qty-bought');
      this.$dealStatus = this.$('.deal-status');
      this.fixPossiblePriceOverflow();
    }
    this.hasBeenClicked = false;
    this.variationsSelected = false;
    this.multiOptionEnabled = multiOptionEnabled;
    this.multiOptionInline = multiOptionInline;
    if (this.multiOptionInline) {
      this.restoreOptionSelection();
    }
    processLink = (function(_this) {
      return function() {
        return _this.processLink();
      };
    })(this);
    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000);
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        _this.variationsSelected = priceData.variationsSelected;
        _this.$buyButton.removeClass("login-disabled");
        _this.updatePrice(priceData);
        _this.updateValue(priceData);
        return _this.updateBuyButton(priceData);
      };
    })(this));
  },
  buyButtonClicked: function(e) {
    this.offersClicked = false;
    this.giftButtonClicked = false;
    e.preventDefault();
    return BuyButton.eventBus.go('buy_button_clicked', e);
  },
  offersBuyButtonClicked: function(e) {
    this.offersClicked = true;
    this.giftButtonClicked = false;
    e.preventDefault();
    return BuyButton.eventBus.go('buy_button_clicked', e);
  },
  shouldShowPriceInTwoRows: function() {
    var includeMargin;
    includeMargin = true;
    return this.$priceBox.outerWidth(includeMargin) + this.$smallPrice.outerWidth(includeMargin) > this.$dealHeroPrice.outerWidth(includeMargin);
  },
  setPriceWithSale: function(newPrice, regularPrice) {
    this.$priceBox.text(newPrice);
    this.$priceBox.after("<span class='price-small'>" + regularPrice + "</span>");
    this.$smallPrice = this.$dealHeroPrice.find('.price-small');
    return this.fixPossiblePriceOverflow();
  },
  setOfferLabel: function(offerLabel) {
    if (!offerLabel) {
      return;
    }
    offerLabel = "<span class='urgency-pricing-label'>" + offerLabel + "</span>";
    if (this.$headerUrgencyPrice.length) {
      return this.$headerUrgencyPrice.append(offerLabel);
    } else {
      return this.$dealHeroPrice.append(offerLabel);
    }
  },
  cleanPriceBox: function() {
    this.$priceBox.removeClass('two-rows');
    this.$dealHeroPrice.find('.price-small').remove();
    this.$dealHeroPrice.removeClass('urgency-pricing');
    return this.$('.urgency-pricing-label').remove();
  },
  setPriceBox: function(price, sale) {
    var ref;
    this.cleanPriceBox();
    if ((sale != null ? sale.urgencyPricing : void 0) != null) {
      this.$dealHeroPrice.addClass('urgency-pricing');
      this.setPriceWithSale(sale.urgencyPricing.newPrice, sale.urgencyPricing.regularPrice);
      return this.setOfferLabel((ref = sale.urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0);
    } else if ((sale != null ? sale.offer : void 0) != null) {
      this.$mainBtnPrice.text(sale.offer.formattedNewPrice);
      return this.setPriceWithSale(sale.offer.formattedOldPrice, sale.offer.formattedValue);
    } else {
      return this.$priceBox.text(price);
    }
  },
  updatePrice: function(arg) {
    var lengthClass, price, sale, variationsSelected;
    variationsSelected = arg.variationsSelected, price = arg.price, sale = arg.sale, lengthClass = arg.lengthClass;
    if (this.currentPriceClass) {
      this.$buyContainer.removeClass(this.currentPriceClass);
    }
    if (lengthClass) {
      this.$buyContainer.addClass(lengthClass);
    }
    this.setPriceBox(price, sale);
    this.currentPriceClass = lengthClass;
    if (variationsSelected) {
      return this.$priceLabel.hide();
    } else {
      return this.$priceLabel.show();
    }
  },
  updateValue: function(arg) {
    var hideOriginalPriceAndDiscount, value;
    value = arg.value, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    return this.$value.html(hideOriginalPriceAndDiscount ? "" : value);
  },
  updateBuyButton: function(arg) {
    var buyUrl, sale, variationsSelected;
    variationsSelected = arg.variationsSelected, buyUrl = arg.buyUrl, sale = arg.sale;
    if (variationsSelected) {
      this.$buyButton.attr("href", buyUrl);
      if ((sale != null ? sale.offer : void 0) != null) {
        return this.$offersBuyButton.attr("href", sale.offer.buyUrl);
      }
    }
  },
  disableBuyButton: function() {
    this.hasBeenClicked = true;
    this.$buyButton.removeClass("state-buy");
    this.$offersBuyButton.removeClass("state-buy");
    this.$buyButton.addClass("state-disabled");
    this.$offersBuyButton.addClass("state-disabled");
    this.$headerOptions.fadeOut();
    return this.$buyButtonLoader.show();
  },
  enableBuyButton: function() {
    this.hasBeenClicked = false;
    this.$buyButton.removeClass("state-disabled");
    this.$offersBuyButton.removeClass("state-disabled");
    this.$buyButton.addClass("state-buy");
    this.$offersBuyButton.addClass("state-buy");
    this.$headerOptions.fadeIn();
    return this.$buyButtonLoader.hide();
  },
  processLink: function() {
    var button;
    if (!this.hasBeenClicked) {
      button = this.offersClicked ? this.$offersBuyButton : this.$buyButton;
      window.location = button.attr("href");
    }
    return this.disableBuyButton();
  },
  updateMultiOptionBreakoutButton: function(e) {
    var $option, offerLabel, value;
    $option = this.$multiOptions.filter(e.currentTarget);
    if (!$option.length || $option.hasClass('selected')) {
      return;
    }
    this.$multiOptions.removeClass('selected');
    $option.addClass('selected');
    value = $option.val();
    this.$buyButton.attr('href', value);
    if (this.$multiOptionOverlay.length) {
      this.updateClusterOptionPrice($option);
      this.syncDealOptions($option);
      this.cleanPriceBox();
      offerLabel = $option.attr('data-offer-label');
      this.setOfferLabel(offerLabel);
      if (offerLabel) {
        this.$dealHeroPrice.addClass('urgency-pricing');
      }
      this.fixPossiblePriceOverflow();
    } else {
      this.updateHeaderPrice($option);
    }
    this.updateHeaderTitle($option);
    if ($option.parent('a').length) {
      return BuyButton.eventBus.go('buy_button_clicked', e);
    }
  },
  updateHeaderPrice: function($option) {
    var formattedPrice, formattedValue;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    this.$priceBox.text(formattedPrice);
    return this.$smallPrice.text(formattedValue);
  },
  updateHeaderTitle: function($option) {
    var breakoutOptionID, selectedTitle, targetTitleId;
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    this.$headerTitles.removeClass('checked');
    targetTitleId = "#header-title-" + breakoutOptionID;
    selectedTitle = this.$headerTitles.filter(targetTitleId);
    return selectedTitle.addClass('checked');
  },
  updateClusterOptionPrice: function($option) {
    var breakoutOptionID, finePrintDesc, formattedPrice, formattedValue, offerLabel, soldMessage;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    offerLabel = $option.attr('data-offer-label') || '';
    soldMessage = $option.attr('data-sold-message') || '';
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    finePrintDesc = $option.attr('data-description') || '';
    this.$priceBox.text(formattedPrice);
    this.$smallPrice.text(formattedValue);
    this.fixPossiblePriceOverflow();
    this.updateClusterOptionDiscount($option);
    this.$('.urgency-pricing-label').text(offerLabel);
    this.updateUrgencyPricingMetaData(offerLabel, breakoutOptionID);
    if (soldMessage.length) {
      this.$qtyBought.text(soldMessage);
      this.$dealStatus.show();
    } else {
      this.$dealStatus.hide();
    }
    return this.updateFinePrint(finePrintDesc);
  },
  updateClusterOptionDiscount: function($option) {
    var discountPercentage, savings;
    discountPercentage = $option.attr('data-discount-percentage') || '';
    savings = $option.attr('data-savings') || '';
    if (discountPercentage) {
      this.$discountPercent.text(discountPercentage);
      this.$discountYouSave.text(savings);
      return $('.deal-discount').show();
    } else {
      return $('.deal-discount').hide();
    }
  },
  updateUrgencyPricingMetaData: function(offerLabel, breakoutOptionID) {
    if (offerLabel) {
      this.$dealHeroPrice.addClass('urgency-pricing');
      this.$dealHeroPrice.addClass('tooltip-trigger');
      this.$dealHeroPrice.attr('data-bhw', 'UrgencyPrice');
      this.$dealHeroPrice.attr('data-tooltip-id', "urgency-pricing-tooltip-" + breakoutOptionID);
      return this.$dealHeroPrice.attr('data-position', "left");
    } else {
      this.$dealHeroPrice.removeClass('urgency-pricing');
      this.$dealHeroPrice.removeClass('tooltip-trigger');
      this.$dealHeroPrice.removeAttr('data-bhw');
      this.$dealHeroPrice.removeAttr('data-tooltip-id');
      return this.$dealHeroPrice.removeAttr('data-position');
    }
  },
  fixPossiblePriceOverflow: function() {
    this.$priceBox.removeClass('two-rows');
    this.$smallPrice.removeClass('two-rows');
    if (this.shouldShowPriceInTwoRows()) {
      this.$priceBox.addClass('two-rows');
      return this.$smallPrice.addClass('two-rows');
    }
  },
  viewAllOptions: function(e) {
    e.preventDefault();
    return BuyButton.eventBus.go('view_options_clicked', e);
  },
  restoreOptionSelection: function() {
    return this.$el.find('.multi-option-breakout li input:first').trigger('click');
  },
  syncDealOptions: function($option) {
    var breakoutOptionId, optionId;
    optionId = $option.attr('id');
    if (optionId.indexOf('overlay') !== -1) {
      breakoutOptionId = "#" + (this.getPurchaseClusterOptionId(optionId));
      this.reorderDealOptions(breakoutOptionId);
    } else {
      breakoutOptionId = "#overlay-" + optionId;
    }
    return $(breakoutOptionId).prop('checked', true);
  },
  getPurchaseClusterOptionId: function(optionId) {
    if (optionId == null) {
      return '';
    }
    return optionId.replace('overlay-', '');
  },
  reorderDealOptions: function(breakoutOptionId) {
    var $optionElem;
    $optionElem = $(breakoutOptionId).parents('li');
    if ($optionElem.is(':visible')) {
      return;
    }
    $optionElem.insertBefore($optionElem.siblings('li').first());
    $optionElem.parent().find('li:visible:last').hide();
    return $optionElem.show();
  },
  updateFinePrint: function(finePrintDesc) {
    var $body, finePrintLines, tempLines;
    if (!(finePrintDesc != null ? finePrintDesc.length : void 0)) {
      return;
    }
    $body = $(document.body);
    if ($body.hasClass('getaways') || $body.hasClass('getaways-booking')) {
      finePrintLines = (typeof I18n !== "undefined" && I18n !== null ? I18n.country : void 0) === "US" ? (tempLines = _.filter(finePrintDesc.split(". "), function(line) {
        return line.replace(/<[^>]*>/g, '').trim().length > 0;
      }), tempLines = _.map(tempLines, function(line) {
        return "<li class='fine-print-description'>" + line + "</li>";
      }), tempLines.join('')) : "<span class='fine-print-description'>" + (finePrintDesc.replace(/\n/g, '<br/>')) + "</span>";
      $(finePrintLines).insertBefore(this.$finePrintDesc.first());
      this.$finePrintDesc.remove();
      return this.$finePrintDesc = $('.fine-print-description');
    } else {
      return this.$finePrintDesc.html(finePrintDesc);
    }
  }
});

module.exports = BuyButton.View;



},{"../../../deal/frontend/event_pipe":94}],89:[function(require,module,exports){
var generateCartUrl;

generateCartUrl = function(optionuuid, dealuuid) {
  return "/cart/add/" + optionuuid + "?deal_id=" + dealuuid;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.Cart == null) {
    window.Cart = {};
  }
  if (Cart.Helpers == null) {
    Cart.Helpers = {};
  }
  Cart.Helpers.generateCartUrl = generateCartUrl;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    generateCartUrl: generateCartUrl
  };
}



},{}],90:[function(require,module,exports){
var TUTORIAL_SHOWN_COOKIE_NAME, TWENTY_YEARS_IN_SEC;

TWENTY_YEARS_IN_SEC = 630720000;

TUTORIAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-shown';

if (window.CashBack == null) {
  window.CashBack = {};
}

CashBack.init = function(payload, done) {
  return $(function() {
    var $tooltipCloser, cashBack, cookieDomain, tooltipDelay, tutorialLauncher;
    cashBack = payload.cashBack, cookieDomain = payload.cookieDomain;
    if (cashBack != null ? cashBack.showTutorialOnLoad : void 0) {
      tooltipDelay = $('#ls-in-app-messages:not(.hide)').length ? (cashBack != null ? cashBack.tooltipDelay : void 0) || 2000 : 0;
      tutorialLauncher = function() {
        return CashBack.showTutorial(cookieDomain);
      };
      setTimeout(tutorialLauncher, tooltipDelay);
    }
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    return done();
  });
};

CashBack.showTutorial = function(cookieDomain) {
  var $tooltip, $trigger, onTooltipClose;
  if (Cookie.get(TUTORIAL_SHOWN_COOKIE_NAME)) {
    return;
  }
  if (cookieDomain == null) {
    cookieDomain = window.location.hostname;
  }
  $tooltip = $('#cash-back-tutorial-tooltip');
  if (!$tooltip.length) {
    return;
  }
  onTooltipClose = function() {
    return Cookie.set(TUTORIAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain);
  };
  $tooltip.one('click', '.tooltip-close', onTooltipClose);
  $trigger = $('.cash-back .tooltip-trigger');
  return GIG.Tooltip.helpers.tooltip.apply($trigger, [
    {
      preventDefault: function() {}
    }
  ]);
};

module.exports = CashBack;



},{}],91:[function(require,module,exports){
var ChannelTabs;

ChannelTabs = window.ChannelTabs != null ? window.ChannelTabs : window.ChannelTabs = {};

ChannelTabs.init = function(arg, done) {
  var categoriesBaseUrl;
  categoriesBaseUrl = arg.categoriesBaseUrl;
  return $(function() {
    $(".primary-nav").find("a[href='" + categoriesBaseUrl + "']").parent().addClass('active');
    return done();
  });
};

module.exports = ChannelTabs;



},{}],92:[function(require,module,exports){
var DealController, Discount;

DealController = window.DealController != null ? window.DealController : window.DealController = {};

Discount = require('../../discount/frontend/views/discount');

DealController.init = function(payload, done) {
  return $(function() {
    new Discount.View;
    return done();
  });
};

module.exports = DealController;



},{"../../discount/frontend/views/discount":102}],93:[function(require,module,exports){
var DealLazyLoader;

DealLazyLoader = window.DealLazyLoader = {
  sleepyLoadImages: function() {
    return $('.sleepy-load').on('load', function() {
      return $(this).removeClass('blurred');
    }).lazyload({
      skip_invisible: false
    });
  },
  init: function(payload, done) {
    return $(function() {
      $(document.body).on('modal-open', function(e, data) {
        return $('#' + data.id).find('.lazy-load').lazyload();
      });
      $(window).load(function() {
        Groupon.Utils.lazyLoadImages();
        return DealLazyLoader.sleepyLoadImages();
      });
      return done();
    });
  }
};

module.exports = DealLazyLoader;



},{}],94:[function(require,module,exports){
var DealEventPipe;

DealEventPipe = window.DealEventPipe != null ? window.DealEventPipe : window.DealEventPipe = _(Backbone.Events).clone();

module.exports = DealEventPipe;



},{}],95:[function(require,module,exports){
var ExternalLinks, isBlackListedLink, isLinkToEmptyUrl, isLinkToExternalUrl, isLinkToJs, isLinkToPdf, isMailToLink, isWhiteListedLink;

ExternalLinks = window.ExternalLinks != null ? window.ExternalLinks : window.ExternalLinks = {};

isMailToLink = function(obj) {
  return obj.href.match(/^mailto\:/);
};

isLinkToPdf = function(obj) {
  return /.pdf$/.test(obj.href);
};

isLinkToJs = function(obj) {
  return obj.href.match(/^javascript\:/);
};

isLinkToEmptyUrl = function(obj) {
  return obj.href.match(/^$/);
};

isLinkToExternalUrl = function(obj) {
  return obj.hostname !== location.hostname && obj.hostname.indexOf("groupon.com") === -1;
};

isWhiteListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

isBlackListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

$.expr[":"].external = function(obj, index, meta, stack) {
  return (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) && !(isMailToLink(obj) || isLinkToJs(obj) || isLinkToEmptyUrl(obj) || isBlackListedLink(obj));
};

ExternalLinks.init = function(payload, done) {
  return $(function() {
    $("a:external").click(function(e) {
      e.preventDefault();
      return window.open($(this).attr('href'), "_blank");
    });
    return done();
  });
};

module.exports = ExternalLinks;



},{}],96:[function(require,module,exports){
if (window.GliveBookingWrapper == null) {
  window.GliveBookingWrapper = {};
}

GliveBookingWrapper.init = function(arg, done) {
  var gliveBooker;
  gliveBooker = arg.gliveBooker;
  if (!gliveBooker.isGliveDeal) {
    return done();
  }
  return $(function() {
    return BookingV2.gliveDealBookerInit(false, gliveBooker, done);
  });
};



},{}],97:[function(require,module,exports){
var LocalBookingWrapper;

LocalBookingWrapper = window.LocalBookingWrapper != null ? window.LocalBookingWrapper : window.LocalBookingWrapper = {};

LocalBookingWrapper.init = function(arg, done) {
  var booker;
  booker = arg.booker;
  return $(function() {
    Booking.dealBookerInit(booker);
    return done();
  });
};

module.exports = LocalBookingWrapper;



},{}],98:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.Model = require('./models/deal_type');

DealTypes.View = require('./views/deal_type');

DealTypes.init = function(arg, done) {
  var consumerId, csrf, dealTypes, rootUrl;
  dealTypes = arg.dealTypes, consumerId = arg.consumerId, csrf = arg.csrf, rootUrl = arg.rootUrl;
  if (!((consumerId != null ? consumerId.length : void 0) > 0 && (dealTypes != null ? dealTypes.length : void 0) > 0)) {
    return done();
  }
  return $(function() {
    var el, i, id, len, model, ref, value;
    for (i = 0, len = dealTypes.length; i < len; i++) {
      ref = dealTypes[i], id = ref.id, value = ref.value, el = ref.el;
      model = new DealTypes.Model({
        id: id,
        value: value,
        consumerId: consumerId,
        csrf: csrf,
        rootUrl: rootUrl
      });
      new DealTypes.View({
        el: el,
        model: model
      });
    }
    return done();
  });
};

module.exports = DealTypes;



},{"./models/deal_type":99,"./views/deal_type":100}],99:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.Model = Backbone.Model.extend({
  urlRoot: function() {
    return this.get('rootUrl');
  },
  url: function() {
    return (this.urlRoot()) + "/proxy/v2/consumers/" + (this.get('consumerId')) + "/feedback";
  },
  toJSON: function() {
    return {
      _csrf: this.get('csrf'),
      deal_types: [
        {
          id: this.get('id'),
          value: this.get('value')
        }
      ]
    };
  },
  isNew: function() {
    return true;
  },
  toggle: function() {
    if (this.get('value') === 'positive') {
      return this.set('value', 'neutral');
    } else {
      return this.set('value', 'positive');
    }
  }
});

module.exports = DealTypes.Model;



},{}],100:[function(require,module,exports){
if (window.DealTypes == null) {
  window.DealTypes = {};
}

DealTypes.View = Backbone.View.extend({
  events: {
    'click a': '_toggle'
  },
  initialize: function() {
    return this.model.on('change:value', (function(_this) {
      return function() {
        return _this._updateClass();
      };
    })(this));
  },
  _toggle: function(e) {
    if (e != null) {
      e.preventDefault();
    }
    this.model.toggle();
    return this.model.save();
  },
  _updateClass: function() {
    if (this.model.get('value') === 'positive') {
      return this.$('a').addClass('matching');
    } else {
      return this.$('a').removeClass('matching');
    }
  }
});

module.exports = DealTypes.View;



},{}],101:[function(require,module,exports){
var DealWidgets, ProductReviews, base;

DealWidgets = window.DealWidgets != null ? window.DealWidgets : window.DealWidgets = {};

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

ProductReviews.Views.Widget.ReviewRating = require('../../product_reviews/frontend/views/product_reviews_widget_review_rating');

DealWidgets.lazyLoadImages = function($widgets) {
  return $widgets.find('.lazy-load').each(function(position, imageElement) {
    var $image;
    $image = $(imageElement);
    return $image.attr('src', $image.attr('data-original'));
  });
};

DealWidgets.ajax_success = function(data, productReviews, done) {
  var $aboveReviewsSlot, $bottomSlot, $featuredTopSlot, $widgets, hasWidgets, ref, ref1, ref2, ref3;
  if (data == null) {
    $('#featuredtopslot-widget-placeholder').remove();
    $('#bottomslot-widget-placeholder').remove();
    $('#abovereviewsslot-widget-placeholder').remove();
    return done();
  }
  hasWidgets = false;
  $featuredTopSlot = $('#featuredtopslot-widget-placeholder');
  $bottomSlot = $('#bottomslot-widget-placeholder');
  $aboveReviewsSlot = $('#abovereviewsslot-widget-placeholder');
  if ((ref = data.FeaturedTopSlot) != null ? ref.length : void 0) {
    hasWidgets = true;
    $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr class='dotted-border' id='top-slot-border'/>");
  } else {
    $featuredTopSlot.remove();
  }
  if ((ref1 = data.BottomSlot) != null ? ref1.length : void 0) {
    hasWidgets = true;
    $bottomSlot.replaceWith(data.BottomSlot);
  } else {
    $bottomSlot.remove();
  }
  if ((ref2 = data.AboveReviewsSlot) != null ? ref2.length : void 0) {
    hasWidgets = true;
    $aboveReviewsSlot.replaceWith(data.AboveReviewsSlot);
  } else {
    $aboveReviewsSlot.remove();
  }
  if (hasWidgets) {
    if ((ref3 = Groupon.Utils) != null) {
      if (typeof ref3.lazyLoadImages === "function") {
        ref3.lazyLoadImages();
      }
    }
    new ProductReviews.Views.Widget.ReviewRating({
      productReviews: productReviews
    });
    if ($widgets = $('.mm-widget, .fake-wls-widget .widget-deals')) {
      WLS.init($widgets.parent());
      DealWidgets.lazyLoadImages($widgets);
      GIG.Utils.truncateElements($widgets);
    }
  }
  return done();
};

DealWidgets.init = function(arg, done) {
  var clientDealWidgets, productReviews;
  clientDealWidgets = arg.clientDealWidgets, productReviews = arg.productReviews;
  if (clientDealWidgets == null) {
    new ProductReviews.Views.Widget.ReviewRating({
      productReviews: productReviews
    });
    return done();
  }
  return $(function() {
    return $(window).load(function() {
      return $.ajax({
        url: clientDealWidgets.formattedUrl,
        dataType: 'json',
        success: function(data) {
          return DealWidgets.ajax_success(data, productReviews, done);
        },
        error: function(err) {
          $('#featuredtopslot-widget-placeholder').remove();
          $('#bottomslot-widget-placeholder').remove();
          $('#abovereviewsslot-widget-placeholder').remove();
          return done();
        }
      });
    });
  });
};

module.exports = DealWidgets;



},{"../../product_reviews/frontend/views/product_reviews_widget_review_rating":200}],102:[function(require,module,exports){
var DealEventPipe;

if (window.Discount == null) {
  window.Discount = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Discount.View = Backbone.View.extend({
  el: "#discount-data, .discount-data",
  initialize: function() {
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateTiles(priceData);
      };
    })(this));
  },
  updateTiles: function(arg) {
    var hideOriginalPriceAndDiscount, percent, savings, value;
    value = arg.value, percent = arg.percent, savings = arg.savings, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    this.$("#discount-value, .discount-value").html(value);
    this.$("#discount-percent, .discount-percent").html(percent);
    this.$("#discount-you-save, .discount-you-save").html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents(".deal-discount").hide();
    } else {
      return this.$el.parents(".deal-discount").show();
    }
  }
});

module.exports = Discount;



},{"../../../deal/frontend/event_pipe":94}],103:[function(require,module,exports){
var DfpAds;

DfpAds = window.DfpAds != null ? window.DfpAds : window.DfpAds = {};

DfpAds.init = function(arg, done) {
  var dfpHeader;
  dfpHeader = arg.dfpHeader;
  if (!dfpHeader) {
    return done();
  }
  return $(window).load(function() {
    Groupon.DFPAds || (Groupon.DFPAds = {});
    Groupon.DFPAds.showAds = function() {
      return $('.dfp-footer, .dfp-side-rail').map(function() {
        return this.id;
      }).each(function(i, id) {
        return googletag.cmd.push(function() {
          return googletag.display(id);
        });
      });
    };
    return done();
  });
};

module.exports = DfpAds;



},{}],104:[function(require,module,exports){
if (window.ExternalDeal == null) {
  window.ExternalDeal = {};
}

ExternalDeal.init = function(arg, done) {
  var externalDeal;
  externalDeal = arg.externalDeal;
  if (!externalDeal) {
    return done();
  }
  return $(function() {
    var $externalBuyButton;
    $externalBuyButton = $('.external-buy');
    $externalBuyButton.click(function(e) {
      e.preventDefault();
      window.open($(this).attr('href'));
      return setTimeout(GIG.Modal.close, 3000);
    });
    return done();
  });
};

module.exports = ExternalDeal;



},{}],105:[function(require,module,exports){
var _start, vent;

if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = vent = _(Backbone.Events).clone();

GMap._start = _start = function() {
  return GMap.vent.trigger('start');
};

module.exports = {
  vent: vent,
  _start: _start
};



},{}],106:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.View = require('./views/g_map');

GMap.init = function(arg, done) {
  var dynamicMaps, multipleLocations, staticMaps;
  dynamicMaps = arg.dynamicMaps, multipleLocations = arg.multipleLocations, staticMaps = arg.staticMaps;
  if (dynamicMaps == null) {
    return done();
  }
  return $(function() {
    var i, len, map, view;
    if (staticMaps != null ? staticMaps.shouldLazyLoadControls : void 0) {
      return $(window).load(function() {
        var i, len, map, view;
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          view = new GMap.View(_.extend(map, {
            staticMaps: staticMaps
          }));
        }
        return done();
      });
    } else {
      for (i = 0, len = dynamicMaps.length; i < len; i++) {
        map = dynamicMaps[i];
        view = new GMap.View(map);
      }
      return done();
    }
  });
};

module.exports = GMap;



},{"./views/g_map":108}],107:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.Markers = function(googleMaps) {
  return {
    googleMaps: googleMaps,
    makeMarkers: function(markerData) {
      var icon, j, k, len, len1, locationMarker, marker, markerOptions, ref, results;
      this.markers = [];
      results = [];
      for (j = 0, len = markerData.length; j < len; j++) {
        marker = markerData[j];
        locationMarker = {
          currentIndex: 0,
          coloredMarkers: []
        };
        ref = marker.icons;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          icon = ref[k];
          markerOptions = {
            position: new this.googleMaps.LatLng(marker.lat, marker.lng),
            icon: {
              url: icon.url,
              scaledSize: marker.size ? new this.googleMaps.Size(marker.size.width, marker.size.height) : void 0
            }
          };
          locationMarker.coloredMarkers.push({
            color: icon.color,
            dynamicMarker: new this.googleMaps.Marker(markerOptions)
          });
        }
        results.push(this.markers.push(locationMarker));
      }
      return results;
    },
    createBounds: function(markers) {
      var bounds, j, len, marker;
      bounds = new this.googleMaps.LatLngBounds();
      for (j = 0, len = markers.length; j < len; j++) {
        marker = markers[j];
        bounds.extend(marker.getPosition());
      }
      return bounds;
    },
    connectMapToMarkers: function(map, markers) {
      var j, len, marker, results;
      results = [];
      for (j = 0, len = markers.length; j < len; j++) {
        marker = markers[j];
        results.push(marker.setMap(map));
      }
      return results;
    },
    addMarkersToMap: function(map) {
      var activeMarkers, bounds, j, len, marker, ref;
      activeMarkers = [];
      ref = this.markers;
      for (j = 0, len = ref.length; j < len; j++) {
        marker = ref[j];
        activeMarkers.push(marker.coloredMarkers[0].dynamicMarker);
      }
      this.connectMapToMarkers(map, activeMarkers);
      if (activeMarkers.length > 1) {
        bounds = this.createBounds(activeMarkers);
        return map.fitBounds(bounds);
      }
    },
    toggleMarkerColor: function(i) {
      var map, marker, newMarker, oldMarker;
      if (i < 0) {
        return;
      }
      marker = this.markers[i];
      oldMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker;
      marker.currentIndex = (marker.currentIndex + 1) % marker.coloredMarkers.length;
      newMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker;
      map = oldMarker.getMap();
      oldMarker.setMap(null);
      return newMarker.setMap(map);
    }
  };
};

module.exports = GMap.Markers;



},{}],108:[function(require,module,exports){
if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = require('../helpers/events').vent;

GMap.Markers = require('../markers');

GMap.View = Backbone.View.extend({
  events: {
    'click .static-map': 'changeToDynamic'
  },
  initialize: function() {
    var $body, ref;
    ref = this.options, this.mapOptions = ref.mapOptions, this.markerData = ref.markerData, this.staticMaps = ref.staticMaps;
    $body = $(document.body);
    this.$locationsModal = $('#locations');
    this.$staticMap = this.$el.find('.static-map').add(this.$locationsModal.find('static-map'));
    this.$dynamicMap = this.$el.find('.dynamic-map').add(this.$locationsModal.find('dynamic-map'));
    GMap.vent.on('start', (function(_this) {
      return function() {
        return _this.start();
      };
    })(this));
    this.isLocationsPopupWasActivated = false;
    this.isDynamicMapsWasActivated = false;
    return $body.on("modal-open:locations", (function(_this) {
      return function() {
        return _this.onLocationsPopupOpen();
      };
    })(this));
  },
  changeToDynamic: function() {
    Groupon.Utils.GoogleMaps.load(function(err) {
      if (err != null) {
        return;
      }
      return GMap._start();
    });
    return false;
  },
  start: function() {
    var map;
    if (this.googleMaps == null) {
      this.googleMaps = window.google.maps;
    }
    if (!this.$locationsModal.hasClass('show-modal')) {
      this.$locationsModal.css({
        display: 'block',
        visibility: 'hidden'
      });
    }
    if (map = this.createDynamicMap(this.mapOptions)) {
      this.markerHandler = new GMap.Markers(this.googleMaps);
      this.markerHandler.makeMarkers(this.markerData);
      this.markerHandler.addMarkersToMap(map);
      this.revealDynamicMap();
      if (!this.$locationsModal.hasClass('show-modal')) {
        this.$locationsModal.css({
          display: '',
          visibility: ''
        });
      }
      return this.isDynamicMapsWasActivated = true;
    }
  },
  createDynamicMap: function(options) {
    var mapOptions;
    mapOptions = this.buildMapOptions(options);
    return new this.googleMaps.Map(this.$dynamicMap[0], mapOptions);
  },
  revealDynamicMap: function() {
    this.$dynamicMap.each(function() {
      var $dynamicMap, $staticMap;
      $dynamicMap = $(this);
      $staticMap = $dynamicMap.siblings('.static-map');
      if ($staticMap.length) {
        return $dynamicMap.css({
          height: $staticMap.height(),
          width: $staticMap.width()
        });
      }
    });
    this.$staticMap.hide();
    this.$dynamicMap.show();
    return GMap.vent.trigger('dynamicMapRevealed');
  },
  buildMapOptions: function(mapOptions) {
    mapOptions.center = new this.googleMaps.LatLng(mapOptions.center.lat, mapOptions.center.lng);
    mapOptions.mapTypeId = this.googleMaps.MapTypeId.ROADMAP;
    return mapOptions;
  },
  onLocationsPopupOpen: function() {
    if (!this.isLocationsPopupWasActivated && this.isDynamicMapsWasActivated) {
      this.isLocationsPopupWasActivated = true;
      GMap.vent.once('start', (function(_this) {
        return function() {
          return _this.start();
        };
      })(this));
      return this.changeToDynamic();
    }
  }
});

module.exports = GMap.View;



},{"../helpers/events":105,"../markers":107}],109:[function(require,module,exports){
if (window.Gift == null) {
  window.Gift = {};
}

Gift.init = function(payload, done) {
  return $(function() {
    Gift.bindGiftButton();
    return done();
  });
};

Gift.bindGiftButton = function() {
  var $gift_button;
  $gift_button = $('.gift-button');
  if ($gift_button.length > 0) {
    return $gift_button.on('click', function(e) {
      e.preventDefault();
      Gift.createCookie();
      BuyButton.view.giftButtonClicked = true;
      return BuyButton.eventBus.go('buy_button_clicked');
    });
  }
};

Gift.createCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.set('modalForGiftOnLoad', 'true', 60, cookieDomain);
  return Gift.cookieCreated = true;
};

Gift.removeCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.unset('modalForGiftOnLoad', cookieDomain);
  return Gift.cookieCreated = false;
};

module.exports = Gift;



},{}],110:[function(require,module,exports){
window.BookingV2 = (function() {
  var Booking = {};
  Booking.Collections = {};
  Booking.Models = {};
  Booking.Presenters  = {};
  Booking.Views = {};var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Booking.Collections.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Collection.apply(this, arguments);
    this._meta = {};
    this.on('request', this.loading);
    this.on('sync', this.loaded);
    this.on('error', this.loaded);
  }

  Base.prototype.meta = function(prop, value) {
    if (value !== void 0) {
      this._meta[prop] = value;
    }
    return this._meta[prop];
  };

  Base.prototype.loading = function() {
    return this.meta('loaded', false);
  };

  Base.prototype.loaded = function() {
    return this.meta('loaded', true);
  };

  Base.prototype.isLoading = function() {
    return this.meta('loaded') === false;
  };

  Base.prototype.isLoaded = function() {
    return this.meta('loaded') === true;
  };

  return Base;

})(Backbone.Collection);

Booking.Models.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    Backbone.Model.apply(this, arguments);
    if (typeof this.error === 'function') {
      this.on('error', this.error, this);
    }
  }

  Base.prototype.sync = function(method, model, options) {
    if (options == null) {
      options = {};
    }
    options.beforeSend = function(xhr) {
      if (Booking.csrf) {
        xhr.setRequestHeader('x-csrf-token', Booking.csrf);
      }
      if (Booking.authToken) {
        return xhr.setRequestHeader('x-auth-token', Booking.authToken);
      }
    };
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  };

  return Base;

})(Backbone.Model);

Booking.Presenters.Base = (function() {
  Base.prototype.module = 'booking';

  function Base(options1, templateName1) {
    var ref, ref1, ref2;
    this.options = options1;
    this.templateName = templateName1;
    if (this.module == null) {
      this.module = (ref = this.options) != null ? ref.module : void 0;
    }
    this.model = (ref1 = this.options) != null ? ref1.model : void 0;
    this.collection = (ref2 = this.options) != null ? ref2.collection : void 0;
    this.localesBasePath = "modules." + this.module + "." + this.templateName;
  }

  Base.prototype.toHash = function() {};

  Base.prototype.getI18n = function(scope) {
    if (scope == null) {
      scope = this.localesBasePath;
    }
    if (scope != null) {
      return I18n.scoped(scope);
    }
    return I18n;
  };

  Base.prototype.toHashWithHelpers = function() {
    return I18n.mixin(this.toHash(), this.getI18n());
  };

  Base.prototype.generateLink = function(i18nKey, href) {
    var label;
    label = this.getI18n().t(i18nKey);
    return "<a href='" + href + "'>" + label + "</a>";
  };

  return Base;

})();

Booking.Views.Base = (function(superClass) {
  extend(Base, superClass);

  Base.prototype.module = 'booking';

  function Base(options1) {
    this.options = options1 != null ? options1 : {};
    _.extend(this, _.pick(this.options, ['templateName', 'module', 'presenter']));
    Backbone.View.apply(this, arguments);
  }

  Base.prototype.template = function() {
    return window.BookingTemplates[this.module + "_frontend_templates_" + this.templateName];
  };

  Base.prototype.getPresenter = function() {
    if (this.presenter) {
      if (this._presenter == null) {
        this._presenter = new this.presenter(this.options, this.templateName);
      }
      return this._presenter;
    }
  };

  Base.prototype.templateAttributes = function() {
    if (this.presenter) {
      return this.getPresenter().toHashWithHelpers();
    } else {
      return this.options;
    }
  };

  Base.prototype.toHtml = function() {
    if (this.template()) {
      return this.template().render(this.templateAttributes());
    } else {
      return "";
    }
  };

  Base.prototype.render = function() {
    this.$el.html(this.toHtml());
    return this;
  };

  Base.prototype.bhw = function(widget) {
    var ref;
    return (ref = this.$el) != null ? ref.attr('data-bhw', widget) : void 0;
  };

  Base.prototype.translate = function() {
    var i18n;
    i18n = this.getPresenter().getI18n();
    return i18n.translate.apply(i18n, arguments);
  };

  return Base;

})(Backbone.View);

Booking.Models.Attribute = (function(superClass) {
  extend(Attribute, superClass);

  function Attribute() {
    return Attribute.__super__.constructor.apply(this, arguments);
  }

  Attribute.prototype.getLabel = function() {
    return this.get('label');
  };

  Attribute.prototype.getName = function() {
    return this.get('name');
  };

  Attribute.prototype.getType = function() {
    return this.get('type');
  };

  Attribute.prototype.isRequired = function() {
    return true;
  };

  Attribute.prototype.validate = function(value) {
    return value.match(this.get('validation')) != null;
  };

  Attribute.prototype.isPhone = function() {
    return this.getName() === 'phone_number';
  };

  Attribute.prototype.isPartySize = function() {
    return this.getName() === 'party_size';
  };

  Attribute.prototype.isQuestion = function() {
    return this.getType() === 'question';
  };

  Attribute.prototype.allowedValues = function() {
    var ref, ref1;
    return (ref = this.getType().match(/^enumeration\((.*)\)$/)) != null ? (ref1 = ref[1]) != null ? ref1.split(';') : void 0 : void 0;
  };

  return Attribute;

})(Booking.Models.Base);

Booking.Models.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.loaded = false;

  function Booker(arg) {
    var deal;
    deal = arg.deal;
    Booking.Models.Base.apply(this, arguments);
    if (this.get('timezoneData') != null) {
      moment.tz.add(this.get('timezoneData'));
    }
    this.set({
      options: new Booking.Collections.Options,
      availability: new Booking.Collections.Availability,
      times: new Booking.Collections.Times,
      reservations: new Booking.Collections.Reservations,
      partySizes: new Booking.Collections.PartySizes
    });
    this.getAvailability().getTimezone = (function(_this) {
      return function() {
        return _this.getTimezone();
      };
    })(this);
    this.getTimes().getTimezone = (function(_this) {
      return function() {
        return _this.getTimezone();
      };
    })(this);
    this.getTimes().isARSE = (function(_this) {
      return function() {
        return _this.isARSE();
      };
    })(this);
    this.getReservations().on('request', this.booking, this).on('sync', this.booked, this).on('error', this.handleError, this);
    this.getOptions().on('reset', (function(_this) {
      return function() {
        return _this.resetOption();
      };
    })(this));
    this.on('change:selectedOption', this.selectedOptionChanged, this);
    this.resetOptions(deal.options);
    this.resetPartySize();
  }

  Booker.prototype.handleError = function() {
    return this.notBooking();
  };

  Booker.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Booker.prototype.clearError = function() {
    return this.unset('error');
  };

  Booker.prototype.getError = function() {
    return this.get('error');
  };

  Booker.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Booker.prototype.getOrderId = function() {
    return this.get('orderId');
  };

  Booker.prototype.getGrouponId = function() {
    return this.get('grouponId');
  };

  Booker.prototype.getUserId = function() {
    return this.get('userId');
  };

  Booker.prototype.getDeal = function() {
    return this.get('deal');
  };

  Booker.prototype.getOptions = function() {
    return this.get('options');
  };

  Booker.prototype.getTimes = function() {
    return this.get('times');
  };

  Booker.prototype.getAvailability = function() {
    return this.get('availability');
  };

  Booker.prototype.getReservations = function() {
    return this.get('reservations');
  };

  Booker.prototype.resetReservations = function(reservations) {
    if (reservations == null) {
      reservations = [];
    }
    this.getReservations().reset(reservations);
    return this;
  };

  Booker.prototype.getReservation = function() {
    return this.getReservations().first();
  };

  Booker.prototype.createReservation = function() {
    this.setReservation(new Booking.Models.Reservation);
    return this.getReservation();
  };

  Booker.prototype.setReservation = function(reservation) {
    this.resetReservations([reservation]);
    return this;
  };

  Booker.prototype.unsetReservation = function() {
    this.resetReservations();
    return this;
  };

  Booker.prototype.getTimezone = function() {
    return this.getCurrentOption().getLocalBookingSettings().getTimezone();
  };

  Booker.prototype.getMerchantPhoneNumber = function() {
    var ref;
    return (ref = this.getCurrentOption().getRedemptionLocation()) != null ? ref.phoneNumber : void 0;
  };

  Booker.prototype.hasMultipleOptions = function() {
    return this.getOptions().length > 1;
  };

  Booker.prototype.preSelectedOption = function() {
    return this.getOptions().get(this.get('optionId'));
  };

  Booker.prototype.getSettingsDefinitionVersion = function() {
    return this.getCurrentOption().getLocalBookingSettings().getDefinitionVersion();
  };

  Booker.prototype.getPartySizeSettings = function() {
    return this.getCurrentOption().getPartySizeSettings();
  };

  Booker.prototype.getPhoneSettings = function() {
    return this.getCurrentOption().getPhoneSettings();
  };

  Booker.prototype.getQuestionsSettings = function() {
    return this.getCurrentOption().getQuestionsSettings();
  };

  Booker.prototype.getFirstQuestionSettings = function() {
    var ref;
    return (ref = this.getQuestionsSettings()) != null ? ref[0] : void 0;
  };

  Booker.prototype.getQuestion = function() {
    var ref;
    return (ref = this.getFirstQuestionSettings()) != null ? ref.getLabel() : void 0;
  };

  Booker.prototype.requirePartySize = function() {
    var ref;
    return (ref = this.getPartySizeSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requirePhone = function() {
    var ref;
    return (ref = this.getPhoneSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.requireQuestion = function() {
    var ref;
    return (ref = this.getFirstQuestionSettings()) != null ? ref.isRequired() : void 0;
  };

  Booker.prototype.reset = function() {
    this.resetOption();
    return this.resetTime();
  };

  Booker.prototype.resetOptions = function(options) {
    this.getOptions().reset(options);
    return this;
  };

  Booker.prototype.resetOption = function() {
    var defaultOption;
    defaultOption = !this.hasMultipleOptions() ? this.getOptions().firstSelectable() : null;
    return this.selectOption(this.preSelectedOption() || defaultOption);
  };

  Booker.prototype.resetPartySize = function() {
    var currentSelection, partySizes, ref;
    if (this.requirePartySize()) {
      currentSelection = this.selectedPartySize();
      partySizes = this.getPartySizeSettings().allowedValues();
      this.get('partySizes').reset(partySizes);
      if (ref = currentSelection != null ? currentSelection.toString() : void 0, indexOf.call(partySizes, ref) >= 0) {
        return this.selectPartySize(currentSelection);
      }
    }
  };

  Booker.prototype.resetDate = function() {
    this.selectDate(null);
    return this;
  };

  Booker.prototype.resetTime = function() {
    this.selectTime(null);
    return this;
  };

  Booker.prototype.selectOption = function(option) {
    return this.set({
      selectedOption: option
    });
  };

  Booker.prototype.selectedOption = function() {
    return this.get('selectedOption');
  };

  Booker.prototype.selectedOptionChanged = function() {
    this.resetPartySize();
    return this.loadAvailability();
  };

  Booker.prototype.getCurrentOption = function() {
    return this.selectedOption() || this.getOptions().firstSelectable();
  };

  Booker.prototype.selectDate = function(selection) {
    var date, events, selectedDate;
    events = [];
    selectedDate = null;
    if (selection != null) {
      events = selection.events, date = selection.date;
      selectedDate = {
        date: date
      };
    }
    this.resetTime();
    this.getTimes().reset(events);
    return this.set({
      selectedDate: selectedDate
    });
  };

  Booker.prototype.selectTime = function(time) {
    return this.set({
      selectedTime: time
    });
  };

  Booker.prototype.selectedTime = function() {
    return this.get('selectedTime');
  };

  Booker.prototype.selectPartySize = function(partySize) {
    if (!(partySize instanceof Booking.Models.PartySize)) {
      partySize = new Booking.Models.PartySize(partySize);
    }
    return this.set({
      selectedPartySize: partySize
    });
  };

  Booker.prototype.selectedPartySize = function() {
    var ref;
    return (ref = this.get('selectedPartySize')) != null ? ref.getPartySize() : void 0;
  };

  Booker.prototype.setPhoneNumber = function(phoneNumber) {
    return this.set({
      phoneNumber: phoneNumber
    });
  };

  Booker.prototype.getPhoneNumber = function() {
    return this.get('phoneNumber');
  };

  Booker.prototype.setQuestionsAnswer = function(questionsAnswer) {
    return this.set({
      questionsAnswer: questionsAnswer
    });
  };

  Booker.prototype.getQuestionsAnswer = function() {
    return this.get('questionsAnswer');
  };

  Booker.prototype.isDealNotYetOpen = function() {
    var ref;
    return ((ref = this.getDeal()) != null ? ref.status : void 0) === 'not_yet';
  };

  Booker.prototype.isBookAndBuy = function() {
    return this.get('bookAndBuy');
  };

  Booker.prototype.isReschedule = function() {
    return this.get('reschedule');
  };

  Booker.prototype.isARSE = function() {
    var ref;
    return (ref = this.getCurrentOption()) != null ? ref.isARSE() : void 0;
  };

  Booker.prototype.loadAvailability = function() {
    var segments;
    if (this.selectedOption()) {
      this.getTimes().reset();
      segments = this.selectedOption().getAvailability();
      if (segments != null) {
        this.getAvailability().set(segments);
        this.getAvailability().trigger('sync');
      } else {
        this.getAvailability().fetch({
          reset: true,
          data: {
            initialTime: moment().format(),
            finalTime: moment().endOf('month').add('months', 3).format(),
            optionId: this.selectedOption().get('uuid')
          }
        });
      }
      return this;
    }
  };

  Booker.prototype.preset = function(arg) {
    var datetime, option, optionId, partySize, phoneNumber, questionsAnswer, setDateTime;
    datetime = arg.datetime, optionId = arg.optionId, partySize = arg.partySize, questionsAnswer = arg.questionsAnswer, phoneNumber = arg.phoneNumber;
    if (datetime) {
      this.selectDate({
        events: [],
        date: true
      });
      this.selectTime(true);
      setDateTime = (function(_this) {
        return function() {
          var date, events;
          date = moment.unix(datetime).tz(_this.getTimezone());
          events = _this.getAvailability().getTimesByDate(date);
          if (events.length) {
            _this.selectDate({
              date: date,
              events: events
            });
            return _this.selectTime(_.find(events, function(event) {
              return event.get('initialTimeMoment').unix() === parseInt(datetime, 10);
            }));
          } else {
            _this.resetDate();
            return _this.resetTime();
          }
        };
      })(this);
      if ((this.selectedOption() != null) && (this.selectedOption().getAvailability() != null)) {
        setDateTime();
      } else {
        this.getAvailability().once('sync', setDateTime);
      }
    }
    if (optionId) {
      option = this.getOptions().get(optionId);
      if (option) {
        this.selectOption(option);
      }
    }
    if (partySize) {
      this.selectPartySize(partySize);
    }
    if (phoneNumber) {
      this.setPhoneNumber(phoneNumber);
    }
    if (questionsAnswer) {
      return this.setQuestionsAnswer(questionsAnswer);
    }
  };

  Booker.prototype.booking = function() {
    return this.set({
      isBooking: true
    });
  };

  Booker.prototype.booked = function() {
    if (!this.isBookAndBuy()) {
      return this.notBooking();
    }
  };

  Booker.prototype.notBooking = function() {
    return this.set({
      isBooking: false
    });
  };

  Booker.prototype.isBooking = function() {
    return this.get('isBooking') === true;
  };

  Booker.prototype.isReadyToBook = function() {
    var needPhoneNumber, needQuestionsAnswers;
    needPhoneNumber = this.requirePhone() && !this.getPhoneNumber();
    needQuestionsAnswers = this.requireQuestion() && !this.getQuestionsAnswer();
    if (this.isDealNotYetOpen()) {
      return false;
    }
    return (this.selectedTime() != null) && (this.selectedOption() != null) && !needPhoneNumber && !needQuestionsAnswers;
  };

  Booker.prototype.book = function() {
    var reservation, reservationData, selectedOption;
    if (this.isReadyToBook()) {
      this.booking();
      reservation = this.getReservation() || this.createReservation();
      selectedOption = this.selectedOption();
      reservationData = {
        definitionVersion: this.getSettingsDefinitionVersion(),
        segmentId: this.selectedTime().id,
        dealId: this.getDeal().id,
        optionId: selectedOption.id,
        orderId: this.getOrderId(),
        userId: this.getUserId()
      };
      if (this.requirePartySize()) {
        reservationData[this.getPartySizeSettings().getName()] = this.selectedPartySize();
      }
      if (this.requirePhone()) {
        reservationData[this.getPhoneSettings().getName()] = this.getPhoneNumber();
      }
      if (this.requireQuestion()) {
        reservationData[this.getFirstQuestionSettings().getName()] = this.getQuestionsAnswer();
      }
      reservation.set(reservationData);
      if (!reservationData.orderId) {
        reservation.unset('id');
      }
      return reservation.save();
    }
  };

  return Booker;

})(Booking.Models.Base);

Booking.Models.LocalBookingSettings = (function(superClass) {
  extend(LocalBookingSettings, superClass);

  function LocalBookingSettings() {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(this.attributes));
  }

  LocalBookingSettings.prototype.parse = function(raw) {
    if (!raw) {
      return;
    }
    raw.additional_attributes = new Booking.Collections.Attributes(raw.additional_attributes);
    return raw;
  };

  LocalBookingSettings.prototype.getDefinitionVersion = function() {
    return this.get('definition_version');
  };

  LocalBookingSettings.prototype.getDuration = function() {
    return parseInt(this.get('duration'), 10);
  };

  LocalBookingSettings.prototype.getTentativeWindowDuration = function() {
    return parseInt(this.get('tentative_window_duration'), 10);
  };

  LocalBookingSettings.prototype.getTimezone = function() {
    return this.get('time_zone');
  };

  LocalBookingSettings.prototype.isARSE = function() {
    return this.getDuration() - this.getTentativeWindowDuration() !== 0;
  };

  LocalBookingSettings.prototype.getAdditionalAttributes = function() {
    return this.get('additional_attributes');
  };

  LocalBookingSettings.prototype.getAvailability = function() {
    return this.get('availability');
  };

  return LocalBookingSettings;

})(Booking.Models.Base);

Booking.Models.Option = (function(superClass) {
  extend(Option, superClass);

  Option.prototype.idAttribute = 'uuid';

  function Option() {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(this.attributes));
  }

  Option.prototype.parse = function(raw) {
    if (!raw) {
      return;
    }
    raw.localBookingSettings = new Booking.Models.LocalBookingSettings(raw.localBookingSettings);
    return raw;
  };

  Option.prototype.getTitle = function() {
    return this.get('title');
  };

  Option.prototype.getRedemptionLocation = function() {
    return this.get('redemptionLocations')[0];
  };

  Option.prototype.getLocationName = function() {
    var ref;
    return (ref = this.getRedemptionLocation()) != null ? ref.name : void 0;
  };

  Option.prototype.getPrice = function() {
    return this.get('price').amount;
  };

  Option.prototype.getFormattedPrice = function() {
    return this.get('price').formattedAmount;
  };

  Option.prototype.getFormattedValue = function() {
    return this.get('value').formattedAmount;
  };

  Option.prototype.isSoldOut = function() {
    return this.get('isSoldOut');
  };

  Option.prototype.getDiscount = function() {
    return this.get('discount');
  };

  Option.prototype.isFoodAndDrink = function() {
    return this.get('bookable');
  };

  Option.prototype.getLocalBookingSettings = function() {
    return this.get('localBookingSettings');
  };

  Option.prototype.getAvailability = function() {
    return this.getLocalBookingSettings().getAvailability();
  };

  Option.prototype.getAdditionalAttributes = function() {
    return this.getLocalBookingSettings().getAdditionalAttributes();
  };

  Option.prototype.isARSE = function() {
    return this.getLocalBookingSettings().isARSE();
  };

  Option.prototype.getPartySizeSettings = function() {
    return this.getAdditionalAttributes().getPartySize();
  };

  Option.prototype.getPhoneSettings = function() {
    return this.getAdditionalAttributes().getPhone();
  };

  Option.prototype.getQuestionsSettings = function() {
    return this.getAdditionalAttributes().getQuestions();
  };

  return Option;

})(Booking.Models.Base);

Booking.Models.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    arguments[0] = {
      partySize: parseInt(arguments[0], 10)
    };
    Booking.Models.Base.apply(this, arguments);
  }

  PartySize.prototype.getPartySize = function() {
    return this.get('partySize');
  };

  return PartySize;

})(Booking.Models.Base);

Booking.Models.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  Reservation.prototype.statuses = {
    locked: 'locked',
    requested: 'requested',
    confirmed: 'confirmed',
    expired: 'expired',
    canceled: 'user_declined'
  };

  function Reservation(attributes) {
    Booking.Models.Base.apply(this, arguments);
    this.set(this.parse(attributes));
    this.on('error', this.handleError, this);
    this.on('request', this.loading, this);
    this.on('sync', this.loaded, this);
  }

  Reservation.prototype.parse = function(raw) {
    var additionalAttributes, option;
    if (!raw) {
      return;
    }
    additionalAttributes = raw.additionalAttributes, option = raw.option;
    raw.additionalAttributes = new Booking.Collections.Attributes(additionalAttributes);
    raw.option = new Booking.Models.Option(option);
    return raw;
  };

  Reservation.prototype.handleError = function(model, response) {
    var error, errors;
    errors = {
      0: 'timeout',
      404: 'not_found',
      409: 'conflict',
      410: 'gone',
      504: 'timeout'
    };
    error = errors[response.status] || 'server';
    return this.setError(error);
  };

  Reservation.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Reservation.prototype.getError = function() {
    return this.get('error');
  };

  Reservation.prototype.clearError = function() {
    return this.unset('error');
  };

  Reservation.prototype.getOption = function() {
    return this.get('option');
  };

  Reservation.prototype.getMerchant = function() {
    return this.get('merchant');
  };

  Reservation.prototype.getUserId = function() {
    return this.get('userId');
  };

  Reservation.prototype.getStatus = function() {
    return this.get('status');
  };

  Reservation.prototype.getStartDatetime = function() {
    return this.get('startDatetime');
  };

  Reservation.prototype.getEndDatetime = function() {
    return this.get('endDatetime');
  };

  Reservation.prototype.getStartDatetimeMoment = function() {
    return moment(this.getStartDatetime()).tz(this.getTimezone());
  };

  Reservation.prototype.getEndDatetimeMoment = function() {
    return moment(this.getEndDatetime()).tz(this.getTimezone());
  };

  Reservation.prototype.getDuration = function() {
    return this.get('duration');
  };

  Reservation.prototype.isAppointmentRequest = function() {
    return this.get('tentativeWindow');
  };

  Reservation.prototype.getTimezone = function() {
    return this.getOption().getLocalBookingSettings().getTimezone();
  };

  Reservation.prototype.getLocationName = function() {
    return this.getOption().getLocationName();
  };

  Reservation.prototype.getMerchantName = function() {
    return this.getMerchant().name;
  };

  Reservation.prototype.getAttributes = function() {
    return this.get('additionalAttributes');
  };

  Reservation.prototype.getPartySize = function() {
    var ref;
    return this.get((ref = this.getAttributes().getPartySize()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.getQuestion = function() {
    var ref, ref1;
    return this.get((ref = this.getAttributes().getQuestions()) != null ? (ref1 = ref[0]) != null ? ref1.getName() : void 0 : void 0);
  };

  Reservation.prototype.getPhone = function() {
    var ref;
    return this.get((ref = this.getAttributes().getPhone()) != null ? ref.getName() : void 0);
  };

  Reservation.prototype.isLocked = function() {
    return this.getStatus() === this.statuses.locked;
  };

  Reservation.prototype.isRequested = function() {
    return this.getStatus() === this.statuses.requested;
  };

  Reservation.prototype.isConfirmed = function() {
    return this.getStatus() === this.statuses.confirmed;
  };

  Reservation.prototype.isExpired = function() {
    return this.getStatus() === this.statuses.expired;
  };

  Reservation.prototype.isCanceled = function() {
    return this.getStatus() === this.statuses.canceled;
  };

  Reservation.prototype.isBooked = function() {
    return this.isRequested() || this.isConfirmed() || this.isLocked();
  };

  Reservation.prototype.loaded = function() {
    return this.set('loaded', true);
  };

  Reservation.prototype.loading = function() {
    return this.set('loaded', false);
  };

  Reservation.prototype.isLoaded = function() {
    return this.get('loaded') === true;
  };

  Reservation.prototype.isLoading = function() {
    return this.get('loaded') === false;
  };

  Reservation.prototype.cancel = function() {
    this.set({
      status: this.statuses.canceled
    });
    return this.save();
  };

  return Reservation;

})(Booking.Models.Base);

Booking.Models.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    var clndrTimeMoment, finalTimeMoment, initialTimeMoment;
    Booking.Models.Base.apply(this, arguments);
    initialTimeMoment = clndrTimeMoment = moment.unix(this.get('initial_time'));
    finalTimeMoment = moment.unix(this.get('final_time'));
    if (this.collection && !this.collection.meta('browserInMerchantTimezone')) {
      initialTimeMoment = initialTimeMoment.tz(this.collection.getTimezone());
      finalTimeMoment = finalTimeMoment.tz(this.collection.getTimezone());
    }
    this.set({
      initialTimeMoment: initialTimeMoment,
      finalTimeMoment: finalTimeMoment,
      clndrTimeMoment: clndrTimeMoment
    });
  }

  Time.prototype.start = function() {
    return this.get('initialTimeMoment');
  };

  Time.prototype.end = function() {
    return this.get('finalTimeMoment');
  };

  return Time;

})(Booking.Models.Base);

Booking.Collections.Attributes = (function(superClass) {
  extend(Attributes, superClass);

  function Attributes() {
    return Attributes.__super__.constructor.apply(this, arguments);
  }

  Attributes.prototype.model = Booking.Models.Attribute;

  Attributes.prototype.getPhone = function() {
    return this.find(function(attribute) {
      return attribute.isPhone();
    });
  };

  Attributes.prototype.getPartySize = function() {
    return this.find(function(attribute) {
      return attribute.isPartySize();
    });
  };

  Attributes.prototype.getQuestions = function() {
    return this.filter(function(attribute) {
      return attribute.isQuestion();
    });
  };

  return Attributes;

})(Booking.Collections.Base);

Booking.Collections.Availability = (function(superClass) {
  extend(Availability, superClass);

  function Availability() {
    return Availability.__super__.constructor.apply(this, arguments);
  }

  Availability.prototype.model = Booking.Models.Time;

  Availability.prototype.url = function() {
    return Booking.rootUrl + "/availability";
  };

  Availability.prototype.parse = function(arg) {
    var segments;
    segments = arg.segments;
    this.meta('browserInMerchantTimezone', moment().zone() === moment().tz(this.getTimezone()).zone());
    return segments;
  };

  Availability.prototype.getTimesByDate = function(day) {
    var endOfDay, startOfDay;
    startOfDay = day.startOf('day').unix();
    endOfDay = day.endOf('day').unix();
    return this.filter((function(_this) {
      return function(time) {
        var ref;
        return (startOfDay <= (ref = time.start().unix()) && ref <= endOfDay);
      };
    })(this));
  };

  return Availability;

})(Booking.Collections.Base);

Booking.Collections.Options = (function(superClass) {
  extend(Options, superClass);

  function Options() {
    return Options.__super__.constructor.apply(this, arguments);
  }

  Options.prototype.model = Booking.Models.Option;

  Options.prototype.selectable = function() {
    return this.filter(function(option) {
      return option.isSoldOut() === false;
    });
  };

  Options.prototype.firstSelectable = function() {
    return this.selectable()[0];
  };

  Options.prototype.cheapest = function() {
    return this.sortBy(function(option) {
      return option.getPrice();
    })[0];
  };

  Options.prototype.isFoodAndDrink = function() {
    return this.some(function(option) {
      return option.isFoodAndDrink();
    });
  };

  return Options;

})(Booking.Collections.Base);

Booking.Collections.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  function PartySizes() {
    return PartySizes.__super__.constructor.apply(this, arguments);
  }

  PartySizes.prototype.model = Booking.Models.PartySize;

  return PartySizes;

})(Booking.Collections.Base);

Booking.Collections.Reservations = (function(superClass) {
  extend(Reservations, superClass);

  function Reservations() {
    return Reservations.__super__.constructor.apply(this, arguments);
  }

  Reservations.prototype.model = Booking.Models.Reservation;

  Reservations.prototype.url = function() {
    return Booking.rootUrl + "/reservations";
  };

  return Reservations;

})(Booking.Collections.Base);

Booking.Collections.Times = (function(superClass) {
  extend(Times, superClass);

  function Times() {
    return Times.__super__.constructor.apply(this, arguments);
  }

  Times.prototype.model = Booking.Models.Time;

  return Times;

})(Booking.Collections.Base);

Booking.Presenters.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.toHash = function() {
    var bookAndBuy, isDisabled, notYet, requestAppointment, reschedule;
    isDisabled = this.model.isBooking() || !this.model.isReadyToBook();
    notYet = this.model.isDealNotYetOpen();
    bookAndBuy = this.model.isBookAndBuy();
    reschedule = this.model.isReschedule();
    requestAppointment = this.model.isARSE();
    return {
      isDisabled: isDisabled,
      notYet: notYet,
      bookAndBuy: bookAndBuy,
      reschedule: reschedule,
      requestAppointment: requestAppointment
    };
  };

  return Book;

})(Booking.Presenters.Base);

Booking.Presenters.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  function Reservation() {
    Booking.Presenters.Base.apply(this, arguments);
    this.isARSE = this.model.isAppointmentRequest();
    if (this.isARSE) {
      this.localesBasePath = this.localesBasePath + "_arse";
    }
  }

  Reservation.prototype.toHash = function() {
    var dateMoment, hash, location;
    if (!this.model.getError()) {
      if (this.model.isLoaded()) {
        dateMoment = this.model.getStartDatetimeMoment();
        location = this.model.getLocationName();
        if ((location != null ? location.length : void 0) === 0) {
          location = this.model.getMerchantName();
        }
        hash = {
          loaded: true,
          isLocked: this.model.isLocked(),
          isBooked: this.model.isBooked(),
          isExpired: this.model.isExpired(),
          date: dateMoment != null ? dateMoment.format('dddd, MMMM Do YYYY') : void 0,
          time: dateMoment != null ? dateMoment.format('h:mm a') : void 0,
          location: location,
          service: this.model.getOption().getTitle()
        };
        if (this.isARSE) {
          hash.endtime = this.model.getEndDatetimeMoment().format('h:mm a');
        }
      } else {
        hash = {
          loaded: false
        };
      }
    } else {
      hash = {
        error: this.model.getError()
      };
    }
    return _.extend(hash, {
      contactSupportLink: this.generateLink('.contact_support', 'https://www.groupon.com/customer_support'),
      myReservationsLink: this.generateLink('.my_reservations', "/users/" + (this.model.getUserId()) + "/reservations")
    });
  };

  return Reservation;

})(Booking.Presenters.Base);

Booking.Presenters.Picker = (function(superClass) {
  extend(Picker, superClass);

  function Picker() {
    return Picker.__super__.constructor.apply(this, arguments);
  }

  Picker.prototype.selected = function() {
    return this.model.get(this.options.selected);
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1;
  };

  Picker.prototype.toHash = function() {
    return {
      icon: this.options.icon,
      expanded: this.options.expanded,
      selectable: this.isSelectable() || !this.selected()
    };
  };

  return Picker;

})(Booking.Presenters.Base);

Booking.Presenters.Booker = (function(superClass) {
  extend(Booker, superClass);

  function Booker() {
    var ref;
    Booking.Presenters.Base.apply(this, arguments);
    this.isARSE = (ref = this.model.getCurrentOption()) != null ? ref.isARSE() : void 0;
    if (this.isARSE) {
      this.localesBasePath = this.localesBasePath + "_arse";
    }
  }

  Booker.prototype.userPageHref = function(page) {
    return "/users/" + (this.model.getUserId()) + "/" + page;
  };

  Booker.prototype.toHash = function() {
    var error, hash, ref;
    error = this.model.getError();
    hash = {
      error: error,
      errorLoading: error === 'loading' || error === 'timeout',
      errorBooking: error === 'server' || error === 'not_found',
      errorSegmentNotAvailable: error === 'conflict',
      errorSegmentExpired: error === 'gone',
      myReservationsLink: this.generateLink('.my_reservations', this.userPageHref('reservations')),
      myGrouponsLink: this.generateLink('.my_groupons', this.userPageHref('groupons')),
      isOpen: this.options.isOpen,
      isLocked: this.options.isLocked,
      phoneRequired: this.model.requirePhone(),
      questionRequired: this.model.requireQuestion(),
      isARSE: this.isARSE,
      showNewOverlay: this.options.showNewOverlay,
      hasReservation: ((ref = this.model.getReservation()) != null ? ref.id : void 0) != null,
      merchantPhone: this.model.getMerchantPhoneNumber()
    };
    return hash;
  };

  return Booker;

})(Booking.Presenters.Base);

Booking.Presenters.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  function Calendar() {
    return Calendar.__super__.constructor.apply(this, arguments);
  }

  Calendar.prototype.toHash = function() {
    var calendarData, days, firstDayIndex, j, lastDayIndex, lastMonthAvailable, momentEndOfMonth, momentStartOfMonth, nextMonthAvailable, now, numberOfColumns, numberOfRows, ref, row, rows;
    calendarData = this.options.calendarData;
    numberOfColumns = calendarData.days.length / calendarData.numberOfRows;
    numberOfRows = calendarData.numberOfRows;
    rows = [];
    now = moment();
    days = _.map(calendarData.days, function(day, i) {
      var at, diff, label, value;
      label = day.events.length ? 'available' : 'unavailable';
      if (moment.isMoment(day.date)) {
        diff = day.date.diff(now, 'days');
        if (diff) {
          at = diff > 0 ? 'ahead' : 'behind';
          value = at + "-" + (Math.abs(diff));
        } else {
          value = 'today';
        }
      } else {
        value = i < calendarData.days.length / 2 ? 'last-month' : 'next-month';
      }
      day.bhc = label + ":" + value;
      return day;
    });
    for (row = j = 0, ref = numberOfRows - 1; 0 <= ref ? j <= ref : j >= ref; row = 0 <= ref ? ++j : --j) {
      firstDayIndex = row * numberOfColumns;
      lastDayIndex = (row + 1) * numberOfColumns - 1;
      rows[row] = {
        days: days.slice(firstDayIndex, +lastDayIndex + 1 || 9e9)
      };
    }
    momentStartOfMonth = moment(calendarData.month + " " + calendarData.year, 'MMM YYYY').startOf('month');
    momentEndOfMonth = moment(momentStartOfMonth).endOf('month');
    lastMonthAvailable = !!this.collection.filter(function(time) {
      return time.get('initialTimeMoment') < momentStartOfMonth;
    }).length;
    nextMonthAvailable = !!this.collection.filter(function(time) {
      return time.get('initialTimeMoment') > momentEndOfMonth;
    }).length;
    return {
      loaded: this.collection.isLoaded(),
      rows: rows,
      month: calendarData.month,
      daysOfTheWeek: calendarData.daysOfTheWeek,
      lastMonthAvailable: lastMonthAvailable,
      nextMonthAvailable: nextMonthAvailable
    };
  };

  return Calendar;

})(Booking.Presenters.Base);

Booking.Presenters.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.toHash = function() {
    var date, hash, loading, selected;
    selected = this.selected();
    date = selected != null ? selected.date : void 0;
    loading = date === true;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    hash.loading = loading;
    if (!loading && date) {
      hash.selectedDate = {
        month: date.format('MMMM'),
        date: date.format('D'),
        year: date.format('YYYY')
      };
    }
    return hash;
  };

  return DatePicker;

})(Booking.Presenters.Picker);

Booking.Presenters.EditableReservation = (function(superClass) {
  extend(EditableReservation, superClass);

  function EditableReservation() {
    return EditableReservation.__super__.constructor.apply(this, arguments);
  }

  EditableReservation.prototype.toHash = function() {
    var dateMoment, hash;
    hash = Booking.Presenters.Reservation.prototype.toHash.apply(this, arguments);
    hash.loading = this.model.isLoading();
    if (this.model.isBooked()) {
      dateMoment = this.model.getStartDatetimeMoment();
      hash.date = dateMoment.format('ddd, MMM D, YYYY');
      hash.time = dateMoment.format('h:mma');
      hash.partySize = this.model.getPartySize();
    }
    return hash;
  };

  return EditableReservation;

})(Booking.Presenters.Reservation);

Booking.Presenters.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.toHash = function() {
    var option, selectedOption;
    selectedOption = this.model.selectedOption();
    option = selectedOption || this.model.getOptions().cheapest();
    return {
      optionSelected: selectedOption != null,
      price: option.getFormattedPrice()
    };
  };

  return Info;

})(Booking.Presenters.Base);

Booking.Presenters.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.toHash = function() {
    var optionId, ref, selectedOptionId;
    optionId = this.model.id;
    selectedOptionId = (ref = this.options.selected) != null ? ref.id : void 0;
    return {
      optionId: optionId,
      title: this.model.getTitle(),
      selected: selectedOptionId === optionId,
      price: this.model.getFormattedPrice(),
      value: this.model.getFormattedValue(),
      isSoldOut: this.model.isSoldOut(),
      discount: this.model.getDiscount()
    };
  };

  Option.prototype.bhc = function() {
    return "dealoption:" + (this.model.getTitle());
  };

  return Option;

})(Booking.Presenters.Base);

Booking.Presenters.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.toHash = function() {
    var hash;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedOption = {
        title: this.selected().getTitle()
      };
    }
    return hash;
  };

  return OptionPicker;

})(Booking.Presenters.Picker);

Booking.Presenters.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.toHash = function() {
    var partySize, ref, selected;
    if (this.model) {
      partySize = this.model.getPartySize();
      selected = ((ref = this.options.selected) != null ? ref.getPartySize() : void 0) === partySize;
      return {
        partySize: partySize,
        selected: selected
      };
    }
  };

  PartySize.prototype.bhc = function() {
    return "partysize:" + (this.model.getPartySize());
  };

  return PartySize;

})(Booking.Presenters.Base);

Booking.Presenters.PartyPicker = (function(superClass) {
  extend(PartyPicker, superClass);

  function PartyPicker() {
    return PartyPicker.__super__.constructor.apply(this, arguments);
  }

  PartyPicker.prototype.toHash = function() {
    var hash;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedpartySize = {
        partySize: this.selected().getPartySize()
      };
    }
    return hash;
  };

  return PartyPicker;

})(Booking.Presenters.Picker);

Booking.Presenters.Phone = (function(superClass) {
  extend(Phone, superClass);

  function Phone() {
    return Phone.__super__.constructor.apply(this, arguments);
  }

  Phone.prototype.toHash = function() {
    return {
      customerPhone: this.options.customerPhone,
      maxLength: this.options.customerPhoneMaxLength,
      bhw: Booking.bhw + "Phone"
    };
  };

  return Phone;

})(Booking.Presenters.Base);

Booking.Presenters.Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.prototype.toHash = function() {
    return {
      question: this.options.question,
      answer: this.options.answer,
      maxLength: this.options.maxLength,
      bhw: Booking.bhw + "Question"
    };
  };

  return Question;

})(Booking.Presenters.Base);

Booking.Presenters.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.timeHash = function(momentTime) {
    return {
      hours: momentTime.format('h'),
      minutes: momentTime.format('mm'),
      period: momentTime.format('a')
    };
  };

  Time.prototype.isRange = function() {
    var ref;
    return (ref = this.collection) != null ? typeof ref.isARSE === "function" ? ref.isARSE() : void 0 : void 0;
  };

  Time.prototype.modelToHash = function(model, selection) {
    var from, id, isRange, selected, time, to;
    id = model.id;
    isRange = this.isRange();
    from = this.timeHash(model.start().tz(model.collection.getTimezone()));
    if (isRange) {
      to = this.timeHash(model.end().tz(model.collection.getTimezone()));
    }
    selected = id === (selection != null ? selection.id : void 0);
    time = {
      id: id,
      isRange: isRange,
      from: from,
      to: to,
      selected: selected
    };
    return {
      time: time
    };
  };

  Time.prototype.toHash = function() {
    var ref;
    if (this.model) {
      return this.modelToHash(this.model, (ref = this.options) != null ? ref.selected : void 0);
    }
  };

  Time.prototype.bhc = function() {
    var from, isRange, label, ref, time, to, value;
    ref = this.toHash().time, from = ref.from, to = ref.to, isRange = ref.isRange;
    time = function(t) {
      return t.hours + "." + t.minutes + t.period;
    };
    label = 'time';
    value = time(from);
    if (isRange) {
      label = 'range';
      value = value + "-" + (time(to));
    }
    return label + ":" + value;
  };

  return Time;

})(Booking.Presenters.Base);

Booking.Presenters.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  function TimePicker(options, templateName) {
    Booking.Presenters.Picker.apply(this, arguments);
    this.timePresenter = new Booking.Presenters.Time(options, templateName);
  }

  TimePicker.prototype.toHash = function() {
    var hash, loading, selected, selection;
    selected = this.selected();
    loading = selected === true;
    hash = Booking.Presenters.Picker.prototype.toHash.apply(this, arguments);
    hash.loading = loading;
    if (!loading) {
      if (selected) {
        selection = this.timePresenter.modelToHash(selected);
      }
      hash.selection = selection != null ? selection.time : void 0;
      hash.isRange = this.timePresenter.isRange();
    }
    return hash;
  };

  return TimePicker;

})(Booking.Presenters.Picker);

Booking.Views.Picker = (function(superClass) {
  extend(Picker, superClass);

  Picker.prototype.templateName = 'picker';

  Picker.prototype.expandedClassName = 'expanded';

  Picker.prototype.collapsedClassName = 'collapsed';

  Picker.prototype.selectEvent = 'select';

  Picker.prototype.renderedEvent = 'rendered';

  Picker.prototype.events = {
    'click .dropdown': 'toggle'
  };

  Picker.prototype.transitionDuration = 300;

  Picker.prototype.className = function() {
    var className;
    className = "picker " + this.collapsedClassName + " " + this.styleClassName;
    return className;
  };

  function Picker() {
    Booking.Views.Base.apply(this, arguments);
    this.collection.on('reset', this.clearSelection, this);
    this.collection.on('request', this.clearSelection, this);
    this.model.on("change:" + this.options.selected, (function(_this) {
      return function(model, selection) {
        _this.content().options.selected = selection;
        return _this.render();
      };
    })(this));
  }

  Picker.prototype.render = function() {
    this.content().$el.detach();
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.appendContent();
    this.trigger(this.renderedEvent);
    if (!this.isSelectable() && this.collection.first()) {
      this.setSelection(this.collection.first());
    }
    return this;
  };

  Picker.prototype.content = function() {
    if (!this._content) {
      this._content = new this.contentView({
        collection: this.collection,
        selected: this.selected()
      });
      this._content.on('select', this.select, this);
      this._content.render();
    }
    return this._content;
  };

  Picker.prototype.select = function(selection) {
    this.setSelection(selection);
    this.render();
    return this.trigger(this.selectEvent, selection);
  };

  Picker.prototype.selected = function() {
    return this.model.get(this.options.selected);
  };

  Picker.prototype.isSelectable = function() {
    return this.collection.length > 1;
  };

  Picker.prototype.setSelection = function(selection) {
    return this.model.set(this.options.selected, selection);
  };

  Picker.prototype.clearSelection = function() {
    this.setSelection(null);
    return this.render();
  };

  Picker.prototype.container = function() {
    return this.$el.find('.content');
  };

  Picker.prototype.appendContent = function() {
    return this.content().$el.appendTo(this.container());
  };

  Picker.prototype.isPreviousSelected = function() {
    if (this.options.previous) {
      return this.options.previous.selected();
    } else {
      return true;
    }
  };

  Picker.prototype.toggle = function() {
    if (this.collection.length && this.isSelectable()) {
      if (this.isVisible()) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  };

  Picker.prototype.isVisible = function() {
    return this.$el.hasClass(this.expandedClassName);
  };

  Picker.prototype.show = function() {
    var transitionEndHandler;
    if (this.isPreviousSelected()) {
      this.redraw();
      this.trigger('expand', this);
      transitionEndHandler = (function(_this) {
        return function() {
          return _this.trigger('expanded', _this);
        };
      })(this);
      setTimeout(transitionEndHandler, this.transitionDuration);
      return this.$el.removeClass(this.collapsedClassName).addClass(this.expandedClassName);
    }
  };

  Picker.prototype.hide = function(force) {
    var transitionEndHandler;
    if (this.isPreviousSelected() && this.selected() || force === true) {
      this.redraw();
      this.trigger('collapse', this);
      transitionEndHandler = (function(_this) {
        return function() {
          _this.trigger('collapsed', _this);
          return _this.$el.addClass(_this.collapsedClassName);
        };
      })(this);
      setTimeout(transitionEndHandler, this.transitionDuration);
      return this.$el.removeClass(this.expandedClassName);
    }
  };

  Picker.prototype.redraw = function() {
    return this.$el.get(0).offsetHeight;
  };

  return Picker;

})(Booking.Views.Base);

Booking.Views.Reservation = (function(superClass) {
  extend(Reservation, superClass);

  Reservation.prototype.presenter = Booking.Presenters.Reservation;

  Reservation.prototype.templateName = 'reservation';

  Reservation.prototype.events = {
    'click a.reload': 'reload'
  };

  function Reservation() {
    Booking.Views.Base.apply(this, arguments);
    this.bhw(Booking.bhw + "Reservation");
    this.model.on('change:loaded', this.render, this);
  }

  Reservation.prototype.reload = function() {
    return window.location.reload();
  };

  return Reservation;

})(Booking.Views.Base);

Booking.Views.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.presenter = Booking.Presenters.Book;

  Book.prototype.templateName = 'book';

  Book.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "BookButton"
    };
  };

  return Book;

})(Booking.Views.Base);

Booking.Views.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.presenter = Booking.Presenters.Booker;

  Booker.prototype.infoView = Booking.Views.Info;

  Booker.prototype.pickersView = Booking.Views.Pickers;

  Booker.prototype.optionPickerView = Booking.Views.OptionPicker;

  Booker.prototype.partySizePickerView = Booking.Views.PartySizePicker;

  Booker.prototype.datePickerView = Booking.Views.DatePicker;

  Booker.prototype.timePickerView = Booking.Views.TimePicker;

  Booker.prototype.questionView = Booking.Views.Question;

  Booker.prototype.phoneView = Booking.Views.Phone;

  Booker.prototype.bookButtonView = Booking.Views.Book;

  Booker.prototype.events = {
    'submit form': 'book',
    'click .open .btn': 'open',
    'click form > .icon-close': 'close'
  };

  Booker.prototype.className = 'booking-component';

  function Booker() {
    this.clearQuestionsAnswer = bind(this.clearQuestionsAnswer, this);
    this.setQuestionsAnswer = bind(this.setQuestionsAnswer, this);
    this.clearPhoneNumber = bind(this.clearPhoneNumber, this);
    this.setPhoneNumber = bind(this.setPhoneNumber, this);
    this.selectPartySize = bind(this.selectPartySize, this);
    this.selectTime = bind(this.selectTime, this);
    this.selectDate = bind(this.selectDate, this);
    this.selectOption = bind(this.selectOption, this);
    Booking.Views.Base.apply(this, arguments);
    this.model.getAvailability().on('error', this.errorLoading, this);
    this.model.getReservations().on('error', this.errorBooking, this);
    this.model.on('change:selectedOption', this.renderInfo, this);
    this.model.on('change:selectedOption', this.renderQuestion, this);
    this.model.on('change:selectedOption', this.renderPhone, this);
    this.model.on('change:selectedTime', this.renderBookButton, this);
    this.model.on('change:phoneNumber', this.renderBookButton, this);
    this.model.on('change:questionsAnswer', this.renderBookButton, this);
    this.model.on('change:isBooking', this.renderBookButton, this);
  }

  Booker.prototype.canRenderOptions = function() {
    return this.options.optionSelectable && this.model.hasMultipleOptions();
  };

  Booker.prototype.canRenderPartySize = function() {
    return this.model.requirePartySize();
  };

  Booker.prototype.canRenderQuestion = function() {
    return this.model.requireQuestion();
  };

  Booker.prototype.canRenderPhone = function() {
    return this.model.requirePhone();
  };

  Booker.prototype.setOpen = function() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    return this.options.isOpen = true;
  };

  Booker.prototype.setOpenAndLocked = function() {
    this.setOpen();
    return this.options.isLocked = true;
  };

  Booker.prototype.setClosed = function() {
    return this.options.isOpen = false;
  };

  Booker.prototype.open = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-opened", null);
    this.setOpen();
    this.model.reset();
    return this.render({
      fadeIn: true
    });
  };

  Booker.prototype.close = function() {
    OptimizeSuite.TrackingHub.add("booking-widget-closed", null);
    this.setClosed();
    return this.$el.fadeOut((function(_this) {
      return function() {
        _this.render({
          show: true
        });
        if (_this.options.overlapWith) {
          $(_this.options.overlapWith).fadeIn();
        }
        return _this.model.resetOption();
      };
    })(this));
  };

  Booker.prototype.canBeClosed = function() {
    return this.options.isOpen && !this.options.keepOpen;
  };

  Booker.prototype.render = function() {
    var ref, ref1;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (!this.model.getError()) {
      if (this.options.isOpen || this.options.keepOpen) {
        this.renderInfo();
        this.renderPickers();
        this.renderQuestion();
        this.renderPhone();
        this.renderBookButton();
      }
    }
    if (((ref = arguments[0]) != null ? ref.fadeIn : void 0) === true) {
      this.$el.fadeIn();
    }
    if (((ref1 = arguments[0]) != null ? ref1.show : void 0) === true) {
      this.$el.show();
    }
    return this;
  };

  Booker.prototype.renderInfo = function() {
    var infoContainer;
    infoContainer = this.$el.find('[data-info-content]');
    if (infoContainer.length) {
      return infoContainer.html((new this.infoView({
        model: this.model
      })).render().el);
    }
  };

  Booker.prototype.renderPickers = function() {
    var pickersView;
    pickersView = new this.pickersView({
      el: this.$el.find('[data-pickers-content]')
    });
    if (this.canRenderOptions()) {
      pickersView.add({
        view: this.optionPickerView,
        model: this.model,
        collection: 'options',
        selection: 'selectedOption',
        selected: this.selectOption
      });
    }
    if (this.canRenderPartySize()) {
      pickersView.add({
        view: this.partySizePickerView,
        model: this.model,
        collection: 'partySizes',
        selection: 'selectedPartySize',
        selected: this.selectPartySize
      });
    }
    this.datePicker = pickersView.add({
      view: this.datePickerView,
      model: this.model,
      collection: 'availability',
      selection: 'selectedDate',
      selected: this.selectDate
    });
    this.timePicker = pickersView.add({
      view: this.timePickerView,
      model: this.model,
      collection: 'times',
      selection: 'selectedTime',
      selected: this.selectTime
    });
    pickersView.render();
    pickersView.on('collapse', (function(_this) {
      return function() {
        return _this.pickersCollapsed();
      };
    })(this));
    return pickersView.once('expanded', (function(_this) {
      return function() {
        return _this.trigger('ready');
      };
    })(this));
  };

  Booker.prototype.renderQuestion = function() {
    var questionEl;
    questionEl = this.$el.find('[data-question-content]');
    if (!this.canRenderQuestion()) {
      return questionEl.html('');
    }
    this.questionInput = new this.questionView({
      el: questionEl,
      maxLength: this.options.metasSettings.answerMaxLength,
      question: this.model.getQuestion(),
      answer: this.model.getQuestionsAnswer()
    });
    this.questionInput.render();
    this.questionInput.on('complete', this.setQuestionsAnswer, this);
    return this.questionInput.on('incomplete', this.clearQuestionsAnswer, this);
  };

  Booker.prototype.renderPhone = function() {
    var phoneEl;
    phoneEl = this.$el.find('[data-phone-content]');
    if (!this.canRenderPhone()) {
      return phoneEl.html('');
    }
    this.phoneInput = new this.phoneView({
      el: phoneEl,
      customerPhoneMaxLength: this.options.metasSettings.customerPhoneMaxLength,
      customerPhone: this.model.getPhoneNumber()
    });
    this.phoneInput.render();
    this.phoneInput.on('complete', this.setPhoneNumber, this);
    return this.phoneInput.on('incomplete', this.clearPhoneNumber, this);
  };

  Booker.prototype.pickersCollapsed = function() {
    if (this.model.requireQuestion() && !this.model.getQuestionsAnswer()) {
      return this.questionInput.focus();
    } else if (this.model.requirePhone() && !this.model.getPhoneNumber()) {
      return this.phoneInput.focus();
    }
  };

  Booker.prototype.renderBookButton = function() {
    var bookContainer;
    bookContainer = this.$el.find('[data-book-now-content]');
    if (bookContainer.length) {
      return bookContainer.html((new this.bookButtonView({
        model: this.model
      })).render().el);
    }
  };

  Booker.prototype.selectOption = function(option) {
    return this.model.selectOption(option);
  };

  Booker.prototype.selectDate = function(date) {
    return this.model.selectDate(date);
  };

  Booker.prototype.selectTime = function(time) {
    return this.model.selectTime(time);
  };

  Booker.prototype.selectPartySize = function(partySize) {
    return this.model.selectPartySize(partySize);
  };

  Booker.prototype.setPhoneNumber = function(phoneNumber) {
    return this.model.setPhoneNumber(phoneNumber);
  };

  Booker.prototype.clearPhoneNumber = function() {
    return this.setPhoneNumber(void 0);
  };

  Booker.prototype.setQuestionsAnswer = function(answer) {
    return this.model.setQuestionsAnswer(answer);
  };

  Booker.prototype.clearQuestionsAnswer = function() {
    return this.setQuestionsAnswer(void 0);
  };

  Booker.prototype.book = function(event) {
    event.stopPropagation();
    this.model.book();
    return false;
  };

  Booker.prototype.errorLoading = function() {
    return this.error('loading');
  };

  Booker.prototype.errorBooking = function(reservation) {
    return this.error(reservation.getError());
  };

  Booker.prototype.error = function(error) {
    this.model.setError(error);
    if (this.canBeClosed()) {
      return this.close();
    } else {
      return this.render();
    }
  };

  return Booker;

})(Booking.Views.Base);

Booking.Views.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  Calendar.prototype.presenter = Booking.Presenters.Calendar;

  Calendar.prototype.templateName = 'calendar';

  Calendar.prototype.selectedClass = 'selected';

  function Calendar() {
    Booking.Views.Base.apply(this, arguments);
    this.collection.on('request', this.setEvents, this);
    this.collection.on('sync', this.setEvents, this);
  }

  Calendar.prototype.setEvents = function() {
    var ref;
    if ((ref = this.calendar) != null) {
      ref.setEvents(this.collection.toJSON());
    }
    return this.select();
  };

  Calendar.prototype.render = function() {
    this.calendar = this.$el.clndr(this.CLNDRparams());
    this.select();
    return this;
  };

  Calendar.prototype.detach = function() {
    return this.$el.detach();
  };

  Calendar.prototype.toggle = function() {
    return this.$el.toggle();
  };

  Calendar.prototype.hide = function() {
    return this.$el.hide();
  };

  Calendar.prototype.select = function() {
    var ref, ref1;
    if (moment.isMoment((ref = this.options.selected) != null ? ref.date : void 0)) {
      return (ref1 = this.calendar) != null ? ref1.element.find(".calendar-day-" + (this.options.selected.date.format('YYYY-MM-DD'))).addClass(this.selectedClass) : void 0;
    }
  };

  Calendar.prototype.unselect = function() {
    return this.calendar.element.find("." + this.selectedClass).removeClass(this.selectedClass);
  };

  Calendar.prototype.selectDate = function(selection) {
    if (selection.events.length) {
      this.unselect();
      this.options.selected = selection;
      this.trigger('select', selection, this);
      return this.select();
    }
  };

  Calendar.prototype.renderCalendar = function(data) {
    var presenter;
    presenter = new this.presenter({
      calendarData: data,
      collection: this.collection
    });
    return this.template().render(presenter.toHashWithHelpers());
  };

  Calendar.prototype.CLNDRparams = function() {
    var ref, ref1, startWithMonth, timeMomentField;
    timeMomentField = 'clndrTimeMoment';
    startWithMonth = moment.isMoment((ref = this.options.selected) != null ? ref.date : void 0) ? this.options.selected.date : (ref1 = this.collection.first()) != null ? ref1.get(timeMomentField) : void 0;
    return {
      showAdjacentMonths: false,
      dateParameter: timeMomentField,
      startWithMonth: startWithMonth,
      events: this.collection.toJSON(),
      render: _.bind(this.renderCalendar, this),
      clickEvents: {
        click: _.bind(this.selectDate, this)
      },
      targets: {
        nextButton: 'next',
        previousButton: 'previous',
        day: 'day',
        empty: 'unavailable'
      }
    };
  };

  return Calendar;

})(Booking.Views.Base);

Booking.Views.Collection = (function(superClass) {
  extend(Collection, superClass);

  Collection.prototype.containerSelector = '[yield]';

  function Collection() {
    var ref, ref1, ref2, ref3;
    Booking.Views.Base.apply(this, arguments);
    if ((ref = this.collection) != null) {
      ref.on('add', (function(_this) {
        return function(model) {
          return _this.appendChildView(model);
        };
      })(this));
    }
    if ((ref1 = this.collection) != null) {
      ref1.on('remove', (function(_this) {
        return function(model) {
          return _this.removeChildView(model);
        };
      })(this));
    }
    if ((ref2 = this.collection) != null) {
      ref2.on('reset', this.render, this);
    }
    if ((ref3 = this.collection) != null) {
      ref3.on('sort', this.render, this);
    }
  }

  Collection.prototype.container = function() {
    var container;
    container = this.$el.find(this.containerSelector);
    if (container.length) {
      return container;
    } else {
      return this.$el;
    }
  };

  Collection.prototype.render = function() {
    var i, limit, models;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    if (this.collection) {
      models = this.collection.models;
      limit = this.options.limit && models.length > this.options.limit ? this.options.limit : models.length;
      i = 0;
      while (i < limit) {
        this.appendChildView(models[i]);
        i++;
      }
    }
    return this;
  };

  Collection.prototype.appendChildView = function(model) {
    return this.renderChildView('append', model);
  };

  Collection.prototype.prependChildView = function(model) {
    return this.renderChildView('prepend', model);
  };

  Collection.prototype.renderChildView = function(insert, model) {
    var childView, options;
    options = {
      model: model,
      id: model != null ? model.id : void 0
    };
    childView = new this.childView(_.extend(options, _.omit(this.options, 'el')));
    childView.on('all', this.bubbleUpEvent, this);
    this.container()[insert](childView.render().el);
    return this;
  };

  Collection.prototype.removeChildView = function(model) {
    return this.container().find("#" + model.id).remove();
  };

  Collection.prototype.bubbleUpEvent = function() {
    return this.trigger.apply(this, arguments);
  };

  return Collection;

})(Booking.Views.Base);

Booking.Views.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.presenter = Booking.Presenters.DatePicker;

  DatePicker.prototype.contentView = Booking.Views.Calendar;

  DatePicker.prototype.templateName = 'datepicker';

  DatePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "Dates"
    };
  };

  DatePicker.prototype.styleClassName = 'dates';

  DatePicker.prototype.isSelectable = function() {
    return true;
  };

  return DatePicker;

})(Booking.Views.Picker);

Booking.Views.EditableReservation = (function(superClass) {
  extend(EditableReservation, superClass);

  EditableReservation.prototype.presenter = Booking.Presenters.EditableReservation;

  EditableReservation.prototype.events = function() {
    var events;
    events = Booking.Views.Reservation.prototype.events;
    events['click .open-booker'] = 'openBooker';
    events['click .reschedule-reservation'] = 'openBooker';
    events['click .cancel-reservation'] = 'cancelReservation';
    return events;
  };

  function EditableReservation() {
    Booking.Views.Reservation.apply(this, arguments);
    this.model.on('sync', this.updateReservation, this).on('error', this.updateReservation, this);
  }

  EditableReservation.prototype.bookerView = function() {
    return this.options.bookerView;
  };

  EditableReservation.prototype.bookerModel = function() {
    return this.bookerView().model;
  };

  EditableReservation.prototype.bookerElement = function() {
    return this.bookerView().render().$el;
  };

  EditableReservation.prototype.cancelReservation = function(e) {
    e.preventDefault();
    if (confirm(this.translate('.cancel_confirmation'))) {
      return this.model.cancel();
    }
  };

  EditableReservation.prototype.openBooker = function(e) {
    var options;
    if (e != null) {
      e.preventDefault();
    }
    if (e != null) {
      e.stopPropagation();
    }
    this.bookerView().setOpen();
    this.bookerModel().getAvailability().on('error', this.closeBooker, this);
    this.bookerModel().clearError().loadAvailability();
    options = {
      destroyOnClose: false,
      closeOnBgClick: false,
      closeOnEscKey: false
    };
    this.bookerModel().getReservations().on('request', this.closeBooker, this).on('sync', this.updateReservation, this).on('error', this.updateReservation, this);
    return GIG.Modal.create(this.bookerElement(), options);
  };

  EditableReservation.prototype.closeBooker = function() {
    GIG.Modal.close();
    this.bookerView().setClosed();
    return this.render();
  };

  EditableReservation.prototype.updateReservation = function() {
    this.model = this.bookerModel().getReservation();
    if (this.model.isLocked()) {
      return this.bookerModel().preset({
        partySize: this.model.getPartySize(),
        questionsAnswer: this.model.getQuestion(),
        phoneNumber: this.model.getPhone()
      });
    } else {
      return this.bookerModel().resetDate().resetTime();
    }
  };

  return EditableReservation;

})(Booking.Views.Reservation);

Booking.Views.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.presenter = Booking.Presenters.Info;

  Info.prototype.templateName = 'info';

  return Info;

})(Booking.Views.Base);

Booking.Views.Option = (function(superClass) {
  extend(Option, superClass);

  function Option() {
    return Option.__super__.constructor.apply(this, arguments);
  }

  Option.prototype.presenter = Booking.Presenters.Option;

  Option.prototype.templateName = 'option';

  Option.prototype.tagName = 'li';

  Option.prototype.events = {
    'click': 'select'
  };

  Option.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  Option.prototype.select = function() {
    if (!this.model.isSoldOut()) {
      return this.trigger('select', this.model);
    }
  };

  return Option;

})(Booking.Views.Base);

Booking.Views.OptionPicker = (function(superClass) {
  extend(OptionPicker, superClass);

  function OptionPicker() {
    return OptionPicker.__super__.constructor.apply(this, arguments);
  }

  OptionPicker.prototype.presenter = Booking.Presenters.OptionPicker;

  OptionPicker.prototype.contentView = Booking.Views.Options;

  OptionPicker.prototype.templateName = 'optionpicker';

  OptionPicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "DealOptions"
    };
  };

  OptionPicker.prototype.styleClassName = 'options';

  return OptionPicker;

})(Booking.Views.Picker);

Booking.Views.Options = (function(superClass) {
  extend(Options, superClass);

  Options.prototype.tagName = 'ul';

  Options.prototype.childView = Booking.Views.Option;

  function Options() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Options.prototype.select = function(option) {
    this.options.selected = option;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return Options;

})(Booking.Views.Collection);

Booking.Views.PartySize = (function(superClass) {
  extend(PartySize, superClass);

  function PartySize() {
    return PartySize.__super__.constructor.apply(this, arguments);
  }

  PartySize.prototype.presenter = Booking.Presenters.PartySize;

  PartySize.prototype.templateName = 'partysize';

  PartySize.prototype.tagName = 'li';

  PartySize.prototype.events = {
    'click': 'select'
  };

  PartySize.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  PartySize.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  return PartySize;

})(Booking.Views.Base);

Booking.Views.PartySizePicker = (function(superClass) {
  extend(PartySizePicker, superClass);

  function PartySizePicker() {
    return PartySizePicker.__super__.constructor.apply(this, arguments);
  }

  PartySizePicker.prototype.presenter = Booking.Presenters.PartyPicker;

  PartySizePicker.prototype.contentView = Booking.Views.PartySizes;

  PartySizePicker.prototype.templateName = 'partysizepicker';

  PartySizePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "PartySizes"
    };
  };

  PartySizePicker.prototype.styleClassName = 'party-sizes';

  return PartySizePicker;

})(Booking.Views.Picker);

Booking.Views.PartySizes = (function(superClass) {
  extend(PartySizes, superClass);

  PartySizes.prototype.templateName = 'partysizes';

  PartySizes.prototype.childView = Booking.Views.PartySize;

  function PartySizes() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  PartySizes.prototype.select = function(partySize) {
    this.options.selected = partySize;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return PartySizes;

})(Booking.Views.Collection);

Booking.Views.Phone = (function(superClass) {
  extend(Phone, superClass);

  function Phone() {
    return Phone.__super__.constructor.apply(this, arguments);
  }

  Phone.prototype.presenter = Booking.Presenters.Phone;

  Phone.prototype.templateName = 'phone';

  Phone.prototype.maxDigitCount = 10;

  Phone.prototype.events = {
    'keypress input': 'formatPhoneNumber',
    'paste input': 'dismissPasteEvent',
    'keyup input': 'triggerEvents',
    'change input': 'clearable',
    'keydown input': 'clearable',
    'click .clear': 'clear'
  };

  Phone.prototype.render = function() {
    var base;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$input = this.$el.find('input');
    this.input = this.$input.get(0);
    if (typeof (base = this.$input).PlaceholderField === "function") {
      base.PlaceholderField();
    }
    this.clearable();
    return this;
  };

  Phone.prototype.isntDigitOrControlKey = function(charCode) {
    return charCode > 31 && (charCode < 48 || charCode > 57);
  };

  Phone.prototype.formatPhoneNumber = function(e) {
    var digit, length, re, value;
    if (this.isntDigitOrControlKey(e.which)) {
      return false;
    }
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return true;
    }
    value = this.input.value;
    length = (value.replace(/\D/g, '') + digit).length;
    if (length > this.maxDigitCount) {
      e.preventDefault();
      this.input.value = value;
      return;
    }
    if ((this.$input.prop('selectionStart') != null) && this.$input.prop('selectionStart') !== value.length) {
      return;
    }
    re = /^(\d{3}|\d{3}\-\d{3})$/;
    if (re.test(value)) {
      e.preventDefault();
      return this.input.value = value + "-" + digit;
    } else if (re.test(value + digit)) {
      e.preventDefault();
      return this.input.value = "" + value + digit + "-";
    }
  };

  Phone.prototype.triggerEvents = function() {
    var event, value;
    value = this.$input.val();
    event = value.length === this.options.customerPhoneMaxLength ? 'complete' : 'incomplete';
    return this.trigger(event, value);
  };

  Phone.prototype.dismissPasteEvent = function() {
    return false;
  };

  Phone.prototype.focus = function() {
    return this.input.focus();
  };

  Phone.prototype.clearable = function() {
    var method;
    method = this.input.value.length ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Phone.prototype.clear = function() {
    this.input.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  return Phone;

})(Booking.Views.Base);

Booking.Views.Pickers = (function(superClass) {
  extend(Pickers, superClass);

  function Pickers() {
    return Pickers.__super__.constructor.apply(this, arguments);
  }

  Pickers.prototype.add = function(arg) {
    var collection, model, picker, selected, selection, view;
    view = arg.view, model = arg.model, collection = arg.collection, selection = arg.selection, selected = arg.selected;
    if (this.pickers == null) {
      this.pickers = [];
    }
    picker = new view({
      model: model,
      collection: model.get(collection),
      selected: selection,
      previous: this.pickers[this.pickers.length - 1]
    });
    picker.on('select', (function(_this) {
      return function(selection) {
        var nextPicker;
        selected(selection);
        nextPicker = _this.nextUnselectedPicker();
        if (nextPicker) {
          _this.collapse(true);
          return _this.expand(nextPicker);
        } else {
          _this.trigger('collapse');
          picker.once('collapsed', function() {
            return _this.trigger('collapsed');
          });
          return _this.collapse(false);
        }
      };
    })(this));
    picker.on('expand', (function(_this) {
      return function(picker) {
        if (_this.picker) {
          _this.collapse(true);
        }
        return _this.setActivePicker(picker);
      };
    })(this));
    picker.on('collapse', this.unsetActivePicker, this);
    this.pickers.push(picker);
    return picker;
  };

  Pickers.prototype.expanded = function() {
    var picker;
    if ((function() {
      var j, len, ref, results;
      ref = this.pickers;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        picker = ref[j];
        results.push(picker.isVisible);
      }
      return results;
    }).call(this)) {
      return true;
    }
    return false;
  };

  Pickers.prototype.render = function() {
    var j, len, picker, ref;
    Booking.Views.Base.prototype.render.apply(this, arguments);
    ref = this.pickers;
    for (j = 0, len = ref.length; j < len; j++) {
      picker = ref[j];
      this.$el.append(picker.render().el);
    }
    setTimeout(((function(_this) {
      return function() {
        return _this.postRender();
      };
    })(this)), 1000);
    return this;
  };

  Pickers.prototype.postRender = function() {
    var picker;
    picker = this.firstNotSelected();
    if (picker) {
      return this.expand(picker);
    }
  };

  Pickers.prototype.expand = function(picker) {
    picker.show();
    return picker.once('expanded', (function(_this) {
      return function() {
        return _this.trigger('expanded');
      };
    })(this));
  };

  Pickers.prototype.nextUnselectedPicker = function() {
    return _.find(this.pickers, function(picker) {
      return !picker.selected();
    });
  };

  Pickers.prototype.collapse = function() {
    return this.picker.hide(true);
  };

  Pickers.prototype.setActivePicker = function(picker) {
    if (picker) {
      this.picker = picker;
    }
    return picker;
  };

  Pickers.prototype.unsetActivePicker = function() {
    return delete this.picker;
  };

  Pickers.prototype.firstNotSelected = function() {
    return _.find(this.pickers, function(picker) {
      return !picker.selected();
    });
  };

  return Pickers;

})(Booking.Views.Base);

Booking.Views.Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.prototype.presenter = Booking.Presenters.Question;

  Question.prototype.templateName = 'question';

  Question.prototype.events = {
    'click .label': 'focus',
    'blur textarea': 'willBlur',
    'change textarea': 'refreshStatus',
    'keyup textarea': 'refreshStatus',
    'keydown textarea': 'refreshStatus',
    'keypress textarea': 'newText',
    'paste textarea': 'truncatePaste',
    'click .clear': 'clear'
  };

  Question.prototype.render = function() {
    Booking.Views.Base.prototype.render.apply(this, arguments);
    this.$textarea = this.$el.find('textarea');
    this.textarea = this.$textarea.get(0);
    this.$textarea.autosize();
    this.updateLabel(this.$textarea.val());
    return this.refreshStatus();
  };

  Question.prototype.focus = function() {
    clearTimeout(this.willBlurTimer);
    this.updateLabel();
    this.$el.addClass('expanded');
    return this.$textarea.focus();
  };

  Question.prototype.willBlur = function() {
    return this.willBlurTimer = setTimeout(((function(_this) {
      return function() {
        return _this.blur();
      };
    })(this)), 10);
  };

  Question.prototype.blur = function() {
    this.$el.removeClass('expanded');
    this.updateLabel(this.$textarea.val());
    return this.triggerEvents();
  };

  Question.prototype.updateLabel = function(value) {
    if (!value) {
      value = this.options.question;
    }
    return this.$el.find('.label').html(value);
  };

  Question.prototype.refreshStatus = function() {
    this.clearable();
    return this.triggerEvents();
  };

  Question.prototype.newText = function() {
    var maxLength;
    this.refreshStatus();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      if (this.textarea.value.length >= maxLength) {
        this.textarea.value = this.textarea.value.slice(0, maxLength);
        return false;
      }
    }
  };

  Question.prototype.truncatePaste = function(e) {
    var maxLength, paste;
    this.clearable();
    if (indexOf.call(this.textarea, 'maxLength') < 0) {
      maxLength = this.textarea.attributes.maxLength.value;
      paste = e.originalEvent.clipboardData.getData('Text');
      if (this.textarea.value.length + paste.length >= maxLength) {
        this.textarea.value += paste.slice(0, maxLength - this.textarea.value.length);
        return false;
      }
    }
  };

  Question.prototype.clearable = function() {
    var method;
    method = this.textarea.value.length ? 'addClass' : 'removeClass';
    return this.$el[method]('clearable');
  };

  Question.prototype.clear = function() {
    clearTimeout(this.willBlurTimer);
    this.textarea.value = '';
    this.triggerEvents();
    this.clearable();
    return this.focus();
  };

  Question.prototype.triggerEvents = function() {
    var event, value;
    value = this.textarea.value;
    event = value.length ? 'complete' : 'incomplete';
    return this.trigger(event, value);
  };

  return Question;

})(Booking.Views.Base);

Booking.Views.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.presenter = Booking.Presenters.Time;

  Time.prototype.templateName = 'time';

  Time.prototype.tagName = 'li';

  Time.prototype.events = {
    'click': 'select'
  };

  Time.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  Time.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  return Time;

})(Booking.Views.Base);

Booking.Views.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  function TimePicker() {
    return TimePicker.__super__.constructor.apply(this, arguments);
  }

  TimePicker.prototype.presenter = Booking.Presenters.TimePicker;

  TimePicker.prototype.contentView = Booking.Views.Times;

  TimePicker.prototype.templateName = 'timepicker';

  TimePicker.prototype.attributes = function() {
    return {
      'data-bhw': Booking.bhw + "Times"
    };
  };

  TimePicker.prototype.styleClassName = 'times';

  TimePicker.prototype.isSelectable = function() {
    return true;
  };

  return TimePicker;

})(Booking.Views.Picker);

Booking.Views.Times = (function(superClass) {
  extend(Times, superClass);

  Times.prototype.templateName = 'times';

  Times.prototype.childView = Booking.Views.Time;

  function Times() {
    Booking.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Times.prototype.select = function(time) {
    this.options.selected = time;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return Times;

})(Booking.Views.Collection);

Booking.dealBookerInit = function(payload, done) {
  var datetime, deal, el, error, failed, metasSettings, model, optionId, overlapWith, partySize, phoneNumber, questionsAnswer, timezoneData, view;
  if (done == null) {
    done = function() {};
  }
  if (!payload) {
    return done();
  }
  Booking.bhw = 'BookingEngineDealBooker';
  deal = payload.deal, timezoneData = payload.timezoneData, el = payload.el, failed = payload.failed, error = payload.error, overlapWith = payload.overlapWith, metasSettings = payload.metasSettings, optionId = payload.optionId, partySize = payload.partySize, datetime = payload.datetime, questionsAnswer = payload.questionsAnswer, phoneNumber = payload.phoneNumber;
  moment.tz.add(timezoneData);
  model = new Booking.Models.Booker({
    deal: deal,
    bookAndBuy: true
  });
  model.preset({
    optionId: optionId,
    partySize: partySize,
    datetime: datetime,
    questionsAnswer: questionsAnswer,
    phoneNumber: phoneNumber
  });
  if (!model.get('options').selectable().length) {
    return done();
  }
  view = new Booking.Views.Booker({
    optionSelectable: true,
    el: el || '#deal-booker',
    overlapWith: overlapWith || '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card',
    model: model,
    templateName: 'deal_booker',
    metasSettings: metasSettings
  });
  model.get('availability').on('error', function() {
    return failed != null ? failed.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('error', function() {
    return error != null ? error.apply(this, arguments) : void 0;
  });
  model.get('reservations').on('sync', function(reservation) {
    var option;
    option = model.get('options').get(reservation.getOption().id);
    return view.trigger('buy', option, reservation);
  });
  view.on('buy', function(option, reservation) {
    var buyUrl, separator;
    buyUrl = option.get('buyUrl');
    if (reservation) {
      separator = buyUrl.match(/\?/) ? '&' : '?';
      buyUrl += separator + "booking_reservation_id=" + (reservation.get('id'));
    }
    return window.location = buyUrl;
  });
  return $(function() {
    if (!$('#purchase-cluster .buy').length) {
      view.setOpenAndLocked();
    }
    view.render();
    return done();
  });
};
  return Booking;
})();
},{}],111:[function(require,module,exports){
var base, base1, base2, base3, base4, base5;

if (window.GliveBooking == null) {
  window.GliveBooking = {};
}

if ((base = window.GliveBooking).rootUrl == null) {
  base.rootUrl = "/GliveBooking";
}

if ((base1 = window.GliveBooking).Collections == null) {
  base1.Collections = {};
}

if ((base2 = window.GliveBooking).Models == null) {
  base2.Models = {};
}

if ((base3 = window.GliveBooking).Presenters == null) {
  base3.Presenters = {};
}

if ((base4 = window.GliveBooking).Views == null) {
  base4.Views = {};
}

if ((base5 = window.GliveBooking).FilteredCollections == null) {
  base5.FilteredCollections = {};
}



},{}],112:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Collections.Events = (function(superClass) {
  extend(Events, superClass);

  function Events() {
    return Events.__super__.constructor.apply(this, arguments);
  }

  Events.prototype.model = GliveBooking.Models.Event;

  Events.prototype.times = function() {
    return this.map(function(event) {
      return event.getTime();
    });
  };

  return Events;

})(BookingV2.Collections.Base);



},{}],113:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Collections.Prices = (function(superClass) {
  extend(Prices, superClass);

  function Prices() {
    return Prices.__super__.constructor.apply(this, arguments);
  }

  Prices.prototype.model = GliveBooking.Models.Price;

  Prices.prototype.getCheapest = function() {
    return this.min(function(price) {
      return price.getPrice();
    });
  };

  return Prices;

})(BookingV2.Collections.Base);



},{}],114:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Collections.Sections = (function(superClass) {
  extend(Sections, superClass);

  function Sections() {
    return Sections.__super__.constructor.apply(this, arguments);
  }

  Sections.prototype.model = GliveBooking.Models.Section;

  return Sections;

})(BookingV2.Collections.Base);



},{}],115:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Collections.Times = (function(superClass) {
  extend(Times, superClass);

  function Times() {
    return Times.__super__.constructor.apply(this, arguments);
  }

  Times.prototype.model = GliveBooking.Models.Time;

  return Times;

})(BookingV2.Collections.Base);



},{}],116:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.FilteredCollections.Base = (function(superClass) {
  extend(Base, superClass);

  function Base() {
    return Base.__super__.constructor.apply(this, arguments);
  }

  return Base;

})(Backbone.Obscura);



},{}],117:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.FilteredCollections.Events = (function(superClass) {
  extend(Events, superClass);

  function Events() {
    return Events.__super__.constructor.apply(this, arguments);
  }

  Events.prototype.getDates = function() {
    var dates;
    return dates = _.sortBy(this.map(function(event) {
      return event.getTime();
    }), function(time) {
      return time.start();
    });
  };

  Events.prototype.getTimes = function() {
    var times;
    return times = this.map(function(event) {
      return event.getTime();
    });
  };

  Events.prototype.getSections = function() {
    var sections;
    return sections = this.map(function(event) {
      return event.getSection();
    });
  };

  Events.prototype.getQuantities = function() {
    var allQuantityOptions;
    allQuantityOptions = this.map(function(event) {
      return event.getQuantityOptions();
    });
    return _.chain(allQuantityOptions).flatten().uniq().sortBy(function(num) {
      return num;
    }).value();
  };

  Events.prototype.getPrices = function() {
    var prices;
    return prices = this.map(function(event) {
      return event.getPrice();
    });
  };

  Events.prototype.setDateFilter = function(moment) {
    if (moment == null) {
      return;
    }
    this.removeFilter('dates');
    this._selectedDate = moment;
    return this.filterBy('dates', {
      time: function(eventTime) {
        return eventTime.start().format('L') === moment.format('L');
      }
    });
  };

  Events.prototype.setTimeFilter = function(time) {
    if (time == null) {
      return;
    }
    this.removeFilter('times');
    this._selectedTime = time;
    return this.filterBy('times', {
      time: function(eventTime) {
        return eventTime.start().format('HH:mm') === time.start().format('HH:mm');
      }
    });
  };

  Events.prototype.setQuantityFilter = function(quantity) {
    if (quantity == null) {
      return;
    }
    this.removeFilter('quantities');
    this._selectedQuantity = quantity;
    return this.filterBy('quantities', function(event) {
      return (event.getUserMin() <= quantity && quantity <= event.getMaxQuantity());
    });
  };

  Events.prototype.setPriceFilter = function(price) {
    if (price == null) {
      return;
    }
    this.removeFilter('prices');
    this._selectedPrice = price;
    return this.filterBy('prices', function(event) {
      return event.getPrice().getPrice() === price.getPrice();
    });
  };

  Events.prototype.setSectionFilter = function(section) {
    if (section == null) {
      return;
    }
    this.removeFilter('sections');
    this._selectedSection = section;
    return this.filterBy('sections', function(event) {
      return event.getSection().getTitle() === section.getTitle();
    });
  };

  Events.prototype.getMinQuantity = function() {
    if (!(this.length > 0)) {
      return 0;
    }
    return _.min(this.map(function(event) {
      return event.getUserMin();
    }));
  };

  Events.prototype.getMaxQuantity = function() {
    if (!(this.length > 0)) {
      return 0;
    }
    return _.max(this.map(function(event) {
      return event.getMaxQuantity();
    }));
  };

  return Events;

})(GliveBooking.FilteredCollections.Base);



},{}],118:[function(require,module,exports){
BookingV2.gliveDealBookerInit = function(isTouchRequest, payload, done) {
  var calendar, datetime, deal, el, error, gliveAvailabilityHash, metasSettings, model, optionId, overlapWith, partySize, phoneNumber, places, timezoneData, view;
  if (done == null) {
    done = function() {};
  }
  if (!payload) {
    return done();
  }
  GliveBooking.bhw = 'GliveBookingDealBooker';
  calendar = payload.calendar, deal = payload.deal, places = payload.places, timezoneData = payload.timezoneData, el = payload.el, error = payload.error, overlapWith = payload.overlapWith, metasSettings = payload.metasSettings, optionId = payload.optionId, partySize = payload.partySize, datetime = payload.datetime, phoneNumber = payload.phoneNumber;
  if (timezoneData != null) {
    moment.tz.add(timezoneData);
  }
  gliveAvailabilityHash = payload["gliveAvailabilityHash"];
  model = new GliveBooking.Models.Booker({
    bookAndBuy: true,
    calendar: calendar,
    deal: deal,
    gliveAvailabilityHash: gliveAvailabilityHash,
    isTouchRequest: isTouchRequest
  });
  view = new GliveBooking.Views.Booker({
    attributes: {
      'data-bhw': 'GliveBookingDealBooker'
    },
    el: el || '#deal-booker',
    overlapWith: overlapWith || '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card',
    model: model,
    templateName: 'deal_booker',
    metasSettings: metasSettings
  });
  view.on('buy', function(option, reservation) {
    var buyUrl;
    buyUrl = option.get('buyUrl');
    return window.location = buyUrl;
  });
  return $(function() {
    if (!$('#purchase-cluster .buy').length) {
      view.setOpenAndLocked();
    }
    view.render();
    return done();
  });
};



},{}],119:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Models.Booker = (function(superClass) {
  extend(Booker, superClass);

  function Booker() {
    return Booker.__super__.constructor.apply(this, arguments);
  }

  Booker.prototype.loaded = true;

  Booker.prototype.initialize = function() {
    var error, eventsCollection, filteredEventsCollection, isAvailable, isSoldOut, isTouchRequest, prices, ref, sections, times;
    try {
      if (((ref = this.get('gliveAvailabilityHash')) != null ? ref.events : void 0) == null) {
        throw "Invalid availability data";
      }
      eventsCollection = new GliveBooking.Collections.Events(this.get('gliveAvailabilityHash').events);
      filteredEventsCollection = new GliveBooking.FilteredCollections.Events(eventsCollection);
      isSoldOut = this.get('gliveAvailabilityHash').product.isSoldOut;
      isAvailable = filteredEventsCollection.length > 0;
      times = this.uniquifyAndSortTimes(filteredEventsCollection.getTimes());
      sections = this.uniquifySections(filteredEventsCollection.getSections());
      prices = this.uniquifyPrices(filteredEventsCollection.getPrices());
      isTouchRequest = this.get('isTouchRequest');
      this.set({
        isSoldOut: isSoldOut,
        isAvailable: isAvailable,
        isSellable: !isSoldOut && isAvailable,
        events: eventsCollection,
        filteredEvents: filteredEventsCollection,
        dates: new BookingV2.Collections.Availability(filteredEventsCollection.getDates()),
        times: new GliveBooking.Collections.Times(times),
        quantities: new BookingV2.Collections.PartySizes(filteredEventsCollection.getQuantities()),
        sections: new GliveBooking.Collections.Sections(sections),
        prices: new GliveBooking.Collections.Prices(prices),
        isTouch: isTouchRequest
      });
      this.get('dates').meta('loaded', true);
      this.get('times').meta('loaded', true);
      this.get('events').meta('isTouch', this.get('isTouchRequest'));
      this.get('dates').meta('isTouch', this.get('isTouchRequest'));
      this.get('times').meta('isTouch', this.get('isTouchRequest'));
      this.get('quantities').meta('isTouch', this.get('isTouchRequest'));
      this.get('sections').meta('isTouch', this.get('isTouchRequest'));
      return this.get('prices').meta('isTouch', this.get('isTouchRequest'));
    } catch (_error) {
      error = _error;
      console.error(error);
      if (error === "Invalid availability data") {
        return this.setError('loading');
      }
    }
  };

  Booker.prototype.setError = function(error) {
    return this.set({
      error: error
    });
  };

  Booker.prototype.clearError = function() {
    return this.unset('error');
  };

  Booker.prototype.getError = function() {
    return this.get('error');
  };

  Booker.prototype.uniquifyAndSortTimes = function(timesArray) {
    var times;
    times = _.uniq(timesArray, function(time) {
      return time.start().format('LT');
    });
    return times = _.sortBy(times, function(time) {
      return time.start().format("HH mm");
    });
  };

  Booker.prototype.uniquifySections = function(sectionsArray) {
    var sections;
    return sections = _.uniq(sectionsArray, function(section) {
      return section.getTitle();
    });
  };

  Booker.prototype.uniquifyPrices = function(pricesArray) {
    var prices;
    return prices = _.uniq(pricesArray, function(price) {
      return price.getPrice();
    });
  };

  Booker.prototype.getEvents = function() {
    return this.get('events');
  };

  Booker.prototype.requirePhone = function() {
    return false;
  };

  Booker.prototype.requireQuestion = function() {
    return false;
  };

  Booker.prototype.discountEnabled = function() {
    return this.get('deal').discountEnabled;
  };

  Booker.prototype.reset = function() {
    return this.resetTime();
  };

  Booker.prototype.resetDate = function() {
    return this.selectDate(null);
  };

  Booker.prototype.resetTime = function() {
    return this.selectTime(null);
  };

  Booker.prototype.updateAllPickers = function() {
    var dates, prices, quantities, sections, times;
    dates = this.get('filteredEvents').getDates();
    this.get('dates').reset(dates);
    times = this.uniquifyAndSortTimes(this.get('filteredEvents').getTimes());
    this.get('times').reset(times);
    quantities = this.get('filteredEvents').getQuantities();
    this.get('quantities').reset(quantities);
    prices = this.uniquifyPrices(this.get('filteredEvents').getPrices());
    this.get('prices').reset(prices);
    sections = this.uniquifySections(this.get('filteredEvents').getSections());
    this.get('sections').reset(sections);
    return this.trigger("updatedCollections");
  };

  Booker.prototype.selectDate = function(selection) {
    var date, events, selectedDate, selectedEventTime;
    events = [];
    if (selection != null) {
      events = selection.events, date = selection.date;
      selectedDate = {
        date: date
      };
      selectedEventTime = events[0].initialTimeMoment;
    }
    this.set({
      selectedDate: selectedDate
    });
    this.get('filteredEvents').setDateFilter(selectedEventTime);
    return this.updateAllPickers();
  };

  Booker.prototype.selectTime = function(time) {
    this.set({
      selectedTime: time
    });
    this.get('filteredEvents').setTimeFilter(time);
    return this.updateAllPickers();
  };

  Booker.prototype.selectPrice = function(price) {
    this.set({
      selectedPrice: price
    });
    this.get('filteredEvents').setPriceFilter(price);
    return this.updateAllPickers();
  };

  Booker.prototype.selectSection = function(section) {
    this.set({
      selectedSection: section
    });
    this.get('filteredEvents').setSectionFilter(section);
    return this.updateAllPickers();
  };

  Booker.prototype.selectQuantity = function(quantity) {
    this.set({
      selectedQuantity: quantity
    });
    this.get('filteredEvents').setQuantityFilter(quantity.getPartySize());
    return this.updateAllPickers();
  };

  Booker.prototype.clearAll = function() {
    this.get('filteredEvents').resetFilters();
    this.updateAllPickers();
    this.set({
      selectedDate: {
        date: null
      }
    });
    this.set({
      selectedTime: null
    });
    this.set({
      selectedQuantity: null
    });
    this.set({
      selectedSection: null
    });
    this.set({
      selectedPrice: null
    });
    this.updateAllPickers();
    return this.trigger("clearAll");
  };

  Booker.prototype.isReadyToBook = function() {
    var ref;
    return (((ref = this.get('selectedDate')) != null ? ref.date : void 0) != null) && (this.get('selectedTime') != null) && (this.get('selectedQuantity') != null) && (this.get('selectedPrice') != null) && (this.get('selectedSection') != null);
  };

  Booker.prototype.checkoutUrl = function() {
    var event_uuid, permalink, quantity;
    permalink = this.get('deal').id;
    event_uuid = this.get('filteredEvents').first().getUUID();
    quantity = this.get('selectedQuantity').getPartySize();
    return "/live/deals/" + permalink + "/reservation?event=" + event_uuid + "&quantity=" + quantity;
  };

  Booker.prototype.book = function() {
    return window.location.href = this.checkoutUrl();
  };

  return Booker;

})(BookingV2.Models.Base);



},{}],120:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Models.Event = (function(superClass) {
  extend(Event, superClass);

  function Event() {
    return Event.__super__.constructor.apply(this, arguments);
  }

  Event.prototype.initialize = function() {
    var eventStartAt, maxQuantity, ref;
    eventStartAt = moment.unix(this.get('eventStartAt'));
    if (!((this.get('userMax') != null) && (((ref = this.get('quantitySummary')) != null ? ref.estimatedRemainingQuantity : void 0) != null))) {
      throw "Invalid availability data";
    }
    maxQuantity = Math.min(this.get('userMax'), this.get('quantitySummary').estimatedRemainingQuantity);
    return this.set({
      eventStartAt: eventStartAt,
      time: new GliveBooking.Models.Time({
        initial_time: this.get('eventStartAt'),
        final_time: null
      }),
      section: new GliveBooking.Models.Section({
        title: this.get('section')
      }),
      price: new GliveBooking.Models.Price({
        price: this.get('priceSummary').price,
        value: this.get('priceSummary').value,
        discount: this.get('priceSummary').discount,
        savings: this.get('priceSummary').savings
      }),
      maxQuantity: maxQuantity
    });
  };

  Event.prototype.getUUID = function() {
    return this.get('uuid');
  };

  Event.prototype.getUserMin = function() {
    return this.get('userMin');
  };

  Event.prototype.getQuantityOptions = function() {
    var i, maxQuantity, ref, results;
    maxQuantity = this.getMaxQuantity();
    return _.reject((function() {
      results = [];
      for (var i = ref = this.getUserMin(); ref <= maxQuantity ? i <= maxQuantity : i >= maxQuantity; ref <= maxQuantity ? i++ : i--){ results.push(i); }
      return results;
    }).apply(this), function(num) {
      return num === maxQuantity - 1;
    });
  };

  Event.prototype.getMaxQuantity = function() {
    return this.get('maxQuantity');
  };

  Event.prototype.getTime = function() {
    return this.get('time');
  };

  Event.prototype.getPrice = function() {
    return this.get('price');
  };

  Event.prototype.getSection = function() {
    return this.get('section');
  };

  return Event;

})(BookingV2.Models.Base);



},{}],121:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Models.Price = (function(superClass) {
  extend(Price, superClass);

  function Price() {
    return Price.__super__.constructor.apply(this, arguments);
  }

  Price.prototype.getPrice = function() {
    return this.get('price').amount;
  };

  Price.prototype.getFormattedPrice = function() {
    return this.get('price').formattedAmount;
  };

  Price.prototype.getPriceCurrencyCode = function() {
    return this.get('price').currencyCode;
  };

  Price.prototype.getValue = function() {
    return this.get('value').amount;
  };

  Price.prototype.getFormattedValue = function() {
    return this.get('value').formattedAmount;
  };

  Price.prototype.getValueCurrencyCode = function() {
    return this.get("value").currencyCode;
  };

  Price.prototype.getDiscount = function() {
    return this.get('discount');
  };

  Price.prototype.getSavings = function() {
    return this.getValue() - this.getPrice();
  };

  return Price;

})(BookingV2.Models.Base);



},{}],122:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Models.Section = (function(superClass) {
  extend(Section, superClass);

  function Section() {
    return Section.__super__.constructor.apply(this, arguments);
  }

  Section.prototype.getTitle = function() {
    return this.get('title');
  };

  return Section;

})(BookingV2.Models.Base);



},{}],123:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Models.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    var finalTimeMoment, initialTimeMoment;
    BookingV2.Models.Base.apply(this, arguments);
    initialTimeMoment = moment(this.get('initial_time'));
    finalTimeMoment = moment(this.get('initial_time'));
    this.set({
      initialTimeMoment: initialTimeMoment,
      finalTimeMoment: finalTimeMoment,
      clndrTimeMoment: initialTimeMoment
    });
  }

  Time.prototype.start = function() {
    return this.get('initialTimeMoment');
  };

  Time.prototype.end = function() {
    return this.get('initialTimeMoment');
  };

  return Time;

})(BookingV2.Models.Base);



},{}],124:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.module = 'glive-booking';

  Book.prototype.toHash = function() {
    var isDisabled, isSellable;
    isSellable = this.model.get('isSellable');
    isDisabled = !this.model.isReadyToBook() || !isSellable;
    return {
      isAvailable: this.model.get('isAvailable'),
      isDisabled: isDisabled,
      isPromNight: window.promNight,
      isSellable: isSellable,
      isSoldOut: this.model.get('isSoldOut')
    };
  };

  return Book;

})(BookingV2.Presenters.Base);



},{}],125:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.module = 'glive-booking';

  function Booker() {
    BookingV2.Presenters.Base.apply(this, arguments);
    if (this.isARSE) {
      this.localesBasePath = this.localesBasePath + "_arse";
    }
  }

  Booker.prototype.toHash = function() {
    var error, hash;
    error = this.model.get('error');
    hash = {
      error: error,
      errorLoading: error === 'loading' || error === 'timeout',
      errorBooking: error === 'server' || error === 'not_found',
      errorSegmentNotAvailable: error === 'conflict',
      errorSegmentExpired: error === 'gone',
      myReservationsLink: "/users/" + (this.model.get('userId')) + "/reservations",
      myGrouponsLink: "/users/" + (this.model.get('userId')) + "/groupons",
      isOpen: this.options.isOpen,
      isLocked: this.options.isLocked,
      phoneRequired: this.model.requirePhone(),
      questionRequired: this.model.requireQuestion(),
      isARSE: this.isARSE,
      showNewOverlay: this.options.showNewOverlay
    };
    return hash;
  };

  return Booker;

})(BookingV2.Presenters.Base);



},{}],126:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  function Calendar() {
    return Calendar.__super__.constructor.apply(this, arguments);
  }

  Calendar.prototype.toHash = function() {
    var hash;
    hash = BookingV2.Presenters.Calendar.prototype.toHash.apply(this, arguments);
    hash.isTouch = this.collection.meta('isTouch');
    hash.year = this.options.calendarData.year;
    return hash;
  };

  return Calendar;

})(BookingV2.Presenters.Calendar);



},{}],127:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.module = 'glive-booking';

  DatePicker.prototype.toHash = function() {
    var hash;
    hash = BookingV2.Presenters.DatePicker.prototype.toHash.apply(this, arguments);
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  };

  return DatePicker;

})(BookingV2.Presenters.DatePicker);



},{}],128:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.module = 'glive-booking';

  Info.prototype.toHash = function() {
    var discountEnabled, displayPrice, isReadyToBook, quantity, savings, selectedPrice, subtotal, value;
    selectedPrice = this.model.get('selectedPrice');
    displayPrice = selectedPrice || this.model.get('prices').getCheapest();
    quantity = 1;
    discountEnabled = this.model.discountEnabled();
    if (this.model.get('selectedQuantity') != null) {
      quantity = this.model.get('selectedQuantity').getPartySize();
    }
    subtotal = displayPrice.getPrice() * quantity;
    value = displayPrice.getValue() * quantity;
    savings = quantity * displayPrice.getSavings();
    isReadyToBook = this.model.isReadyToBook();
    return {
      optionSelected: selectedPrice != null,
      discountEnabled: discountEnabled,
      price: this.formatMoney(subtotal, displayPrice.getPriceCurrencyCode()),
      value: this.formatMoney(value, displayPrice.getValueCurrencyCode()),
      discount: displayPrice.getDiscount(),
      savings: this.formatMoney(savings, displayPrice.getPriceCurrencyCode()),
      isReadyToBook: isReadyToBook
    };
  };

  Info.prototype.formatMoney = function(amountCents, currencyCode) {
    var formattedCurrency, trailingZerosRegex;
    formattedCurrency = I18n.toCurrency(amountCents / 100, {
      currencyCode: currencyCode
    });
    trailingZerosRegex = /[,\.]00(?!\d)/;
    return formattedCurrency.replace(trailingZerosRegex, "");
  };

  return Info;

})(BookingV2.Presenters.Base);



},{}],129:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Price = (function(superClass) {
  extend(Price, superClass);

  function Price() {
    return Price.__super__.constructor.apply(this, arguments);
  }

  Price.prototype.module = 'glive-booking';

  Price.prototype.toHash = function() {
    var ref;
    return {
      selected: this.model.getPrice() === ((ref = this.options.selected) != null ? ref.getPrice() : void 0),
      price: this.model.getFormattedPrice(),
      value: this.model.getFormattedValue()
    };
  };

  return Price;

})(BookingV2.Presenters.Base);



},{}],130:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.PricePicker = (function(superClass) {
  extend(PricePicker, superClass);

  function PricePicker() {
    return PricePicker.__super__.constructor.apply(this, arguments);
  }

  PricePicker.prototype.module = 'glive-booking';

  PricePicker.prototype.toHash = function() {
    var hash;
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedPrice = {
        price: this.selected().getFormattedPrice()
      };
    }
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  };

  return PricePicker;

})(BookingV2.Presenters.Picker);



},{}],131:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Quantity = (function(superClass) {
  extend(Quantity, superClass);

  function Quantity() {
    return Quantity.__super__.constructor.apply(this, arguments);
  }

  Quantity.prototype.module = 'glive-booking';

  Quantity.prototype.toHash = function() {
    var ref;
    if (this.model) {
      return {
        selected: ((ref = this.options.selected) != null ? ref.getPartySize() : void 0) === this.model.getPartySize(),
        quantity: this.model.getPartySize()
      };
    }
  };

  Quantity.prototype.bhc = function() {
    return "partysize:" + (this.model.getPartySize());
  };

  return Quantity;

})(BookingV2.Presenters.Base);



},{}],132:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.QuantityPicker = (function(superClass) {
  extend(QuantityPicker, superClass);

  function QuantityPicker() {
    return QuantityPicker.__super__.constructor.apply(this, arguments);
  }

  QuantityPicker.prototype.module = 'glive-booking';

  QuantityPicker.prototype.toHash = function() {
    var hash;
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedQuantity = {
        quantity: this.selected().getPartySize()
      };
    }
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  };

  return QuantityPicker;

})(BookingV2.Presenters.Picker);



},{}],133:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Section = (function(superClass) {
  extend(Section, superClass);

  function Section() {
    return Section.__super__.constructor.apply(this, arguments);
  }

  Section.prototype.module = 'glive-booking';

  Section.prototype.toHash = function() {
    var ref;
    return {
      title: this.model.getTitle(),
      selected: ((ref = this.options.selected) != null ? ref.getTitle() : void 0) === this.model.getTitle()
    };
  };

  return Section;

})(BookingV2.Presenters.Base);



},{}],134:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.SectionPicker = (function(superClass) {
  extend(SectionPicker, superClass);

  function SectionPicker() {
    return SectionPicker.__super__.constructor.apply(this, arguments);
  }

  SectionPicker.prototype.module = 'glive-booking';

  SectionPicker.prototype.toHash = function() {
    var hash;
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments);
    if (this.selected() != null) {
      hash.selectedSection = {
        title: this.selected().getTitle()
      };
    }
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  };

  return SectionPicker;

})(BookingV2.Presenters.Picker);



},{}],135:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.module = 'glive-booking';

  Time.prototype.timeHash = function(momentTime) {
    return {
      hours: momentTime.format('h'),
      minutes: momentTime.format('mm'),
      period: momentTime.format('a')
    };
  };

  Time.prototype.isRange = function() {
    var ref, ref1;
    return (ref = this.collection) != null ? (ref1 = ref.meta('calendar')) != null ? ref1.isARSE() : void 0 : void 0;
  };

  Time.prototype.modelToHash = function(model, selection) {
    var from, id, isRange, selected, time, to;
    id = model.get('id');
    isRange = this.isRange();
    from = this.timeHash(model.get('initialTimeMoment'));
    if (isRange) {
      to = this.timeHash(model.get('finalTimeMoment'));
    }
    selected = (selection != null ? selection.start() : void 0) === model.start();
    time = {
      id: id,
      isRange: isRange,
      from: from,
      to: to,
      selected: selected
    };
    return {
      time: time
    };
  };

  Time.prototype.toHash = function() {
    var ref;
    if ((this.model != null)) {
      return this.modelToHash(this.model, (ref = this.options) != null ? ref.selected : void 0);
    }
  };

  Time.prototype.bhc = function() {
    var from, isRange, label, ref, time, to, value;
    ref = this.toHash().time, from = ref.from, to = ref.to, isRange = ref.isRange;
    time = function(t) {
      return t.hours + "." + t.minutes + t.period;
    };
    label = 'time';
    value = time(from);
    if (isRange) {
      label = 'range';
      value = value + "-" + (time(to));
    }
    return label + ":" + value;
  };

  return Time;

})(BookingV2.Presenters.Base);



},{}],136:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Presenters.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  TimePicker.prototype.module = 'glive-booking';

  function TimePicker(options, templateName) {
    BookingV2.Presenters.Picker.apply(this, arguments);
    this.timePresenter = new GliveBooking.Presenters.Time(options, templateName);
  }

  TimePicker.prototype.toHash = function() {
    var hash, loading, selected, selection;
    selected = this.selected();
    loading = selected === true;
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments);
    hash.loading = loading;
    hash.isTouch = this.collection.meta('isTouch');
    if (!loading) {
      if (selected) {
        selection = this.timePresenter.modelToHash(selected);
      }
      hash.selection = selection != null ? selection.time : void 0;
      hash.isRange = this.timePresenter.isRange();
    }
    return hash;
  };

  return TimePicker;

})(BookingV2.Presenters.Picker);



},{}],137:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<button");_.b("\n" + i);_.b("  type=\"submit\"");_.b("\n" + i);_.b("  class=\"");_.b("\n" + i);_.b("    btn-buy-big");_.b("\n" + i);if(_.s(_.f("isDisabled",c,p,1),c,p,0,69,111,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      disabled");_.b("\n" + i);_.b("      tooltip-trigger");_.b("\n");});c.pop();}if(!_.s(_.f("isSellable",c,p,1),c,p,1,0,0,"")){_.b("      state-expired");_.b("\n");};_.b("  \"");_.b("\n" + i);if(!_.s(_.f("isSellable",c,p,1),c,p,1,0,0,"")){_.b("    disabled=\"disabled\"");_.b("\n");};_.b("  data-tooltip-id=\"buy-button-tooltip\"");_.b("\n" + i);_.b("  data-position=\"top\">");_.b("\n" + i);if(_.s(_.f("isSellable",c,p,1),c,p,0,330,354,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    ");if(_.s(_.f("t",c,p,1),c,p,0,341,345,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".buy");});c.pop();}_.b("\n");});c.pop();}if(!_.s(_.f("isSellable",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("isSoldOut",c,p,1),c,p,0,407,440,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      ");if(_.s(_.f("t",c,p,1),c,p,0,420,429,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".sold_out");});c.pop();}_.b("\n");});c.pop();}if(!_.s(_.f("isSoldOut",c,p,1),c,p,1,0,0,"")){if(!_.s(_.f("isAvailable",c,p,1),c,p,1,0,0,"")){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,513,527,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".not_available");});c.pop();}_.b("\n");};};};_.b("  </button>");_.b("\n" + i);_.b("<div id=\"buy-button-tooltip\" class=\"tooltip\">");_.b("\n" + i);_.b("  <div class=\"indicator\"></div>");_.b("\n" + i);_.b("  <div class=\"tooltip-content\">");if(_.s(_.f("t",c,p,1),c,p,0,722,737,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".make_selection");});c.pop();}_.b("</div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<button\n  type=\"submit\"\n  class=\"\n    btn-buy-big\n    {{#isDisabled}}\n      disabled\n      tooltip-trigger\n    {{/isDisabled}}\n    {{^isSellable}}\n      state-expired\n    {{/isSellable}}\n  \"\n  {{^isSellable}}\n    disabled=\"disabled\"\n  {{/isSellable}}\n  data-tooltip-id=\"buy-button-tooltip\"\n  data-position=\"top\">\n  {{#isSellable}}\n    {{#t}}.buy{{/t}}\n  {{/isSellable}}\n  {{^isSellable}}\n    {{# isSoldOut}}\n      {{#t}}.sold_out{{/t}}\n    {{/ isSoldOut}}\n    {{^ isSoldOut}}\n      {{^isAvailable}}\n        {{#t}}.not_available{{/t}}\n      {{/isAvailable}}\n    {{/ isSoldOut}}\n  {{/isSellable}}\n  </button>\n<div id=\"buy-button-tooltip\" class=\"tooltip\">\n  <div class=\"indicator\"></div>\n  <div class=\"tooltip-content\">{{#t}}.make_selection{{/t}}</div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],138:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<table class=\"calendar\">");_.b("\n" + i);_.b("  <thead>");_.b("\n" + i);_.b("    <tr>");_.b("\n" + i);_.b("      <th colspan=\"7\">");_.b("\n" + i);_.b("        <span class=\"previous glive-booking-icon");if(!_.s(_.f("lastMonthAvailable",c,p,1),c,p,1,0,0,"")){_.b(" disabled");};_.b("\"></span>");_.b("\n" + i);_.b("        <span class=\"next glive-booking-icon");if(!_.s(_.f("nextMonthAvailable",c,p,1),c,p,1,0,0,"")){_.b(" disabled");};_.b("\"></span>");_.b("\n" + i);_.b("        ");_.b(_.v(_.f("month",c,p,0)));_.b(" ");_.b(_.v(_.f("year",c,p,0)));_.b("\n" + i);_.b("      </th>");_.b("\n" + i);_.b("    </tr>");_.b("\n" + i);_.b("  </thead>");_.b("\n" + i);_.b("  <tbody>");_.b("\n" + i);_.b("    <tr class=\"week-titles\">");_.b("\n" + i);if(_.s(_.f("daysOfTheWeek",c,p,1),c,p,0,412,440,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <td>");_.b(_.v(_.d(".",c,p,0)));_.b("</td>");_.b("\n");});c.pop();}_.b("    </tr>");_.b("\n" + i);if(_.s(_.f("rows",c,p,1),c,p,0,482,746,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <tr class=\"week\">");_.b("\n" + i);if(_.s(_.f("days",c,p,1),c,p,0,520,722,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <td class=\"");_.b(_.v(_.f("classes",c,p,0)));_.b(" ");if(_.s(_.d("events.length",c,p,1),c,p,0,568,577,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("available");});c.pop();}if(!_.s(_.d("events.length",c,p,1),c,p,1,0,0,"")){_.b("unavailable");};_.b("\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);_.b("        <div><span>");_.b(_.v(_.f("day",c,p,0)));_.b("</span></div>");_.b("\n" + i);_.b("      </td>");_.b("\n");});c.pop();}_.b("    </tr>");_.b("\n");});c.pop();}_.b("  </tbody>");_.b("\n" + i);_.b("</table>");_.b("\n" + i);if(!_.s(_.f("loaded",c,p,1),c,p,1,0,0,"")){_.b("<div class=\"loading csspseudoanimations\">");_.b("\n" + i);_.b("  <div class=\"overlay\"></div>");_.b("\n" + i);_.b("  <div class=\"icon-g-loader\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");};return _.fl();;},"<table class=\"calendar\">\n  <thead>\n    <tr>\n      <th colspan=\"7\">\n        <span class=\"previous glive-booking-icon{{^lastMonthAvailable}} disabled{{/lastMonthAvailable}}\"></span>\n        <span class=\"next glive-booking-icon{{^nextMonthAvailable}} disabled{{/nextMonthAvailable}}\"></span>\n        {{month}} {{year}}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class=\"week-titles\">\n      {{#daysOfTheWeek}}\n      <td>{{.}}</td>\n      {{/daysOfTheWeek}}\n    </tr>\n    {{#rows}}\n    <tr class=\"week\">\n      {{#days}}\n      <td class=\"{{classes}} {{#events.length}}available{{/events.length}}{{^events.length}}unavailable{{/events.length}}\" data-bhc=\"{{bhc}}\">\n        <div><span>{{day}}</span></div>\n      </td>\n      {{/days}}\n    </tr>\n    {{/rows}}\n  </tbody>\n</table>\n{{^loaded}}\n<div class=\"loading csspseudoanimations\">\n  <div class=\"overlay\"></div>\n  <div class=\"icon-g-loader\"></div>\n</div>\n{{/loaded}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],139:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown\">");_.b("\n" + i);_.b("    <span class=\"icon icon-calendar\"></span>");_.b("\n" + i);_.b("    <span class=\"selection");if(_.s(_.f("loading",c,p,1),c,p,0,130,138,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" loading");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("loading",c,p,1),c,p,0,171,191,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,177,185,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".loading");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("loading",c,p,1),c,p,1,0,0,"")){_.b("        ");if(!_.s(_.f("selectedDate",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,254,261,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);if(_.s(_.f("selectedDate",c,p,1),c,p,0,310,407,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          ");if(_.s(_.f("t",c,p,1),c,p,0,327,392,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected, \"month\": ");_.b(_.v(_.f("month",c,p,0)));_.b(", \"date\": ");_.b(_.v(_.f("date",c,p,0)));_.b(", \"year\": ");_.b(_.v(_.f("year",c,p,0)));});c.pop();}_.b("\n");});c.pop();}};_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown\">\n    <span class=\"icon icon-calendar\"></span>\n    <span class=\"selection{{#loading}} loading{{/loading}}\">\n      {{#loading}}{{#t}}.loading{{/t}}{{/loading}}\n      {{^loading}}\n        {{^selectedDate}}{{#t}}.select{{/t}}{{/selectedDate}}\n        {{#selectedDate}}\n          {{#t}}.selected, \"month\": {{month}}, \"date\": {{date}}, \"year\": {{year}}{{/t}}\n        {{/selectedDate}}\n      {{/loading}}\n    </span>\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n    </span>\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],140:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(!_.s(_.f("error",c,p,1),c,p,1,0,0,"")){if(!_.s(_.f("isOpen",c,p,1),c,p,1,0,0,"")){_.b("    <div class=\"open\">");_.b("\n" + i);_.b("      <input type=\"button\" class=\"btn\" value=\"");if(_.s(_.f("t",c,p,1),c,p,0,100,118,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("check_availability");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      <small>");if(_.s(_.f("t",c,p,1),c,p,0,146,173,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".check_availability_details");});c.pop();}_.b("</small>");_.b("\n" + i);_.b("    </div>");_.b("\n");};if(_.s(_.f("isOpen",c,p,1),c,p,0,226,604,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <div class=\"glive-booking-info\" data-glive-info-content ></div>");_.b("\n" + i);_.b("    <form class=\"glive-booking-component\">");_.b("\n" + i);if(!_.s(_.f("isLocked",c,p,1),c,p,1,0,0,"")){_.b("        <span class=\"icon-close\"><span>X</span></span>");_.b("\n");};_.b("      <div data-info-content class=\"info\"></div>");_.b("\n" + i);_.b("      <div data-pickers-content class=\"pickers\"></div>");_.b("\n" + i);_.b("      <div data-book-now-content class=\"book\"></div>");_.b("\n" + i);_.b("    </form>");_.b("\n");});c.pop();}};if(_.s(_.f("error",c,p,1),c,p,0,637,865,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"open\" data-bhw=\"GliveBookingDealBookerError\">");_.b("\n" + i);_.b("    <div class=\"notification error\" data-bhc=\"error:");_.b(_.v(_.f("error",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("errorLoading",c,p,1),c,p,0,785,827,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,800,814,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".error.loading");});c.pop();}_.b("\n");});c.pop();}_.b("    </div>");_.b("\n" + i);_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{^error}}\n  {{^isOpen}}\n    <div class=\"open\">\n      <input type=\"button\" class=\"btn\" value=\"{{#t}}check_availability{{/t}}\">\n      <small>{{#t}}.check_availability_details{{/t}}</small>\n    </div>\n  {{/isOpen}}\n  {{#isOpen}}\n    <div class=\"glive-booking-info\" data-glive-info-content ></div>\n    <form class=\"glive-booking-component\">\n      {{^isLocked}}\n        <span class=\"icon-close\"><span>X</span></span>\n      {{/isLocked}}\n      <div data-info-content class=\"info\"></div>\n      <div data-pickers-content class=\"pickers\"></div>\n      <div data-book-now-content class=\"book\"></div>\n    </form>\n  {{/isOpen}}\n{{/error}}\n{{#error}}\n  <div class=\"open\" data-bhw=\"GliveBookingDealBookerError\">\n    <div class=\"notification error\" data-bhc=\"error:{{error}}\">\n      {{#errorLoading}}\n        {{#t}}.error.loading{{/t}}\n      {{/errorLoading}}\n    </div>\n  </div>\n{{/error}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],141:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"glive-deal-info\" >");_.b("\n" + i);_.b("  <div id=\"deal-hero-price\" >");_.b("\n" + i);if(_.s(_.f("isReadyToBook",c,p,1),c,p,0,83,149,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <span class=\"price-label\">");if(_.s(_.f("t",c,p,1),c,p,0,122,131,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".subtotal");});c.pop();}_.b("</span>");_.b("\n");});c.pop();}if(!_.s(_.f("isReadyToBook",c,p,1),c,p,1,0,0,"")){_.b("      <span class=\"price-label\">");if(_.s(_.f("t",c,p,1),c,p,0,229,234,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".from");});c.pop();}_.b("</span>");_.b("\n");};_.b("    <span class=\"price\">");_.b(_.v(_.f("price",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("discountEnabled",c,p,1),c,p,0,346,747,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <table class=\"deal-discount\">");_.b("\n" + i);_.b("    <tbody>");_.b("\n" + i);_.b("      <tr>");_.b("\n" + i);_.b("        <th>");if(_.s(_.f("t",c,p,1),c,p,0,420,426,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".value");});c.pop();}_.b("</th>");_.b("\n" + i);_.b("        <th>");if(_.s(_.f("t",c,p,1),c,p,0,456,465,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".discount");});c.pop();}_.b("</th>");_.b("\n" + i);_.b("        <th>");if(_.s(_.f("t",c,p,1),c,p,0,495,504,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".you_save");});c.pop();}_.b("</th>");_.b("\n" + i);_.b("      </tr>");_.b("\n" + i);_.b("      <tr id=\"discount-data\">");_.b("\n" + i);_.b("        <td id=\"discount-value\">");_.b(_.v(_.f("value",c,p,0)));_.b("</td>");_.b("\n" + i);_.b("        <td id=\"discount-percent\">");_.b(_.v(_.f("discount",c,p,0)));_.b("</td>");_.b("\n" + i);_.b("        <td id=\"discount-you-save\">");_.b(_.v(_.f("savings",c,p,0)));_.b("</td>");_.b("\n" + i);_.b("      </tr>");_.b("\n" + i);_.b("    </tbody>");_.b("\n" + i);_.b("  </table>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"glive-deal-info\" >\n  <div id=\"deal-hero-price\" >\n    {{#isReadyToBook}}\n      <span class=\"price-label\">{{#t}}.subtotal{{/t}}</span>\n    {{/isReadyToBook}}\n    {{^isReadyToBook}}\n      <span class=\"price-label\">{{#t}}.from{{/t}}</span>\n    {{/isReadyToBook}}\n    <span class=\"price\">{{price}}</span>\n  </div>\n\n  {{# discountEnabled }}\n  <table class=\"deal-discount\">\n    <tbody>\n      <tr>\n        <th>{{#t}}.value{{/t}}</th>\n        <th>{{#t}}.discount{{/t}}</th>\n        <th>{{#t}}.you_save{{/t}}</th>\n      </tr>\n      <tr id=\"discount-data\">\n        <td id=\"discount-value\">{{value}}</td>\n        <td id=\"discount-percent\">{{discount}}</td>\n        <td id=\"discount-you-save\">{{savings}}</td>\n      </tr>\n    </tbody>\n  </table>\n  {{/ discountEnabled }}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],142:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"");if(_.s(_.f("isSoldOut",c,p,1),c,p,0,26,34,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("sold-out");});c.pop();}_.b(" ");if(_.s(_.f("selected",c,p,1),c,p,0,62,70,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("selected");});c.pop();}_.b("\" data-bhc=\"booking:deal-price-");_.b(_.v(_.f("priceId",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  <div class=\"event-price\">");_.b("\n" + i);_.b("    ");_.b(_.v(_.f("price",c,p,0)));_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"{{#isSoldOut}}sold-out{{/isSoldOut}} {{#selected}}selected{{/selected}}\" data-bhc=\"booking:deal-price-{{priceId}}\">\n  <div class=\"event-price\">\n    {{price}}\n  </div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],143:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown\">");_.b("\n" + i);_.b("    <span class=\"icon price-icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection\">");_.b("\n" + i);_.b("      ");if(!_.s(_.f("selectedPrice",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,148,155,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);_.b("      ");if(_.s(_.f("selectedPrice",c,p,1),c,p,0,204,213,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.v(_.f("price",c,p,0)));});c.pop();}_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown\">\n    <span class=\"icon price-icon\"></span>\n    <span class=\"selection\">\n      {{^selectedPrice}}{{#t}}.select{{/t}}{{/selectedPrice}}\n      {{#selectedPrice}}{{price}}{{/selectedPrice}}\n    </span>\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n    </span>\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],144:[function(require,module,exports){
module.exports=require(51)
},{"/var/groupon/home/daryan/napistrano/build/1467059334533-60699/deal-2016.06.23_17.26/deal/modules/booking/frontend/templates/partysizes.html.mustache":51,"hogan.js":248}],145:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div");if(_.s(_.f("selected",c,p,1),c,p,0,17,34,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" class=\"selected\"");});c.pop();}_.b(">");_.b("\n" + i);_.b("  ");if(_.s(_.f("t",c,p,1),c,p,0,57,89,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".quantity, \"count\": ");_.b(_.v(_.f("quantity",c,p,0)));});c.pop();}_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div{{#selected}} class=\"selected\"{{/selected}}>\n  {{#t}}.quantity, \"count\": {{quantity}}{{/t}}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],146:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown\">");_.b("\n" + i);_.b("    <span class=\"icon quantity-icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection\">");_.b("\n" + i);_.b("      ");if(!_.s(_.f("selectedQuantity",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,154,161,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);if(_.s(_.f("selectedQuantity",c,p,1),c,p,0,216,276,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        ");if(_.s(_.f("t",c,p,1),c,p,0,231,263,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".quantity, \"count\": ");_.b(_.v(_.f("quantity",c,p,0)));});c.pop();}_.b("\n");});c.pop();}_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown\">\n    <span class=\"icon quantity-icon\"></span>\n    <span class=\"selection\">\n      {{^selectedQuantity}}{{#t}}.select{{/t}}{{/selectedQuantity}}\n      {{#selectedQuantity}}\n        {{#t}}.quantity, \"count\": {{quantity}}{{/t}}\n      {{/selectedQuantity}}\n    </span>\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n    </span>\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],147:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"");if(_.s(_.f("isSoldOut",c,p,1),c,p,0,26,34,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("sold-out");});c.pop();}_.b(" ");if(_.s(_.f("selected",c,p,1),c,p,0,62,70,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("selected");});c.pop();}_.b("\" data-bhc=\"booking:deal-section-");_.b(_.v(_.f("sectionId",c,p,0)));_.b("\">");_.b("\n" + i);_.b("  <div class=\"description\">");_.b("\n" + i);_.b("    <span>");_.b(_.v(_.f("title",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <span class=\"section-info\">");_.b("\n" + i);if(_.s(_.f("isSoldOut",c,p,1),c,p,0,244,286,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <em>");if(_.s(_.f("t",c,p,1),c,p,0,261,270,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".sold_out");});c.pop();}_.b("</em>");_.b("\n");});c.pop();}if(!_.s(_.f("isSoldOut",c,p,1),c,p,1,0,0,"")){};_.b("  </span>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"{{#isSoldOut}}sold-out{{/isSoldOut}} {{#selected}}selected{{/selected}}\" data-bhc=\"booking:deal-section-{{sectionId}}\">\n  <div class=\"description\">\n    <span>{{title}}</span>\n  </div>\n  <span class=\"section-info\">\n    {{#isSoldOut}}\n      <em>{{#t}}.sold_out{{/t}}</em>\n    {{/isSoldOut}}\n    {{^isSoldOut}}\n    {{/isSoldOut}}\n  </span>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],148:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown\">");_.b("\n" + i);_.b("    <span class=\"icon section-icon\"></span>");_.b("\n" + i);_.b("    <span class=\"selection\">");_.b("\n" + i);_.b("      ");if(!_.s(_.f("selectedSection",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,152,159,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select");});c.pop();}};_.b("\n" + i);_.b("      ");if(_.s(_.f("selectedSection",c,p,1),c,p,0,212,221,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.v(_.f("title",c,p,0)));});c.pop();}_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown\">\n    <span class=\"icon section-icon\"></span>\n    <span class=\"selection\">\n      {{^selectedSection}}{{#t}}.select{{/t}}{{/selectedSection}}\n      {{#selectedSection}}{{title}}{{/selectedSection}}\n    </span>\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n    </span>\n  </div>\n  <div class=\"content\"></div>\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],149:[function(require,module,exports){
module.exports=require(56)
},{"/var/groupon/home/daryan/napistrano/build/1467059334533-60699/deal-2016.06.23_17.26/deal/modules/booking/frontend/templates/time.html.mustache":56,"hogan.js":248}],150:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"wrapper\">");_.b("\n" + i);_.b("  <div class=\"dropdown\">");_.b("\n" + i);_.b("    <span class=\"icon icon-now\"></span>");_.b("\n" + i);_.b("    <span class=\"selection");if(_.s(_.f("loading",c,p,1),c,p,0,125,133,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" loading");});c.pop();}_.b("\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("loading",c,p,1),c,p,0,166,186,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,172,180,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".loading");});c.pop();}});c.pop();}_.b("\n" + i);if(!_.s(_.f("loading",c,p,1),c,p,1,0,0,"")){if(!_.s(_.f("isRange",c,p,1),c,p,1,0,0,"")){_.b("          ");if(!_.s(_.f("selection",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,269,281,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select_time");});c.pop();}};_.b("\n" + i);_.b("          ");if(_.s(_.f("selection",c,p,1),c,p,0,326,445,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,332,439,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected_time, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));});c.pop();}});c.pop();}_.b("\n");};if(_.s(_.f("isRange",c,p,1),c,p,0,501,814,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          ");if(!_.s(_.f("selection",c,p,1),c,p,1,0,0,"")){if(_.s(_.f("t",c,p,1),c,p,0,532,545,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".select_range");});c.pop();}};_.b("\n" + i);_.b("          ");if(_.s(_.f("selection",c,p,1),c,p,0,590,791,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("t",c,p,1),c,p,0,596,785,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(".selected_range, \"fromHours\": ");_.b(_.v(_.d("from.hours",c,p,0)));_.b(", \"fromMinutes\": ");_.b(_.v(_.d("from.minutes",c,p,0)));_.b(", \"fromPeriod\": ");_.b(_.v(_.d("from.period",c,p,0)));_.b(", \"toHours\": ");_.b(_.v(_.d("to.hours",c,p,0)));_.b(", \"toMinutes\": ");_.b(_.v(_.d("to.minutes",c,p,0)));_.b(", \"toPeriod\": ");_.b(_.v(_.d("to.period",c,p,0)));});c.pop();}});c.pop();}_.b("\n");});c.pop();}};_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"arrow\">");_.b("\n" + i);_.b("      <span class=\"icon-arrow-down-large\"></span>");_.b("\n" + i);_.b("    </span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("  <div class=\"content\"></div>");_.b("\n" + i);_.b("</div>");_.b("\n" + i);_.b("\n");return _.fl();;},"<div class=\"wrapper\">\n  <div class=\"dropdown\">\n    <span class=\"icon icon-now\"></span>\n    <span class=\"selection{{#loading}} loading{{/loading}}\">\n      {{#loading}}{{#t}}.loading{{/t}}{{/loading}}\n      {{^loading}}\n        {{^isRange}}\n          {{^selection}}{{#t}}.select_time{{/t}}{{/selection}}\n          {{#selection}}{{#t}}.selected_time, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}{{/t}}{{/selection}}\n        {{/isRange}}\n        {{#isRange}}\n          {{^selection}}{{#t}}.select_range{{/t}}{{/selection}}\n          {{#selection}}{{#t}}.selected_range, \"fromHours\": {{from.hours}}, \"fromMinutes\": {{from.minutes}}, \"fromPeriod\": {{from.period}}, \"toHours\": {{to.hours}}, \"toMinutes\": {{to.minutes}}, \"toPeriod\": {{to.period}}{{/t}}{{/selection}}\n        {{/isRange}}\n      {{/loading}}\n    </span>\n    <span class=\"arrow\">\n      <span class=\"icon-arrow-down-large\"></span>\n    </span>\n  </div>\n  <div class=\"content\"></div>\n</div>\n\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],151:[function(require,module,exports){
module.exports=require(51)
},{"/var/groupon/home/daryan/napistrano/build/1467059334533-60699/deal-2016.06.23_17.26/deal/modules/booking/frontend/templates/partysizes.html.mustache":51,"hogan.js":248}],152:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Book = (function(superClass) {
  extend(Book, superClass);

  function Book() {
    return Book.__super__.constructor.apply(this, arguments);
  }

  Book.prototype.module = 'glive-booking';

  Book.prototype.initialize = function() {
    if (!this._isTouchRequest()) {
      return _.defer(this._setupTooltip, this);
    }
  };

  Book.prototype.presenter = GliveBooking.Presenters.Book;

  Book.prototype.templateName = 'book';

  Book.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "BookButton"
    };
  };

  Book.prototype._isTouchRequest = function() {
    var ref;
    return (ref = this.model) != null ? ref.get("isTouchRequest") : void 0;
  };

  Book.prototype._setupTooltip = function(book) {
    var element;
    GIG.Tooltip.reloadBindings(element = document.body);
    book._disableButton();
    return book._moveTooltipToRoot();
  };

  Book.prototype._disableButton = function() {
    return $(this.el).find("button.disabled").click(function(e) {
      return e.preventDefault();
    });
  };

  Book.prototype._moveTooltipToRoot = function() {
    if (this._tooltip().parent()[0] !== document.body) {
      return $(document.body).append(this._tooltip());
    }
  };

  Book.prototype._tooltip = function() {
    return $(this.el).find("#" + this._tooltipId());
  };

  Book.prototype._tooltipId = _.memoize(function() {
    return $(this.el).find("button").data("tooltip-id");
  });

  return Book;

})(BookingV2.Views.Base);



},{}],153:[function(require,module,exports){
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Booker = (function(superClass) {
  extend(Booker, superClass);

  Booker.prototype.module = 'glive-booking';

  Booker.prototype.presenter = GliveBooking.Presenters.Booker;

  Booker.prototype.events = {
    'submit form': 'book',
    'click .open .btn': 'open',
    'click .icon-close': 'close'
  };

  Booker.prototype.className = 'glive-booking-component';

  function Booker() {
    this.clearAll = bind(this.clearAll, this);
    this.selectPrice = bind(this.selectPrice, this);
    this.selectSection = bind(this.selectSection, this);
    this.selectQuantity = bind(this.selectQuantity, this);
    this.selectTime = bind(this.selectTime, this);
    this.selectDate = bind(this.selectDate, this);
    BookingV2.Views.Base.apply(this, arguments);
    this.model.on('updatedCollections', this.renderInfo, this);
    this.model.on('updatedCollections', this.renderBookButton, this);
    this.model.on('updatedCollections', this.enableClearButton, this);
    this.model.on('updatedCollections', this.fixDatesInCalendar, this);
    this.model.on('clearAll', this.disableClearButton, this);
  }

  Booker.prototype.canRenderOptions = function() {
    return false;
  };

  Booker.prototype.canRenderPhone = function() {
    return false;
  };

  Booker.prototype.setOpen = function() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    return this.options.isOpen = true;
  };

  Booker.prototype.setOpenAndLocked = function() {
    this.setOpen();
    return this.options.isLocked = true;
  };

  Booker.prototype.open = function() {
    this.setOpen();
    this.model.reset();
    return this.render({
      fadeIn: true
    });
  };

  Booker.prototype.close = function() {
    this.options.isOpen = false;
    return this.$el.fadeOut((function(_this) {
      return function() {
        _this.render();
        if (_this.options.overlapWith) {
          $(_this.options.overlapWith).fadeIn();
        }
        return _this.model.resetOption();
      };
    })(this));
  };

  Booker.prototype.render = function() {
    var ref, showMethod;
    this.$el.hide();
    BookingV2.Views.Base.prototype.render.apply(this, arguments);
    if (!this.model.get('error')) {
      if (this.options.isOpen) {
        this.$el.find('[data-info-content]').hide();
        if (this.model.get('isSellable')) {
          this.renderInfo();
          this.renderPickers();
          this.renderClearButton();
        }
        this.renderBookButton();
      }
    }
    showMethod = ((ref = arguments[0]) != null ? ref.fadeIn : void 0) === true ? 'fadeIn' : 'show';
    this.$el[showMethod]();
    return this;
  };

  Booker.prototype.renderInfo = function() {
    var infoContainer;
    infoContainer = this.$el.find('[data-glive-info-content]');
    return infoContainer.html((new GliveBooking.Views.Info({
      model: this.model
    })).render().el);
  };

  Booker.prototype.renderPickers = function() {
    var pickersView;
    pickersView = new BookingV2.Views.Pickers({
      el: this.$el.find('[data-pickers-content]')
    });
    this.datePicker = pickersView.add({
      view: GliveBooking.Views.DatePicker,
      model: this.model,
      collection: 'dates',
      selection: 'selectedDate',
      selected: this.selectDate
    });
    this.timePicker = pickersView.add({
      view: GliveBooking.Views.TimePicker,
      model: this.model,
      collection: 'times',
      selection: 'selectedTime',
      selected: this.selectTime
    });
    this.quantityPicker = pickersView.add({
      view: GliveBooking.Views.QuantityPicker,
      model: this.model,
      collection: 'quantities',
      selection: 'selectedQuantity',
      selected: this.selectQuantity
    });
    this.sectionPicker = pickersView.add({
      view: GliveBooking.Views.SectionPicker,
      model: this.model,
      collection: 'sections',
      selection: 'selectedSection',
      selected: this.selectSection
    });
    this.pricePicker = pickersView.add({
      view: GliveBooking.Views.PricePicker,
      model: this.model,
      collection: 'prices',
      selection: 'selectedPrice',
      selected: this.selectPrice
    });
    pickersView.render();
    return pickersView.once('expanded', (function(_this) {
      return function() {
        return _this.trigger('ready');
      };
    })(this));
  };

  Booker.prototype.renderClearButton = function() {
    var pickersContainer;
    pickersContainer = this.$el.find('[data-pickers-content]');
    pickersContainer.append("<div class='clear-button'>Clear All</div>");
    return $('.clear-button').click((function(_this) {
      return function() {
        return _this.clearAll();
      };
    })(this));
  };

  Booker.prototype.enableClearButton = function() {
    return $('.clear-button').addClass('clear-enabled');
  };

  Booker.prototype.disableClearButton = function() {
    return $('.clear-button').removeClass('clear-enabled');
  };

  Booker.prototype.renderBookButton = function() {
    var bookContainer;
    bookContainer = this.$el.find('[data-book-now-content]');
    if (bookContainer.length) {
      return bookContainer.html((new GliveBooking.Views.Book({
        model: this.model
      })).render().el);
    }
  };

  Booker.prototype.selectDate = function(date) {
    return this.model.selectDate(date);
  };

  Booker.prototype.selectTime = function(time) {
    return this.model.selectTime(time);
  };

  Booker.prototype.selectQuantity = function(quantity) {
    return this.model.selectQuantity(quantity);
  };

  Booker.prototype.selectSection = function(section) {
    return this.model.selectSection(section);
  };

  Booker.prototype.selectPrice = function(price) {
    return this.model.selectPrice(price);
  };

  Booker.prototype.fixDatesInCalendar = function() {
    return this.datePicker.refreshDates();
  };

  Booker.prototype.clearAll = function() {
    return this.model.clearAll();
  };

  Booker.prototype.book = function(event) {
    event.stopPropagation();
    this.model.book();
    return false;
  };

  return Booker;

})(BookingV2.Views.Base);



},{}],154:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Calendar = (function(superClass) {
  extend(Calendar, superClass);

  function Calendar() {
    return Calendar.__super__.constructor.apply(this, arguments);
  }

  Calendar.prototype.module = 'glive-booking';

  Calendar.prototype.presenter = GliveBooking.Presenters.Calendar;

  return Calendar;

})(BookingV2.Views.Calendar);



},{}],155:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.prototype.module = 'glive-booking';

  DatePicker.prototype.presenter = GliveBooking.Presenters.DatePicker;

  DatePicker.prototype.contentView = GliveBooking.Views.Calendar;

  DatePicker.prototype.templateName = 'datepicker';

  DatePicker.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "Dates"
    };
  };

  DatePicker.prototype.styleClassName = 'dates';

  DatePicker.prototype.refreshDates = function() {
    this.content().$el.detach();
    this._content = new this.contentView({
      collection: this.collection,
      selected: this.selected
    });
    this._content.on('select', this.select, this);
    this._content.render();
    return this.appendContent();
  };

  DatePicker.prototype.setSelection = function(selection) {
    if (this.collection.length === 1) {
      return this.model.set({
        selectedDate: {
          date: this.collection.first().start()
        }
      });
    }
  };

  return DatePicker;

})(GliveBooking.Views.Picker);



},{}],156:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Info = (function(superClass) {
  extend(Info, superClass);

  function Info() {
    return Info.__super__.constructor.apply(this, arguments);
  }

  Info.prototype.module = 'glive-booking';

  Info.prototype.presenter = GliveBooking.Presenters.Info;

  Info.prototype.templateName = 'gliveinfo';

  return Info;

})(BookingV2.Views.Base);



},{}],157:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Picker = (function(superClass) {
  extend(Picker, superClass);

  Picker.prototype.className = function() {
    return "picker glive-picker " + this.collapsedClassName + " " + this.styleClassName;
  };

  function Picker() {
    BookingV2.Views.Base.apply(this, arguments);
    this.collection.on('clear', this.clearSelection, this);
    this.collection.on('request', this.clearSelection, this);
    this.model.on("change:" + this.options.selected, (function(_this) {
      return function(model, selection) {
        _this.content().options.selected = selection;
        return _this.render();
      };
    })(this));
  }

  Picker.prototype.show = function() {
    var transitionEndHandler;
    this.redraw();
    this.trigger('expand', this);
    transitionEndHandler = (function(_this) {
      return function() {
        return _this.trigger('expanded', _this);
      };
    })(this);
    setTimeout(transitionEndHandler, this.transitionDuration);
    return this.$el.removeClass(this.collapsedClassName).addClass(this.expandedClassName);
  };

  Picker.prototype.hide = function() {
    var transitionEndHandler;
    this.redraw();
    this.trigger('collapse', this);
    transitionEndHandler = (function(_this) {
      return function() {
        _this.trigger('collapsed', _this);
        return _this.$el.addClass(_this.collapsedClassName);
      };
    })(this);
    setTimeout(transitionEndHandler, this.transitionDuration);
    return this.$el.removeClass(this.expandedClassName);
  };

  Picker.prototype.toggle = function() {
    if (this.isVisible()) {
      return this.hide();
    } else {
      return this.show();
    }
  };

  return Picker;

})(BookingV2.Views.Picker);



},{}],158:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Price = (function(superClass) {
  extend(Price, superClass);

  function Price() {
    return Price.__super__.constructor.apply(this, arguments);
  }

  Price.prototype.module = 'glive-booking';

  Price.prototype.presenter = GliveBooking.Presenters.Price;

  Price.prototype.templateName = 'price';

  Price.prototype.tagName = 'li';

  Price.prototype.events = {
    'click': 'select'
  };

  Price.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  return Price;

})(BookingV2.Views.Base);



},{}],159:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.PricePicker = (function(superClass) {
  extend(PricePicker, superClass);

  function PricePicker() {
    return PricePicker.__super__.constructor.apply(this, arguments);
  }

  PricePicker.prototype.module = 'glive-booking';

  PricePicker.prototype.presenter = GliveBooking.Presenters.PricePicker;

  PricePicker.prototype.contentView = GliveBooking.Views.Prices;

  PricePicker.prototype.templateName = 'pricepicker';

  PricePicker.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "Prices"
    };
  };

  PricePicker.prototype.styleClassName = 'prices';

  return PricePicker;

})(GliveBooking.Views.Picker);



},{}],160:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Prices = (function(superClass) {
  extend(Prices, superClass);

  Prices.prototype.module = 'glive-booking';

  Prices.prototype.tagName = 'ul';

  Prices.prototype.childView = GliveBooking.Views.Price;

  Prices.prototype.attributes = {
    'data-bhc': 'booking:sections'
  };

  function Prices() {
    BookingV2.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Prices.prototype.select = function(section) {
    this.options.selected = section;
    return this.render();
  };

  return Prices;

})(BookingV2.Views.Collection);



},{}],161:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Quantities = (function(superClass) {
  extend(Quantities, superClass);

  function Quantities() {
    return Quantities.__super__.constructor.apply(this, arguments);
  }

  Quantities.prototype.module = 'glive-booking';

  Quantities.prototype.templateName = 'quantities';

  Quantities.prototype.childView = GliveBooking.Views.Quantity;

  return Quantities;

})(BookingV2.Views.PartySizes);



},{}],162:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Quantity = (function(superClass) {
  extend(Quantity, superClass);

  function Quantity() {
    return Quantity.__super__.constructor.apply(this, arguments);
  }

  Quantity.prototype.module = 'glive-booking';

  Quantity.prototype.presenter = GliveBooking.Presenters.Quantity;

  Quantity.prototype.templateName = 'quantity';

  return Quantity;

})(BookingV2.Views.PartySize);



},{}],163:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.QuantityPicker = (function(superClass) {
  extend(QuantityPicker, superClass);

  function QuantityPicker() {
    return QuantityPicker.__super__.constructor.apply(this, arguments);
  }

  QuantityPicker.prototype.module = 'glive-booking';

  QuantityPicker.prototype.presenter = GliveBooking.Presenters.QuantityPicker;

  QuantityPicker.prototype.templateName = 'quantitypicker';

  QuantityPicker.prototype.contentView = GliveBooking.Views.Quantities;

  QuantityPicker.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "Quantities"
    };
  };

  QuantityPicker.prototype.styleClassName = 'quantities';

  return QuantityPicker;

})(GliveBooking.Views.Picker);



},{}],164:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Section = (function(superClass) {
  extend(Section, superClass);

  function Section() {
    return Section.__super__.constructor.apply(this, arguments);
  }

  Section.prototype.module = 'glive-booking';

  Section.prototype.presenter = GliveBooking.Presenters.Section;

  Section.prototype.templateName = 'section';

  Section.prototype.tagName = 'li';

  Section.prototype.events = {
    'click': 'select'
  };

  Section.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  return Section;

})(BookingV2.Views.Base);



},{}],165:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.SectionPicker = (function(superClass) {
  extend(SectionPicker, superClass);

  function SectionPicker() {
    return SectionPicker.__super__.constructor.apply(this, arguments);
  }

  SectionPicker.prototype.module = 'glive-booking';

  SectionPicker.prototype.presenter = GliveBooking.Presenters.SectionPicker;

  SectionPicker.prototype.contentView = GliveBooking.Views.Sections;

  SectionPicker.prototype.templateName = 'sectionpicker';

  SectionPicker.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "Sections"
    };
  };

  SectionPicker.prototype.styleClassName = 'sections';

  return SectionPicker;

})(GliveBooking.Views.Picker);



},{}],166:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Sections = (function(superClass) {
  extend(Sections, superClass);

  Sections.prototype.module = 'glive-booking';

  Sections.prototype.tagName = 'ul';

  Sections.prototype.childView = GliveBooking.Views.Section;

  Sections.prototype.attributes = {
    'data-bhc': 'booking:sections'
  };

  function Sections() {
    BookingV2.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Sections.prototype.select = function(section) {
    this.options.selected = section;
    return this.render();
  };

  return Sections;

})(BookingV2.Views.Collection);



},{}],167:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Time = (function(superClass) {
  extend(Time, superClass);

  function Time() {
    return Time.__super__.constructor.apply(this, arguments);
  }

  Time.prototype.module = 'glive-booking';

  Time.prototype.presenter = GliveBooking.Presenters.Time;

  Time.prototype.templateName = 'time';

  Time.prototype.tagName = 'li';

  Time.prototype.events = {
    'click': 'select'
  };

  Time.prototype.select = function() {
    return this.trigger('select', this.model);
  };

  Time.prototype.attributes = function() {
    var ref;
    return {
      'data-bhc': (ref = this.getPresenter()) != null ? ref.bhc() : void 0
    };
  };

  return Time;

})(BookingV2.Views.Base);



},{}],168:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.TimePicker = (function(superClass) {
  extend(TimePicker, superClass);

  function TimePicker() {
    return TimePicker.__super__.constructor.apply(this, arguments);
  }

  TimePicker.prototype.module = 'glive-booking';

  TimePicker.prototype.presenter = GliveBooking.Presenters.TimePicker;

  TimePicker.prototype.contentView = GliveBooking.Views.Times;

  TimePicker.prototype.templateName = 'timepicker';

  TimePicker.prototype.attributes = function() {
    return {
      'data-bhw': GliveBooking.bhw + "Times"
    };
  };

  TimePicker.prototype.styleClassName = 'times';

  return TimePicker;

})(GliveBooking.Views.Picker);



},{}],169:[function(require,module,exports){
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GliveBooking.Views.Times = (function(superClass) {
  extend(Times, superClass);

  Times.prototype.module = 'glive-booking';

  Times.prototype.templateName = 'times';

  Times.prototype.childView = GliveBooking.Views.Time;

  function Times() {
    BookingV2.Views.Collection.apply(this, arguments);
    this.on('select', this.select, this);
  }

  Times.prototype.select = function(time) {
    this.options.selected = time;
    return setTimeout(((function(_this) {
      return function() {
        return _this.render();
      };
    })(this)), 0);
  };

  return Times;

})(BookingV2.Views.Collection);



},{}],170:[function(require,module,exports){
var ReadMore, _readLess, _readMore;

ReadMore = window.ReadMore != null ? window.ReadMore : window.ReadMore = {};

_readMore = function(pitch, readMoreSection, targetHeight) {
  pitch.css('max-height', targetHeight + "px");
  readMoreSection.find('.read-less').css('display', 'inline');
  readMoreSection.find('.read-more').css('display', 'none');
  return readMoreSection.find('.gradient-finish').css('display', 'none');
};

_readLess = function(pitch, readMoreSection, targetHeight) {
  pitch.css('max-height', targetHeight + "px");
  readMoreSection.find('.read-less').css('display', 'none');
  readMoreSection.find('.read-more').css('display', 'inline');
  return readMoreSection.find('.gradient-finish').css('display', 'inline');
};

ReadMore.init = function(payload, done) {
  return $(function() {
    var $pitch, $readMoreSection, lessHeight, moreHeight, readLess, readMore, readMoreHtml;
    $pitch = $('.pitch-container');
    moreHeight = $('#deal-info').height() + 100;
    lessHeight = $('.purchase-cluster-bottom').height() + 80;
    $pitch.css('max-height', lessHeight + "px");
    readMore = I18n.translate('.modules.goods_v2.read_more');
    readLess = I18n.translate('.modules.goods_v2.read_less');
    readMoreHtml = "<div id='read-more-section' > <div class='gradient-finish'></div> <div class='read-more-container'> <span class='read-more' data-height='" + moreHeight + "' data-bhw='ReadMore'> " + readMore + " <span class='icon-arrow-down'></span></span> <span class='read-less' data-height='" + lessHeight + "' data-bhw='ReadLess'> " + readLess + " <span class='icon-arrow-up'></span></span> </div> </div>";
    $readMoreSection = $(readMoreHtml).insertAfter($pitch);
    $('.read-more').click(function() {
      return _readMore($pitch, $readMoreSection, $(this).data('height'));
    });
    $('.read-less').click(function() {
      return _readLess($pitch, $readMoreSection, $(this).data('height'));
    });
    return done();
  });
};

module.exports = ReadMore;



},{}],171:[function(require,module,exports){
var getMedia, loadScripts, loadVideoScripts, prepareCarouselOptions, ref, setVideoLoaderFlags;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.carouselViews = {};

DealCarousel.dealMedia = {};

DealCarousel.current = {};

ref = DealCarousel.Helpers, getMedia = ref.getMedia, prepareCarouselOptions = ref.prepareCarouselOptions, setVideoLoaderFlags = ref.setVideoLoaderFlags, loadVideoScripts = ref.loadVideoScripts, loadScripts = ref.loadScripts;

DealCarousel.init = function(arg, done) {
  var carousel, carouselOptions, currentCarouselView, currentDealMedia, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return typeof done === "function" ? done() : void 0;
  }
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  if (this.i18n == null) {
    this.i18n = I18n.scoped('modules.groupon-deal-carousel');
  }
  this.dealMedia[dealId] = currentDealMedia = new Backbone.Collection(media, {
    model: DealCarousel.Media
  });
  this.current.currentDealMedia = currentDealMedia;
  carouselOptions = prepareCarouselOptions(carousel, currentDealMedia, featuredImage, this.i18n);
  this.carouselViews[dealId] = currentCarouselView = new DealCarousel.View(carouselOptions);
  this.current.currentCarouselView = currentCarouselView;
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  return $((function(_this) {
    return function() {
      loadVideoScripts(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
      loadScripts(carouselOptions);
      currentCarouselView.render();
      return typeof done === "function" ? done() : void 0;
    };
  })(this));
};

DealCarousel.updateCurrent = function(arg) {
  var carousel, carouselOptions, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  if (!(this.current.currentDealMedia && this.current.currentCarouselView)) {
    return;
  }
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return;
  }
  delete this.dealMedia[this.current.currentDealMedia.uuid];
  delete this.carouselViews[this.current.currentDealMedia.uuid];
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  this.current.currentDealMedia.reset(media, {
    model: DealCarousel.Media
  });
  carouselOptions = prepareCarouselOptions(carousel, this.current.currentDealMedia, featuredImage, this.i18n);
  this.current.currentCarouselView.options = carouselOptions;
  this.current.currentCarouselView.initialize();
  this.current.currentCarouselView.updateCollection(this.current.currentDealMedia);
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  return $((function(_this) {
    return function() {
      return loadVideoScripts(carousel, _this.current.currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
    };
  })(this));
};



},{}],172:[function(require,module,exports){
if (window.DetectFlash == null) {
  window.DetectFlash = {};
}

DetectFlash.hasFlash = swfobject.hasFlashPlayerVersion('1');



},{}],173:[function(require,module,exports){
var DEFAULT_EL;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DEFAULT_EL = '.featured-image';

DealCarousel.Helpers = {
  getMedia: function(carousel) {
    var dealImages, dealVideos, forceVideos, media, showVideos, videoPosition;
    dealImages = carousel.dealImages, forceVideos = carousel.forceVideos, dealVideos = carousel.dealVideos, videoPosition = carousel.videoPosition;
    media = dealImages.slice(0);
    showVideos = forceVideos || DetectFlash.hasFlash || !!(typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.video : void 0);
    if (showVideos && (dealVideos != null ? dealVideos.length : void 0) > 0) {
      media.splice(videoPosition, 0, dealVideos[0]);
    }
    return {
      media: media,
      showVideos: showVideos
    };
  },
  prepareCarouselOptions: function(carousel, currentDealMedia, featuredImage, i18n) {
    var carouselOptions, dealId, el, featuredImageLowQuality, featuredImageThumbnail, imageQuality, imageZoomState, lazyLoadFeatured, lazyLoadThumbs, mediaHeight, prefetchImages, showProductSizing, showThumbs, zoomMessage;
    dealId = carousel.dealId, el = carousel.el, imageQuality = carousel.imageQuality, imageZoomState = carousel.imageZoomState, mediaHeight = carousel.mediaHeight, prefetchImages = carousel.prefetchImages, showProductSizing = carousel.showProductSizing, showThumbs = carousel.showThumbs, lazyLoadThumbs = carousel.lazyLoadThumbs, lazyLoadFeatured = carousel.lazyLoadFeatured, featuredImageThumbnail = carousel.featuredImageThumbnail, featuredImageLowQuality = carousel.featuredImageLowQuality;
    switch (imageZoomState) {
      case "hover":
        zoomMessage = i18n.t('.hoverZoom');
        break;
      case "click":
        zoomMessage = i18n.t('.clickZoom');
        break;
      default:
        zoomMessage = false;
    }
    carouselOptions = {
      collection: currentDealMedia,
      el: el || DEFAULT_EL,
      imageQuality: imageQuality,
      imageZoomState: imageZoomState,
      mediaHeight: mediaHeight,
      prefetchImages: prefetchImages,
      showThumbs: showThumbs,
      uuid: dealId,
      zoomMessage: zoomMessage,
      showProductSizing: showProductSizing,
      lazyLoadThumbs: lazyLoadThumbs,
      lazyLoadFeatured: lazyLoadFeatured,
      featuredImageThumbnail: featuredImageThumbnail,
      featuredImageLowQuality: featuredImageLowQuality
    };
    if (showProductSizing) {
      carouselOptions.compareSizeMessage = i18n.t('.compareSize');
    }
    if (featuredImage != null) {
      carouselOptions.featured = currentDealMedia.findWhere({
        baseURL: featuredImage
      });
    }
    return carouselOptions;
  },
  setVideoLoaderFlags: function(showVideos, carousel) {
    var i, len, loadKaltura, loadOoyala, loadYoutube, ref, video;
    loadKaltura = false;
    loadOoyala = false;
    loadYoutube = false;
    if (showVideos && ((typeof kWidget === "undefined" || kWidget === null) || (typeof OO === "undefined" || OO === null) || (typeof YT === "undefined" || YT === null))) {
      ref = carousel.dealVideos || [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        if (!loadKaltura && video.provider === "KALTURA") {
          loadKaltura = true;
        }
        if (!loadOoyala && video.provider === "OOYALA") {
          loadOoyala = true;
        }
        if (!loadYoutube && video.provider === "YOUTUBE") {
          loadYoutube = true;
        }
      }
    }
    return {
      loadKaltura: loadKaltura,
      loadOoyala: loadOoyala,
      loadYoutube: loadYoutube
    };
  },
  loadVideoScripts: function(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube) {
    if (loadKaltura && (typeof kWidget === "undefined" || kWidget === null)) {
      $.getScript(carousel.kalturaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "KALTURA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadOoyala && (typeof OO === "undefined" || OO === null)) {
      $.getScript(carousel.ooyalaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "OOYALA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadYoutube && (typeof YT === "undefined" || YT === null)) {
      return $.getScript(carousel.youtubeScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "YOUTUBE"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
  },
  loadScripts: function(carouselOptions) {
    var caller, initTangiblee, rootPath, showProductSizing, tangibleeTimeoutId;
    showProductSizing = carouselOptions.showProductSizing;
    if (showProductSizing) {
      rootPath = document.location.protocol === 'https:' ? 'https://az646174.vo.msecnd.net/tangiblee-static' : 'http://wcdn.tangiblee.com/tangiblee-static';
      caller = document.createElement('script');
      caller.src = rootPath + "/caller.min.js?v=3ujn9jg82";
      caller.id = 'tangiblee-caller';
      document.body.appendChild(caller);
      tangibleeTimeoutId = void 0;
      initTangiblee = function() {
        var TangibleeScript;
        if (typeof Tangiblee === 'function') {
          if (tangibleeTimeoutId) {
            clearInterval(tangibleeTimeoutId);
          }
          TangibleeScript = new Tangiblee();
          return TangibleeScript.init({
            clientDomain: 'www.groupon.com',
            widgetLoadingMode: 'onButtonClick'
          });
        } else {
          return tangibleeTimeoutId = setTimeout(initTangiblee, 100);
        }
      };
      return initTangiblee();
    }
  }
};



},{}],174:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.Media = Backbone.Model.extend({
  initialize: function(arg) {
    var ref;
    ref = arg != null ? arg : {}, this.id = ref.id, this.type = ref.type, this.media = ref.media, this.thumb = ref.thumb, this.provider = ref.provider, this.baseURL = ref.baseURL, this.alt = ref.alt;
    return this.id != null ? this.id : this.id = this.cid;
  },
  isFeatured: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.view.currentFeatured : void 0) === this;
  },
  isLast: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.last() : void 0) === this;
  },
  isVideo: function() {
    return this.type === "video";
  }
});



},{}],175:[function(require,module,exports){
window.swfobject = (function() {
  var EXPRESS_INSTALL_ID, FLASH_MIME_TYPE, OBJECT, ON_READY_STATE_CHANGE, SHOCKWAVE_FLASH, SHOCKWAVE_FLASH_AX, UNDEF, abstractAltContent, addDomLoadEvent, addListener, addLoadEvent, autoHideShow, callDomLoadFunctions, canExpressInstall, cleanup, createCSS, createElement, createObjParam, createSWF, displayAltContent, doc, domLoadFnArr, dynamicStylesheet, dynamicStylesheetMedia, getElementById, getObjectById, hasPlayerVersion, isDomLoaded, isExpressInstallActive, listenersArr, main, matchVersions, nav, objIdArr, onDomLoad, plugin, regObjArr, removeObjectInIE, removeSWF, setVisibility, showExpressInstall, storedAltContent, storedAltContentId, storedCallbackFn, storedCallbackObj, testPlayerVersion, ua, urlEncodeIfNecessary, win;
  UNDEF = "undefined";
  OBJECT = "object";
  SHOCKWAVE_FLASH = "Shockwave Flash";
  SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash";
  FLASH_MIME_TYPE = "application/x-shockwave-flash";
  EXPRESS_INSTALL_ID = "SWFObjectExprInst";
  ON_READY_STATE_CHANGE = "onreadystatechange";
  win = window;
  doc = document;
  nav = navigator;
  plugin = false;
  regObjArr = [];
  objIdArr = [];
  listenersArr = [];
  isDomLoaded = false;
  isExpressInstallActive = false;
  autoHideShow = true;
  storedAltContent = storedAltContentId = storedCallbackFn = storedCallbackObj = dynamicStylesheet = dynamicStylesheetMedia = null;
  callDomLoadFunctions = function() {
    var dl, dlFn, e, i, len, ref, results, t, w;
    if (isDomLoaded) {
      return;
    }
    try {
      t = doc.getElementsByTagName("body")[0].appendChild(createElement("span"));
      t.parentNode.removeChild(t);
    } catch (_error) {
      e = _error;
      return;
    }
    isDomLoaded = true;
    dl = domLoadFnArr;
    ref = domLoadFnArr || [];
    results = [];
    for (i = w = 0, len = ref.length; w < len; i = ++w) {
      dlFn = ref[i];
      results.push(dlFn());
    }
    return results;
  };
  addDomLoadEvent = function(fn) {
    if (isDomLoaded) {
      return fn();
    } else {
      return domLoadFnArr[domLoadFnArr.length] = fn;
    }
  };
  addLoadEvent = function(fn) {
    var fnOld;
    if (typeof win.addEventListener !== UNDEF) {
      return win.addEventListener("load", fn, false);
    } else if (typeof doc.addEventListener !== UNDEF) {
      return doc.addEventListener("load", fn, false);
    } else if (typeof win.attachEvent !== UNDEF) {
      return addListener(win, "onload", fn);
    } else if (typeof win.onload === "function") {
      fnOld = win.onload;
      return win.onload = function() {
        fnOld();
        return fn();
      };
    } else {
      return win.onload = fn;
    }
  };
  main = function() {
    if (plugin) {
      return testPlayerVersion();
    } else {
      return matchVersions();
    }
  };
  domLoadFnArr = [main];
  testPlayerVersion = function() {
    var b, counter, o, t;
    b = doc.getElementsByTagName("body")[0];
    o = createElement(OBJECT);
    o.setAttribute("type", FLASH_MIME_TYPE);
    t = b.appendChild(o);
    if (t) {
      counter = 0;
      return (function() {
        var d;
        if (typeof t.GetVariable !== UNDEF) {
          d = t.GetVariable("$version");
          if (d) {
            d = d.split(" ")[1].split(",");
            ua.pv = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        } else if (counter < 10) {
          counter++;
          setTimeout(arguments.callee, 10);
          return;
        }
        b.removeChild(o);
        t = null;
        return matchVersions();
      })();
    } else {
      return matchVersions();
    }
  };
  matchVersions = function() {
    var att, cb, cbObj, i, id, len, len1, o, obj, p, pair, par, pl, ref, regObj, results, rl, w, x;
    rl = regObjArr.length;
    if (regObjArr.length) {
      results = [];
      for (i = w = 0, len = regObjArr.length; w < len; i = ++w) {
        regObj = regObjArr[i];
        id = regObj.id;
        cb = regObj.callbackFn;
        cbObj = {
          success: false,
          id: id
        };
        if (ua.pv[0] > 0) {
          obj = getElementById(id);
          if (obj) {
            if (hasPlayerVersion(regObj.swfVersion) && !(ua.wk && ua.wk < 312)) {
              setVisibility(id, true);
              if (cb) {
                cbObj.success = true;
                cbObj.ref = getObjectById(id);
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            } else if (regObj.expressInstall && canExpressInstall()) {
              att = {};
              att.data = regObj.expressInstall;
              att.width = obj.getAttribute("width") || "0";
              att.height = obj.getAttribute("height") || "0";
              if (obj.getAttribute("class")) {
                att.styleclass = obj.getAttribute("class");
              }
              if (obj.getAttribute("align")) {
                att.align = obj.getAttribute("align");
              }
              par = {};
              p = obj.getElementsByTagName("param");
              pl = p.length;
              ref = p || [];
              for (x = 0, len1 = ref.length; x < len1; x++) {
                pair = ref[x];
                if (pair.getAttribute("name").toLowerCase() !== "movie") {
                  par[pair.getAttribute("name")] = pair.getAttribute("value");
                }
              }
              results.push(showExpressInstall(att, par, id, cb));
            } else {
              displayAltContent(obj);
              if (cb) {
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            }
          } else {
            results.push(void 0);
          }
        } else {
          setVisibility(id, true);
          if (cb) {
            o = getObjectById(id);
            if (o && typeof o.SetVariable !== UNDEF) {
              cbObj.success = true;
              cbObj.ref = o;
            }
            results.push(cb(cbObj));
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    }
  };
  getObjectById = function(objectIdStr) {
    var n, o, r;
    r = null;
    o = getElementById(objectIdStr);
    if (o && o.nodeName === "OBJECT") {
      if (typeof o.SetVariable !== UNDEF) {
        r = o;
      } else {
        n = o.getElementsByTagName(OBJECT)[0];
        if (n) {
          r = n;
        }
      }
    }
    return r;
  };
  canExpressInstall = function() {
    return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312);
  };
  showExpressInstall = function(att, par, replaceElemIdStr, callbackFn) {
    var fv, newObj, obj, pt;
    isExpressInstallActive = true;
    storedCallbackFn = callbackFn || null;
    storedCallbackObj = {
      success: false,
      id: replaceElemIdStr
    };
    obj = getElementById(replaceElemIdStr);
    if (obj) {
      if (obj.nodeName === "OBJECT") {
        storedAltContent = abstractAltContent(obj);
        storedAltContentId = null;
      } else {
        storedAltContent = obj;
        storedAltContentId = replaceElemIdStr;
      }
      att.id = EXPRESS_INSTALL_ID;
      if (typeof att.width === UNDEF || (!/%$/.test(att.width) && parseInt(att.width, 10) < 310)) {
        att.width = "310";
      }
      if (typeof att.height === UNDEF || (!/%$/.test(att.height) && parseInt(att.height, 10) < 137)) {
        att.height = "137";
      }
      doc.title = doc.title.slice(0, 47) + " - Flash Player Installation";
      pt = ua.ie && ua.win ? "ActiveX" : "PlugIn";
      fv = "MMredirectURL=" + win.location.toString().replace(/&/g, "%26") + "&MMplayerType=" + pt + "&MMdoctitle=" + doc.title;
      if (typeof par.flashvars !== UNDEF) {
        par.flashvars += "&" + fv;
      } else {
        par.flashvars = fv;
      }
      if (ua.ie && ua.win && obj.readyState !== 4) {
        newObj = createElement("div");
        replaceElemIdStr += "SWFObjectNew";
        newObj.setAttribute("id", replaceElemIdStr);
        obj.parentNode.insertBefore(newObj, obj);
        obj.style.display = "none";
        (function() {
          if (obj.readyState === 4) {
            return obj.parentNode.removeChild(obj);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      }
      return createSWF(att, par, replaceElemIdStr);
    }
  };
  displayAltContent = function(obj) {
    var el;
    if (ua.ie && ua.win && obj.readyState !== 4) {
      el = createElement("div");
      obj.parentNode.insertBefore(el, obj);
      el.parentNode.replaceChild(abstractAltContent(obj), el);
      obj.style.display = "none";
      return (function() {
        if (obj.readyState === 4) {
          return obj.parentNode.removeChild(obj);
        } else {
          return setTimeout(arguments.callee, 10);
        }
      })();
    } else {
      return obj.parentNode.replaceChild(abstractAltContent(obj), obj);
    }
  };
  abstractAltContent = function(obj) {
    var ac, c, childNode, cl, len, nestedObj, w;
    ac = createElement("div");
    if (ua.win && ua.ie) {
      ac.innerHTML = obj.innerHTML;
    } else {
      nestedObj = obj.getElementsByTagName(OBJECT)[0];
      if (nestedObj) {
        c = nestedObj.childNodes;
        if (c) {
          cl = c.length;
          for (w = 0, len = c.length; w < len; w++) {
            childNode = c[w];
            if (!(childNode.nodeType === 1 && childNode.nodeName === "PARAM") && !(childNode.nodeType === 8)) {
              ac.appendChild(childNode.cloneNode(true));
            }
          }
        }
      }
    }
    return ac;
  };
  createSWF = function(attObj, parObj, id) {
    var att, el, i, j, m, n, o, par, r;
    r = void 0;
    el = getElementById(id);
    if (ua.wk && ua.wk < 312) {
      return r;
    }
    if (el) {
      if (typeof attObj.id === UNDEF) {
        attObj.id = id;
      }
      if (ua.ie && ua.win) {
        att = "";
        for (i in attObj) {
          if (attObj[i] !== Object.prototype[i]) {
            if (i.toLowerCase() === "data") {
              parObj.movie = attObj[i];
            } else if (i.toLowerCase() === "styleclass") {
              att += ' class="' + attObj[i] + '"';
            } else if (i.toLowerCase() !== "classid") {
              att += ' ' + i + '="' + attObj[i] + '"';
            }
          }
        }
        par = "";
        for (j in parObj) {
          if (parObj[j] !== Object.prototype[j]) {
            par += '<param name="' + j + '" value="' + parObj[j] + '" />';
          }
        }
        el.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + att + '>' + par + '</object>';
        objIdArr[objIdArr.length] = attObj.id;
        r = getElementById(attObj.id);
      } else {
        o = createElement(OBJECT);
        o.setAttribute("type", FLASH_MIME_TYPE);
        for (m in attObj) {
          if (attObj[m] !== Object.prototype[m]) {
            if (m.toLowerCase() === "styleclass") {
              o.setAttribute("class", attObj[m]);
            } else if (m.toLowerCase() !== "classid") {
              o.setAttribute(m, attObj[m]);
            }
          }
        }
        for (n in parObj) {
          if (parObj[n] !== Object.prototype[n] && n.toLowerCase() !== "movie") {
            createObjParam(o, n, parObj[n]);
          }
        }
        el.parentNode.replaceChild(o, el);
        r = o;
      }
    }
    return r;
  };
  createObjParam = function(el, pName, pValue) {
    var p;
    p = createElement("param");
    p.setAttribute("name", pName);
    p.setAttribute("value", pValue);
    return el.appendChild(p);
  };
  removeSWF = function(id) {
    var obj;
    obj = getElementById(id);
    if (obj && obj.nodeName === "OBJECT") {
      if (ua.ie && ua.win) {
        obj.style.display = "none";
        return (function() {
          if (obj.readyState === 4) {
            return removeObjectInIE(id);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      } else {
        return obj.parentNode.removeChild(obj);
      }
    }
  };
  removeObjectInIE = function(id) {
    var len, obj, thing, w;
    obj = getElementById(id);
    if (obj) {
      for (w = 0, len = obj.length; w < len; w++) {
        thing = obj[w];
        if (typeof thing === "function") {
          thing = null;
        }
      }
      return obj.parentNode.removeChild(obj);
    }
  };
  getElementById = function(id) {
    var e, el;
    el = null;
    try {
      el = doc.getElementById(id);
    } catch (_error) {
      e = _error;
    }
    return el;
  };
  createElement = function(el) {
    return doc.createElement(el);
  };
  addListener = function(target, eventType, fn) {
    target.attachEvent(eventType, fn);
    return listenersArr[listenersArr.length] = [target, eventType, fn];
  };
  hasPlayerVersion = function(rv) {
    var pv, ref, v;
    pv = ua.pv;
    v = rv.split(".");
    v[0] = parseInt(v[0], 10);
    v[1] = parseInt(v[1], 10) || 0;
    v[2] = parseInt(v[2], 10) || 0;
    return (ref = pv[0] > v[0] || (pv[0] === v[0] && pv[1] > v[1]) || (pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2])) != null ? ref : {
      "true": false
    };
  };
  createCSS = function(sel, decl, media, newStyle) {
    var h, m, ref, s;
    if (ua.ie && ua.mac) {
      return;
    }
    h = doc.getElementsByTagName("head")[0];
    if (!h) {
      return;
    }
    m = (ref = media && typeof media === "string") != null ? ref : {
      media: "screen"
    };
    if (newStyle) {
      dynamicStylesheet = null;
      dynamicStylesheetMedia = null;
    }
    if (!dynamicStylesheet || dynamicStylesheetMedia !== m) {
      s = createElement("style");
      s.setAttribute("type", "text/css");
      s.setAttribute("media", m);
      dynamicStylesheet = h.appendChild(s);
      if (ua.ie && ua.win && typeof doc.styleSheets !== UNDEF && doc.styleSheets.length > 0) {
        dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1];
      }
      dynamicStylesheetMedia = m;
    }
    if (ua.ie && ua.win) {
      if (dynamicStylesheet && typeof dynamicStylesheet.addRule === OBJECT) {
        return dynamicStylesheet.addRule(sel, decl);
      }
    } else {
      if (dynamicStylesheet && typeof doc.createTextNode !== UNDEF) {
        return dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"));
      }
    }
  };
  setVisibility = function(id, isVisible) {
    var v;
    if (!autoHideShow) {
      return;
    }
    v = isVisible != null ? isVisible : {
      "visible": "hidden"
    };
    if (isDomLoaded && getElementById(id)) {
      return getElementById(id).style.visibility = v;
    } else {
      return createCSS("#" + id, "visibility:" + v);
    }
  };
  urlEncodeIfNecessary = function(s) {
    var hasBadChars, regex;
    regex = /[\\\"<>\.;]/;
    hasBadChars = regex.exec(s) !== null;
    return hasBadChars && typeof encodeURIComponent !== (UNDEF ? encodeURIComponent(s) : s);
  };
  ua = (function() {
    var a, d, e, ie, mac, p, playerVersion, u, w3cdom, webkit, windows;
    w3cdom = typeof doc.getElementById !== UNDEF && typeof doc.getElementsByTagName !== UNDEF && typeof doc.createElement !== UNDEF;
    u = nav.userAgent.toLowerCase();
    p = nav.platform.toLowerCase();
    windows = p ? /win/.test(p) : /win/.test(u);
    mac = p ? /mac/.test(p) : /mac/.test(u);
    webkit = /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false;
    ie = !+"\v1";
    playerVersion = [0, 0, 0];
    d = null;
    if (typeof nav.plugins !== UNDEF && typeof nav.plugins[SHOCKWAVE_FLASH] === OBJECT) {
      d = nav.plugins[SHOCKWAVE_FLASH].description;
      if (d && !(typeof nav.mimeTypes !== UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) {
        plugin = true;
        ie = false;
        d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
        playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10);
        playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
        playerVersion[2] = /[a-zA-Z]/.test(d) ? parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
      }
    } else if (typeof win.ActiveXObject !== UNDEF) {
      try {
        a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
        if (a) {
          d = a.GetVariable("$version");
          if (d) {
            ie = true;
            d = d.split(" ")[1].split(",");
            playerVersion = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        }
      } catch (_error) {
        e = _error;
      }
    }
    return {
      w3: w3cdom,
      pv: playerVersion,
      wk: webkit,
      ie: ie,
      win: windows,
      mac: mac
    };
  })();
  onDomLoad = (function() {
    if (!ua.w3) {
      return;
    }
    if ((typeof doc.readyState !== UNDEF && doc.readyState === "complete") || (typeof doc.readyState === UNDEF && (doc.getElementsByTagName("body")[0] || doc.body))) {
      callDomLoadFunctions();
    }
    if (!isDomLoaded) {
      if (typeof doc.addEventListener !== UNDEF) {
        doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false);
      }
      if (ua.ie && ua.win) {
        doc.attachEvent(ON_READY_STATE_CHANGE, function() {
          if (doc.readyState === "complete") {
            doc.detachEvent(ON_READY_STATE_CHANGE, arguments.callee);
            return callDomLoadFunctions();
          }
        });
        if (win === top) {
          (function() {
            var e;
            if (isDomLoaded) {
              return;
            }
            try {
              doc.documentElement.doScroll("left");
            } catch (_error) {
              e = _error;
              setTimeout(arguments.callee, 0);
              return;
            }
            return callDomLoadFunctions();
          })();
        }
      }
      if (ua.wk) {
        (function() {
          if (isDomLoaded) {
            return;
          }
          if (!/loaded|complete/.test(doc.readyState)) {
            setTimeout(arguments.callee, 0);
            return;
          }
          return callDomLoadFunctions();
        })();
      }
      return addLoadEvent(callDomLoadFunctions);
    }
  })();
  cleanup = (function() {
    if (ua.ie && ua.win) {
      return window.attachEvent("onunload", function() {
        var k, l, len, len1, listener, obj, swfobject, w, x;
        for (w = 0, len = listenersArr.length; w < len; w++) {
          listener = listenersArr[w];
          listener[0].detachEvent(listener[1], listener[2]);
        }
        for (x = 0, len1 = objIdArr.length; x < len1; x++) {
          obj = objIdArr[x];
          removeSWF(obj);
        }
        for (k in ua) {
          ua[k] = null;
        }
        ua = null;
        for (l in swfobject) {
          swfobject[l] = null;
        }
        return swfobject = null;
      });
    }
  })();
  return {
    registerObject: function(objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) {
      var regObj;
      if (ua.w3 && objectIdStr && swfVersionStr) {
        regObj = {};
        regObj.id = objectIdStr;
        regObj.swfVersion = swfVersionStr;
        regObj.expressInstall = xiSwfUrlStr;
        regObj.callbackFn = callbackFn;
        regObjArr[regObjArr.length] = regObj;
        return setVisibility(objectIdStr, false);
      } else {
        return typeof callbackFn === "function" ? callbackFn({
          success: false,
          id: objectIdStr
        }) : void 0;
      }
    },
    getObjectById: function(objectIdStr) {
      if (ua.w3) {
        return getObjectById(objectIdStr);
      }
    },
    embedSWF: function(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
      var callbackObj;
      callbackObj = {
        success: false,
        id: replaceElemIdStr
      };
      if (ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
        setVisibility(replaceElemIdStr, false);
        return addDomLoadEvent(function() {
          var att, i, j, k, obj, par;
          widthStr += "";
          heightStr += "";
          att = {};
          if (attObj && typeof attObj === OBJECT) {
            for (i in attObj) {
              att[i] = attObj[i];
            }
          }
          att.data = swfUrlStr;
          att.width = widthStr;
          att.height = heightStr;
          par = {};
          if (parObj && typeof parObj === OBJECT) {
            for (j in parObj) {
              par[j] = parObj[j];
            }
          }
          if (flashvarsObj && typeof flashvarsObj === OBJECT) {
            for (k in flashvarsObj) {
              if (typeof par.flashvars !== UNDEF) {
                par.flashvars += "&" + k + "=" + flashvarsObj[k];
              } else {
                par.flashvars = k + "=" + flashvarsObj[k];
              }
            }
          }
          if (hasPlayerVersion(swfVersionStr)) {
            obj = createSWF(att, par, replaceElemIdStr);
            if (att.id === replaceElemIdStr) {
              setVisibility(replaceElemIdStr, true);
            }
            callbackObj.success = true;
            callbackObj.ref = obj;
          } else if (xiSwfUrlStr && canExpressInstall()) {
            att.data = xiSwfUrlStr;
            showExpressInstall(att, par, replaceElemIdStr, callbackFn);
            return;
          } else {
            setVisibility(replaceElemIdStr, true);
          }
          return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
        });
      } else {
        return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
      }
    },
    switchOffAutoHideShow: function() {
      return autoHideShow = false;
    },
    ua: ua,
    getFlashPlayerVersion: function() {
      return {
        major: ua.pv[0],
        minor: ua.pv[1],
        release: ua.pv[2]
      };
    },
    hasFlashPlayerVersion: hasPlayerVersion,
    createSWF: function(attObj, parObj, replaceElemIdStr) {
      if (ua.w3) {
        return createSWF(attObj, parObj, replaceElemIdStr);
      } else {
        return void 0;
      }
    },
    showExpressInstall: function(att, par, replaceElemIdStr, callbackFn) {
      if (ua.w3 && canExpressInstall()) {
        return showExpressInstall(att, par, replaceElemIdStr, callbackFn);
      }
    },
    removeSWF: function(objElemIdStr) {
      if (ua.w3) {
        return removeSWF(objElemIdStr);
      }
    },
    createCSS: function(selStr, declStr, mediaStr, newStyleBoolean) {
      if (ua.w3) {
        return createCSS(selStr, declStr, mediaStr, newStyleBoolean);
      }
    },
    addDomLoadEvent: addDomLoadEvent,
    addLoadEvent: addLoadEvent,
    getQueryParamValue: function(param) {
      var len, pair, pairs, q, w;
      q = doc.location.search || doc.location.hash;
      if (q) {
        if (/\?/.test(q)) {
          q = q.split("?")[1];
        }
        if (param === null) {
          return urlEncodeIfNecessary(q);
        }
        pairs = q.split("&");
        for (w = 0, len = pairs.length; w < len; w++) {
          pair = pairs[w];
          if (pair.substring(0, pair.indexOf("=")) === param) {
            return urlEncodeIfNecessary(pair.substring(pair.indexOf("=") + 1));
          }
        }
      }
      return "";
    },
    expressInstallCallback: function() {
      var obj;
      if (isExpressInstallActive) {
        obj = getElementById(EXPRESS_INSTALL_ID);
        if (obj && storedAltContent) {
          obj.parentNode.replaceChild(storedAltContent, obj);
          if (storedAltContentId) {
            setVisibility(storedAltContentId, true);
            if (ua.ie && ua.win) {
              storedAltContent.style.display = "block";
            }
          }
          if (storedCallbackFn) {
            storedCallbackFn(storedCallbackObj);
          }
        }
        return isExpressInstallActive = false;
      }
    }
  };
})();



},{}],176:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.CarouselTemplate = Hogan.compile('{{# renderFullCarousel }}\n  <div class="gallery {{ classes }}" data-bhw="PromNightGallery" data-bhc="PromNightGallery:{{ uuid }}">\n    <div class="gallery-featured">\n      <div class="click-blocker"></div>\n      {{# featured }}\n        {{# isVideo }}\n          <img src="http://cdnapi.kaltura.com/p/1302621/thumbnail/entry_id/{{ media }}/height/{{ collection.view.options.mediaHeight}}" id="gallery-video-{{ id }}" data-id="{{ id }}" />\n        {{/ isVideo }}\n        {{^ isVideo }}\n          {{# featuredImageLowQuality }}\n            <img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageLowQuality }}" id="gallery-image-{{ id }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />\n          {{/ featuredImageLowQuality }}\n          {{^ featuredImageLowQuality }}\n            {{# lazyLoadFeatured }}<img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageThumbnail }}" id="gallery-image-{{ id }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}\n            {{^ lazyLoadFeatured }}<img class="init-no-animation" src="{{ media }}" id="gallery-image-{{ id }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}\n          {{/ featuredImageLowQuality }}\n        {{/ isVideo }}\n      {{/ featured }}\n    </div>\n\n    {{# showThumbs }}\n      <ul class="gallery-thumbs">\n        {{# models }}\n          <li class="gallery-thumbnail{{# isFeatured }} selected{{/ isFeatured }}{{# isVideo }} video{{/ isVideo }}{{^ thumb }} no-thumbnail{{/ thumb }}{{# isLast }} last{{/ isLast }}" id="gallery-thumb-{{ id }}" data-id="{{ id }}" data-bhc="thumbnail_click:{{ id }}"{{# isVideo }} data-bhd="{{ videoBHD }}"{{/ isVideo }}>\n            {{# thumb }}\n              {{# lazyLoadThumbs }}<img class="lazy-load" data-original="{{ thumb }}" />{{/ lazyLoadThumbs }}\n              {{^ lazyLoadThumbs }}<img src="{{ thumb }}" />{{/ lazyLoadThumbs }}\n            {{/ thumb }}\n          </li>\n        {{/ models }}\n      </ul>\n    {{/ showThumbs }}\n\n    <div class="gallery-controls">\n      {{# showProductSizing }}\n        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">\n          <div class="compare-size-background"></div>\n          <div class="compare-size-icon"></div>\n          <div class="compare-size-text">{{ compareSizeMessage }}</div>\n        </div>\n      {{/ showProductSizing }}\n\n      {{# showRTL }}\n        {{# showThumbs }}\n          <div class="gallery-control-back icon-arrow-right-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>\n          <div class="gallery-control-forward icon-arrow-left-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>\n        {{/ showThumbs }}\n\n        <div class="gallery-control-left icon-arrow-right-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>\n        <div class="gallery-control-right icon-arrow-left-large" data-bhc="bumper_right:{{ uuid }}"></div>\n      {{/ showRTL }}\n\n      {{^ showRTL }}\n        {{# showThumbs }}\n          <div class="gallery-control-back icon-arrow-left-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>\n          <div class="gallery-control-forward icon-arrow-right-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>\n        {{/ showThumbs }}\n\n        <div class="gallery-control-left icon-arrow-left-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>\n        <div class="gallery-control-right icon-arrow-right-large" data-bhc="bumper_right:{{ uuid }}"></div>\n      {{/ showRTL }}\n    </div>\n  </div>\n{{/ renderFullCarousel }}\n{{^ renderFullCarousel }}\n  <div class="gallery-single">\n    <div class="gallery-featured">\n      {{# first }}\n\n        {{# featuredImageLowQuality }}\n          <img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageLowQuality }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />\n        {{/ featuredImageLowQuality }}\n        {{^ featuredImageLowQuality }}\n          {{# lazyLoadFeatured }}<img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageThumbnail }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}\n          {{^ lazyLoadFeatured }}<img class="featured-image init-no-animation" src="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}\n        {{/ featuredImageLowQuality }}\n\n      {{/ first }}\n    </div>\n    <div class="gallery-controls">\n      {{# showProductSizing }}\n        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">\n          <div class="compare-size-background"></div>\n          <div class="compare-size-icon"></div>\n          <div class="compare-size-text">{{ compareSizeMessage }}</div>\n        </div>\n      {{/ showProductSizing }}\n    </div>\n  </div>\n{{/ renderFullCarousel }}');



},{}],177:[function(require,module,exports){
var IMAGE_ASPECT_RATIO, TABLET_MQ_WIDTH;

TABLET_MQ_WIDTH = 768;

IMAGE_ASPECT_RATIO = 0.6;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.View = Backbone.View.extend({
  events: {
    'click .gallery-control-back': 'onBackClick',
    'click .gallery-control-forward': 'onForwardClick',
    'click .gallery-control-left': 'onLeftClick',
    'click .gallery-control-right': 'onRightClick',
    'click .gallery-thumbnail': 'onThumbnailClick'
  },
  initialize: function() {
    var base;
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.currentFeatured = this.options.featured || this.collection.first();
    this.collection.classes = '';
    this.collection.view = this;
    this.collection.videoBHD = JSON.stringify({
      video: true
    });
    this.collection.featured = (function(_this) {
      return function() {
        return _this.currentFeatured;
      };
    })(this);
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = this.collection.length > 1;
    this.collection.showThumbs = this.options.showThumbs;
    this.collection.showProductSizing = this.options.showProductSizing;
    if (this.options.showProductSizing) {
      this.collection.compareSizeMessage = this.options.compareSizeMessage;
    }
    this.collection.lazyLoadThumbs = this.options.lazyLoadThumbs;
    this.collection.lazyLoadFeatured = this.options.lazyLoadFeatured;
    this.collection.featuredImageThumbnail = this.options.featuredImageThumbnail;
    this.collection.featuredImageLowQuality = this.options.featuredImageLowQuality;
    return (base = this.options).imageQualty != null ? base.imageQualty : base.imageQualty = '';
  },
  render: function() {
    var bodyWidth, el, featuredIndex, height, isSleepyLoadedMediaPresent, renderOptions;
    this.$el = $(this.el);
    this.$body = $(document.body);
    this.rtl = this.$body.hasClass('rtl');
    renderOptions = _.extend({
      zoomMessage: this.options.zoomMessage,
      showRTL: this.rtl
    }, this.collection);
    el = DealCarousel.CarouselTemplate.render(renderOptions);
    this.$el = $(el).replaceAll(this.$el);
    this.el = this.$el[0];
    this.$thumbs = this.$el.find(".gallery-thumbs");
    this.$thumbnails = this.$thumbs.children();
    this.$gallery = this.$el.find(".gallery-featured");
    this.$galleryMedia = this.$gallery.find("img");
    this.$gallerySleepyMedia = this.$gallery.find(".featured-image.sleepy-load");
    this.$clickBlocker = this.$el.find(".click-blocker");
    this.$controls = this.$el.find(".gallery-controls");
    this.$backButton = this.$controls.find(".gallery-control-back");
    this.$forwardButton = this.$controls.find(".gallery-control-forward");
    this.$leftButton = this.$controls.find(".gallery-control-left");
    this.$rightButton = this.$controls.find(".gallery-control-right");
    this.containerWidth = this.$el.width();
    this.insideContainerWidth = this.containerWidth - this.$backButton.width() - this.$forwardButton.width();
    this.animateViaJS = !this.$body.parent('html').hasClass('cssanimations');
    this.thumbsWidth = this.$thumbs.width();
    this.thumbWidth = this.$thumbs.children().outerWidth();
    if (this.rtl) {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-left"));
    } else {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-right"));
    }
    this.thumbsWidth = this._calculateThumbsWidth();
    this.media = {};
    this.currentPosition = 0;
    this.hasOverflow = this.thumbsWidth > this.containerWidth;
    isSleepyLoadedMediaPresent = this.$gallerySleepyMedia.length || this.$gallerySleepyMedia.length;
    if (this.options.mediaHeight < this.$galleryMedia.height() || this.$galleryMedia.height() === 0 || isSleepyLoadedMediaPresent) {
      bodyWidth = this.$body.width();
      if (bodyWidth > TABLET_MQ_WIDTH) {
        this.setFeaturedHeight(this.options.mediaHeight);
      } else {
        height = IMAGE_ASPECT_RATIO * this.containerWidth;
        this.setFeaturedHeight(height);
      }
    } else {
      this.setFeaturedHeight(this.$galleryMedia.height());
    }
    this.centerThumbs();
    featuredIndex = this.collection.indexOf(this.currentFeatured);
    if (!(this.options.featuredImageLowQuality || this.options.lazyLoadFeatured)) {
      this.fetchInitialMedia(featuredIndex);
    }
    this._prepareGroups();
    if (featuredIndex !== 0) {
      this._adjustThumbs(featuredIndex);
    }
    return this.delegateEvents();
  },
  centerThumbs: function() {
    var direction;
    this.thumbsWidth = this._calculateThumbsWidth();
    this.$thumbs.width(this.thumbsWidth);
    if (!this.hasOverflow) {
      return this.visibleThumbs = this.$thumbnails.length;
    } else {
      direction = this.rtl ? 'right' : 'left';
      this.visibleThumbs = Math.floor(this.insideContainerWidth / this.thumbWidth);
      this.visibleThumbs--;
      this.$el.addClass("has-navigation");
      return this.$thumbs.css(direction, this.$backButton.width() + this.thumbMargin);
    }
  },
  fetchMedia: function(index) {
    var media;
    media = this.collection.at(index);
    if (this.media[media.id] != null) {
      return false;
    }
    if (media.type === "video") {
      return this.fetchVideo(media);
    } else {
      return this.fetchImage(media);
    }
  },
  fetchImage: function(image) {
    var $newImage, newImage;
    newImage = new Image();
    newImage.src = image.media;
    $newImage = $(newImage);
    $newImage.data("id", image.id);
    $newImage.attr("id", "gallery-image-" + image.id);
    if (image.alt != null) {
      $newImage.attr("alt", image.alt);
    }
    return this.media[image.id] = $newImage;
  },
  fetchVideo: function(video) {
    var playerId;
    playerId = video.provider === "KALTURA" ? "kaltura-player-1360194818" : video.provider === "OOYALA" ? "ooyala-player" : video.provider === "YOUTUBE" ? "yt-player" : void 0;
    return this.media[video.id] = $("<div/>", {
      id: "video-container"
    }).attr("data-bhw", "PromNightVideo").html("<div id=\"" + playerId + "\" style=\"width:" + this.containerWidth + "px; height:" + this.options.mediaHeight + "px; margin: 0 auto;\"></div>");
  },
  fetchInitialMedia: function(start) {
    var collectionSize, i, j, loadCount, ref, ref1, results;
    if (start == null) {
      start = 0;
    }
    loadCount = 1;
    if (this.options.prefetchImages) {
      collectionSize = this.collection.size();
      loadCount = this.visibleThumbs;
      if (start + loadCount > collectionSize) {
        loadCount = collectionSize - start;
      }
    }
    results = [];
    for (i = j = ref = start, ref1 = start + loadCount; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      results.push(this.fetchMedia(i));
    }
    return results;
  },
  onBackClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onForwardClick(null, true);
      }
    }
    if (this.activeGroup > 0) {
      this.activeGroup--;
    } else {
      this.activeGroup = this.totalGroups - 1;
    }
    return this._updateThumbsPosition();
  },
  onForwardClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onBackClick(null, true);
      }
    }
    if (this.activeGroup < this.totalGroups - 1) {
      this.activeGroup++;
    } else {
      this.activeGroup = 0;
    }
    return this._updateThumbsPosition();
  },
  onLeftClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onRightClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb > 0) {
      newMedia = this.collection.at(currentThumb - 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(this.collection.size() - 1);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onRightClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onLeftClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb < this.collection.size() - 1) {
      newMedia = this.collection.at(currentThumb + 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(0);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onThumbnailClick: function(e) {
    var $thumb, newMedia;
    $thumb = this.$thumbs.find(e.currentTarget);
    newMedia = this.collection.get($thumb.data("id"));
    if (newMedia === this.currentFeatured) {
      return;
    }
    return this.updateGallery(newMedia);
  },
  playVideo: function(media) {
    if (media.provider === "KALTURA") {
      return kWidget.embed({
        "targetId": "kaltura-player-1360194818",
        "cache_st": 1360194818,
        "wid": "_1302621",
        "uiconf_id": "11486911",
        "flashvars": {
          "autoPlay": true,
          "streamerType": "hdnetwork",
          "akamaiHD": {
            "loadingPolicy": "preInitialize",
            "asyncInit": "true"
          }
        },
        "entry_id": media.media
      });
    } else if (media.provider === "OOYALA") {
      return this.videoPlayer = OO.Player.create('ooyala-player', media.media, {
        autoplay: true
      });
    } else if (media.provider === "YOUTUBE") {
      return this.videoPlayer = new YT.Player('yt-player', {
        height: this.$el.height(),
        width: this.$el.width(),
        videoId: media.media,
        playerVars: {
          'rel': 0,
          'showinfo': 0
        },
        events: {
          onReady: function(e) {
            return e.target.playVideo();
          }
        }
      });
    }
  },
  setFeaturedHeight: function(mediaHeight) {
    this.$gallery.height(mediaHeight);
    if (!(this.$body.hasClass("goods") || this.$body.hasClass("getaways") || this.$body.hasClass("getaways-booking"))) {
      mediaHeight += 3;
    }
    return this.$controls.height(mediaHeight);
  },
  updateGallery: function(newMedia) {
    var $newGalleryMedia, isCurrentVideo, newGalleryMedia, newMediaIndex, onComplete, transitionCSS;
    newMediaIndex = this.collection.indexOf(newMedia);
    if (this.media[newMedia.id]) {
      newGalleryMedia = this.media[newMedia.id];
    } else {
      this.fetchMedia(newMediaIndex);
      newGalleryMedia = this.media[newMedia.id];
    }
    $newGalleryMedia = $(newGalleryMedia);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 0
      };
      $newGalleryMedia.css(transitionCSS);
    }
    $newGalleryMedia.appendTo(this.$gallery);
    if (newMediaIndex > 0) {
      this.$leftButton.removeClass("disabled");
    } else {
      this.$leftButton.addClass("disabled");
    }
    if (newMediaIndex < this.collection.size() - 1) {
      this.$rightButton.removeClass("disabled");
    } else {
      this.$rightButton.addClass("disabled");
    }
    this._adjustThumbs(this.collection.indexOf(newMedia));
    if (newMedia.type === "video") {
      this.playVideo(newMedia);
      this.$clickBlocker.hide();
      this.$controls.hide();
    } else {
      this.$clickBlocker.show();
      this.$controls.show();
    }
    isCurrentVideo = this.currentFeatured.type === "video";
    onComplete = (function(_this) {
      return function() {
        var ref;
        _this.$gallery.children("[id^='gallery-']:not(#gallery-video-" + _this.currentFeatured.id + ", #gallery-image-" + _this.currentFeatured.id + ")").remove();
        if (isCurrentVideo) {
          if ((ref = _this.videoPlayer) != null) {
            ref.destroy();
          }
          return _this.$gallery.children("#video-container").remove();
        }
      };
    })(this);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 1
      };
      $newGalleryMedia.animate(transitionCSS, {
        complete: onComplete
      }, "slow");
    } else {
      setTimeout(onComplete, 600);
    }
    this.$thumbs.find("#gallery-thumb-" + newMedia.id).addClass("selected").siblings().removeClass("selected");
    this.$galleryMedia = $newGalleryMedia;
    this.currentFeatured = newMedia;
    return this.$body.trigger("carouselUpdate", {
      image: newMedia.baseURL,
      uuid: this.options.uuid
    });
  },
  updateCollection: function(collection) {
    var currentHeight, singleImage;
    this.collection = collection;
    if (!this.collection) {
      return;
    }
    singleImage = this.collection.length === 1;
    if (singleImage) {
      currentHeight = this.$el.height();
    }
    this.undelegateEvents;
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = !singleImage;
    this.currentFeatured = this.collection.first();
    this.render();
    if (singleImage) {
      return this.$el.css("min-height", currentHeight);
    }
  },
  _calculateThumbMargins: function(marginalia) {
    if (this.visibleThumbs > 1) {
      return Math.floor(marginalia / (this.visibleThumbs - 1));
    } else {
      return Math.floor(marginalia);
    }
  },
  _calculateThumbsWidth: function() {
    return (this.thumbWidth + this.thumbMargin) * this.$thumbnails.length - this.thumbMargin;
  },
  _prepareGroups: function() {
    this.thumbGroups = [];
    this.totalGroups = 0;
    this.thumbsPerGroup = 0;
    this.activeGroup = 0;
    this.pnThumbWidth = this.thumbWidth + this.thumbMargin;
    this.pnThumbWrapWidth = this.$thumbnails.length * this.pnThumbWidth;
    if (this.hasOverflow) {
      this._setThumbsPerGroup();
      this._setTotalGroups();
      this._setThumbGroups();
      this._setLastGroupThumbsShort();
      this._setActiveGroup();
      return this._updateThumbsPosition();
    }
  },
  _scrollThumbsPosition: function() {
    var direction, options;
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = -1 * $(this.$thumbnails[this.currentPosition]).position()[direction] + this.$backButton.width();
    if (this.animateViaJS) {
      this.$thumbs.animate(options);
    } else {
      this.$thumbs.css(options);
    }
    if (this.currentPosition === 0) {
      this.$backButton.addClass("disabled");
    } else {
      this.$backButton.removeClass("disabled");
    }
    if (this.currentPosition === this.collection.size() - this.visibleThumbs) {
      return this.$forwardButton.addClass("disabled");
    } else {
      return this.$forwardButton.removeClass("disabled");
    }
  },
  _setActiveGroup: function() {
    var currentIndex, group, i, j, lastRange, len, ref, results;
    currentIndex = this.collection.indexOf(this.currentFeatured);
    lastRange = this.thumbGroups[this.totalGroups - 1];
    ref = this.thumbGroups;
    results = [];
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (currentIndex >= group[0] && currentIndex <= group[1]) {
        if (this.activeGroup !== i) {
          this.activeGroup = i;
          results.push(this._updateThumbsPosition());
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  _setLastGroupThumbsShort: function() {
    return this.thumbsShort = this.thumbsPerGroup - (this.thumbGroups[this.totalGroups - 1][1] - this.thumbGroups[this.totalGroups - 1][0] + 1);
  },
  _setThumbGroups: function() {
    var end, i, j, ref, results, start;
    results = [];
    for (i = j = 0, ref = this.totalGroups - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      start = i * this.thumbsPerGroup;
      end = start + this.thumbsPerGroup - 1;
      if (end >= this.$thumbnails.length) {
        end = this.$thumbnails.length - 1;
      }
      results.push(this.thumbGroups[i] = [start, end]);
    }
    return results;
  },
  _setThumbsPerGroup: function() {
    return this.thumbsPerGroup = Math.floor(this.insideContainerWidth / (this.thumbWidth + this.thumbMargin));
  },
  _setTotalGroups: function() {
    return this.totalGroups = Math.ceil(this.thumbsWidth / this.insideContainerWidth);
  },
  _updateThumbsPosition: function() {
    var direction, modifier, options;
    modifier = 0;
    if (this.activeGroup === this.totalGroups - 1) {
      modifier = (this.thumbWidth + this.thumbMargin) * this.thumbsShort;
    }
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = (-1 * (((this.insideContainerWidth - this.thumbMargin) * this.activeGroup) - modifier - this.$backButton.width() - this.thumbMargin)) + "px";
    if (this.animateViaJS) {
      return this.$thumbs.animate(options);
    } else {
      return this.$thumbs.css(options);
    }
  },
  _adjustThumbs: function(index) {
    var group, i, j, k, len, ref, ref1, ref2;
    ref = this.thumbGroups;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (index >= group[0] && index <= group[1] && this.activeGroup !== i) {
        this.activeGroup = i;
        this._updateThumbsPosition();
        for (i = k = ref1 = group[0], ref2 = group[1]; ref1 <= ref2 ? k <= ref2 : k >= ref2; i = ref1 <= ref2 ? ++k : --k) {
          this.fetchMedia(i);
        }
        break;
      }
    }
  }
});



},{}],178:[function(require,module,exports){
var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, shouldShowTimerForGoods, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, ignoreCap) {
  if (ignoreCap == null) {
    ignoreCap = false;
  }
  switch (false) {
    case !(timeLeft.days >= 15 && !ignoreCap):
      return "";
    case !(timeLeft.days > 1):
      return ".countdown_time_many_days";
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

shouldShowTimerForGoods = function(dealTimer, timeLeft) {
  switch (dealTimer) {
    case 'lessThanEqualTo7Days':
      return timeLeft.days < 7 || (timeLeft.days === 7 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo3Days':
      return timeLeft.days < 3 || (timeLeft.days === 3 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo1Day':
      return timeLeft.days < 1 || (timeLeft.days === 1 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo12Hrs':
      return (timeLeft.days === 0 && timeLeft.hours < 12) || (timeLeft.days === 0 && timeLeft.hours === 12 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    default:
      return true;
  }
};

if (typeof window !== "undefined" && window !== null) {
  if (window.CountdownTimer == null) {
    window.CountdownTimer = {};
  }
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
  CountdownTimer.Helpers.shouldShowTimerForGoods = shouldShowTimerForGoods;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp,
    shouldShowTimerForGoods: shouldShowTimerForGoods
  };
}



},{}],179:[function(require,module,exports){
var base;

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

if ((base = window.CountdownTimer).current == null) {
  base.current = {};
}

CountdownTimer.init = function(arg, done) {
  var endAt, ref, timerData, timerModel, timerView;
  timerData = arg.timerData;
  if (done == null) {
    done = function() {};
  }
  endAt = timerData != null ? (ref = timerData.expiringSoon) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new CountdownTimer.Model({
    endAt: endAt
  });
  window.CountdownTimer.current.timerModel = timerModel;
  window.CountdownTimer.current.timerView = new CountdownTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: timerData != null ? timerData.el : void 0
  });
  timerView = window.CountdownTimer.current.timerView;
  return $(function() {
    timerView.render();
    return done();
  });
};



},{}],180:[function(require,module,exports){
if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.get('endAt'));
    return CountdownTimer.Helpers.timeRemaining(millisLeft);
  }
});



},{}],181:[function(require,module,exports){
var DEFAULT_EL;

DEFAULT_EL = '.limited-time > .counter li.countdown-timer';

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    return this.el = this.options.el || DEFAULT_EL;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("js.modules.groupon-deal-timer" + (CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timerIcon: '<span class="icon-now"></span>',
      timestamp: CountdownTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});



},{}],182:[function(require,module,exports){
var ShortcutHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ShortcutHeader = window.ShortcutHeader = {};

ShortcutHeader.EventHandler = (function() {
  var TOP_BUFFER;

  TOP_BUFFER = 10;

  function EventHandler(config, eventExtends) {
    this.updateShortcutSelection = bind(this.updateShortcutSelection, this);
    var animationConfig;
    if (eventExtends) {
      this.onSectionScroll = eventExtends.onSectionScroll, this.onShortcutClick = eventExtends.onShortcutClick;
    }
    this.stickyWatchElements = config.stickyWatchElements, this.shortcutMap = config.shortcutMap, this.stickyClass = config.stickyClass, animationConfig = config.animationConfig;
    this.$headers = $('#shortcut-header');
    this.setDefaults(animationConfig);
  }

  EventHandler.prototype.setDefaults = function(config) {
    this.tickInterval = (config != null ? config.tickInterval : void 0) || 15;
    this.visibleFactor = (config != null ? config.visibleFactor : void 0) || 100;
    this.scrollDelay = (config != null ? config.scrollDelay : void 0) || 20;
    if (this.stickyClass == null) {
      this.stickyClass = 'fixed';
    }
    return this.elemSelected = false;
  };

  EventHandler.prototype._getTopPosition = function(target) {
    var $target;
    $target = $(target);
    if ($target.length) {
      return $target.offset().top - this._offsetHeight() + TOP_BUFFER;
    }
  };

  EventHandler.prototype._isSectionInViewport = function(el) {
    var offset, rect, ref;
    rect = (ref = el[0]) != null ? ref.getBoundingClientRect() : void 0;
    offset = this._offsetHeight() + this.visibleFactor;
    return (rect != null ? rect.bottom : void 0) >= offset;
  };

  EventHandler.prototype._offsetHeight = function() {
    var bottom, height, index, len, stickyElements;
    height = 0;
    index = 0;
    stickyElements = $("." + this.stickyClass);
    len = stickyElements.length;
    while (index < len) {
      bottom = stickyElements[index].getBoundingClientRect().bottom;
      if (bottom > height) {
        height = bottom;
      }
      index++;
    }
    return height;
  };

  EventHandler.prototype.navigateTargetSection = function(target, callback) {
    var current, difference, duration, final, increment, initial, stepAnimator;
    initial = $(window).scrollTop();
    final = this._getTopPosition(target);
    difference = Math.abs(final - initial);
    duration = difference / 10 + 100;
    increment = Math.ceil(difference * this.tickInterval / duration);
    current = initial;
    stepAnimator = (function(_this) {
      return function() {
        if (Math.abs(current - final) < increment) {
          current = final;
        } else if (current < final) {
          current = current + increment;
        } else {
          current = current - increment;
        }
        window.scrollTo(0, current);
        if (current !== final) {
          final = _this._getTopPosition(target) || final;
          return setTimeout(stepAnimator, _this.tickInterval);
        } else {
          return callback();
        }
      };
    })(this);
    return stepAnimator();
  };

  EventHandler.prototype.processShortcutSelection = function(el, ev) {
    var $el, ref, targetSection;
    $el = $(el);
    targetSection = (ref = this.shortcutMap) != null ? ref[$el.attr('id')] : void 0;
    this.elemSelected = true;
    this.navigateTargetSection(targetSection, (function(_this) {
      return function() {
        return _this.elemSelected = false;
      };
    })(this));
    this.$headers.find('.shortcut-group li').removeClass("selected");
    $el.addClass("selected");
    if (typeof this.onShortcutClick === "function") {
      this.onShortcutClick($el);
    }
    return ev != null ? ev.preventDefault() : void 0;
  };

  EventHandler.prototype.stickHeader = function(watchElement) {
    var $watchElement, isFixed, offset, offsetTop, processStickHeader, throttled, watchParentOffset;
    offset = 0;
    isFixed = false;
    if (_.isObject(watchElement)) {
      $watchElement = $(watchElement.elem);
      watchParentOffset = $(watchElement.parent).height();
    } else {
      $watchElement = $(watchElement);
    }
    if (!($watchElement && $watchElement.offset())) {
      return;
    }
    offsetTop = $watchElement.offset().top - offset;
    processStickHeader = function() {
      var scrollTop, shouldBeFixed;
      scrollTop = $(window).scrollTop();
      if (watchParentOffset == null) {
        watchParentOffset = $(watchElement.parent).height();
      }
      if (!isFixed) {
        offsetTop = $watchElement.offset().top - (watchParentOffset != null ? watchParentOffset : 0);
      }
      shouldBeFixed = scrollTop > offsetTop;
      if (shouldBeFixed && !isFixed) {
        isFixed = true;
        return $watchElement.trigger("stickElement", {
          offset: watchParentOffset != null ? watchParentOffset : 0
        });
      } else if (!shouldBeFixed && isFixed) {
        isFixed = false;
        return $watchElement.trigger("unstickElement", []);
      }
    };
    throttled = _.throttle(processStickHeader, this.scrollDelay);
    return $(window).on("scroll", throttled);
  };

  EventHandler.prototype.updateShortcutSelection = function() {
    var $el, contentId, shortcutId;
    for (shortcutId in this.shortcutMap) {
      contentId = this.shortcutMap[shortcutId];
      $el = $(contentId);
      if (!this.elemSelected && $el.length === 1 && this._isSectionInViewport($el)) {
        this.$headers.find('.shortcut-group li').removeClass("selected");
        this.$headers.find("." + shortcutId).addClass("selected");
        if (typeof this.onSectionScroll === "function") {
          this.onSectionScroll($el);
        }
        break;
      }
    }
  };

  EventHandler.prototype.activate = function() {
    var elem, layout, processShortcutSelection;
    if (this.$headers.find('.shortcut-group li.selected').length === 0) {
      this.$headers.find('.shortcut-group li:first').addClass("selected");
    }
    layout = this;
    this.$headers.find('.shortcut-group li').on("click", function(ev) {
      return layout.processShortcutSelection($(this), ev);
    });
    for (elem in this.stickyWatchElements) {
      this.stickHeader(this.stickyWatchElements[elem]);
    }
    processShortcutSelection = _.throttle(this.updateShortcutSelection, this.scrollDelay);
    return $(window).on("resize scroll", processShortcutSelection);
  };

  return EventHandler;

})();

module.exports = ShortcutHeader;



},{}],183:[function(require,module,exports){
var ShortcutHeader, StickyHeader, _getTargetsOnce, _handleWindowResize;

StickyHeader = window.StickyHeader != null ? window.StickyHeader : window.StickyHeader = {};

ShortcutHeader = require('./header');

_handleWindowResize = function() {
  var $purchaseCluster;
  $purchaseCluster = $('#purchase-cluster');
  return $(window).on('resize', function() {
    var $buyElement, ref;
    $buyElement = $purchaseCluster.find('.buy.fixed');
    return $buyElement.css({
      left: $purchaseCluster != null ? (ref = $purchaseCluster.offset()) != null ? ref.left : void 0 : void 0
    });
  });
};

_getTargetsOnce = function(shortcutMap) {
  var key, target, targets;
  targets = {};
  for (key in shortcutMap) {
    target = shortcutMap[key];
    targets[key] = $(shortcutMap[key]);
  }
  return targets;
};

StickyHeader.init = function(arg, done) {
  var config, header, options, pageType, shortcutMap, stickyHeader, watchElements;
  header = arg.header, stickyHeader = arg.stickyHeader;
  shortcutMap = header.shortcutMap, watchElements = header.watchElements, pageType = header.pageType, options = header.options;
  config = {
    stickyWatchElements: watchElements,
    shortcutMap: shortcutMap
  };
  return $(function() {
    var $carouselElem, $headerSticky, $rowElem, $writeUp, carouselBottomPosition, carouselHeight, carouselOffset, targets;
    $headerSticky = $('.header-row-sticky');
    if (pageType === 'local') {
      $carouselElem = $('.gallery, .gallery-single, .featured-image');
      carouselOffset = $carouselElem.offset();
      carouselHeight = $carouselElem.outerHeight();
      carouselBottomPosition = carouselHeight + carouselOffset.top;
      StickyHeader.elements = {
        pageType: pageType,
        top: carouselBottomPosition,
        headerSticky: $headerSticky
      };
      if ($(".multi-option-overlay-items").children().length) {
        $(".header-options a").click(function(e) {
          var $modal;
          e.preventDefault();
          $modal = $("#options");
          return GIG.Modal.open({
            el: $modal
          });
        });
      }
    } else if (pageType === 'goods') {
      $rowElem = $('.header-row');
      $writeUp = $('#deal-info');
      targets = _getTargetsOnce(shortcutMap);
      StickyHeader.elements = {
        pageType: pageType,
        row: $rowElem,
        headerSticky: $headerSticky,
        targets: targets,
        watchElements: watchElements,
        gap: 100,
        shouldShowSticky: stickyHeader,
        shouldShowQuicklinks: options.shouldShowQuicklinks,
        shouldShowGoodsV2Sticky: options.shouldShowGoodsV2Sticky,
        stickyTopV2SlideUpTime: options.stickyTopV2SlideUpTime,
        stickyTopV2SlideDownTime: options.stickyTopV2SlideDownTime
      };
      if ($rowElem.length) {
        _.extend(StickyHeader.elements, {
          rowParent: $rowElem.parent(),
          top: $rowElem.offset().top,
          height: $rowElem.outerHeight()
        });
      }
      if ($writeUp.length) {
        _.extend(StickyHeader.elements, {
          stickyTop: $writeUp.offset().top
        });
      }
    }
    if (options.shouldShowQuicklinks) {
      StickyHeader.quicklinks = $('#shorcuts-container li');
      StickyHeader.quicklinks.on('click', function(ev) {
        return StickyHeader.animateQuicklink($(this), ev);
      });
    }
    if (stickyHeader) {
      $(window).scroll(_.throttle(StickyHeader.scrollAction, 20));
    }
    return done();
  });
};

StickyHeader.updateCssClass = function(clicked) {
  var current;
  current = StickyHeader.quicklinks.filter('.selected');
  if (clicked !== current) {
    current.removeClass('selected');
    return clicked.addClass('selected');
  }
};

StickyHeader.animateQuicklink = function(clicked, ev) {
  var current, gap, ref, row, shouldShowSticky, target, targets, top;
  ref = StickyHeader.elements, row = ref.row, gap = ref.gap, shouldShowSticky = ref.shouldShowSticky, targets = ref.targets;
  current = StickyHeader.quicklinks.filter('.selected');
  if (clicked !== current) {
    target = targets[clicked.attr('id')];
    top = target.offset().top;
    if (shouldShowSticky) {
      top -= row.outerHeight();
      if (!row.hasClass('header-row-sticked')) {
        top -= gap;
      }
    }
    $('body,html').animate({
      scrollTop: top
    }, 500, function() {
      return StickyHeader.updateCssClass(clicked);
    });
    return ev != null ? ev.preventDefault() : void 0;
  }
};

StickyHeader.scrollAction = function() {
  var belowThreshold, gap, headerSticky, height, pageType, position, ref, ref1, ref2, row, rowParent, shouldShowGoodsV2Sticky, shouldShowQuicklinks, stickyTop, stickyTopV2SlideDownTime, stickyTopV2SlideUpTime, target, targetTop, targets, top, watchElements, yPosition;
  ref = StickyHeader.elements, row = ref.row, rowParent = ref.rowParent, headerSticky = ref.headerSticky, targets = ref.targets, watchElements = ref.watchElements, gap = ref.gap, top = ref.top, height = ref.height, stickyTop = ref.stickyTop, shouldShowQuicklinks = ref.shouldShowQuicklinks, shouldShowGoodsV2Sticky = ref.shouldShowGoodsV2Sticky, pageType = ref.pageType, stickyTopV2SlideUpTime = ref.stickyTopV2SlideUpTime, stickyTopV2SlideDownTime = ref.stickyTopV2SlideDownTime;
  yPosition = $(window).scrollTop();
  if (pageType === 'local') {
    belowThreshold = yPosition > top;
    if (belowThreshold && !headerSticky.is(":animated")) {
      return headerSticky.slideDown(280);
    } else if (!belowThreshold && headerSticky.is(":visible") && !headerSticky.is(":animated")) {
      return headerSticky.slideUp(280);
    }
  } else if (pageType === 'goods') {
    if (shouldShowGoodsV2Sticky) {
      belowThreshold = yPosition > stickyTop;
      if (belowThreshold && !(headerSticky.is(":animated") || headerSticky.is(":visible"))) {
        headerSticky.slideDown(stickyTopV2SlideDownTime);
        if (shouldShowQuicklinks) {
          position = watchElements.length - 1;
          while (position >= 0) {
            target = targets[watchElements[position]];
            targetTop = target != null ? (ref1 = target.offset()) != null ? ref1.top : void 0 : void 0;
            if ((targetTop != null) && (yPosition + gap) >= targetTop) {
              break;
            }
            position--;
          }
          return StickyHeader.updateCssClass(StickyHeader.quicklinks.eq(position));
        }
      } else if (!(belowThreshold || headerSticky.is(":animated")) && headerSticky.is(":visible")) {
        return headerSticky.slideUp(stickyTopV2SlideUpTime);
      }
    } else {
      if (row.hasClass('header-row-static')) {
        top = StickyHeader.elements.top = row.offset().top;
      }
      if (yPosition > top) {
        row.removeClass('header-row-static');
        row.addClass('header-row-sticked');
        rowParent.css({
          paddingTop: height
        });
        if (shouldShowQuicklinks) {
          position = watchElements.length - 1;
          while (position >= 0) {
            target = targets[watchElements[position]];
            targetTop = target != null ? (ref2 = target.offset()) != null ? ref2.top : void 0 : void 0;
            if ((targetTop != null) && (yPosition + gap) >= targetTop) {
              break;
            }
            position--;
          }
          return StickyHeader.updateCssClass(StickyHeader.quicklinks.eq(position));
        }
      } else {
        row.removeClass('header-row-sticked');
        row.addClass('header-row-static');
        return rowParent.css({
          paddingTop: 0
        });
      }
    }
  }
};

module.exports = StickyHeader;



},{"./header":182}],184:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = require('../models/option');

InlineVariations.Collections.Options = Backbone.Collection.extend({
  model: InlineVariations.Models.Option
});

module.exports = InlineVariations.Collections.Options;



},{"../models/option":187}],185:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Trait = require('../models/trait');

InlineVariations.Collections.Traits = Backbone.Collection.extend({
  model: InlineVariations.Models.Trait,
  selectedTraitValues: {},
  initialize: function() {
    return this.on('change:selectedTraitValue', this.changeSelectedTraitValue, this);
  },
  changeSelectedTraitValue: function(model, val) {
    if (val) {
      return this.selectedTraitValues[model.get('name')] = val;
    } else {
      return delete this.selectedTraitValues[model.get('name')];
    }
  },
  someTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length > 0;
  },
  allTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length === this.models.length;
  },
  closeDropdowns: function() {
    var i, len, ref, results, trait;
    ref = this.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.closeDropdown());
    }
    return results;
  }
});

module.exports = InlineVariations.Collections.Traits;



},{"../models/trait":188}],186:[function(require,module,exports){
var InlineVariations, _scrollToBuyButton, _scrollToTouchInlineVariation;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

InlineVariations.Collections.Options = require('./collections/options');

InlineVariations.Collections.Traits = require('./collections/traits');

InlineVariations.Views.Main = require('./views/main');

_scrollToBuyButton = function() {
  if (!$('#purchase-cluster .buy.fixed, .header-row-sticked, .header-row-sticky').length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $('.main').position().top - 100
  }, 500);
};

_scrollToTouchInlineVariation = function() {
  var $inlineVariationContainer;
  $inlineVariationContainer = $('#inline-variations-container');
  if (!$inlineVariationContainer.length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $inlineVariationContainer.position().top - $(window).height() / 5
  }, 500);
};

InlineVariations.init = function(arg, done) {
  var buyButton, carouselViews, dealMedia, dealOptionUuid, dealUuid, deliveryEstimates, inlineVariations, isCart, isResponsive, isTouch, mappings, offer, options, preSelectTraits, ref, ref1, stickyHeader, touchBuyButton, traits;
  buyButton = arg.buyButton, deliveryEstimates = arg.deliveryEstimates, inlineVariations = arg.inlineVariations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (!((inlineVariations != null ? (ref = inlineVariations.options) != null ? ref.length : void 0 : void 0) && ((ref1 = inlineVariations.traits) != null ? ref1.length : void 0))) {
    return done();
  }
  dealOptionUuid = inlineVariations.dealOptionUuid, dealUuid = inlineVariations.dealUuid, isResponsive = inlineVariations.isResponsive, isTouch = inlineVariations.isTouch, mappings = inlineVariations.mappings, options = inlineVariations.options, preSelectTraits = inlineVariations.preSelectTraits, traits = inlineVariations.traits;
  if (typeof DealCarousel !== "undefined" && DealCarousel !== null) {
    carouselViews = DealCarousel.carouselViews, dealMedia = DealCarousel.dealMedia;
  }
  isCart = (isTouch && (buyButton != null ? buyButton.cartIcon : void 0)) || (!isTouch && (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0));
  options = new InlineVariations.Collections.Options(options);
  traits = new InlineVariations.Collections.Traits(traits, {
    isTouch: isTouch
  });
  if (isTouch) {
    touchBuyButton = isResponsive ? ResponsiveBuyButton : TouchBuyButton;
    touchBuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (_this.main.variationsSelected()) {
          return;
        }
        _this.main.showErrorMessages();
        _scrollToTouchInlineVariation();
        return {
          stopTheBus: true
        };
      };
    })(this))(-300);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (BuyButton.view.variationsSelected) {
          return;
        }
        _this.main.showErrorMessages();
        if (stickyHeader) {
          _scrollToBuyButton();
        }
        BuyButton.view.enableBuyButton();
        return {
          stopTheBus: true
        };
      };
    })(this));
  }
  return $((function(_this) {
    return function() {
      var ref2;
      _this.main = new InlineVariations.Views.Main({
        carouselViews: carouselViews,
        dealMedia: dealMedia,
        dealOptionUuid: dealOptionUuid,
        dealUuid: dealUuid,
        deliveryEstimates: deliveryEstimates,
        isCart: isCart,
        isTouch: isTouch,
        mappings: mappings,
        offer: offer,
        options: options,
        preSelectTraits: preSelectTraits,
        traits: traits,
        _scrollToTouchInlineVariation: _scrollToTouchInlineVariation
      });
      traits.view = _this.main;
      if (options != null ? (ref2 = options[0]) != null ? ref2.hideOriginalPriceAndDiscount : void 0 : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html('');
      }
      $(document.body).on('carouselUpdate', function(e, arg1) {
        var image;
        image = arg1.image;
        return _this.main.updateInlineVariationSelections(image);
      });
      return done();
    };
  })(this));
};

module.exports = InlineVariations;



},{"./collections/options":184,"./collections/traits":185,"./views/main":189}],187:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = Backbone.Model.extend({});

module.exports = InlineVariations.Models.Option;



},{}],188:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = require('../views/trait');

InlineVariations.Views.NativeDropdownTrait = require('../views/native_dropdown_trait');

InlineVariations.Models.Trait = Backbone.Model.extend({
  initialize: function(arg, arg1) {
    var id, isTouch, layout;
    id = arg.id, layout = arg.layout;
    isTouch = arg1.isTouch;
    if (layout != null ? layout.isNativeDropdown : void 0) {
      return this.view = new InlineVariations.Views.NativeDropdownTrait({
        model: this,
        el: "#" + id
      });
    } else {
      return this.view = new InlineVariations.Views.Trait({
        model: this,
        el: "#" + id,
        isTouch: isTouch
      });
    }
  },
  setSelectedTraitValueById: function(id) {
    var selectedTraitValue;
    if (id) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        id: id
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  getTraitValueById: function(id) {
    return _.findWhere(this.get('values'), {
      id: id
    });
  },
  setSelectedTraitValueByName: function(name) {
    var selectedTraitValue;
    if (name) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        name: name
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  updateTraitValue: function(selectedTraitValue) {
    if (selectedTraitValue && !selectedTraitValue.isSoldOut && !selectedTraitValue.isPlaceholder) {
      return this.set({
        selectedTraitValueId: selectedTraitValue.id,
        selectedTraitValue: selectedTraitValue.name,
        selectedTraitValueHtml: selectedTraitValue.selectedHtml
      });
    } else {
      return this.set({
        selectedTraitValueId: false,
        selectedTraitValue: false,
        selectedTraitValueHtml: false
      });
    }
  }
});

module.exports = InlineVariations.Models.Trait;



},{"../views/native_dropdown_trait":190,"../views/trait":191}],189:[function(require,module,exports){
var Cart, DealEventPipe, InlineVariations;

Cart = window.Cart != null ? window.Cart : window.Cart = {};

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Cart.Helpers = require('../../../cart/common/helpers');

InlineVariations.Views.Main = Backbone.View.extend({
  el: '#inline-variations-container',
  body: 'body',
  inlineVariationsTraits: '.inline-variation-trait',
  inlineVariationsDropdowns: '.inline-variation-layout-generic-dropdown, .inline-variation-native-dropdown',
  touch: {
    main: '.t-main',
    featuredImg: '#featured-image',
    featuredImgSize: 't300x182.jpg',
    buyButton: '#buy',
    priceBuy: '#price-buy, #price-buy-v2',
    values: '#price-buy .value, #price-buy-v2 .value',
    prices: '#price-buy .price, #price-buy-v2 .price, #inline-variations-filters-header .price',
    urgencyPrice: '#price-buy .urgency-pricing-value-unit strong, #price-buy-v2 .urgency-pricing-value-unit strong',
    urgencyOfferLabel: '#price-buy .urgency-pricing-value-unit .urgency-pricing-offer-label, #price-buy-v2 .urgency-pricing-value-unit .urgency-pricing-offer-label',
    deliveryEstimate: '.delivery-estimates-container',
    discount: '#discount-percent span, .discount-percentage',
    savings: '#discount-savings span',
    filters: '#inline-variations-filters',
    filtersHeight: '48%'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    this.$inlineVariationsDropdowns = this.$el.find(this.inlineVariationsDropdowns);
    this.$inlineVariationsTraits = this.$el.find(this.inlineVariationsTraits);
    this.$body = $(this.body);
    if (this.isTouch) {
      this.$body = $(this.touch.main);
      this.$touchFeaturedImg = $(this.touch.featuredImg);
      this.$touchBuyButton = $(this.touch.buyButton);
      this.$touchPriceBuy = $(this.touch.priceBuy);
      this.$touchPrices = $(this.touch.prices);
      this.$touchValues = $(this.touch.values);
      this.$touchUrgencyPrice = $(this.touch.urgencyPrice);
      this.$touchUrgencyOfferLabel = $(this.touch.urgencyOfferLabel);
      this.$touchDeliveryEstimate = $(this.touch.deliveryEstimate);
      this.$touchDiscount = $(this.touch.discount);
      this.$touchSavings = $(this.touch.savings);
      this.$touchFilters = $(this.touch.filters);
      this.touchOriginalFeaturedImg = this.$touchFeaturedImg.attr('src');
    }
    this.attachBackdropEventListener();
    return this.makeSelectionsViaPreselection();
  },
  attachBackdropEventListener: function() {
    return this.$body.click((function(_this) {
      return function(e) {
        if (!_this.$body.hasClass('inline-variation-backdrop')) {
          return;
        }
        if (_this.$body.hasClass('stop-propagation')) {
          return _this.$body.removeClass('stop-propagation');
        } else {
          _this.traits.closeDropdowns();
          if (_this.isTouch) {
            return _this.$touchFilters.animate({
              height: '0'
            }, 400, 'swing', function() {
              _this.$body.removeClass('inline-variation-backdrop');
              _this.$touchFilters.height('auto');
              return _this._scrollToTouchInlineVariation();
            });
          } else {
            return _this.$body.removeClass('inline-variation-backdrop');
          }
        }
      };
    })(this));
  },
  makeSelectionsViaPreselection: function() {
    var i, len, option, ref, ref1, selections, trait, value;
    if (!((ref = this.preSelectTraits) != null ? ref.length : void 0)) {
      return;
    }
    if (!(option = this.options.findWhere({
      uuid: this.dealOptionUuid
    }))) {
      return;
    }
    selections = {};
    ref1 = this.preSelectTraits;
    for (i = 0, len = ref1.length; i < len; i++) {
      trait = ref1[i];
      if (value = option.get(trait)) {
        selections[trait] = value;
      }
    }
    this.updateSelections(selections);
    return this.render();
  },
  render: function(updateCarouselOrFeaturedImage) {
    if (updateCarouselOrFeaturedImage == null) {
      updateCarouselOrFeaturedImage = true;
    }
    this.updateSoldout();
    this.updatePriceAndBuyButton();
    if (updateCarouselOrFeaturedImage) {
      this.updateCarouselOrFeaturedImage();
    }
    return this.hideErrorMessages();
  },
  updateSoldout: function() {
    var currentValue, filteredSelection, i, len, ref, results, trait, traitValue;
    if (this.traits.models.length < 2) {
      return;
    }
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      filteredSelection = _.omit(this.traits.selectedTraitValues, trait.get('name'));
      results.push((function() {
        var j, len1, ref1, results1;
        ref1 = trait.get('values') || [];
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          traitValue = ref1[j];
          if (traitValue.isPlaceholder) {
            continue;
          }
          currentValue = {};
          currentValue[traitValue.traitName] = traitValue.name;
          results1.push(trait.view.toggleSoldOut(traitValue, this.options.where(_.extend(filteredSelection, currentValue)).length === 0));
        }
        return results1;
      }).call(this));
    }
    return results;
  },
  updatePriceAndBuyButton: function() {
    var cheapestOption, optionInfo, qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    if (!qualifiedOptions.length) {
      return;
    }
    if (!(cheapestOption = _.min(qualifiedOptions, function(option) {
      return option.get('amount');
    }))) {
      return;
    }
    if (cheapestOption === Infinity) {
      return;
    }
    optionInfo = {
      buyUrl: this.buyButtonUrl(cheapestOption),
      hideOriginalPriceAndDiscount: cheapestOption.get('hideOriginalPriceAndDiscount'),
      id: cheapestOption.get('id'),
      lengthClass: cheapestOption.get('lengthClass'),
      percent: cheapestOption.get('discount'),
      price: cheapestOption.get('newPrice'),
      savings: cheapestOption.get('savePrice'),
      uuid: cheapestOption.get('uuid'),
      value: cheapestOption.get('oldPrice'),
      variationsSelected: qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected()
    };
    this.overridePrice(optionInfo, cheapestOption);
    if (this.isTouch) {
      this.updateTouchDealInfo(optionInfo);
      this.updateTouchBuyButton(optionInfo);
      return DealEventPipe.trigger("touchDeliveryEstimatesUpdate", optionInfo);
    } else {
      return DealEventPipe.trigger("priceUpdate", optionInfo);
    }
  },
  updateTouchDealInfo: function(arg) {
    var id, percent, price, ref, sale, savings, urgencyPricing, uuid, value;
    id = arg.id, percent = arg.percent, price = arg.price, sale = arg.sale, savings = arg.savings, uuid = arg.uuid, value = arg.value;
    this.$touchValues.text(value);
    this.$touchDiscount.html(percent);
    this.$touchSavings.text(savings);
    this.$touchPriceBuy.attr('data-option-id', id);
    if (urgencyPricing = sale != null ? sale.urgencyPricing : void 0) {
      this.$touchPrices.text(urgencyPricing.regularPrice);
      this.$touchUrgencyPrice.show().text(urgencyPricing.newPrice);
      this.$touchPriceBuy.addClass('urgency-pricing-cluster');
      if ((ref = urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0) {
        return this.$touchUrgencyOfferLabel.show().text(urgencyPricing.pricingMetadata.offerLabel);
      } else {
        return this.$touchUrgencyOfferLabel.hide();
      }
    } else {
      this.$touchPrices.text(price);
      return this.$touchPriceBuy.removeClass('urgency-pricing-cluster');
    }
  },
  updateTouchBuyButton: function(arg) {
    var buyUrl, id, variationsSelected;
    buyUrl = arg.buyUrl, id = arg.id, variationsSelected = arg.variationsSelected;
    if (variationsSelected) {
      this.$touchBuyButton.attr('href', buyUrl);
      if (this.isCart) {
        return this.$touchBuyButton.attr('data-option', id);
      }
    } else {
      this.$touchBuyButton.removeAttr('href');
      if (this.isCart) {
        return this.$touchBuyButton.removeAttr('data-option');
      }
    }
  },
  getQualifiedOptions: function() {
    if (this.traits.someTraitValuesSelected()) {
      return this.options.where(this.traits.selectedTraitValues);
    } else {
      return this.options.models;
    }
  },
  variationsSelected: function() {
    var qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    return qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected();
  },
  buyButtonUrl: function(option) {
    var ref;
    switch (false) {
      case !((ref = option.get('externalUrl')) != null ? ref.length : void 0):
        return option.get('externalUrl');
      case !this.isCart:
        return Cart.Helpers.generateCartUrl(option.get('uuid'), this.dealUuid);
      default:
        return option.get('url');
    }
  },
  overridePrice: function(optionInfo, option) {
    var offer, ref, ref1, ref2, ref3, sale;
    if (!((option.get('regularPrice') != null) || ((ref = this.offer) != null ? (ref1 = ref.offerOptions) != null ? ref1.length : void 0 : void 0))) {
      return;
    }
    sale = {};
    if (option.get('regularPrice')) {
      sale.urgencyPricing = {
        newPrice: option.get('newPrice'),
        pricingMetadata: option.get('pricingMetadata'),
        regularPrice: option.get('regularPrice')
      };
    }
    if (offer = _.findWhere((ref2 = this.offer) != null ? ref2.offerOptions : void 0, {
      id: option.get('uuid')
    })) {
      if (offer.buyUrl && !((ref3 = this.offer.offerModal) != null ? ref3.isSoldOut : void 0)) {
        optionInfo.buyUrl = offer.buyUrl;
      }
      _.extend(sale, {
        offer: offer
      });
    }
    if (sale !== {}) {
      return _.extend(optionInfo, {
        sale: sale
      });
    }
  },
  updateCarouselOrFeaturedImage: function() {
    var currentBaseUrl, image, imageUrl;
    if (this.isTouch) {
      if (imageUrl = this.findFeaturedImageUrl()) {
        return this.$touchFeaturedImg.attr('src', imageUrl);
      }
    } else if (image = this.findCarouselImage()) {
      currentBaseUrl = this.carouselViews[this.dealUuid].currentFeatured.baseURL;
      if (currentBaseUrl !== image.baseURL) {
        return this.carouselViews[this.dealUuid].updateGallery(image);
      }
    }
  },
  findFeaturedImageUrl: function() {
    var image, ref;
    if (!(image = (ref = this.options.findWhere(this.traits.selectedTraitValues)) != null ? ref.get('image') : void 0)) {
      return this.touchOriginalFeaturedImg;
    }
    return "" + image + this.touch.featuredImgSize;
  },
  findCarouselImage: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.dealMedia[this.dealUuid].models[0];
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        this.carouselImage = imageUrl;
        return this.dealMedia[this.dealUuid].findWhere({
          baseURL: imageUrl
        });
      }
    }
  },
  updateInlineVariationSelections: function(image) {
    var key, ref, selections, value;
    if (!image) {
      return;
    }
    if (image === this.carouselImage) {
      return;
    }
    this.carouselImage = image;
    selections = {};
    if (this.mappings[image]) {
      ref = this.mappings[image];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections[key] = value[0];
        }
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateSelections: function(selections) {
    var i, len, ref, results, trait;
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.setSelectedTraitValueByName(selections[trait.get('name')]));
    }
    return results;
  },
  showErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.addClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.showErrorMessages());
    }
    return results;
  },
  hideErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.removeClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.hideErrorMessages());
    }
    return results;
  },
  showBackdrop: function(traitView) {
    var isOpen;
    isOpen = this.$body.hasClass('inline-variation-backdrop');
    this.$body.addClass('inline-variation-backdrop stop-propagation');
    if (!this.isTouch) {
      return;
    }
    if (isOpen) {
      return traitView.slideDownAnimation();
    } else {
      return this.$touchFilters.animate({
        height: this.touch.filtersHeight
      }, function() {
        return traitView.slideDownAnimation();
      });
    }
  }
});

module.exports = InlineVariations.Views.Main;



},{"../../../cart/common/helpers":89,"../../../deal/frontend/event_pipe":94}],190:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.NativeDropdownTrait = Backbone.View.extend({
  inlineTrait: '.inline-variation-trait',
  events: {
    'change .inline-variation-trait': 'traitValueSelection'
  },
  initialize: function() {
    this.$inlineNativeTrait = this.$el.find(this.inlineTrait);
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    return this.processTraitValues();
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  traitValueSelection: function(e) {
    this.model.setSelectedTraitValueByName($(e.currentTarget).val());
    return this.model.collection.view.render();
  },
  getSelectedTrait: function(id) {
    if (id) {
      return _.findWhere(this.model.get('values'), {
        id: id
      });
    } else {
      return _.first(this.model.get('values'));
    }
  },
  setTraitValue: function() {
    return this.getSelectedTrait(this.model.get('selectedTraitValueId')).$el.prop('selected', true);
  },
  showErrorMessages: function() {
    if (this.model.get('selectedTraitValue')) {
      return;
    }
    this.$el.addClass('error');
    return this.$inlineNativeTrait.addClass('error');
  },
  hideErrorMessages: function() {
    this.$el.removeClass('error');
    return this.$inlineNativeTrait.removeClass('error');
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    return traitValue.$el.prop('disabled', isSoldOut);
  },
  closeDropdown: function() {}
});

module.exports = InlineVariations.Views.NativeDropdownTrait;



},{}],191:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = Backbone.View.extend({
  dropdownSelection: '.inline-variation-dropdown-selection',
  traitValues: '.inline-variation-trait-value',
  inlineTitleHtml: '.inline-variation-trait-title',
  body: 'body',
  touch: {
    main: '.t-main',
    traitValuesContainer: '.inline-variation-trait-values'
  },
  events: {
    'click .inline-variation-dropdown-selection': 'toggleDropdown',
    'click .inline-variation-trait-value': 'traitValueSelection'
  },
  webSwatchEvents: {
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait',
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'
  },
  initialize: function() {
    this.layout = this.model.get('layout');
    this.title = this.model.get('title');
    this.isSwatchImageDropdown = this.layout.isImageSwatch && this.layout.isDropdown;
    this.isTouch = this.options.isTouch;
    this.$body = $(this.body);
    this.$traitValues = this.$el.find(this.traitValues);
    if (this.layout.isDropdown) {
      this.placeholderHtml = this.model.get('title');
      this.placeholderValue = this.model.get('placeholderValue');
      this.placeholderValueId = this.model.get('placeholderValueId');
      this.$titleHtml = this.$el.find(this.dropdownSelection);
    } else {
      this.$titleHtml = this.$el.find(this.inlineTitleHtml);
    }
    if (this.layout.enableFilterSheet) {
      this.$body = $(this.touch.main);
      this.$touchTraitValuesContainer = this.$el.find(this.touch.traitValuesContainer);
    }
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    if (this.layout.isSwatch && !(this.isTouch || this.isTouchDevice())) {
      _.extend(this.events, this.webSwatchEvents);
    }
    return this.processTraitValues();
  },
  isTouchDevice: function() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  toggleDropdown: function(e) {
    var isOpen;
    isOpen = this.$el.hasClass('open');
    this.model.collection.closeDropdowns();
    if (isOpen) {
      return;
    }
    this.model.collection.view.showBackdrop(this);
    if (!this.layout.enableFilterSheet) {
      return this.openTrait();
    }
  },
  slideDownAnimation: function() {
    return this.$touchTraitValuesContainer.slideDown(400, (function(_this) {
      return function() {
        return _this.openTrait();
      };
    })(this));
  },
  openTrait: function() {
    this.$el.addClass('open');
    return this.sendDropdownTrackingEvent(false);
  },
  sendDropdownTrackingEvent: function(isOpen) {
    var status;
    status = isOpen ? 'close' : 'open';
    return OptimizeSuite.TrackingHub.add("inline-variations-dropdown-" + status);
  },
  closeDropdown: function() {
    var isOpen;
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    if (!(isOpen = this.$el.hasClass('open'))) {
      return;
    }
    if (this.layout.enableFilterSheet) {
      return this.$touchTraitValuesContainer.slideUp(400, (function(_this) {
        return function() {
          _this.$el.removeClass('open');
          return _this.sendDropdownTrackingEvent(isOpen);
        };
      })(this));
    } else {
      this.$el.removeClass('open');
      return this.sendDropdownTrackingEvent(isOpen);
    }
  },
  traitValueSelection: function(e) {
    var $target, selected;
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return e.stopPropagation();
    }
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    selected = $target.hasClass('selected');
    if (selected && this.layout.isDropdown && !(this.layout.isSwatch || this.isTouch)) {
      return;
    }
    this.$traitValues.removeClass('selected');
    if (selected) {
      this.model.setSelectedTraitValueById();
    } else {
      this.model.setSelectedTraitValueById($target.attr('id'));
    }
    return this.model.collection.view.render();
  },
  updateTitleToHoveredTrait: function(e) {
    var $target, currentTraitValue;
    if (!this.layout.isSwatch) {
      return;
    }
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return;
    }
    if (currentTraitValue = this.model.getTraitValueById($target.attr('id'))) {
      return this.$titleHtml.html(currentTraitValue.selectedHtml);
    }
  },
  updateTitleToOriginalTrait: function(e) {
    if (!this.layout.isSwatch) {
      return;
    }
    if ($(e.currentTarget).hasClass('sold-out')) {
      return;
    }
    return this.$titleHtml.html(this.model.get('selectedTraitValueHtml') || this.title);
  },
  setTraitValue: function() {
    var selectedTraitValue, selectedTraitValueId;
    if (!this.layout.enableFilterSheet) {
      this.closeDropdown();
    }
    selectedTraitValue = this.model.get('selectedTraitValueHtml');
    selectedTraitValueId = this.model.get('selectedTraitValueId');
    if (this.layout.isDropdown || this.layout.isSwatch) {
      if (!selectedTraitValue) {
        if (this.layout.isSwatch) {
          selectedTraitValue = this.title;
        } else {
          selectedTraitValue = this.placeholderHtml;
          selectedTraitValueId = this.placeholderValueId;
        }
      }
      this.$titleHtml.html(selectedTraitValue);
    }
    return this.$traitValues.each(function() {
      var $traitValue;
      $traitValue = $(this);
      return $traitValue.toggleClass('selected', $traitValue.attr('id') === selectedTraitValueId);
    });
  },
  showErrorMessages: function() {
    var ref;
    if (!this.model.get('selectedTraitValue')) {
      this.$el.addClass('error');
    }
    return (ref = this.$traitValuesContainer) != null ? ref.addClass('error') : void 0;
  },
  hideErrorMessages: function() {
    var ref;
    this.$el.removeClass('error');
    return (ref = this.$traitValuesContainer) != null ? ref.removeClass('error') : void 0;
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    return traitValue.$el.toggleClass('sold-out', isSoldOut);
  }
});

module.exports = InlineVariations.Views.Trait;



},{}],192:[function(require,module,exports){
var lazyLoadMerchantLocations;

lazyLoadMerchantLocations = window.lazyLoadMerchantLocations != null ? window.lazyLoadMerchantLocations : window.lazyLoadMerchantLocations = {};

lazyLoadMerchantLocations.reload = function(data) {
  var el, merchantHtml, merchantModalHtml, merchantSubtitleTooltipHtml, ref, ref1, touchRequest, unbindFirst;
  merchantHtml = data.merchantHtml, merchantModalHtml = data.merchantModalHtml, merchantSubtitleTooltipHtml = data.merchantSubtitleTooltipHtml, touchRequest = data.touchRequest;
  if (merchantHtml.length) {
    GMap.init(data, function() {});
  }
  if (!touchRequest) {
    if (merchantSubtitleTooltipHtml.length) {
      if (typeof GIG !== "undefined" && GIG !== null) {
        if ((ref = GIG.Tooltip) != null) {
          ref.reloadBindings(document.body);
        }
      }
    }
    if (merchantModalHtml.length) {
      return typeof GIG !== "undefined" && GIG !== null ? (ref1 = GIG.Modal) != null ? ref1.reloadBindings(el = document.body, unbindFirst = false) : void 0 : void 0;
    }
  }
};

lazyLoadMerchantLocations.ajax_success = function(data) {
  var $lastTooltip, $tooltipAndModalData, dealTitleMerchantInfoHtml, merchantHtml, merchantModalHtml, merchantSubtitleTooltipHtml, touchRequest;
  dealTitleMerchantInfoHtml = data.dealTitleMerchantInfoHtml, merchantHtml = data.merchantHtml, merchantModalHtml = data.merchantModalHtml, merchantSubtitleTooltipHtml = data.merchantSubtitleTooltipHtml, touchRequest = data.touchRequest;
  if (merchantHtml.length) {
    $('#merchant-locations-placeholder').replaceWith(merchantHtml);
  } else {
    $('#merchant-locations-placeholder').remove();
  }
  if (dealTitleMerchantInfoHtml.length) {
    $('.deal-subtitle').replaceWith(dealTitleMerchantInfoHtml);
  }
  if (touchRequest) {
    if (merchantModalHtml.length) {
      $('.t-main').after(merchantModalHtml);
    }
  } else {
    $tooltipAndModalData = "";
    if (_.isString(merchantSubtitleTooltipHtml)) {
      $tooltipAndModalData += merchantSubtitleTooltipHtml;
    }
    if (_.isString(merchantModalHtml)) {
      $tooltipAndModalData += merchantModalHtml;
    }
    if ($tooltipAndModalData.length) {
      $lastTooltip = $('.tooltip').last() || $('section.main');
      $lastTooltip.after($tooltipAndModalData);
    }
  }
  return lazyLoadMerchantLocations.reload(data);
};

lazyLoadMerchantLocations.init = function(payload, done) {
  var clientSideMerchantLocations;
  clientSideMerchantLocations = payload.clientSideMerchantLocations;
  if (clientSideMerchantLocations == null) {
    return done();
  }
  return $(function() {
    return $(window).load(function() {
      $.ajax({
        url: clientSideMerchantLocations.formattedUrl,
        dataType: 'json',
        success: lazyLoadMerchantLocations.ajax_success,
        error: function(err) {
          $('#merchant-location-placeholder').remove();
          return done();
        }
      });
      return done();
    });
  });
};

module.exports = lazyLoadMerchantLocations;



},{}],193:[function(require,module,exports){
var SubtitleTooltip;

SubtitleTooltip = window.SubtitleTooltip != null ? window.SubtitleTooltip : window.SubtitleTooltip = {};

SubtitleTooltip.init = function(payload, done) {
  return $(function() {
    $("#show-all-locations-subtitle").click(function() {
      var subtitletooltip;
      subtitletooltip = $("#subtitle-locations-tooltip");
      subtitletooltip.css('opacity', 0);
      return subtitletooltip.hide();
    });
    return done();
  });
};

module.exports = SubtitleTooltip;



},{}],194:[function(require,module,exports){
var CountdownTimer, OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

CountdownTimer = window.CountdownTimer != null ? window.CountdownTimer : window.CountdownTimer = {};

CountdownTimer.Helpers = require('../../../groupon-deal-timer/common/helpers');

OffersTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.get('endAt'));
    return {
      timeLeft: CountdownTimer.Helpers.timeRemaining(millisLeft),
      millisLeft: millisLeft
    };
  },
  buyUrlHash: function() {
    var urlHash;
    urlHash = {};
    _.each(this.get('offerOptions'), function(option) {
      return urlHash[option.buyUrl] = option.originalBuyUrl;
    });
    return urlHash;
  }
});

module.exports = OffersTimer.Model;



},{"../../../groupon-deal-timer/common/helpers":178}],195:[function(require,module,exports){
var OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

OffersTimer.Model = require('./models/offers_timer');

OffersTimer.View = require('./views/offers_timer');

OffersTimer.init = function(arg, done) {
  var offer, ref, ref1, timerModel, timerView;
  offer = arg.offer;
  if (done == null) {
    done = function() {};
  }
  if (!(offer != null ? (ref = offer.offerModal) != null ? ref.expiresAt : void 0 : void 0)) {
    return done();
  }
  timerModel = new OffersTimer.Model({
    endAt: offer != null ? (ref1 = offer.offerModal) != null ? ref1.expiresAt : void 0 : void 0,
    offerOptions: offer != null ? offer.offerOptions : void 0
  });
  timerView = new OffersTimer.View({
    model: timerModel,
    i18n: I18n.scoped()
  });
  return $(function() {
    timerView.render();
    return done();
  });
};

module.exports = OffersTimer;



},{"./models/offers_timer":194,"./views/offers_timer":196}],196:[function(require,module,exports){
var CountdownTimer, OFFERS_TIME_EL, OffersTimer;

OffersTimer = window.OffersTimer != null ? window.OffersTimer : window.OffersTimer = {};

CountdownTimer = window.CountdownTimer != null ? window.CountdownTimer : window.CountdownTimer = {};

CountdownTimer.Helpers = require('../../../groupon-deal-timer/common/helpers');

OFFERS_TIME_EL = "#offers-time-left";

OffersTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  isSoldOut: false,
  initialize: function() {
    return this.i18n = this.options.i18n;
  },
  render: function() {
    var ref;
    this.$el = $(OFFERS_TIME_EL);
    if (((ref = this.model.timeLeft()) != null ? ref.millisLeft : void 0) <= 0) {
      return;
    }
    return setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var buyUrlHash, countdownTime, offersTimer, ref, txnKey;
    if (this.isSoldOut) {
      return;
    }
    offersTimer = this.model.timeLeft();
    if ((offersTimer != null ? offersTimer.millisLeft : void 0) <= 0) {
      this.isSoldOut = true;
      this.$el.html(this.t("js.modules.offers.sold_out"));
      this.$el.addClass('sold-out');
      buyUrlHash = this.model.buyUrlHash();
      return _.each($('.btn-buy-big.buy-button, .options-content tr a'), function(element) {
        var originalBuyUrl;
        if (element.href !== (window.location.href + "#")) {
          originalBuyUrl = buyUrlHash[element.href];
          return element.href = originalBuyUrl;
        }
      });
    } else {
      txnKey = CountdownTimer.Helpers.countdownTimeKey(offersTimer != null ? offersTimer.timeLeft : void 0);
      if (!txnKey) {
        return;
      }
      countdownTime = this.t("js.modules.offers" + txnKey, {
        days: offersTimer != null ? (ref = offersTimer.timeLeft) != null ? ref.days : void 0 : void 0,
        timestamp: CountdownTimer.Helpers.countdownTimestamp(offersTimer != null ? offersTimer.timeLeft : void 0)
      });
      return this.$el.html(countdownTime);
    }
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});

module.exports = OffersTimer.View;



},{"../../../groupon-deal-timer/common/helpers":178}],197:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_card'] = require('../../review_card.html.mustache');

ProductReviews.Views.ReviewCard = Backbone.View.extend({
  events: {
    'click .read-more': 'toggleReadMore'
  },
  initialize: function() {
    var ref;
    if ((ref = this.model.displayOptions) != null ? ref.readMoreEnabled : void 0) {
      return this.listenTo(this.model, 'change:reviewTextHeight', this.updateReadMore);
    }
  },
  render: function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      displayOptions: this.model.displayOptions,
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    this.$el.append(ProductReviews.Templates['product_reviews_review_card'].render(data));
    this.$readMore = this.$el.find('.read-more');
    return this.$reviewText = this.$el.find('.review-text-container');
  },
  updateReadMore: function() {
    return this.$reviewText.toggleClass('show', this.model.shouldShowReadMore());
  },
  toggleReadMore: function() {
    if (this.$reviewText.hasClass('expanded')) {
      this.$reviewText.removeClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_more'));
    } else {
      this.$reviewText.addClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_less'));
    }
  }
});

module.exports = ProductReviews.Views.ReviewCard;



},{"../../review_card.html.mustache":201}],198:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_stars'] = require('../../stars.html.mustache');

ProductReviews.Views.ReviewRating = Backbone.View.extend({
  render: function() {
    return this.$el.append(ProductReviews.Templates['product_reviews_stars'].render(this.model.attributes));
  }
});

module.exports = ProductReviews.Views.ReviewRating;



},{"../../stars.html.mustache":202}],199:[function(require,module,exports){
var ProductReviews, base;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_widget_review_rating'] = require('../../widget_review_rating.html.mustache');

ProductReviews.Views.Widget.Review = (function() {
  function Review(arg) {
    this.data = arg.data, this.uuid = arg.uuid, this.$el = arg.$el;
  }

  Review.prototype.prepareData = function() {
    var bhc, i, position, rating, ref, starType, stars;
    if (!(((ref = this.data) != null ? ref.averageRating : void 0) && this.data.ratingCount)) {
      return;
    }
    rating = Math.round(this.data.averageRating * 10) / 10;
    bhc = {
      rating: "deal-review-rating:" + this.uuid + "_" + rating,
      ratingCount: "deal-rating-count:" + this.uuid + "_" + this.data.ratingCount
    };
    stars = [];
    for (position = i = 1; i <= 5; position = ++i) {
      starType = (function() {
        switch (false) {
          case !(rating > 3 / 4):
            return 'full-star';
          case !(rating > 1 / 4):
            return 'half-star';
          default:
            return 'empty-star';
        }
      })();
      stars.push("<span class='" + starType + " icon-star-filled'></span>");
      rating--;
    }
    return {
      productRating: {
        bhc: bhc,
        count: I18n.toNumber(this.data.ratingCount),
        stars: stars
      }
    };
  };

  Review.prototype.render = function() {
    return this.$el.find('.deal-title').after(ProductReviews.Templates['product_reviews_widget_review_rating'].render(this.prepareData()));
  };

  return Review;

})();

module.exports = ProductReviews.Views.Widget.Review;



},{"../../widget_review_rating.html.mustache":203}],200:[function(require,module,exports){
var ProductReviews, base,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if ((base = ProductReviews.Views).Widget == null) {
  base.Widget = {};
}

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.Widget.Review = require('./product_reviews_widget_review');

ProductReviews.Views.Widget.ReviewRating = (function() {
  function ReviewRating(arg) {
    var productReviews;
    productReviews = arg.productReviews;
    this.fetchSuccess = bind(this.fetchSuccess, this);
    if (productReviews) {
      this.rootUrl = productReviews.rootUrl, this.locale = productReviews.locale, this.showWidgetReview = productReviews.showWidgetReview;
    }
    if (!(this.rootUrl && this.locale && this.showWidgetReview)) {
      return {};
    }
    this.fetchProductReviews();
  }

  ReviewRating.prototype.fetchProductReviews = function() {
    var csrf;
    this.deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid]');
    if (this.deals.length) {
      csrf = $('meta[name=csrf-token]').attr('content');
      return $.ajax({
        url: this.rootUrl + "/product_review_proxy/products.json?locale=" + this.locale + "&_csrf=" + csrf,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(this.prepareData()),
        success: this.fetchSuccess
      });
    }
  };

  ReviewRating.prototype.prepareData = function() {
    return {
      deal_uuid: this.extractDealUuids().join()
    };
  };

  ReviewRating.prototype.extractDealUuids = function() {
    var dealUuids;
    dealUuids = [];
    this.deals.each(function() {
      var uuid;
      uuid = $(this).data('uuid');
      if (uuid.length) {
        return dealUuids.push(uuid);
      }
    });
    return dealUuids;
  };

  ReviewRating.prototype.fetchSuccess = function(data) {
    var products;
    if (!(products = data.products)) {
      return;
    }
    return this.deals.each(function() {
      var $el, params, uuid;
      $el = $(this);
      uuid = $el.data('uuid');
      params = {
        $el: $el,
        data: products[uuid],
        uuid: uuid
      };
      if (params.data) {
        return (new ProductReviews.Views.Widget.Review(params)).render();
      }
    });
  };

  return ReviewRating;

})();

module.exports = ProductReviews.Views.Widget.ReviewRating;



},{"./product_reviews_review_card":197,"./product_reviews_review_rating":198,"./product_reviews_widget_review":199}],201:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"review-header\">");_.b("\n" + i);_.b("  <div class=\"review-header-line\">");_.b("\n" + i);_.b("    <span class=\"review-rating\" id=\"");_.b(_.v(_.d("reviewIds.rating",c,p,0)));_.b("\">");_.b("\n" + i);_.b(_.rp("product_reviews_stars",c,p,"      "));_.b("    </span>");_.b("\n" + i);_.b("    <span class=\"review-display-name should-truncate\" data-display-name=\"");_.b(_.v(_.f("displayName",c,p,0)));_.b("\">");_.b(_.v(_.f("username",c,p,0)));_.b("</span>");_.b("\n" + i);if(_.s(_.f("isPending",c,p,1),c,p,0,305,614,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,497,547,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.review_pending");});c.pop();}_.b("<span class=\"icon-question\"></span>");_.b("\n" + i);_.b("      </a>");_.b("\n");});c.pop();}if(_.s(_.f("isRejected",c,p,1),c,p,0,652,1108,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <span class=\"review-status");if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,708,724,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" tooltip-trigger");});c.pop();}_.b("\" ");if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,772,892,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-tooltip-id=\"product-reviews-rejected-tooltip\" data-bhw=\"ProductReviewsRejectedTooltipTrigger\" data-position=\"right\"");});c.pop();}_.b(">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,941,992,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.review_rejected");});c.pop();}if(_.s(_.f("rejectionReasons",c,p,1),c,p,0,1031,1066,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<span class=\"icon-question\"></span>");});c.pop();}_.b("\n" + i);_.b("      </span>");_.b("\n");});c.pop();}_.b("    <span class=\"review-date\">");_.b(_.v(_.f("date",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("</div>");_.b("\n" + i);_.b("<div class=\"review-text-container\">");_.b("\n" + i);_.b("  <div class=\"review-text");if(_.s(_.f("isRatingOnly",c,p,1),c,p,0,1270,1289,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" rating-only-review");});c.pop();}_.b("\" id=\"");_.b(_.v(_.d("reviewIds.reviewText",c,p,0)));_.b("\">");_.b(_.v(_.f("text",c,p,0)));_.b("</div>");_.b("\n" + i);if(_.s(_.d("displayOptions.readMoreEnabled",c,p,1),c,p,0,1398,1524,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <div class=\"read-more\">");_.b("\n" + i);_.b("      ");if(_.s(_.f("translate",c,p,1),c,p,0,1449,1494,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.read_more");});c.pop();}_.b("\n" + i);_.b("    </div>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n" + i);_.b("<div class=\"review-actions\">");_.b("\n" + i);if(_.s(_.f("helpfulUpvote",c,p,1),c,p,0,1620,2376,"{{ }}")){_.rs(c,p,function(c,p,_){if(_.s(_.f("buttonText",c,p,1),c,p,0,1642,2356,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <div class=\"review-vote\">");_.b("\n" + i);_.b("        <span class=\"review-vote-prompt\">");if(_.s(_.f("translate",c,p,1),c,p,0,1732,1782,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.helpful.prompt");});c.pop();}_.b("</span>");_.b("\n" + i);_.b("        <button");_.b("\n" + i);_.b("          id=\"");_.b(_.v(_.d("reviewIds.vote",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          class=\"btn-secondary btn-small ");_.b(_.v(_.d("displayOptions.loginRequired.triggerClass",c,p,0)));_.b(" ");_.b(_.v(_.f("buttonClass",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          ");_.b(_.t(_.d("displayOptions.loginRequired.triggerData.vote",c,p,0)));_.b("\n" + i);_.b("          ");if(_.s(_.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,2087,2113,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-login-required=\"true\"");});c.pop();}_.b("\n" + i);_.b("          data-review-id=\"");_.b(_.v(_.f("uuid",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          data-review-placement=\"");_.b(_.v(_.f("placement",c,p,0)));_.b("\"");_.b("\n" + i);_.b("          data-bhw=\"ProductReviewsVote\">");_.b("\n" + i);_.b("            ");_.b(_.v(_.f("buttonText",c,p,0)));_.b("\n" + i);_.b("          </button>");_.b("\n" + i);_.b("      </div>");_.b("\n");});c.pop();}});c.pop();}if(_.s(_.f("isUserReview",c,p,1),c,p,0,2418,3084,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <a");_.b("\n" + i);_.b("      id=\"review-delete\"");_.b("\n" + i);_.b("      class=\"");_.b(_.v(_.d("displayOptions.loginRequired.triggerClass",c,p,0)));_.b("\"");_.b("\n" + i);_.b("      ");_.b(_.t(_.d("displayOptions.loginRequired.triggerData.review",c,p,0)));_.b("\n" + i);_.b("      ");if(_.s(_.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,2628,2654,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-login-required=\"true\"");});c.pop();}_.b("\n" + i);_.b("      data-review-id=\"");_.b(_.v(_.f("uuid",c,p,0)));_.b("\"");_.b("\n" + i);_.b("      data-bhw=\"ProductReviewsDelete\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,2799,2841,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.delete");});c.pop();}_.b("\n" + i);_.b("      </a>");_.b("\n" + i);_.b("    <button");_.b("\n" + i);_.b("      id=\"review-cancel\"");_.b("\n" + i);_.b("      class=\"btn-secondary btn-small\"");_.b("\n" + i);_.b("      data-bhw=\"ProductReviewsCancel\">");_.b("\n" + i);_.b("        ");if(_.s(_.f("translate",c,p,1),c,p,0,3007,3049,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.cancel");});c.pop();}_.b("\n" + i);_.b("      </button>");_.b("\n");});c.pop();}if(_.s(_.d("displayOptions.showShare",c,p,1),c,p,0,3137,3470,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">");_.b("\n" + i);_.b("      <span class=\"icon-share\"></span><span class=\"share-text\">");if(_.s(_.f("translate",c,p,1),c,p,0,3392,3433,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("modules.product_reviews.review_card.share");});c.pop();}_.b("</span>");_.b("\n" + i);_.b("    </div>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n" + i);if(_.s(_.f("helpfulUpvote",c,p,1),c,p,0,3529,3609,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div id=\"");_.b(_.v(_.d("reviewIds.voteText",c,p,0)));_.b("\" class=\"review-vote-text\">");_.b(_.v(_.f("text",c,p,0)));_.b("</div>");_.b("\n");});c.pop();}_.b("<div id=\"");_.b(_.v(_.d("reviewIds.notification",c,p,0)));_.b("\" class=\"notification review-notification\"></div>");_.b("\n");return _.fl();;},"<div class=\"review-header\">\n  <div class=\"review-header-line\">\n    <span class=\"review-rating\" id=\"{{ reviewIds.rating }}\">\n      {{> product_reviews_stars }}\n    </span>\n    <span class=\"review-display-name should-truncate\" data-display-name=\"{{ displayName }}\">{{ username }}</span>\n    {{# isPending }}\n      <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">\n        {{# translate }}modules.product_reviews.review_card.review_pending{{/ translate }}<span class=\"icon-question\"></span>\n      </a>\n    {{/ isPending }}\n    {{# isRejected }}\n      <span class=\"review-status{{# rejectionReasons }} tooltip-trigger{{/ rejectionReasons }}\" {{# rejectionReasons }}data-tooltip-id=\"product-reviews-rejected-tooltip\" data-bhw=\"ProductReviewsRejectedTooltipTrigger\" data-position=\"right\"{{/ rejectionReasons }}>\n        {{# translate }}modules.product_reviews.review_card.review_rejected{{/ translate }}{{# rejectionReasons }}<span class=\"icon-question\"></span>{{/ rejectionReasons }}\n      </span>\n    {{/ isRejected }}\n    <span class=\"review-date\">{{ date }}</span>\n  </div>\n</div>\n<div class=\"review-text-container\">\n  <div class=\"review-text{{# isRatingOnly }} rating-only-review{{/ isRatingOnly }}\" id=\"{{ reviewIds.reviewText }}\">{{ text }}</div>\n  {{# displayOptions.readMoreEnabled }}\n    <div class=\"read-more\">\n      {{# translate }}modules.product_reviews.review_card.read_more{{/ translate }}\n    </div>\n  {{/ displayOptions.readMoreEnabled }}\n</div>\n<div class=\"review-actions\">\n  {{# helpfulUpvote }}\n    {{# buttonText }}\n      <div class=\"review-vote\">\n        <span class=\"review-vote-prompt\">{{# translate }}modules.product_reviews.review_card.helpful.prompt{{/ translate }}</span>\n        <button\n          id=\"{{ reviewIds.vote }}\"\n          class=\"btn-secondary btn-small {{ displayOptions.loginRequired.triggerClass }} {{ buttonClass }}\"\n          {{{ displayOptions.loginRequired.triggerData.vote }}}\n          {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n          data-review-id=\"{{ uuid }}\"\n          data-review-placement=\"{{ placement }}\"\n          data-bhw=\"ProductReviewsVote\">\n            {{ buttonText }}\n          </button>\n      </div>\n    {{/ buttonText }}\n  {{/ helpfulUpvote }}\n  {{# isUserReview }}\n    <a\n      id=\"review-delete\"\n      class=\"{{ displayOptions.loginRequired.triggerClass }}\"\n      {{{ displayOptions.loginRequired.triggerData.review }}}\n      {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n      data-review-id=\"{{ uuid }}\"\n      data-bhw=\"ProductReviewsDelete\">\n        {{# translate }}modules.product_reviews.review_card.delete{{/ translate }}\n      </a>\n    <button\n      id=\"review-cancel\"\n      class=\"btn-secondary btn-small\"\n      data-bhw=\"ProductReviewsCancel\">\n        {{# translate }}modules.product_reviews.review_card.cancel{{/ translate }}\n      </button>\n  {{/ isUserReview }}\n  {{# displayOptions.showShare }}\n    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">\n      <span class=\"icon-share\"></span><span class=\"share-text\">{{# translate }}modules.product_reviews.review_card.share{{/ translate }}</span>\n    </div>\n  {{/ displayOptions.showShare }}\n</div>\n{{# helpfulUpvote }}\n  <div id=\"{{ reviewIds.voteText }}\" class=\"review-vote-text\">{{ text }}</div>\n{{/ helpfulUpvote }}\n<div id=\"{{ reviewIds.notification }}\" class=\"notification review-notification\"></div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],202:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("ratingStars",c,p,1),c,p,0,18,170,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <ul class=\"product-reviews-rating\" data-bhc=\"");_.b(_.v(_.f("bhc",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("stars",c,p,1),c,p,0,94,149,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <li class=\"icon-star-filled\">");_.b(_.t(_.d(".",c,p,0)));_.b("</li>");_.b("\n");});c.pop();}_.b("  </ul>");_.b("\n");});c.pop();}return _.fl();;},"{{# ratingStars }}\n  <ul class=\"product-reviews-rating\" data-bhc=\"{{ bhc }}\">\n    {{# stars }}\n      <li class=\"icon-star-filled\">{{{ . }}}</li>\n    {{/ stars }}\n  </ul>\n{{/ ratingStars }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],203:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"deal-product-review\">");_.b("\n" + i);if(_.s(_.f("productRating",c,p,1),c,p,0,56,271,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <ul class=\"rating\" data-bhc=\"");_.b(_.v(_.d("bhc.rating",c,p,0)));_.b("\">");_.b("\n" + i);if(_.s(_.f("stars",c,p,1),c,p,0,127,161,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        <li>");_.b(_.t(_.d(".",c,p,0)));_.b("</li>");_.b("\n");});c.pop();}_.b("    </ul>");_.b("\n" + i);_.b("    <span class=\"rating-count\" data-bhc=\"");_.b(_.v(_.d("bhc.ratingCount",c,p,0)));_.b("\">(");_.b(_.v(_.f("count",c,p,0)));_.b(")</span>");_.b("\n");});c.pop();}_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"deal-product-review\">\n  {{# productRating }}\n    <ul class=\"rating\" data-bhc=\"{{ bhc.rating }}\">\n      {{# stars }}\n        <li>{{{ . }}}</li>\n      {{/ stars }}\n    </ul>\n    <span class=\"rating-count\" data-bhc=\"{{ bhc.ratingCount }}\">({{ count }})</span>\n  {{/ productRating }}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],204:[function(require,module,exports){
if (window.FacebookPromNight == null) {
  window.FacebookPromNight = {};
}

FacebookPromNight.init = function(payload, done) {
  return $(function() {
    $(".share-links .icon-facebook").on({
      click: function(e) {
        e.preventDefault();
        return window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436');
      }
    });
    return done();
  });
};

module.exports = FacebookPromNight;



},{}],205:[function(require,module,exports){




},{}],206:[function(require,module,exports){
var safeInit;

if (window.Tracking == null) {
  window.Tracking = {};
}

safeInit = function(obj, payload, cb) {
  var err;
  try {
    return obj.init(payload, cb);
  } catch (_error) {
    err = _error;
    OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Error", {
      error: err
    });
    return cb();
  }
};

Tracking.Initializer = function(timeoutInMs) {
  var finished, inFlight;
  if (timeoutInMs == null) {
    timeoutInMs = 30 * 1000;
  }
  inFlight = 0;
  this._hasRun = false;
  finished = false;
  return {
    run: function(modules, payload, cb) {
      var i, len, module;
      for (i = 0, len = modules.length; i < len; i++) {
        module = modules[i];
        inFlight++;
        safeInit(module, payload, (function(_this) {
          return function() {
            inFlight--;
            if (inFlight === 0 && _this._hasRun && !finished) {
              finished = true;
              return cb();
            }
          };
        })(this));
      }
      this._hasRun = true;
      if (inFlight === 0 && !finished) {
        finished = true;
        cb();
      }
      return setTimeout((function() {
        if (!finished) {
          OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Timeout", {
            numberInFlight: inFlight
          });
          finished = true;
          return cb();
        }
      }), timeoutInMs);
    }
  };
};

module.exports = Tracking.Initializer;



},{}],207:[function(require,module,exports){
var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, ignoreCap) {
  if (ignoreCap == null) {
    ignoreCap = false;
  }
  switch (false) {
    case !(timeLeft.days >= 15 && !ignoreCap):
      return "";
    case !(timeLeft.days > 1):
      return ".countdown_time_many_days";
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.UrgencyTimer == null) {
    window.UrgencyTimer = {};
  }
  if (UrgencyTimer.Helpers == null) {
    UrgencyTimer.Helpers = {};
  }
  UrgencyTimer.Helpers.timeRemaining = timeRemaining;
  UrgencyTimer.Helpers.millisRemaining = millisRemaining;
  UrgencyTimer.Helpers.countdownTimeKey = countdownTimeKey;
  UrgencyTimer.Helpers.countdownTimestamp = countdownTimestamp;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp
  };
}



},{}],208:[function(require,module,exports){
var base;

if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

if ((base = window.UrgencyTimer).current == null) {
  base.current = {};
}

UrgencyTimer.Model = require('./models/countdown_timer');

UrgencyTimer.View = require('./views/countdown_timer');

UrgencyTimer.init = function(arg, done) {
  var endAt, ref, timerModel, umsData;
  umsData = arg.umsData;
  if (done == null) {
    done = function() {};
  }
  endAt = umsData != null ? (ref = umsData.urgencyTimer) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new UrgencyTimer.Model({
    endAt: endAt
  });
  window.UrgencyTimer.current.timerModel = timerModel;
  window.UrgencyTimer.current.timerView = new UrgencyTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: umsData != null ? umsData.el : void 0
  });
  return $(function() {
    window.UrgencyTimer.current.timerView.render();
    return done();
  });
};

module.exports = UrgencyTimer.init;



},{"./models/countdown_timer":209,"./views/countdown_timer":211}],209:[function(require,module,exports){
if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

UrgencyTimer.Helpers = require('../../common/helpers');

UrgencyTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = UrgencyTimer.Helpers.millisRemaining(this.get('endAt'));
    return UrgencyTimer.Helpers.timeRemaining(millisLeft);
  }
});

module.exports = UrgencyTimer.Model;



},{"../../common/helpers":207}],210:[function(require,module,exports){
var ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, MESSAGE_TIMEOUT, MESSAGE_TIMEOUT_TOUCH, POPUP_SWITCH_MESSAGE_TIMEOUT, UrgencyMessaging;

UrgencyMessaging = window.UrgencyMessaging != null ? window.UrgencyMessaging : window.UrgencyMessaging = {};

MESSAGE_TIMEOUT = 5000;

ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;

MESSAGE_TIMEOUT_TOUCH = MESSAGE_TIMEOUT - ACTIVATE_PRIMARY_MESSAGE_TIMEOUT;

POPUP_SWITCH_MESSAGE_TIMEOUT = 500;

UrgencyMessaging.inlineUrgencyMessaging = function(touchRequest) {
  var inlineSwitchMessageTimeout, primaryMessage, secondaryMessage, switchMessage, urgencyMessages;
  urgencyMessages = $('.urgency-messaging.inline .urgency-message');
  primaryMessage = urgencyMessages.find('.primary');
  secondaryMessage = urgencyMessages.find('.secondary');
  switchMessage = function() {
    primaryMessage.addClass('fade-out');
    secondaryMessage.children('span').removeClass('hide');
    return secondaryMessage.addClass('fade-in');
  };
  if (!touchRequest) {
    urgencyMessages.addClass('visible');
    primaryMessage.addClass('fade-in');
  }
  inlineSwitchMessageTimeout = touchRequest ? MESSAGE_TIMEOUT_TOUCH : MESSAGE_TIMEOUT;
  if (secondaryMessage.length) {
    return window.setTimeout(switchMessage, inlineSwitchMessageTimeout);
  }
};

UrgencyMessaging.popupUrgencyMessaging = function() {
  var addSecondaryMessage, addXIconHandler, fadePrimaryMessage, fadeSecondaryMessage, isMessageSwitched, primaryMessage, secondaryMessage, switchMessage, urgencyMessages;
  urgencyMessages = $('.urgency-messaging.popup');
  primaryMessage = urgencyMessages.find('.primary');
  secondaryMessage = urgencyMessages.find('.secondary');
  isMessageSwitched = false;
  fadePrimaryMessage = function() {
    return primaryMessage.addClass('pop-out');
  };
  fadeSecondaryMessage = function() {
    return secondaryMessage.addClass('pop-out');
  };
  addSecondaryMessage = function() {
    secondaryMessage.addClass('pop-in');
    return window.setTimeout(fadeSecondaryMessage, MESSAGE_TIMEOUT);
  };
  switchMessage = function() {
    if (isMessageSwitched) {
      return;
    }
    isMessageSwitched = true;
    fadePrimaryMessage();
    return window.setTimeout(addSecondaryMessage, POPUP_SWITCH_MESSAGE_TIMEOUT);
  };
  addXIconHandler = function() {
    var popup;
    popup = $(this).parent('.ums-text');
    if (popup.hasClass('primary')) {
      return switchMessage();
    } else {
      return popup.addClass('pop-out');
    }
  };
  urgencyMessages.find('.icon-x').click(addXIconHandler);
  primaryMessage.addClass('pop-in');
  if (secondaryMessage.length) {
    return setTimeout(switchMessage, MESSAGE_TIMEOUT);
  } else {
    return setTimeout(fadePrimaryMessage, MESSAGE_TIMEOUT);
  }
};

UrgencyMessaging.init = function(arg, done) {
  var activateUrgencyMessaging, inlineTreatment, isActivated, realTimeMessaging, scrollHandler, showPopups, touchRequest, umsData;
  umsData = arg.umsData;
  realTimeMessaging = umsData.realTimeMessaging;
  touchRequest = realTimeMessaging.touchRequest, showPopups = realTimeMessaging.showPopups, inlineTreatment = realTimeMessaging.inlineTreatment;
  isActivated = false;
  activateUrgencyMessaging = function() {
    if (isActivated) {
      return;
    }
    isActivated = true;
    if (inlineTreatment) {
      return UrgencyMessaging.inlineUrgencyMessaging(touchRequest);
    } else if (showPopups) {
      return UrgencyMessaging.popupUrgencyMessaging();
    }
  };
  scrollHandler = function(e) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      return activateUrgencyMessaging();
    }
  };
  return $(function() {
    window.setTimeout(activateUrgencyMessaging, ACTIVATE_PRIMARY_MESSAGE_TIMEOUT);
    $(window).on('scroll', scrollHandler);
    return done();
  });
};

module.exports = UrgencyMessaging;



},{}],211:[function(require,module,exports){
var DEFAULT_EL;

DEFAULT_EL = '.urgency-message > .timer #timer-clock';

if (window.UrgencyTimer == null) {
  window.UrgencyTimer = {};
}

UrgencyTimer.Helpers = require('../../common/helpers');

UrgencyTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    return this.el = this.options.el || DEFAULT_EL;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("js.modules.urgency_messaging" + (UrgencyTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timestamp: UrgencyTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});

module.exports = UrgencyTimer.View;



},{"../../common/helpers":207}],212:[function(require,module,exports){
var VariationsWidget, base;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if ((base = VariationsWidget.Collections).Option == null) {
  base.Option = {};
}

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = require('./option');

VariationsWidget.Collections.Option = Backbone.Collection.extend({
  model: VariationsWidget.Models.Option,
  chosen: function(value) {
    return this.find(function(trait) {
      return trait.get('traitValue') === value;
    });
  },
  selected: function() {
    return this.find(function(trait) {
      return trait.get('selected');
    });
  },
  setSelected: function(id) {
    this.selected().set('selected', false);
    return this.get(id).set('selected', true);
  }
});

VariationsWidget.Collections.Option.create = function(traits) {
  var data, i, len, option, results, trait;
  results = [];
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    data = (function() {
      var j, len1, ref, results1;
      ref = trait.data;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        option = ref[j];
        results1.push({
          traitValue: option.value,
          disabled: false,
          forceDisplay: false,
          traitIndex: option.traitIndex,
          traitName: option.name,
          id: option.optionIndex,
          isSoldOut: option.isSoldOut,
          optionPrice: false,
          selected: option.optionIndex === 0
        });
      }
      return results1;
    })();
    results.push(new VariationsWidget.Collections.Option(data));
  }
  return results;
};

module.exports = VariationsWidget.Collections.Option;



},{"./option":213}],213:[function(require,module,exports){
var VariationsWidget;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = Backbone.Model.extend({
  initialize: function() {}
});

module.exports = VariationsWidget.Models.Option;



},{}],214:[function(require,module,exports){
var Cart, DealEventPipe, VariationsWidget,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

Cart = window.Cart != null ? window.Cart : window.Cart = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

Cart.Helpers = require('../../cart/common/helpers');

VariationsWidget.Controller = (function() {
  function Controller() {
    this.findSelectedCollections = bind(this.findSelectedCollections, this);
    this.findDefaultCollections = bind(this.findDefaultCollections, this);
    this.isSelectionDefault = bind(this.isSelectionDefault, this);
    var ref;
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '7.0') {
      this.ie7 = true;
    }
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.updateSelectElements("", true);
    this.availableOptions = this.getAvailableOptions();
    this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
    this.lastImage = "";
    this.clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection;
    this.$selectElements = $('#variation-traits').find('.variation-trait');
    if ((ref = VariationsWidget.preSelectTraits) != null ? ref.length : void 0) {
      this.makeSelectionsViaPreselection();
    } else {
      this.updateSelectionsToDefault();
    }
  }

  Controller.prototype.render = function(latestSelection, updateCarousel) {
    if (updateCarousel == null) {
      updateCarousel = true;
    }
    if (latestSelection.selection != null) {
      this.updateSelections(latestSelection);
      this.updateSelectElements(latestSelection.trait);
      this.availableOptions = this.getAvailableOptions();
      this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
      this.updatePricing(this.cheapestOption, this.availableOptions.length);
      if (updateCarousel) {
        this.updateCarousel();
      }
      this.removeErrorMessages();
    }
  };

  Controller.prototype.updateSelectionsToDefault = function() {
    var i, len, ref, results, selectElement;
    ref = this.$selectElements || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      selectElement = ref[i];
      results.push($(selectElement).find('option:eq(0)').prop('selected', true));
    }
    return results;
  };

  Controller.prototype.updateSelections = function(latestSelection) {
    var collection, i, len, ref;
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      if (collection.models[0].get('traitName') === latestSelection.trait) {
        collection.setSelected(latestSelection.id);
        break;
      }
    }
  };

  Controller.prototype.updateSelectElements = function(latestSelection, updateAll) {
    var collection, conditions, enabledOptions, enabledValues, i, j, k, l, lastSelection, len, len1, len2, len3, len4, m, model, notSoldOut, option, ref, ref1, ref2, trait, traitName, unavailableOptions, unavailableValues, value;
    if (updateAll == null) {
      updateAll = false;
    }
    if (VariationsWidget.printOptionPrice) {
      updateAll = true;
    }
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      traitName = collection.models[0].get('traitName');
      if (traitName !== latestSelection || updateAll) {
        conditions = this.getConditions(collection.selected());
        lastSelection = _.keys(conditions).length === VariationsWidget.collections.length - 1;
        enabledOptions = [];
        unavailableOptions = [];
        if (!$.isEmptyObject(conditions)) {
          enabledOptions = _.where(VariationsWidget.options, conditions);
        } else {
          enabledOptions = VariationsWidget.options;
        }
        enabledValues = _.pluck(enabledOptions, traitName);
        unavailableValues = _.uniq(enabledValues);
        notSoldOut = [];
        for (j = 0, len1 = enabledOptions.length; j < len1; j++) {
          option = enabledOptions[j];
          for (k = 0, len2 = unavailableValues.length; k < len2; k++) {
            value = unavailableValues[k];
            if (value === option[traitName] && !option.isSoldOut) {
              notSoldOut.push(value);
            }
          }
        }
        unavailableValues = _.difference(unavailableValues, notSoldOut);
        enabledValues.unshift((this.i18n.t('js.modules.variations.selector')) + " " + traitName);
        ref1 = VariationsWidget.collections;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          trait = ref1[l];
          if (trait.models[0].get('traitName') === traitName) {
            ref2 = trait.models;
            for (m = 0, len4 = ref2.length; m < len4; m++) {
              model = ref2[m];
              this.setOptionState(model, enabledValues, unavailableValues);
              if (lastSelection && (conditions[traitName] == null)) {
                this.setOptionPrice(model, enabledValues, enabledOptions);
              } else if (conditions[traitName] == null) {
                this.setOptionFromPrice(model, enabledValues, enabledOptions);
              } else {
                model.set('optionPrice', false);
              }
            }
          }
        }
      }
    }
    if (this.ie7) {
      $('option').removeClass("ie7-color");
      return $('option[disabled]').addClass("ie7-color");
    }
  };

  Controller.prototype.setOptionState = function(model, enabledValues, unavailableValues) {
    var printSoldOut;
    printSoldOut = VariationsWidget.printSoldOut;
    if (model.id === 0 || (_.contains(enabledValues, model.get('traitValue')))) {
      if (model.get('isSoldOut') || ((unavailableValues != null) && (_.contains(unavailableValues, model.get('traitValue'))))) {
        model.set('disabled', true);
        if (printSoldOut) {
          model.set('forceDisplay', true);
        }
      } else {
        model.set('disabled', false);
        if (printSoldOut) {
          model.set('forceDisplay', false);
        }
      }
    } else {
      model.set('disabled', true);
      if (printSoldOut) {
        model.set('forceDisplay', false);
      }
    }
  };

  Controller.prototype.setOptionFromPrice = function(model, enabledValues, enabledOptions) {
    var cheapestOption, modelID, name, printOptionPrice, selected, traitOptions, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    traitOptions = _.filter(enabledOptions, (function(item) {
      return item[name] === value;
    }));
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      cheapestOption = this.getCheapestAvailableOption(traitOptions);
      if (cheapestOption != null) {
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {
          minPrice: cheapestOption.newPrice
        }));
      }
    }
  };

  Controller.prototype.setOptionPrice = function(model, enabledValues, enabledOptions) {
    var i, len, modelID, name, option, printOptionPrice, selected, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      for (i = 0, len = enabledOptions.length; i < len; i++) {
        option = enabledOptions[i];
        if (value === option[name]) {
          model.set('optionPrice', option.newPrice);
        }
      }
    }
  };

  Controller.prototype.getConditions = function(selected) {
    var conditions, i, len, ref, tempCollection, tempSelected, tempSelectedTraitValue;
    conditions = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      tempCollection = ref[i];
      tempSelected = tempCollection.selected();
      tempSelectedTraitValue = tempSelected.get('traitValue');
      if (tempSelectedTraitValue !== selected.get('traitValue') && !this.isSelectionDefault(tempSelectedTraitValue)) {
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue;
      }
    }
    return conditions;
  };

  Controller.prototype.getAvailableOptions = function() {
    var collection, i, len, options, properties, ref, selectedTrait, selectedTraitValue;
    properties = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitValue = selectedTrait.get('traitValue');
      if (!this.isSelectionDefault(selectedTraitValue)) {
        properties[selectedTrait.get('traitName')] = selectedTraitValue;
      }
    }
    if ($.isEmptyObject(properties)) {
      options = VariationsWidget.options;
    } else {
      options = _.where(VariationsWidget.options, properties);
    }
    return options;
  };

  Controller.prototype.getCheapestAvailableOption = function(availableOptions) {
    var currentCheapest, i, len, option;
    currentCheapest = void 0;
    for (i = 0, len = availableOptions.length; i < len; i++) {
      option = availableOptions[i];
      if (!option.isSoldOut && (currentCheapest === void 0 || (option.amount < currentCheapest.amount))) {
        currentCheapest = option;
      }
    }
    return currentCheapest || availableOptions[0];
  };

  Controller.prototype.overridePriceDataWithSaleInfo = function(priceData, option) {
    var i, len, offer, ref, ref1, ref2, ref3, ref4, sale;
    if (!(((option != null ? option.regularPrice : void 0) != null) || (((ref = VariationsWidget.offerCollections) != null ? ref.offerOptions : void 0) != null))) {
      return;
    }
    sale = {};
    if (option.regularPrice) {
      _.extend(sale, {
        urgencyPricing: {
          regularPrice: option.regularPrice,
          newPrice: option.newPrice,
          pricingMetadata: option.pricingMetadata
        }
      });
    }
    ref2 = ((ref1 = VariationsWidget.offerCollections) != null ? ref1.offerOptions : void 0) || [];
    for (i = 0, len = ref2.length; i < len; i++) {
      offer = ref2[i];
      if (offer.uuid === option.uuid) {
        if (((offer != null ? offer.buyUrl : void 0) != null) && !((ref3 = VariationsWidget.offerCollections) != null ? (ref4 = ref3.offerModal) != null ? ref4.isSoldOut : void 0 : void 0)) {
          priceData.buyUrl = offer.buyUrl;
        }
        _.extend(sale, {
          offer: offer
        });
      }
    }
    if (sale !== {}) {
      return _.extend(priceData, {
        sale: sale
      });
    }
  };

  Controller.prototype.updatePricing = function(cheapestOption, length) {
    var priceData;
    priceData = {
      value: cheapestOption.oldPrice,
      percent: cheapestOption.discount,
      savings: cheapestOption.savePrice,
      price: cheapestOption.newPrice,
      lengthClass: cheapestOption.lengthClass,
      buyUrl: this.buyButtonUrl(cheapestOption),
      uuid: cheapestOption.uuid,
      variationsSelected: length === 1 && !this.areAnySelectionsDefault(VariationsWidget.collections),
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount
    };
    this.overridePriceDataWithSaleInfo(priceData, cheapestOption);
    return DealEventPipe.trigger("priceUpdate", priceData);
  };

  Controller.prototype.buyButtonUrl = function(cheapestOption) {
    var ref;
    if ((ref = cheapestOption.externalUrl) != null ? ref.length : void 0) {
      return cheapestOption.externalUrl;
    }
    if (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0) {
      return Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid);
    } else {
      return cheapestOption.url;
    }
  };

  Controller.prototype.updateCarousel = function() {
    var currentImage, foundMatch, imageUrl, ref, valuesHash;
    if (this.areSelectionsDefault(VariationsWidget.collections)) {
      DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(DealCarousel.dealMedia[payload.carousel.dealId].models[0]);
    } else {
      ref = VariationsWidget.mappings;
      for (imageUrl in ref) {
        valuesHash = ref[imageUrl];
        foundMatch = _.every(VariationsWidget.collections, (function(_this) {
          return function(collection) {
            var selectedTrait, selectedTraitValue;
            selectedTrait = collection.selected();
            selectedTraitValue = selectedTrait.get('traitValue');
            if (_this.isSelectionDefault(selectedTraitValue)) {
              return true;
            } else {
              return _.contains(valuesHash[selectedTrait.get('traitName')], selectedTraitValue);
            }
          };
        })(this));
        currentImage = DealCarousel.carouselViews[payload.carousel.dealId].currentFeatured.baseURL;
        if (foundMatch && currentImage !== imageUrl) {
          this.changeToMatchingImage(imageUrl);
          break;
        }
      }
    }
  };

  Controller.prototype.changeToMatchingImage = function(imgPath) {
    var image;
    this.lastImage = imgPath;
    image = DealCarousel.dealMedia[payload.carousel.dealId].findWhere({
      thumb: imgPath + "t100x100" + payload.carousel.imageQuality + ".jpg"
    });
    return DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(image);
  };

  Controller.prototype.findMatchingTraits = function(img) {
    var key, ref, selections, value;
    this.lastImage = img;
    selections = [];
    if (VariationsWidget.mappings[img] != null) {
      ref = VariationsWidget.mappings[img];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections.push({
            trait: key,
            selection: value[0]
          });
        }
      }
    }
    return this.makeSelectionsViaCarousel(selections);
  };

  Controller.prototype.makeSelectionsViaCarousel = function(selections) {
    if ((selections != null ? selections.length : void 0) < 1 && !this.clearTraitsOnCarouselSelection) {
      return;
    }
    this.clearSelections();
    return this.makeSelections(selections);
  };

  Controller.prototype.makeSelectionsViaPreselection = function() {
    var collection, i, j, len, len1, option, ref, ref1, selections, trait;
    option = _.findWhere(VariationsWidget.options, {
      uuid: VariationsWidget.dealOptionUuid
    });
    if ((option == null) || option.isSoldOut) {
      return;
    }
    selections = [];
    ref = VariationsWidget.preSelectTraits || [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get("traitName") === trait) {
          selections.push({
            trait: trait,
            selection: option[trait]
          });
          break;
        }
      }
    }
    return this.makeSelections(selections);
  };

  Controller.prototype.clearSelections = function() {
    var collection, data, i, len, ref, results, selectedTrait, selectedTraitName, selection;
    ref = VariationsWidget.collections || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitName = selectedTrait.get('traitName');
      if (!this.isSelectionDefault(selectedTrait.get('traitValue'))) {
        selection = this.i18n.t('js.modules.variations.select', {
          name: selectedTraitName
        });
        data = {
          trait: selectedTraitName,
          selection: selection,
          id: 0
        };
        $("#trait-" + (selectedTrait.get('traitIndex'))).val(selection);
        if ($("#trait-" + (selectedTrait.get('traitIndex'))).val() == null) {
          $("#trait-" + (selectedTrait.get('traitIndex'))).prop('selectedIndex', 0);
        }
        results.push(this.render(data, false));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  Controller.prototype.makeSelections = function(selections) {
    var collection, element, i, j, len, len1, ref, ref1, trait;
    ref = selections || [];
    for (i = 0, len = ref.length; i < len; i++) {
      element = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get('traitName') === element.trait) {
          trait = collection.findWhere({
            traitValue: element.selection
          });
          if (!trait.get('disabled')) {
            element['id'] = trait.get('id');
            $('#trait-' + collection.models[0].get('traitIndex')).val(element.selection);
            this.render(element, false);
            break;
          }
        }
      }
    }
  };

  Controller.prototype.showErrorMessages = function() {
    var defaultCollections, i, index, len, results;
    VariationsWidget.error.show();
    VariationsWidget.error.$el.addClass("icon-circle-alert");
    defaultCollections = this.findDefaultCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = defaultCollections.length; i < len; i++) {
      index = defaultCollections[i];
      results.push($('#trait-' + index).addClass('error'));
    }
    return results;
  };

  Controller.prototype.removeErrorMessages = function() {
    var i, index, len, results, selectedCollections;
    if (!this.areAnySelectionsDefault(VariationsWidget.collections)) {
      VariationsWidget.error.hide();
    }
    selectedCollections = this.findSelectedCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = selectedCollections.length; i < len; i++) {
      index = selectedCollections[i];
      results.push($('#trait-' + index).removeClass('error'));
    }
    return results;
  };

  Controller.prototype.areSelectionsDefault = function(collections) {
    return _.every(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.areAnySelectionsDefault = function(collections) {
    return _.some(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.isSelectionDefault = function(selection) {
    return RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(selection);
  };

  Controller.prototype.findDefaultCollections = function(collections) {
    var collection, defaultCollections, i, index, len;
    defaultCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        defaultCollections.push(index);
      }
    }
    return defaultCollections;
  };

  Controller.prototype.findSelectedCollections = function(collections) {
    var collection, i, index, len, selectedCollections;
    selectedCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (!RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        selectedCollections.push(index);
      }
    }
    return selectedCollections;
  };

  return Controller;

})();

module.exports = VariationsWidget.Controller;



},{"../../cart/common/helpers":89,"../../deal/frontend/event_pipe":94}],215:[function(require,module,exports){
var DealEventPipe, VariationsWidget, _scrollToBuyButton;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Collections.Option = require('./models/option-collection');

VariationsWidget.Views.OptionCollection = require('./views/option-collection');

VariationsWidget.Views.Error = require('./views/error');

VariationsWidget.Controller = require('./variations-widget-controller');

DealEventPipe = require('../../deal/frontend/event_pipe');

_scrollToBuyButton = function() {
  var top;
  if ($('#purchase-cluster .buy.fixed').length || $('.header-row-sticked').length || $('.header-row-sticky').length) {
    top = $('.main').position().top - 100;
    return $('body,html').animate({
      scrollTop: top
    }, 500);
  }
};

VariationsWidget.init = function(arg, done) {
  var offer, stickyHeader, variations;
  variations = arg.variations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (variations == null) {
    return done();
  }
  this.options = variations.options, this.traits = variations.traits, this.mappings = variations.mappings, this.uuid = variations.uuid, this.dealOptionUuid = variations.dealOptionUuid, this.preSelectTraits = variations.preSelectTraits, this.printSoldOut = variations.printSoldOut, this.printOptionPrice = variations.printOptionPrice, this.clearTraitsOnCarouselSelection = variations.clearTraitsOnCarouselSelection;
  this.collections = VariationsWidget.Collections.Option.create(this.traits);
  this.offerCollections = offer;
  BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
    return function() {
      if (BuyButton.view.variationsSelected) {
        return;
      }
      _this.controller.showErrorMessages();
      if (stickyHeader) {
        _scrollToBuyButton();
      }
      BuyButton.view.enableBuyButton();
      return {
        stopTheBus: true
      };
    };
  })(this));
  return $((function(_this) {
    return function() {
      var ref;
      _this.views = VariationsWidget.Views.OptionCollection.create(_this.collections);
      _this.error = new VariationsWidget.Views.Error({
        el: '#variation-error'
      });
      _this.controller = new VariationsWidget.Controller();
      if ((ref = _this.options) != null ? ref[0].hideOriginalPriceAndDiscount : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html("");
      }
      $(document.body).on("carouselUpdate", function(e, data) {
        if (data.image !== _this.controller.lastImage) {
          return _this.controller.findMatchingTraits(data.image);
        }
      });
      return done();
    };
  })(this));
};

module.exports = VariationsWidget;



},{"../../deal/frontend/event_pipe":94,"./models/option-collection":212,"./variations-widget-controller":214,"./views/error":216,"./views/option-collection":217}],216:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Error = Backbone.View.extend({
  show: function() {
    return this.$el.show();
  },
  hide: function() {
    return this.$el.hide();
  }
});

module.exports = VariationsWidget.Views.Error;



},{}],217:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = require('./option');

VariationsWidget.Views.OptionCollection = Backbone.View.extend({
  events: {
    "change": "selectionChanged"
  },
  initialize: function() {
    var optionElementModel;
    _.bindAll(this, 'selectionChanged', 'render');
    return this.optionElementViews = (function() {
      var i, len, ref, results;
      ref = this.collection.models;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        optionElementModel = ref[i];
        results.push(new VariationsWidget.Views.Option({
          el: "#trait-" + optionElementModel.get('traitIndex') + "-" + optionElementModel.get('id'),
          model: optionElementModel
        }));
      }
      return results;
    }).call(this);
  },
  render: function() {
    var i, len, optionElementView, ref, results;
    ref = this.optionElementViews;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      optionElementView = ref[i];
      results.push(optionElementView.render());
    }
    return results;
  },
  isSelectedOptionDisabled: function(selectElement) {
    return selectElement != null ? selectElement.options[selectElement.selectedIndex].disabled : void 0;
  },
  selectionChanged: function(e) {
    var $currentElement, model, value;
    $currentElement = $(e.currentTarget)[0];
    if (VariationsWidget.controller.ie7 && this.isSelectedOptionDisabled($currentElement)) {
      $currentElement.selectedIndex = 0;
    }
    value = $(e.currentTarget).val();
    model = this.collection.chosen(value);
    return VariationsWidget.controller.render({
      trait: this.collection.models[0].get('traitName'),
      selection: value,
      id: model.get('id')
    });
  }
});

VariationsWidget.Views.OptionCollection.create = function(collections) {
  var i, index, len, results, trait;
  results = [];
  for (index = i = 0, len = collections.length; i < len; index = ++i) {
    trait = collections[index];
    results.push(new VariationsWidget.Views.OptionCollection({
      collection: trait,
      el: "#trait-" + index
    }));
  }
  return results;
};

module.exports = VariationsWidget.Views.OptionCollection;



},{"./option":218}],218:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = Backbone.View.extend({
  initialize: function() {
    _.bindAll(this, 'render');
    this.model.bind('change:disabled', this.render);
    if (VariationsWidget.printSoldOut) {
      this.model.bind('change:forceDisplay', this.render);
    }
    if (VariationsWidget.printOptionPrice) {
      this.model.bind('change:optionPrice', this.render);
      this.model.bind('change:selected', this.render);
    }
    return this.rtl = $('body').hasClass('rtl');
  },
  render: function() {
    this.$el.attr('disabled', this.model.get('disabled'));
    if (VariationsWidget.printSoldOut) {
      this.renderSoldOut();
    }
    if (VariationsWidget.printOptionPrice) {
      return this.renderPrintOptionPrice();
    }
  },
  renderSoldOut: function() {
    var soldOutText, string;
    soldOutText = typeof I18n !== "undefined" && I18n !== null ? I18n.t('js.modules.variations.sold_out') : void 0;
    string = "<span class=\"sold-out-text\">" + soldOutText + "</span>";
    this.$el.removeClass('force-display');
    this.$el.find('.sold-out-text').remove();
    if (this.model.get('forceDisplay')) {
      this.$el.addClass('force-display');
      if (this.rtl) {
        return this.$el.append(string);
      } else {
        return this.$el.prepend(string);
      }
    }
  },
  renderPrintOptionPrice: function() {
    var isSelected, optionPrice, string;
    optionPrice = this.model.get('optionPrice');
    isSelected = this.model.get('selected');
    string = "<span class=\"option-price\">(" + optionPrice + ")</span>";
    this.$el.find('.option-price').remove();
    if (optionPrice && !isSelected) {
      if (this.rtl) {
        return this.$el.prepend(string);
      } else {
        return this.$el.append(string);
      }
    }
  }
});

module.exports = VariationsWidget.Views.Option;



},{}],219:[function(require,module,exports){
var DealEventPipe, WishlistButton;

WishlistButton = window.WishlistButton != null ? window.WishlistButton : window.WishlistButton = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

WishlistButton = function() {
  var $wishlistButton, $wishlistButtonTextAdd, $wishlistButtonTextRemove, _checkMultiOptionSelection, addItemToWishlist, csrfToken, dealId, init, listenToOptionSelection, onAddItemSuccess, removeItemFromWishlist, selectedOptionUUID, toggleWishlistButtonStyle, updateRemoveItemUrl, updateWishlistedNotifier, wishlistButtonClicked, wishlistPayload;
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null;
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null;
  init = function(arg, done) {
    var carousel, csrf, wishlist;
    carousel = arg.carousel, csrf = arg.csrf, wishlist = arg.wishlist;
    $wishlistButton = $("#add-to-wishlist-btn");
    $wishlistButtonTextAdd = $("#add-to-wishlist-btn-text-add");
    $wishlistButtonTextRemove = $("#add-to-wishlist-btn-text-remove");
    wishlistPayload = wishlist;
    dealId = carousel != null ? carousel.dealId : void 0;
    if (wishlistPayload.selectedOptionUUID) {
      selectedOptionUUID = wishlistPayload.selectedOptionUUID;
    }
    csrfToken = csrf;
    listenToOptionSelection();
    return $(function() {
      $wishlistButton.on("click", wishlistButtonClicked);
      return done();
    });
  };
  updateWishlistedNotifier = function(optionUUID) {
    var optionUUIDFilter;
    $wishlistButton.removeClass("wishlisted");
    $wishlistButtonTextAdd.removeClass("hidden");
    $wishlistButtonTextRemove.addClass("hidden");
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID && _.filter(wishlistPayload.items, optionUUIDFilter).length > 0) {
      $wishlistButton.addClass("wishlisted");
      $wishlistButtonTextAdd.addClass("hidden");
      return $wishlistButtonTextRemove.removeClass("hidden");
    }
  };
  updateRemoveItemUrl = function(optionUUID) {
    var optionUUIDFilter, ref, ref1;
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID) {
      return wishlistPayload.removeItemUrl = (ref = _.filter(wishlistPayload.items, optionUUIDFilter)) != null ? (ref1 = ref[0]) != null ? ref1.removeItemUrl : void 0 : void 0;
    }
  };
  listenToOptionSelection = function() {
    return DealEventPipe.on("priceUpdate", function(priceData) {
      var $tooltip;
      $tooltip = $('#select-option-tooltip');
      GIG.Tooltip.close($tooltip);
      selectedOptionUUID = priceData.variationsSelected && priceData.uuid;
      updateWishlistedNotifier(selectedOptionUUID);
      return updateRemoveItemUrl(selectedOptionUUID);
    });
  };
  toggleWishlistButtonStyle = function() {
    $wishlistButton.toggleClass("wishlisted");
    $wishlistButtonTextAdd.toggleClass("hidden");
    return $wishlistButtonTextRemove.toggleClass("hidden");
  };
  onAddItemSuccess = function(data) {
    var updateWishlistItems;
    updateWishlistItems = function(newItem) {
      var addedItem;
      addedItem = {
        dealId: dealId,
        itemId: newItem.itemId,
        listId: newItem.listId,
        removeItemUrl: "/deals/wishlists_proxy/remove/" + newItem.listId + "/" + newItem.itemId
      };
      if (selectedOptionUUID) {
        addedItem.optionId = selectedOptionUUID;
      }
      return wishlistPayload.items.push(addedItem);
    };
    wishlistPayload.removeItemUrl = "/deals/wishlists_proxy/remove/" + data.listId + "/" + data.itemId;
    toggleWishlistButtonStyle();
    return updateWishlistItems(data);
  };
  _checkMultiOptionSelection = function() {
    return wishlistPayload.isMultiOptionsAvailable && !selectedOptionUUID;
  };
  addItemToWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.addItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        dealId: dealId,
        optionId: selectedOptionUUID ? selectedOptionUUID : void 0,
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $("#wishlist-add-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, status, xhr) {
        return onAddItemSuccess(data);
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  removeItemFromWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.removeItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $("#wishlist-remove-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, textStatus, error) {
        toggleWishlistButtonStyle();
        return wishlistPayload.items = _.filter(wishlistPayload.items, function(i) {
          return i.optionId !== selectedOptionUUID;
        });
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  wishlistButtonClicked = function(e) {
    e.preventDefault();
    if (_checkMultiOptionSelection()) {
      return $wishlistButton.trigger("show-tooltip");
    }
    if ($wishlistButton.hasClass("wishlisted")) {
      return removeItemFromWishlist();
    } else {
      return addItemToWishlist();
    }
  };
  return {
    init: init,
    onAddItemSuccess: onAddItemSuccess
  };
};

window.WishlistButton = WishlistButton();

module.exports = WishlistButton;



},{"../../deal/frontend/event_pipe":94}],220:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],221:[function(require,module,exports){
/*!
	Autosize v1.18.9 - 2014-05-27
	Automatically adjust textarea height based on user input.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/autosize
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function ($) {
	var
	defaults = {
		className: 'autosizejs',
		id: 'autosizejs',
		append: '\n',
		callback: false,
		resizeDelay: 10,
		placeholder: true
	},

	// border:0 is unnecessary, but avoids a bug in Firefox on OSX
	copy = '<textarea tabindex="-1" style="position:absolute; top:-999px; left:0; right:auto; bottom:auto; border:0; padding: 0; -moz-box-sizing:content-box; -webkit-box-sizing:content-box; box-sizing:content-box; word-wrap:break-word; height:0 !important; min-height:0 !important; overflow:hidden; transition:none; -webkit-transition:none; -moz-transition:none;"/>',

	// line-height is conditionally included because IE7/IE8/old Opera do not return the correct value.
	typographyStyles = [
		'fontFamily',
		'fontSize',
		'fontWeight',
		'fontStyle',
		'letterSpacing',
		'textTransform',
		'wordSpacing',
		'textIndent'
	],

	// to keep track which textarea is being mirrored when adjust() is called.
	mirrored,

	// the mirror element, which is used to calculate what size the mirrored element should be.
	mirror = $(copy).data('autosize', true)[0];

	// test that line-height can be accurately copied.
	mirror.style.lineHeight = '99px';
	if ($(mirror).css('lineHeight') === '99px') {
		typographyStyles.push('lineHeight');
	}
	mirror.style.lineHeight = '';

	$.fn.autosize = function (options) {
		if (!this.length) {
			return this;
		}

		options = $.extend({}, defaults, options || {});

		if (mirror.parentNode !== document.body) {
			$(document.body).append(mirror);
		}

		return this.each(function () {
			var
			ta = this,
			$ta = $(ta),
			maxHeight,
			minHeight,
			boxOffset = 0,
			callback = $.isFunction(options.callback),
			originalStyles = {
				height: ta.style.height,
				overflow: ta.style.overflow,
				overflowY: ta.style.overflowY,
				wordWrap: ta.style.wordWrap,
				resize: ta.style.resize
			},
			timeout,
			width = $ta.width(),
			taResize = $ta.css('resize');

			if ($ta.data('autosize')) {
				// exit if autosize has already been applied, or if the textarea is the mirror element.
				return;
			}
			$ta.data('autosize', true);

			if ($ta.css('box-sizing') === 'border-box' || $ta.css('-moz-box-sizing') === 'border-box' || $ta.css('-webkit-box-sizing') === 'border-box'){
				boxOffset = $ta.outerHeight() - $ta.height();
			}

			// IE8 and lower return 'auto', which parses to NaN, if no min-height is set.
			minHeight = Math.max(parseInt($ta.css('minHeight'), 10) - boxOffset || 0, $ta.height());

			$ta.css({
				overflow: 'hidden',
				overflowY: 'hidden',
				wordWrap: 'break-word' // horizontal overflow is hidden, so break-word is necessary for handling words longer than the textarea width
			});

			if (taResize === 'vertical') {
				$ta.css('resize','none');
			} else if (taResize === 'both') {
				$ta.css('resize', 'horizontal');
			}

			// The mirror width must exactly match the textarea width, so using getBoundingClientRect because it doesn't round the sub-pixel value.
			// window.getComputedStyle, getBoundingClientRect returning a width are unsupported, but also unneeded in IE8 and lower.
			function setWidth() {
				var width;
				var style = window.getComputedStyle ? window.getComputedStyle(ta, null) : false;
				
				if (style) {

					width = ta.getBoundingClientRect().width;

					if (width === 0 || typeof width !== 'number') {
						width = parseInt(style.width,10);
					}

					$.each(['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'], function(i,val){
						width -= parseInt(style[val],10);
					});
				} else {
					width = $ta.width();
				}

				mirror.style.width = Math.max(width,0) + 'px';
			}

			function initMirror() {
				var styles = {};

				mirrored = ta;
				mirror.className = options.className;
				mirror.id = options.id;
				maxHeight = parseInt($ta.css('maxHeight'), 10);

				// mirror is a duplicate textarea located off-screen that
				// is automatically updated to contain the same text as the
				// original textarea.  mirror always has a height of 0.
				// This gives a cross-browser supported way getting the actual
				// height of the text, through the scrollTop property.
				$.each(typographyStyles, function(i,val){
					styles[val] = $ta.css(val);
				});
				
				$(mirror).css(styles).attr('wrap', $ta.attr('wrap'));

				setWidth();

				// Chrome-specific fix:
				// When the textarea y-overflow is hidden, Chrome doesn't reflow the text to account for the space
				// made available by removing the scrollbar. This workaround triggers the reflow for Chrome.
				if (window.chrome) {
					var width = ta.style.width;
					ta.style.width = '0px';
					var ignore = ta.offsetWidth;
					ta.style.width = width;
				}
			}

			// Using mainly bare JS in this function because it is going
			// to fire very often while typing, and needs to very efficient.
			function adjust() {
				var height, original;

				if (mirrored !== ta) {
					initMirror();
				} else {
					setWidth();
				}

				if (!ta.value && options.placeholder) {
					// If the textarea is empty, copy the placeholder text into 
					// the mirror control and use that for sizing so that we 
					// don't end up with placeholder getting trimmed.
					mirror.value = ($ta.attr("placeholder") || '') + options.append;
				} else {
					mirror.value = ta.value + options.append;
				}

				mirror.style.overflowY = ta.style.overflowY;
				original = parseInt(ta.style.height,10);

				// Setting scrollTop to zero is needed in IE8 and lower for the next step to be accurately applied
				mirror.scrollTop = 0;

				mirror.scrollTop = 9e4;

				// Using scrollTop rather than scrollHeight because scrollHeight is non-standard and includes padding.
				height = mirror.scrollTop;

				if (maxHeight && height > maxHeight) {
					ta.style.overflowY = 'scroll';
					height = maxHeight;
				} else {
					ta.style.overflowY = 'hidden';
					if (height < minHeight) {
						height = minHeight;
					}
				}

				height += boxOffset;

				if (original !== height) {
					ta.style.height = height + 'px';
					if (callback) {
						options.callback.call(ta,ta);
					}
				}
			}

			function resize () {
				clearTimeout(timeout);
				timeout = setTimeout(function(){
					var newWidth = $ta.width();

					if (newWidth !== width) {
						width = newWidth;
						adjust();
					}
				}, parseInt(options.resizeDelay,10));
			}

			if ('onpropertychange' in ta) {
				if ('oninput' in ta) {
					// Detects IE9.  IE9 does not fire onpropertychange or oninput for deletions,
					// so binding to onkeyup to catch most of those occasions.  There is no way that I
					// know of to detect something like 'cut' in IE9.
					$ta.on('input.autosize keyup.autosize', adjust);
				} else {
					// IE7 / IE8
					$ta.on('propertychange.autosize', function(){
						if(event.propertyName === 'value'){
							adjust();
						}
					});
				}
			} else {
				// Modern Browsers
				$ta.on('input.autosize', adjust);
			}

			// Set options.resizeDelay to false if using fixed-width textarea elements.
			// Uses a timeout and width check to reduce the amount of times adjust needs to be called after window resize.

			if (options.resizeDelay !== false) {
				$(window).on('resize.autosize', resize);
			}

			// Event for manual triggering if needed.
			// Should only be needed when the value of the textarea is changed through JavaScript rather than user input.
			$ta.on('autosize.resize', adjust);

			// Event for manual triggering that also forces the styles to update as well.
			// Should only be needed if one of typography styles of the textarea change, and the textarea is already the target of the adjust method.
			$ta.on('autosize.resizeIncludeStyle', function() {
				mirrored = null;
				adjust();
			});

			$ta.on('autosize.destroy', function(){
				mirrored = null;
				clearTimeout(timeout);
				$(window).off('resize', resize);
				$ta
					.off('autosize')
					.off('.autosize')
					.css(originalStyles)
					.removeData('autosize');
			});

			// Call adjust in case the textarea already contains text.
			adjust();
		});
	};
}(window.jQuery || window.$)); // jQuery or jQuery-like library, such as Zepto

},{}],222:[function(require,module,exports){
/*
 *               ~ CLNDR v1.2.0 ~
 * ==============================================
 *       https://github.com/kylestetz/CLNDR
 * ==============================================
 *  created by kyle stetz (github.com/kylestetz)
 *        &available under the MIT license
 * http://opensource.org/licenses/mit-license.php
 * ==============================================
 *
 * This is the fully-commented development version of CLNDR.
 * For the production version, check out clndr.min.js
 * at https://github.com/kylestetz/CLNDR
 *
 * This work is based on the
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 */

;(function ( $, window, document, undefined ) {

  // This is the default calendar template. This can be overridden.
  var clndrTemplate = "<div class='clndr-controls'>" +
    "<div class='clndr-control-button'><span class='clndr-previous-button'>previous</span></div><div class='month'><%= month %> <%= year %></div><div class='clndr-control-button rightalign'><span class='clndr-next-button'>next</span></div>" +
    "</div>" +
  "<table class='clndr-table' border='0' cellspacing='0' cellpadding='0'>" +
    "<thead>" +
    "<tr class='header-days'>" +
    "<% for(var i = 0; i < daysOfTheWeek.length; i++) { %>" +
      "<td class='header-day'><%= daysOfTheWeek[i] %></td>" +
    "<% } %>" +
    "</tr>" +
    "</thead>" +
    "<tbody>" +
    "<% for(var i = 0; i < numberOfRows; i++){ %>" +
      "<tr>" +
      "<% for(var j = 0; j < 7; j++){ %>" +
      "<% var d = j + i * 7; %>" +
      "<td class='<%= days[d].classes %>'><div class='day-contents'><%= days[d].day %>" +
      "</div></td>" +
      "<% } %>" +
      "</tr>" +
    "<% } %>" +
    "</tbody>" +
  "</table>";

  var pluginName = 'clndr';

  var defaults = {
    template: clndrTemplate,
    weekOffset: 0,
    startWithMonth: null,
    timezoneOffset: null,
    clickEvents: {
      click: null,
      nextMonth: null,
      previousMonth: null,
      nextYear: null,
      previousYear: null,
      today: null,
      onMonthChange: null,
      onYearChange: null
    },
    targets: {
      nextButton: 'clndr-next-button',
      previousButton: 'clndr-previous-button',
      nextYearButton: 'clndr-next-year-button',
      previousYearButton: 'clndr-previous-year-button',
      todayButton: 'clndr-today-button',
      day: 'day',
      empty: 'empty'
    },
    events: [],
    extras: null,
    dateParameter: 'date',
    multiDayEvents: null,
    doneRendering: null,
    render: null,
    daysOfTheWeek: null,
    showAdjacentMonths: true,
    adjacentDaysChangeMonth: false,
    ready: null,
    constraints: null,
    forceSixRows: null
  };

  // The actual plugin constructor
  function Clndr( element, options ) {
    this.element = element;

    // merge the default options with user-provided options
    this.options = $.extend(true, {}, defaults, options);

    // if there are events, we should run them through our addMomentObjectToEvents function
    // which will add a date object that we can use to make life easier. This is only necessary
    // when events are provided on instantiation, since our setEvents function uses addMomentObjectToEvents.
    if(this.options.events.length) {
      if(this.options.multiDayEvents) {
        this.options.events = this.addMultiDayMomentObjectsToEvents(this.options.events);
      } else {
        this.options.events = this.addMomentObjectToEvents(this.options.events);
      }
    }

    // this object will store a reference to the current month.
    // it's a moment object, which allows us to poke at it a little if we need to.
    // this will serve as the basis for switching between months & is the go-to
    // internally if we want to know which month we're currently at.
    if(this.options.startWithMonth) {
      this.month = this.moment(this.options.startWithMonth).startOf('month');
    } else {
      this.month = this.moment().startOf('month');
    }

    // if we've got constraints set, make sure the month is within them.
    if(this.options.constraints) {
      // first check if the start date exists & is later than now.
      if(this.options.constraints.startDate) {
        var startMoment = this.moment(this.options.constraints.startDate);
        if(this.month.isBefore(startMoment, 'month')) {
          this.month.set('month', startMoment.month());
          this.month.set('year', startMoment.year());
        }
      }
      // make sure the month (whether modified or not) is before the endDate
      if(this.options.constraints.endDate) {
        var endMoment = this.moment(this.options.constraints.endDate);
        if(this.month.isAfter(endMoment, 'month')) {
          this.month.set('month', endMoment.month()).set('year', endMoment.year());
        }
      }
    }

    this._defaults = defaults;
    this._name = pluginName;

    // Some first-time initialization -> day of the week offset,
    // template compiling, making and storing some elements we'll need later,
    // & event handling for the controller.
    this.init();
  }

  Clndr.prototype.init = function () {
    // create the days of the week using moment's current language setting
    this.daysOfTheWeek = this.options.daysOfTheWeek || [];
    if(!this.options.daysOfTheWeek) {
      this.daysOfTheWeek = [];
      for(var i = 0; i < 7; i++) {
        this.daysOfTheWeek.push( this.moment().weekday(i).format('dd').charAt(0) );
      }
    }
    // shuffle the week if there's an offset
    if(this.options.weekOffset) {
      this.daysOfTheWeek = this.shiftWeekdayLabels(this.options.weekOffset);
    }

    // quick & dirty test to make sure rendering is possible.
    if( !$.isFunction(this.options.render) ) {
      this.options.render = null;
      if (typeof _ === 'undefined') {
        throw new Error("Underscore was not found. Please include underscore.js OR provide a custom render function.");
      }
      else {
        // we're just going ahead and using underscore here if no render method has been supplied.
        this.compiledClndrTemplate = _.template(this.options.template);
      }
    }

    // create the parent element that will hold the plugin & save it for later
    $(this.element).html("<div class='clndr'></div>");
    this.calendarContainer = $('.clndr', this.element);

    // attach event handlers for clicks on buttons/cells
    this.bindEvents();

    // do a normal render of the calendar template
    this.render();

    // if a ready callback has been provided, call it.
    if(this.options.ready) {
      this.options.ready.apply(this, []);
    }
  };

  Clndr.prototype.moment = function() {
    if(this.options.timezoneOffset){
      if(arguments.length > 0){
        // If we want to create a date with some arguments, create it in the timezoneOffset zone
        args = Array.prototype.slice.call(arguments);
        args.push(this.options.timezoneOffset);
        return moment.tz.apply(this, args);
      }
      else {
        // If we don't receive any argument, create it now and then convert it to the timezoneOffset zone
        return moment().tz(this.options.timezoneOffset);
      }
    }
    else {
      return moment.apply(this, arguments);
    }
  }

  Clndr.prototype.shiftWeekdayLabels = function(offset) {
    var days = this.daysOfTheWeek;
    for(var i = 0; i < offset; i++) {
      days.push( days.shift() );
    }
    return days;
  };

  // This is where the magic happens. Given a moment object representing the current month,
  // an array of calendarDay objects is constructed that contains appropriate events and
  // classes depending on the circumstance.
  Clndr.prototype.createDaysObject = function(currentMonth) {
    // this array will hold numbers for the entire grid (even the blank spaces)
    daysArray = [];
    var date = currentMonth.startOf('month');

    // filter the events list (if it exists) to events that are happening last month, this month and next month (within the current grid view)
    this.eventsLastMonth = [];
    this.eventsThisMonth = [];
    this.eventsNextMonth = [];

    if(this.options.events.length) {

      // MULTI-DAY EVENT PARSING
      // if we're using multi-day events, the start or end must be in the current month
      if(this.options.multiDayEvents) {
        this.eventsThisMonth = $(this.options.events).filter( function() {
          return this._clndrStartDateObject.format("YYYY-MM") <= currentMonth.format("YYYY-MM")
          || currentMonth.format("YYYY-MM") <= this._clndrEndDateObject.format("YYYY-MM");
        }).toArray();

        if(this.options.showAdjacentMonths) {
          var lastMonth = currentMonth.clone().subtract('months', 1);
          var nextMonth = currentMonth.clone().add('months', 1);
          this.eventsLastMonth = $(this.options.events).filter( function() {
            return this._clndrStartDateObject.format("YYYY-MM") <= lastMonth.format("YYYY-MM")
          || lastMonth.format("YYYY-MM") <= this._clndrEndDateObject.format("YYYY-MM");
          }).toArray();

          this.eventsNextMonth = $(this.options.events).filter( function() {
            return this._clndrStartDateObject.format("YYYY-MM") <= nextMonth.format("YYYY-MM")
          || nextMonth.format("YYYY-MM") <= this._clndrEndDateObject.format("YYYY-MM");
          }).toArray();
        }
      }

      // SINGLE-DAY EVENT PARSING
      // if we're using single-day events, use _clndrDateObject
      else {
        this.eventsThisMonth = $(this.options.events).filter( function() {
          return this._clndrDateObject.format("YYYY-MM") == currentMonth.format("YYYY-MM");
        }).toArray();

        // filter the adjacent months as well, if the option is true
        if(this.options.showAdjacentMonths) {
          var lastMonth = currentMonth.clone().subtract('months', 1);
          var nextMonth = currentMonth.clone().add('months', 1);
          this.eventsLastMonth = $(this.options.events).filter( function() {
            return this._clndrDateObject.format("YYYY-MM") == lastMonth.format("YYYY-MM");
          }).toArray();

          this.eventsNextMonth = $(this.options.events).filter( function() {
            return this._clndrDateObject.format("YYYY-MM") == nextMonth.format("YYYY-MM");
          }).toArray();
        }
      }
    }

    // if diff is greater than 0, we'll have to fill in last days of the previous month
    // to account for the empty boxes in the grid.
    // we also need to take into account the weekOffset parameter
    var diff = date.weekday() - this.options.weekOffset;
    if(diff < 0) diff += 7;

    if(this.options.showAdjacentMonths) {
      for(var i = 0; i < diff; i++) {
        var day = this.moment([currentMonth.year(), currentMonth.month(), i - diff + 1]);
        daysArray.push( this.createDayObject(day, this.eventsLastMonth) );
      }
    } else {
      for(var i = 0; i < diff; i++) {
        daysArray.push( this.calendarDay({ classes: this.options.targets.empty + " last-month" }) );
      }
    }

    // now we push all of the days in a month
    var numOfDays = date.daysInMonth();
    for(var i = 1; i <= numOfDays; i++) {
      var day = this.moment([currentMonth.year(), currentMonth.month(), i]);
      daysArray.push(this.createDayObject(day, this.eventsThisMonth) )
    }

    // ...and if there are any trailing blank boxes, fill those in
    // with the next month first days
    var i = 1;
    while(daysArray.length % 7 !== 0) {
      if(this.options.showAdjacentMonths) {
        var day = this.moment([currentMonth.year(), currentMonth.month(), numOfDays + i]);
        daysArray.push( this.createDayObject(day, this.eventsNextMonth) );
      } else {
        daysArray.push( this.calendarDay({ classes: this.options.targets.empty + " next-month" }) );
      }
      i++;
    }

    // if we want to force six rows of calendar, now's our last chance to add another row.
    // if the 42 seems explicit it's because we're creating a 7-row grid and 6 rows of 7 is always 42!
    if(this.options.forceSixRows && daysArray.length !== 42 ) {
      var start = this.moment(daysArray[daysArray.length - 1].date).add('days', 1);
      while(daysArray.length < 42) {
        if(this.options.showAdjacentMonths) {
          daysArray.push( this.createDayObject(this.moment(start), this.eventsNextMonth) );
          start.add('days', 1);
        } else {
          daysArray.push( this.calendarDay({ classes: this.options.targets.empty + " next-month" }) );
        }
      }
    }

    return daysArray;
  };

  Clndr.prototype.createDayObject = function(day, monthEvents) {
    var eventsToday = [];
    var now = this.moment();
    var self = this;

    var j = 0, l = monthEvents.length;
    for(j; j < l; j++) {
      // keep in mind that the events here already passed the month/year test.
      // now all we have to compare is the moment.date(), which returns the day of the month.
      if(self.options.multiDayEvents) {
        var start = monthEvents[j]._clndrStartDateObject;
        var end = monthEvents[j]._clndrEndDateObject;
        // if today is the same day as start or is after the start, and
        // if today is the same day as the end or before the end ...
        // woohoo semantics!
        if( ( day.isSame(start, 'day') || day.isAfter(start, 'day') ) &&
          ( day.isSame(end, 'day') || day.isBefore(end, 'day') ) ) {
          eventsToday.push( monthEvents[j] );
        }
      } else {
        if( monthEvents[j]._clndrDateObject.date() == day.date() ) {
          eventsToday.push( monthEvents[j] );
        }
      }
    }

    var extraClasses = "";

    if(now.format("YYYY-MM-DD") == day.format("YYYY-MM-DD")) {
       extraClasses += " today";
    }
    if(day.isBefore(now, 'day')) {
      extraClasses += " past";
    }
    if(eventsToday.length) {
       extraClasses += " event";
    }
    if(this.month.month() > day.month()) {
       extraClasses += " adjacent-month";

       this.month.year() === day.year()
           ? extraClasses += " last-month"
           : extraClasses += " next-month";

    } else if(this.month.month() < day.month()) {
       extraClasses += " adjacent-month";

       this.month.year() === day.year()
           ? extraClasses += " next-month"
           : extraClasses += " last-month";
    }

    // if there are constraints, we need to add the inactive class to the days outside of them
    if(this.options.constraints) {
      if(this.options.constraints.startDate && day.isBefore(this.moment( this.options.constraints.startDate ))) {
        extraClasses += " inactive";
      }
      if(this.options.constraints.endDate && day.isAfter(this.moment( this.options.constraints.endDate ))) {
        extraClasses += " inactive";
      }
    }

    // validate moment date
    if (!day.isValid() && day.hasOwnProperty('_d') && day._d != undefined) {
        day = this.moment(day._d);
    }

    // we're moving away from using IDs in favor of classes, since when
    // using multiple calendars on a page we are technically violating the
    // uniqueness of IDs.
    extraClasses += " calendar-day-" + day.format("YYYY-MM-DD");

    // day of week
    extraClasses += " calendar-dow-" + day.weekday();

    return this.calendarDay({
      day: day.date(),
      classes: this.options.targets.day + extraClasses,
      events: eventsToday,
      date: day
    });
  };

  Clndr.prototype.render = function() {
    // get rid of the previous set of calendar parts.
    // TODO: figure out if this is the right way to ensure proper garbage collection?
    this.calendarContainer.children().remove();
    // get an array of days and blank spaces
    var days = this.createDaysObject(this.month);
    // this is to prevent a scope/naming issue between this.month and data.month
    var currentMonth = this.month;

    var data = {
      daysOfTheWeek: this.daysOfTheWeek,
      numberOfRows: Math.ceil(days.length / 7),
      days: days,
      month: this.month.format('MMMM'),
      year: this.month.year(),
      eventsThisMonth: this.eventsThisMonth,
      eventsLastMonth: this.eventsLastMonth,
      eventsNextMonth: this.eventsNextMonth,
      extras: this.options.extras
    };

    // render the calendar with the data above & bind events to its elements
    if(!this.options.render) {
      this.calendarContainer.html(this.compiledClndrTemplate(data));
    } else {
      this.calendarContainer.html(this.options.render.apply(this, [data]));
    }

    // if there are constraints, we need to add the 'inactive' class to the controls
    if(this.options.constraints) {
      // in the interest of clarity we're just going to remove all inactive classes and re-apply them each render.
      for(target in this.options.targets) {
        if(target != this.options.targets.day) {
          this.element.find('.' + this.options.targets[target]).toggleClass('inactive', false);
        }
      }

      var start = null;
      var end = null;

      if(this.options.constraints.startDate) {
        start = this.moment(this.options.constraints.startDate);
      }
      if(this.options.constraints.endDate) {
        end = this.moment(this.options.constraints.endDate);
      }
      // deal with the month controls first.
      // are we at the start month?
      if(start && this.month.isSame( start, 'month' )) {
        this.element.find('.' + this.options.targets.previousButton).toggleClass('inactive', true);
      }
      // are we at the end month?
      if(end && this.month.isSame( end, 'month' )) {
        this.element.find('.' + this.options.targets.nextButton).toggleClass('inactive', true);
      }
      // what's last year looking like?
      if(start && this.moment(start).subtract('years', 1).isBefore(this.moment(this.month).subtract('years', 1)) ) {
        this.element.find('.' + this.options.targets.previousYearButton).toggleClass('inactive', true);
      }
      // how about next year?
      if(end && this.moment(end).add('years', 1).isAfter(this.moment(this.month).add('years', 1)) ) {
        this.element.find('.' + this.options.targets.nextYearButton).toggleClass('inactive', true);
      }
      // today? we could put this in init(), but we want to support the user changing the constraints on a living instance.
      if(( start && start.isAfter( this.moment(), 'month' ) ) || ( end && end.isBefore( this.moment(), 'month' ) )) {
        this.element.find('.' + this.options.targets.today).toggleClass('inactive', true);
      }
    }


    if(this.options.doneRendering) {
      this.options.doneRendering.apply(this, []);
    }
  };

  Clndr.prototype.bindEvents = function() {
    var $container = $(this.element);
    var self = this;

    // target the day elements and give them click events
    $container.on('click', '.'+this.options.targets.day, function(event) {
      if(self.options.clickEvents.click) {
        var target = self.buildTargetObject(event.currentTarget, true);
        self.options.clickEvents.click.apply(self, [target]);
      }
      // if adjacentDaysChangeMonth is on, we need to change the month here.
      if(self.options.adjacentDaysChangeMonth) {
        if($(event.currentTarget).is(".last-month")) {
          self.backActionWithContext(self);
        } else if($(event.currentTarget).is(".next-month")) {
          self.forwardActionWithContext(self);
        }
      }
    });
    // target the empty calendar boxes as well
    $container.on('click', '.'+this.options.targets.empty, function(event) {
      if(self.options.clickEvents.click) {
        var target = self.buildTargetObject(event.currentTarget, false);
        self.options.clickEvents.click.apply(self, [target]);
      }
      if(self.options.adjacentDaysChangeMonth) {
        if($(event.currentTarget).is(".last-month")) {
          self.backActionWithContext(self);
        } else if($(event.currentTarget).is(".next-month")) {
          self.forwardActionWithContext(self);
        }
      }
    });

    // bind the previous, next and today buttons
    $container
      .on('click', '.'+this.options.targets.previousButton, { context: this }, this.backAction)
      .on('click', '.'+this.options.targets.nextButton, { context: this }, this.forwardAction)
      .on('click', '.'+this.options.targets.todayButton, { context: this }, this.todayAction)
      .on('click', '.'+this.options.targets.nextYearButton, { context: this }, this.nextYearAction)
      .on('click', '.'+this.options.targets.previousYearButton, { context: this }, this.previousYearAction);
  }

  // If the user provided a click callback we'd like to give them something nice to work with.
  // buildTargetObject takes the DOM element that was clicked and returns an object with
  // the DOM element, events, and the date (if the latter two exist). Currently it is based on the id,
  // however it'd be nice to use a data- attribute in the future.
  Clndr.prototype.buildTargetObject = function(currentTarget, targetWasDay) {
    // This is our default target object, assuming we hit an empty day with no events.
    var target = {
      element: currentTarget,
      events: [],
      date: null
    };
    // did we click on a day or just an empty box?
    if(targetWasDay) {
      var dateString;

      // Our identifier is in the list of classNames. Find it!
      var classNameIndex = currentTarget.className.indexOf('calendar-day-');
      if(classNameIndex !== 0) {
        // our unique identifier is always 23 characters long.
        // If this feels a little wonky, that's probably because it is.
        // Open to suggestions on how to improve this guy.
        dateString = currentTarget.className.substring(classNameIndex + 13, classNameIndex + 23);
        target.date = this.moment(dateString);
      } else {
        target.date = null;
      }

      // do we have events?
      if(this.options.events) {
        // are any of the events happening today?
        if(this.options.multiDayEvents) {
          target.events = $.makeArray( $(this.options.events).filter( function() {
            // filter the dates down to the ones that match.
            return ( ( target.date.isSame(this._clndrStartDateObject, 'day') || target.date.isAfter(this._clndrStartDateObject, 'day') ) &&
              ( target.date.isSame(this._clndrEndDateObject, 'day') || target.date.isBefore(this._clndrEndDateObject, 'day') ) );
          }) );
        } else {
          target.events = $.makeArray( $(this.options.events).filter( function() {
            // filter the dates down to the ones that match.
            return this._clndrDateObject.format('YYYY-MM-DD') == dateString;
          }) );
        }
      }
    }

    return target;
  }

  // the click handlers in bindEvents need a context, so these are wrappers
  // to the actual functions. Todo: better way to handle this?
  Clndr.prototype.forwardAction = function(event) {
    var self = event.data.context;
    self.forwardActionWithContext(self);
  };

  Clndr.prototype.backAction = function(event) {
    var self = event.data.context;
    self.backActionWithContext(self);
  };

  // These are called directly, except for in the bindEvent click handlers,
  // where forwardAction and backAction proxy to these guys.
  Clndr.prototype.backActionWithContext = function(self) {
    // before we do anything, check if there is an inactive class on the month control.
    // if it does, we want to return and take no action.
    if(self.element.find('.' + self.options.targets.previousButton).hasClass('inactive')) {
      return;
    }

    // is subtracting one month going to switch the year?
    var yearChanged = !self.month.isSame( this.moment(self.month).subtract('months', 1), 'year');
    self.month.subtract('months', 1);

    self.render();

    if(self.options.clickEvents.previousMonth) {
      self.options.clickEvents.previousMonth.apply( self, [this.moment(self.month)] );
    }
    if(self.options.clickEvents.onMonthChange) {
      self.options.clickEvents.onMonthChange.apply( self, [this.moment(self.month)] );
    }
    if(yearChanged) {
      if(self.options.clickEvents.onYearChange) {
        self.options.clickEvents.onYearChange.apply( self, [this.moment(self.month)] );
      }
    }
  };

  Clndr.prototype.forwardActionWithContext = function(self) {
    // before we do anything, check if there is an inactive class on the month control.
    // if it does, we want to return and take no action.
    if(self.element.find('.' + self.options.targets.nextButton).hasClass('inactive')) {
      return;
    }

    // is adding one month going to switch the year?
    var yearChanged = !self.month.isSame( this.moment(self.month).add('months', 1), 'year');
    self.month.add('months', 1);

    self.render();

    if(self.options.clickEvents.nextMonth) {
      self.options.clickEvents.nextMonth.apply(self, [this.moment(self.month)]);
    }
    if(self.options.clickEvents.onMonthChange) {
      self.options.clickEvents.onMonthChange.apply(self, [this.moment(self.month)]);
    }
    if(yearChanged) {
      if(self.options.clickEvents.onYearChange) {
        self.options.clickEvents.onYearChange.apply( self, [this.moment(self.month)] );
      }
    }
  };

  Clndr.prototype.todayAction = function(event) {
    var self = event.data.context;

    // did we switch months when the today button was hit?
    var monthChanged = !self.month.isSame(this.moment(), 'month');
    var yearChanged = !self.month.isSame(this.moment(), 'year');

    self.month = this.moment().startOf('month');

    // fire the today event handler regardless of whether the month changed.
    if(self.options.clickEvents.today) {
      self.options.clickEvents.today.apply( self, [this.moment(self.month)] );
    }

    if(monthChanged) {
      // no need to re-render if we didn't change months.
      self.render();

      self.month = this.moment();
      // fire the onMonthChange callback
      if(self.options.clickEvents.onMonthChange) {
        self.options.clickEvents.onMonthChange.apply( self, [this.moment(self.month)] );
      }
      // maybe fire the onYearChange callback?
      if(yearChanged) {
        if(self.options.clickEvents.onYearChange) {
          self.options.clickEvents.onYearChange.apply( self, [this.moment(self.month)] );
        }
      }
    }
  };

  Clndr.prototype.nextYearAction = function(event) {
    var self = event.data.context;
    // before we do anything, check if there is an inactive class on the month control.
    // if it does, we want to return and take no action.
    if(self.element.find('.' + self.options.targets.nextYearButton).hasClass('inactive')) {
      return;
    }

    self.month.add('years', 1);
    self.render();

    if(self.options.clickEvents.nextYear) {
      self.options.clickEvents.nextYear.apply( self, [moment(self.month)] );
    }
    if(self.options.clickEvents.onMonthChange) {
      self.options.clickEvents.onMonthChange.apply( self, [moment(self.month)] );
    }
    if(self.options.clickEvents.onYearChange) {
      self.options.clickEvents.onYearChange.apply( self, [moment(self.month)] );
    }
  };

  Clndr.prototype.previousYearAction = function(event) {
    var self = event.data.context;
    // before we do anything, check if there is an inactive class on the month control.
    // if it does, we want to return and take no action.
    if(self.element.find('.' + self.options.targets.previousYear).hasClass('inactive')) {
      return;
    }

    self.month.subtract('years', 1);
    self.render();

    if(self.options.clickEvents.previousYear) {
      self.options.clickEvents.previousYear.apply( self, [moment(self.month)] );
    }
    if(self.options.clickEvents.onMonthChange) {
      self.options.clickEvents.onMonthChange.apply( self, [moment(self.month)] );
    }
    if(self.options.clickEvents.onYearChange) {
      self.options.clickEvents.onYearChange.apply( self, [moment(self.month)] );
    }
  };

  Clndr.prototype.forward = function(options) {
    this.month.add('months', 1);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onMonthChange) {
        this.options.clickEvents.onMonthChange.apply( this, [moment(this.month)] );
      }

      // We entered a new year
      if (this.month.month() === 0 && this.options.clickEvents.onYearChange) {
        this.options.clickEvents.onYearChange.apply( this, [moment(this.month)] );
      }
    }

    return this;
  }

  Clndr.prototype.back = function(options) {
    this.month.subtract('months', 1);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onMonthChange) {
        this.options.clickEvents.onMonthChange.apply( this, [moment(this.month)] );
      }

      // We went all the way back to previous year
      if (this.month.month() === 11 && this.options.clickEvents.onYearChange) {
        this.options.clickEvents.onYearChange.apply( this, [moment(this.month)] );
      }
    }

    return this;
  }

  // alternate names for convenience
  Clndr.prototype.next = function(options) {
    this.forward(options);
    return this;
  }

  Clndr.prototype.previous = function(options) {
    this.back(options);
    return this;
  }

  Clndr.prototype.setMonth = function(newMonth, options) {
    // accepts 0 - 11 or a full/partial month name e.g. "Jan", "February", "Mar"
    this.month.month(newMonth);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onMonthChange) {
        this.options.clickEvents.onMonthChange.apply( this, [moment(this.month)] );
      }
    }
    return this;
  }

  Clndr.prototype.nextYear = function(options) {
    this.month.add('year', 1);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onYearChange) {
        this.options.clickEvents.onYearChange.apply( this, [moment(this.month)] );
      }
    }
    return this;
  }

  Clndr.prototype.previousYear = function(options) {
    this.month.subtract('year', 1);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onYearChange) {
        this.options.clickEvents.onYearChange.apply( this, [moment(this.month)] );
      }
    }
    return this;
  }

  Clndr.prototype.setYear = function(newYear, options) {
    this.month.year(newYear);
    this.render();
    if(options && options.withCallbacks) {
      if(this.options.clickEvents.onYearChange) {
        this.options.clickEvents.onYearChange.apply( this, [moment(this.month)] );
      }
    }
    return this;
  }

  Clndr.prototype.setEvents = function(events) {
    // go through each event and add a moment object
    if(this.options.multiDayEvents) {
      this.options.events = this.addMultiDayMomentObjectsToEvents(events);
    } else {
      this.options.events = this.addMomentObjectToEvents(events);
    }

    this.render();
    return this;
  };

  Clndr.prototype.addEvents = function(events) {
    // go through each event and add a moment object
    if(this.options.multiDayEvents) {
      this.options.events = $.merge(this.options.events, this.addMultiDayMomentObjectsToEvents(events));
    } else {
      this.options.events = $.merge(this.options.events, this.addMomentObjectToEvents(events));
    }

    this.render();
    return this;
  };

  Clndr.prototype.addMomentObjectToEvents = function(events) {
    var self = this;
    var i = 0, l = events.length;
    for(i; i < l; i++) {
      // stuff a _clndrDateObject in each event, which really, REALLY should not be
      // overriding any existing object... Man that would be weird.
      events[i]._clndrDateObject = this.moment( events[i][self.options.dateParameter] );
    }
    return events;
  }

  Clndr.prototype.addMultiDayMomentObjectsToEvents = function(events) {
    var self = this;
    var i = 0, l = events.length;
    for(i; i < l; i++) {
      events[i]._clndrStartDateObject = this.moment( events[i][self.options.multiDayEvents.startDate] );
      events[i]._clndrEndDateObject = this.moment( events[i][self.options.multiDayEvents.endDate] );
    }
    return events;
  }

  Clndr.prototype.calendarDay = function(options) {
    var defaults = { day: "", classes: this.options.targets.empty, events: [], date: null };
    return $.extend({}, defaults, options);
  }

  $.fn.clndr = function(options) {
    if(this.length === 1) {
      if(!this.data('plugin_clndr')) {
        var clndr_instance = new Clndr(this, options);
        this.data('plugin_clndr', clndr_instance);
        return clndr_instance;
      }
    } else if(this.length > 1) {
      throw new Error("CLNDR does not support multiple elements yet. Make sure your clndr selector returns only one element.");
    }
  }

})( jQuery, window, document );

},{}],223:[function(require,module,exports){
(function (global){
(function (root, factory) {
  if (typeof exports === 'object') {
    module.exports = factory((typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), require('backbone'));
  }
  else if (typeof define === 'function' && define.amd) {
    define(['underscore', 'backbone'], factory);
  }
  else {
    root.Backbone.Obscura = factory(root['_'], root['Backbone']);
  }
}(this, function(_, Backbone) {
  function _requireDep(name) {
    return {'underscore': _, 'backbone': Backbone}[name];
  }

  var _bundleExports =
(function (define) {
    function _require(index) {
        var module = _require.cache[index];
        if (!module) {
            var exports = {};
            module = _require.cache[index] = {
                id: index,
                exports: exports
            };
            _require.modules[index].call(exports, module, exports);
        }
        return module.exports;
    }
    _require.cache = [];
    _require.modules = [
        function (module, exports) {
            var _ = _requireDep('underscore');
            var Backbone = _requireDep('backbone');
            var FilteredCollection = _require(2);
            var SortedCollection = _require(5);
            var PaginatedCollection = _require(4);
            var proxyCollection = _require(1);
            var proxyEvents = _require(7);
            function Obscura(superset, options) {
                this._superset = superset;
                this._filtered = new FilteredCollection(superset, options);
                this._sorted = new SortedCollection(this._filtered, options);
                this._paginated = new PaginatedCollection(this._sorted, options);
                proxyCollection(this._paginated, this);
                proxyEvents.call(this, this._filtered, filteredEvents);
                proxyEvents.call(this, this._sorted, sortedEvents);
                proxyEvents.call(this, this._paginated, paginatedEvents);
            }
            var methods = {
                    superset: function () {
                        return this._superset;
                    },
                    getFilteredLength: function () {
                        return this._filtered.length;
                    },
                    removeTransforms: function () {
                        this._filtered.resetFilters();
                        this._sorted.removeSort();
                        this._paginated.removePagination();
                        return this;
                    },
                    destroy: function () {
                        this.stopListening();
                        this._filtered.destroy();
                        this._sorted.destroy();
                        this._paginated.destroy();
                        this.length = 0;
                        this.trigger('obscura:destroy');
                    }
                };
            var filteredMethods = [
                    'filterBy',
                    'removeFilter',
                    'resetFilters',
                    'refilter',
                    'hasFilter',
                    'getFilters'
                ];
            var filteredEvents = [
                    'filtered:add',
                    'filtered:remove',
                    'filtered:reset'
                ];
            var sortedMethods = [
                    'setSort',
                    'reverseSort',
                    'removeSort'
                ];
            var sortedEvents = [
                    'sorted:add',
                    'sorted:remove'
                ];
            var paginatedMethods = [
                    'setPerPage',
                    'setPage',
                    'getPerPage',
                    'getNumPages',
                    'getPage',
                    'hasNextPage',
                    'hasPrevPage',
                    'nextPage',
                    'prevPage',
                    'movePage',
                    'removePagination',
                    'firstPage',
                    'lastPage'
                ];
            var paginatedEvents = [
                    'paginated:change:perPage',
                    'paginated:change:page',
                    'paginated:change:numPages'
                ];
            var unsupportedMethods = [
                    'add',
                    'create',
                    'remove',
                    'set',
                    'reset',
                    'sort',
                    'parse',
                    'sync',
                    'fetch',
                    'push',
                    'pop',
                    'shift',
                    'unshift'
                ];
            _.each(filteredMethods, function (method) {
                methods[method] = function () {
                    var result = FilteredCollection.prototype[method].apply(this._filtered, arguments);
                    return result === this._filtered ? this : result;
                };
            });
            _.each(paginatedMethods, function (method) {
                methods[method] = function () {
                    var result = PaginatedCollection.prototype[method].apply(this._paginated, arguments);
                    return result === this._paginated ? this : result;
                };
            });
            _.each(sortedMethods, function (method) {
                methods[method] = function () {
                    var result = SortedCollection.prototype[method].apply(this._sorted, arguments);
                    return result === this._sorted ? this : result;
                };
            });
            _.each(unsupportedMethods, function (method) {
                methods[method] = function () {
                    throw new Error('Backbone.Obscura: Unsupported method: ' + method + 'called on read-only proxy');
                };
            });
            _.extend(Obscura.prototype, methods, Backbone.Events);
            Obscura = Backbone.Collection.extend(Obscura.prototype);
            Obscura.FilteredCollection = FilteredCollection;
            Obscura.SortedCollection = SortedCollection;
            Obscura.PaginatedCollection = PaginatedCollection;
            module.exports = Obscura;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            var Backbone = _requireDep('backbone');
            var blacklistedMethods = [
                    '_onModelEvent',
                    '_prepareModel',
                    '_removeReference',
                    '_reset',
                    'add',
                    'initialize',
                    'sync',
                    'remove',
                    'reset',
                    'set',
                    'push',
                    'pop',
                    'unshift',
                    'shift',
                    'sort',
                    'parse',
                    'fetch',
                    'create',
                    'model',
                    'off',
                    'on',
                    'listenTo',
                    'listenToOnce',
                    'bind',
                    'trigger',
                    'once',
                    'stopListening'
                ];
            var eventWhiteList = [
                    'add',
                    'remove',
                    'reset',
                    'sort',
                    'destroy',
                    'sync',
                    'request',
                    'error'
                ];
            function proxyCollection(from, target) {
                function updateLength() {
                    target.length = from.length;
                }
                function pipeEvents(eventName) {
                    var args = _.toArray(arguments);
                    var isChangeEvent = eventName === 'change' || eventName.slice(0, 7) === 'change:';
                    if (eventName === 'reset') {
                        target.models = from.models;
                    }
                    if (_.contains(eventWhiteList, eventName)) {
                        if (_.contains([
                                'add',
                                'remove',
                                'destroy'
                            ], eventName)) {
                            args[2] = target;
                        } else if (_.contains([
                                'reset',
                                'sort'
                            ], eventName)) {
                            args[1] = target;
                        }
                        target.trigger.apply(this, args);
                    } else if (isChangeEvent) {
                        if (target.contains(args[1])) {
                            target.trigger.apply(this, args);
                        }
                    }
                }
                var methods = {};
                _.each(_.functions(Backbone.Collection.prototype), function (method) {
                    if (!_.contains(blacklistedMethods, method)) {
                        methods[method] = function () {
                            return from[method].apply(from, arguments);
                        };
                    }
                });
                _.extend(target, Backbone.Events, methods);
                target.listenTo(from, 'all', updateLength);
                target.listenTo(from, 'all', pipeEvents);
                target.models = from.models;
                updateLength();
                return target;
            }
            module.exports = proxyCollection;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            var Backbone = _requireDep('backbone');
            var proxyCollection = _require(1);
            var createFilter = _require(3);
            function invalidateCache() {
                this._filterResultCache = {};
            }
            function invalidateCacheForFilter(filterName) {
                for (var cid in this._filterResultCache) {
                    if (this._filterResultCache.hasOwnProperty(cid)) {
                        delete this._filterResultCache[cid][filterName];
                    }
                }
            }
            function addFilter(filterName, filterObj) {
                if (this._filters[filterName]) {
                    invalidateCacheForFilter.call(this, filterName);
                }
                this._filters[filterName] = filterObj;
                this.trigger('filtered:add', filterName);
            }
            function removeFilter(filterName) {
                delete this._filters[filterName];
                invalidateCacheForFilter.call(this, filterName);
                this.trigger('filtered:remove', filterName);
            }
            function execFilterOnModel(model) {
                if (!this._filterResultCache[model.cid]) {
                    this._filterResultCache[model.cid] = {};
                }
                var cache = this._filterResultCache[model.cid];
                for (var filterName in this._filters) {
                    if (this._filters.hasOwnProperty(filterName)) {
                        if (!cache.hasOwnProperty(filterName)) {
                            cache[filterName] = this._filters[filterName].fn(model);
                        }
                        if (!cache[filterName]) {
                            return false;
                        }
                    }
                }
                return true;
            }
            function execFilter() {
                var filtered = [];
                if (this._superset) {
                    filtered = this._superset.filter(_.bind(execFilterOnModel, this));
                }
                this._collection.reset(filtered);
                this.length = this._collection.length;
            }
            function onAddChange(model) {
                this._filterResultCache[model.cid] = {};
                if (execFilterOnModel.call(this, model)) {
                    if (!this._collection.get(model.cid)) {
                        var index = this.superset().indexOf(model);
                        var filteredIndex = null;
                        for (var i = index - 1; i >= 0; i -= 1) {
                            if (this.contains(this.superset().at(i))) {
                                filteredIndex = this.indexOf(this.superset().at(i)) + 1;
                                break;
                            }
                        }
                        filteredIndex = filteredIndex || 0;
                        this._collection.add(model, { at: filteredIndex });
                    }
                } else {
                    if (this._collection.get(model.cid)) {
                        this._collection.remove(model);
                    }
                }
                this.length = this._collection.length;
            }
            function onModelAttributeChange(model) {
                this._filterResultCache[model.cid] = {};
                if (!execFilterOnModel.call(this, model)) {
                    if (this._collection.get(model.cid)) {
                        this._collection.remove(model);
                    }
                }
            }
            function onAll(eventName, model, value) {
                if (eventName.slice(0, 7) === 'change:') {
                    onModelAttributeChange.call(this, arguments[1]);
                }
            }
            function onModelRemove(model) {
                if (this.contains(model)) {
                    this._collection.remove(model);
                }
                this.length = this._collection.length;
            }
            function Filtered(superset) {
                this._superset = superset;
                this._collection = new Backbone.Collection(superset.toArray());
                proxyCollection(this._collection, this);
                this.resetFilters();
                this.listenTo(this._superset, 'reset sort', execFilter);
                this.listenTo(this._superset, 'add change', onAddChange);
                this.listenTo(this._superset, 'remove', onModelRemove);
                this.listenTo(this._superset, 'all', onAll);
            }
            var methods = {
                    defaultFilterName: '__default',
                    filterBy: function (filterName, filter) {
                        if (!filter) {
                            filter = filterName;
                            filterName = this.defaultFilterName;
                        }
                        addFilter.call(this, filterName, createFilter(filter));
                        execFilter.call(this);
                        return this;
                    },
                    removeFilter: function (filterName) {
                        if (!filterName) {
                            filterName = this.defaultFilterName;
                        }
                        removeFilter.call(this, filterName);
                        execFilter.call(this);
                        return this;
                    },
                    resetFilters: function () {
                        this._filters = {};
                        invalidateCache.call(this);
                        this.trigger('filtered:reset');
                        execFilter.call(this);
                        return this;
                    },
                    superset: function () {
                        return this._superset;
                    },
                    refilter: function (arg) {
                        if (typeof arg === 'object' && arg.cid) {
                            onAddChange.call(this, arg);
                        } else {
                            invalidateCache.call(this);
                            execFilter.call(this);
                        }
                        return this;
                    },
                    getFilters: function () {
                        return _.keys(this._filters);
                    },
                    hasFilter: function (name) {
                        return _.contains(this.getFilters(), name);
                    },
                    destroy: function () {
                        this.stopListening();
                        this._collection.reset([]);
                        this._superset = this._collection;
                        this.length = 0;
                        this.trigger('filtered:destroy');
                    }
                };
            _.extend(Filtered.prototype, methods, Backbone.Events);
            module.exports = Filtered;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            function convertKeyValueToFunction(key, value) {
                return function (model) {
                    return model.get(key) === value;
                };
            }
            function convertKeyFunctionToFunction(key, fn) {
                return function (model) {
                    return fn(model.get(key));
                };
            }
            function createFilterObject(filterFunction, keys) {
                if (!_.isArray(keys)) {
                    keys = null;
                }
                return {
                    fn: filterFunction,
                    keys: keys
                };
            }
            function createFilterFromObject(filterObj) {
                var keys = _.keys(filterObj);
                var filterFunctions = _.map(keys, function (key) {
                        var val = filterObj[key];
                        if (_.isFunction(val)) {
                            return convertKeyFunctionToFunction(key, val);
                        }
                        return convertKeyValueToFunction(key, val);
                    });
                var filterFunction = function (model) {
                    for (var i = 0; i < filterFunctions.length; i++) {
                        if (!filterFunctions[i](model)) {
                            return false;
                        }
                    }
                    return true;
                };
                return createFilterObject(filterFunction, keys);
            }
            function createFilter(filter, keys) {
                if (_.isFunction(filter)) {
                    return createFilterObject(filter, keys);
                }
                if (_.isObject(filter)) {
                    return createFilterFromObject(filter);
                }
            }
            module.exports = createFilter;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            var Backbone = _requireDep('backbone');
            var proxyCollection = _require(1);
            function getPageLimits() {
                var start = this.getPage() * this.getPerPage();
                var end = start + this.getPerPage();
                return [
                    start,
                    end
                ];
            }
            function updatePagination() {
                var pages = getPageLimits.call(this);
                this._collection.reset(this.superset().slice(pages[0], pages[1]));
            }
            function updateNumPages() {
                var currentNumPages = this._totalPages;
                var length = this.superset().length;
                var perPage = this.getPerPage();
                var totalPages = length % perPage === 0 ? length / perPage : Math.floor(length / perPage) + 1;
                var numPagesChanged = this._totalPages !== totalPages;
                this._totalPages = totalPages;
                if (numPagesChanged) {
                    this.trigger('paginated:change:numPages', { numPages: totalPages });
                }
                if (this.getPage() >= totalPages) {
                    this.setPage(totalPages - 1);
                    return true;
                }
            }
            function recalculatePagination() {
                if (updateNumPages.call(this)) {
                    return;
                }
                updatePagination.call(this);
            }
            function difference(arrayA, arrayB) {
                var maxLength = _.max([
                        arrayA.length,
                        arrayB.length
                    ]);
                for (var i = 0, j = 0; i < maxLength; i += 1, j += 1) {
                    if (arrayA[i] !== arrayB[j]) {
                        if (arrayB[i - 1] === arrayA[i]) {
                            j -= 1;
                        } else if (arrayB[i + 1] === arrayA[i]) {
                            j += 1;
                        } else {
                            return arrayA[i];
                        }
                    }
                }
            }
            function onAddRemove(model, collection, options) {
                if (updateNumPages.call(this)) {
                    return;
                }
                var pages = getPageLimits.call(this);
                var start = pages[0], end = pages[1];
                var toAdd = difference(this.superset().slice(start, end), this._collection.toArray());
                var toRemove = difference(this._collection.toArray(), this.superset().slice(start, end));
                if (toRemove) {
                    this._collection.remove(toRemove);
                }
                if (toAdd) {
                    this._collection.add(toAdd, { at: this.superset().indexOf(toAdd) - start });
                }
            }
            function Paginated(superset, options) {
                this._superset = superset;
                this._collection = new Backbone.Collection(superset.toArray());
                this._page = 0;
                this.setPerPage(options && options.perPage ? options.perPage : null);
                proxyCollection(this._collection, this);
                this.listenTo(this._superset, 'add remove', onAddRemove);
                this.listenTo(this._superset, 'reset sort', recalculatePagination);
            }
            var methods = {
                    removePagination: function () {
                        this.setPerPage(null);
                        return this;
                    },
                    setPerPage: function (perPage) {
                        this._perPage = perPage;
                        recalculatePagination.call(this);
                        this.setPage(0);
                        this.trigger('paginated:change:perPage', {
                            perPage: perPage,
                            numPages: this.getNumPages()
                        });
                        return this;
                    },
                    setPage: function (page) {
                        var lowerLimit = 0;
                        var upperLimit = this.getNumPages() - 1;
                        page = page > lowerLimit ? page : lowerLimit;
                        page = page < upperLimit ? page : upperLimit;
                        page = page < 0 ? 0 : page;
                        this._page = page;
                        updatePagination.call(this);
                        this.trigger('paginated:change:page', { page: page });
                        return this;
                    },
                    getPerPage: function () {
                        return this._perPage || this.superset().length || 1;
                    },
                    getNumPages: function () {
                        return this._totalPages;
                    },
                    getPage: function () {
                        return this._page;
                    },
                    hasNextPage: function () {
                        return this.getPage() < this.getNumPages() - 1;
                    },
                    hasPrevPage: function () {
                        return this.getPage() > 0;
                    },
                    nextPage: function () {
                        this.movePage(1);
                        return this;
                    },
                    prevPage: function () {
                        this.movePage(-1);
                        return this;
                    },
                    firstPage: function () {
                        this.setPage(0);
                    },
                    lastPage: function () {
                        this.setPage(this.getNumPages() - 1);
                    },
                    movePage: function (delta) {
                        this.setPage(this.getPage() + delta);
                        return this;
                    },
                    superset: function () {
                        return this._superset;
                    },
                    destroy: function () {
                        this.stopListening();
                        this._collection.reset([]);
                        this._superset = this._collection;
                        this._page = 0;
                        this._totalPages = 0;
                        this.length = 0;
                        this.trigger('paginated:destroy');
                    }
                };
            _.extend(Paginated.prototype, methods, Backbone.Events);
            module.exports = Paginated;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            var Backbone = _requireDep('backbone');
            var proxyCollection = _require(1);
            var reverseSortedIndex = _require(6);
            function lookupIterator(value) {
                return _.isFunction(value) ? value : function (obj) {
                    return obj.get(value);
                };
            }
            function modelInsertIndex(model) {
                if (!this._comparator) {
                    return this._superset.indexOf(model);
                } else {
                    if (!this._reverse) {
                        return _.sortedIndex(this._collection.toArray(), model, lookupIterator(this._comparator));
                    } else {
                        return reverseSortedIndex(this._collection.toArray(), model, lookupIterator(this._comparator));
                    }
                }
            }
            function onAdd(model) {
                var index = modelInsertIndex.call(this, model);
                this._collection.add(model, { at: index });
            }
            function onRemove(model) {
                if (this.contains(model)) {
                    this._collection.remove(model);
                }
            }
            function onChange(model) {
                if (this.contains(model) && this._collection.indexOf(model) !== modelInsertIndex.call(this, model)) {
                    this._collection.remove(model);
                    onAdd.call(this, model);
                }
            }
            function sort() {
                if (!this._comparator) {
                    this._collection.reset(this._superset.toArray());
                    return;
                }
                var newOrder = this._superset.sortBy(this._comparator);
                this._collection.reset(this._reverse ? newOrder.reverse() : newOrder);
            }
            function Sorted(superset) {
                this._superset = superset;
                this._reverse = false;
                this._comparator = null;
                this._collection = new Backbone.Collection(superset.toArray());
                proxyCollection(this._collection, this);
                this.listenTo(this._superset, 'add', onAdd);
                this.listenTo(this._superset, 'remove', onRemove);
                this.listenTo(this._superset, 'change', onChange);
                this.listenTo(this._superset, 'reset', sort);
            }
            var methods = {
                    setSort: function (comparator, direction) {
                        this._reverse = direction === 'desc' ? true : false;
                        this._comparator = comparator;
                        sort.call(this);
                        if (!comparator) {
                            this.trigger('sorted:remove');
                        } else {
                            this.trigger('sorted:add');
                        }
                        return this;
                    },
                    reverseSort: function () {
                        this._reverse = !this._reverse;
                        sort.call(this);
                        return this;
                    },
                    removeSort: function () {
                        this.setSort();
                        return this;
                    },
                    superset: function () {
                        return this._superset;
                    },
                    destroy: function () {
                        this.stopListening();
                        this._collection.reset([]);
                        this._superset = this._collection;
                        this.length = 0;
                        this.trigger('sorted:destroy');
                    }
                };
            _.extend(Sorted.prototype, methods, Backbone.Events);
            module.exports = Sorted;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            function lookupIterator(value) {
                return _.isFunction(value) ? value : function (obj) {
                    return obj[value];
                };
            }
            function reverseSortedIndex(array, obj, iterator, context) {
                iterator = iterator == null ? _.identity : lookupIterator(iterator);
                var value = iterator.call(context, obj);
                var low = 0, high = array.length;
                while (low < high) {
                    var mid = low + high >>> 1;
                    iterator.call(context, array[mid]) < value ? high = mid : low = mid + 1;
                }
                return low;
            }
            module.exports = reverseSortedIndex;
        },
        function (module, exports) {
            var _ = _requireDep('underscore');
            function proxyEvents(from, eventNames) {
                _.each(eventNames, function (eventName) {
                    this.listenTo(from, eventName, function () {
                        var args = _.toArray(arguments);
                        args.unshift(eventName);
                        this.trigger.apply(this, args);
                    });
                }, this);
            }
            module.exports = proxyEvents;
        }
    ];
    return  _require(0);
}());

  return _bundleExports;
}));
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"backbone":220}],224:[function(require,module,exports){
var TEMPLATES;

TEMPLATES = {
  modal: require('../modal.html.mustache')
};

window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  getTemplate: function(args) {
    return TEMPLATES.modal.render(args);
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref;
    if (path == null) {
      path = window.location.href;
    }
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    try {
      return (ref = frames[this.iframeName]) != null ? ref.IframeLogin.iframeView.resetHeight() : void 0;
    } catch (_error) {
      return window.location.assign(path);
    }
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  module.exports = IframeLogin;
}



},{"../modal.html.mustache":225}],225:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(!_.s(_.f("authenticated",c,p,1),c,p,1,0,0,"")){_.b("  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">");_.b("\n" + i);_.b("    <div class=\"modal-body\">");_.b("\n" + i);_.b("      <a class=\"close-modal icon-x\"></a>");_.b("\n" + i);_.b("      <iframe name=\"modal-login\" src=\"");_.b(_.v(_.f("iframeSrc",c,p,0)));_.b("\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>");_.b("\n" + i);_.b("    </div>");_.b("\n" + i);_.b("  </div>");_.b("\n");};return _.fl();;},"{{^ authenticated }}\n  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">\n    <div class=\"modal-body\">\n      <a class=\"close-modal icon-x\"></a>\n      <iframe name=\"modal-login\" src=\"{{ iframeSrc }}\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>\n    </div>\n  </div>\n{{/ authenticated }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],226:[function(require,module,exports){
module.exports = {
  getAspectSummaryContent: function(aspectStats, I18n) {
    var aspect, aspectClose, aspectOpen, aspectStatPresent, aspectSummaryExists, negAdjArray, negAdjString, negPercentage, negativeSentiment, negativeStrings, negativeText, numClose, numOpen, percentClose, percentOpen, percentSymbol, posAdjArray, posAdjString, posPercentage, positiveSentiment, positiveStrings, positiveText, ref, ref1, sentimentType;
    aspectSummaryExists = aspectStats.summaryexists;
    if (aspectSummaryExists !== '') {
      aspect = aspectStats.aspect_text;
      posAdjArray = (ref = aspectStats.positiveSentimentAdjs) != null ? ref.split(',') : void 0;
      negAdjArray = (ref1 = aspectStats.negativeSentimentAdjs) != null ? ref1.split(',') : void 0;
      if (posAdjArray != null) {
        positiveStrings = [];
        _.each(posAdjArray, function(adj) {
          var translation;
          translation = I18n.translate('modules.translations.adjective', {
            'adjective': adj.capitalize(),
            'aspect': aspect.capitalize()
          });
          return positiveStrings.push("\"" + translation + "\"");
        });
        if (positiveStrings.length > 1) {
          posAdjString = positiveStrings != null ? positiveStrings.join(', ') : void 0;
        } else {
          posAdjString = positiveStrings != null ? positiveStrings[0] : void 0;
        }
      }
      if (negAdjArray != null) {
        negativeStrings = [];
        _.each(negAdjArray, function(adj) {
          var translation;
          translation = I18n.translate('modules.translations.adjective', {
            'adjective': adj.capitalize(),
            'aspect': aspect.capitalize()
          });
          return negativeStrings.push("\"" + translation + "\"");
        });
        if (negativeStrings.length > 1) {
          negAdjString = negativeStrings != null ? negativeStrings.join(', ') : void 0;
        } else {
          negAdjString = negativeStrings != null ? negativeStrings[0] : void 0;
        }
      }
      percentOpen = "<span class='percentage'>";
      numOpen = "<span class='num'>";
      numClose = "</span>";
      percentClose = "</span>";
      posPercentage = aspectStats.posPercentage;
      negPercentage = aspectStats.negPercentage;
      sentimentType = aspectStats.sentimentType;
      aspectOpen = "<span class='aspect-bold'>";
      aspectClose = "</span>";
      percentSymbol = "%";
      positiveSentiment = "positive";
      negativeSentiment = "negative";
      positiveText = I18n.translate('modules.translations.aspect', {
        'percentage': posPercentage,
        percentOpen: percentOpen,
        numOpen: numOpen,
        percentSymbol: percentSymbol,
        sentiment: positiveSentiment,
        numClose: numClose,
        percentClose: percentClose,
        'aspect': aspect,
        aspectOpen: aspectOpen,
        aspectClose: aspectClose
      });
      negativeText = I18n.translate('modules.translations.aspect', {
        'percentage': negPercentage,
        percentOpen: percentOpen,
        numOpen: numOpen,
        percentSymbol: percentSymbol,
        sentiment: negativeSentiment,
        numClose: numClose,
        percentClose: percentClose,
        'aspect': aspect,
        aspectOpen: aspectOpen,
        aspectClose: aspectClose
      });
      aspectStatPresent = {
        positiveText: positiveText,
        negativeText: negativeText,
        negativeAdjs: negAdjString,
        positiveAdjs: posAdjString,
        summaryExists: aspectSummaryExists,
        sentimentType: sentimentType
      };
      return aspectStatPresent;
    }
  }
};



},{}],227:[function(require,module,exports){
if (window.UGC == null) {
  window.UGC = {};
}

UGC.ExpandTipsHandler = (function() {
  function _Class() {}

  _Class.setTAExpandClicks = function() {
    var $items;
    $items = $('.ta-review');
    return _.each($items, (function(_this) {
      return function(item) {
        var $thisElement;
        $thisElement = $(item);
        return _this.setTAShowLink($thisElement);
      };
    })(this));
  };

  _Class.setTAShowLink = function($element) {
    var $description, $showMoreLink, $textContainer;
    $showMoreLink = $element.find('.ta-show-more');
    $description = $element.find('.tip-body');
    $textContainer = $element.find('.tip-text');
    $showMoreLink.one('click', function() {
      var fullText;
      fullText = $textContainer != null ? $textContainer.data('text') : void 0;
      $description.toggleClass('expanded');
      return $textContainer.html(fullText);
    });
  };

  _Class.setTouchTipEllipsis = function() {
    return $('.tips-mobile-container .tip-text').each(function() {
      var $this;
      $this = $(this);
      if ($this.is(':hidden')) {
        return $this.removeClass('ellipsis');
      } else {
        if (this.offsetHeight < this.scrollHeight) {
          return $this.addClass('fadeout-ellipsis').click(function() {
            if ($this.hasClass('fadeout-ellipsis')) {
              $this.removeClass('fadeout-ellipsis');
              return $this.removeClass('ellipsis');
            } else {
              $this.addClass('ellipsis');
              return $this.addClass('fadeout-ellipsis');
            }
          });
        }
      }
    });
  };

  return _Class;

})();

$(function() {
  UGC.ExpandTipsHandler.setTAExpandClicks();
  return UGC.ExpandTipsHandler.setTouchTipEllipsis();
});



},{}],228:[function(require,module,exports){

/*
We have 2 login options:
- Regular login flow (/login page)
- Modal iframe login (it opens a modal with an iframe pointing to /login/iframe)

The login iframe is loaded after everything else has been loaded.

If the user clicks on something that requires authentication before the iframe has been loaded,
then they will be redirected to the regular login flow. This is to prevent a problem with the iframe
interfering with the login flow.
 */
var _iframeLoaded;

_iframeLoaded = false;

if (!window.UGC) {
  window.UGC = {};
}

UGC.JsonResponseHandler = (function() {
  function _Class() {}

  _Class.getCurrentUrl = function() {
    return window.location.protocol + "//" + window.location.host + window.location.pathname;
  };

  _Class.redirectToLogin = function() {
    var currentUrl, loginLink;
    currentUrl = encodeURIComponent(this.getCurrentUrl());
    loginLink = "/login?ref=" + currentUrl + "&return_to=" + currentUrl;
    return window.location.href = loginLink;
  };

  _Class.openModalIframeLogin = function() {
    if (!this.iframeLoginInitialized) {
      IframeLogin.init({
        iframeLogin: {
          authenticated: false,
          authType: 'login',
          src: '/login/iframe'
        }
      });
      this.iframeLoginInitialized = true;
    }
    return IframeLogin.openModal(this.getCurrentUrl());
  };

  _Class.loginRequired = function(res, options) {
    var interval, start, waitForIframeToLoad;
    if (options == null) {
      options = {};
    }
    if ((res != null ? res.error : void 0) !== 'login-required') {
      return false;
    }
    if (options.method === 'redirect' || !$('#login-modal').length) {
      this.redirectToLogin();
    } else if (_iframeLoaded === true) {
      this.openModalIframeLogin();
    } else {
      start = new Date().getTime();
      waitForIframeToLoad = (function(_this) {
        return function() {
          var now;
          now = new Date().getTime();
          if (!_iframeLoaded && (now - start > 2500)) {
            clearInterval(interval);
            _this.redirectToLogin();
            return;
          }
          if (_iframeLoaded !== true) {
            return;
          }
          clearInterval(interval);
          return _this.openModalIframeLogin();
        };
      })(this);
      interval = setInterval(waitForIframeToLoad, 250);
    }
    return true;
  };

  return _Class;

})();

$(window).load(function() {
  var $iframe, $loginContainer, modal, templateData;
  templateData = {
    iframeLogin: {
      authenticated: false,
      authType: 'login',
      src: '/login/iframe'
    }
  };
  modal = IframeLogin.getTemplate(templateData);
  $iframe = $(modal).find('iframe');
  if (!$iframe.length) {
    return;
  }
  $loginContainer = $('.tip-widget-iframe-login');
  $loginContainer.html(modal);
  $loginContainer.find('iframe').attr('src', '/login/iframe');
  return _iframeLoaded = true;
});



},{}],229:[function(require,module,exports){
module.exports = {
  getPageNumbers: function(paginationIndex, totalPages) {
    var curPage, i, j, k, l, nextIndex, nextLinkDisabled, page, paginationSlots, prevIndex, prevLinkDisabled, ref, ref1, ref2, ref3, ref4;
    paginationSlots = [];
    curPage = paginationIndex + 1;
    prevIndex = paginationIndex - 1;
    nextIndex = paginationIndex + 1;
    if (totalPages <= 1) {
      return;
    }
    if (paginationIndex === 0) {
      prevLinkDisabled = true;
    }
    if ((paginationIndex + 1) > (totalPages - 1)) {
      nextLinkDisabled = true;
    }
    if (totalPages <= 10) {
      for (page = i = 1, ref = totalPages; 1 <= ref ? i <= ref : i >= ref; page = 1 <= ref ? ++i : --i) {
        paginationSlots.push({
          current: page === curPage,
          text: page,
          url: '#',
          index: page - 1
        });
      }
    } else if (curPage < 8) {
      for (page = j = 1; j <= 8; page = ++j) {
        paginationSlots.push({
          current: page === curPage,
          text: page,
          url: '#',
          index: page - 1
        });
      }
      paginationSlots.push({
        text: "..."
      });
      paginationSlots.push({
        current: page === curPage,
        text: totalPages,
        url: '#',
        index: totalPages - 1
      });
    } else if (curPage > totalPages - 7) {
      paginationSlots.push({
        current: page === curPage,
        text: '1',
        url: '#',
        index: 0
      });
      paginationSlots.push({
        text: "..."
      });
      for (page = k = ref1 = totalPages - 7, ref2 = totalPages; ref1 <= ref2 ? k <= ref2 : k >= ref2; page = ref1 <= ref2 ? ++k : --k) {
        paginationSlots.push({
          current: page === curPage,
          text: page,
          url: '#',
          index: page - 1
        });
      }
    } else {
      paginationSlots.push({
        current: page === curPage,
        text: '1',
        url: '#',
        index: 0
      });
      paginationSlots.push({
        text: "..."
      });
      for (page = l = ref3 = curPage - 2, ref4 = curPage + 3; ref3 <= ref4 ? l <= ref4 : l >= ref4; page = ref3 <= ref4 ? ++l : --l) {
        paginationSlots.push({
          current: page === curPage,
          text: page,
          url: '#',
          index: page - 1
        });
      }
      paginationSlots.push({
        text: "..."
      });
      paginationSlots.push({
        current: page === curPage,
        text: totalPages,
        url: '#',
        index: totalPages - 1
      });
    }
    return {
      paginationSlots: paginationSlots,
      prevIndex: prevIndex,
      nextIndex: nextIndex,
      prevLinkDisabled: prevLinkDisabled,
      nextLinkDisabled: nextLinkDisabled
    };
  }
};



},{}],230:[function(require,module,exports){
(function (global){
var STRINGS, TEMPLATES, aspectStatsPresenter, defaults, paginationPresenter, tipWidgetI18n,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

TEMPLATES = {
  main: require('../../templates/main.html.mustache'),
  tips: require('../../templates/partials/tips.html.mustache'),
  endorsements: require('../../templates/partials/endorsements.html.mustache'),
  pagination: require('../../templates/partials/pagination.html.mustache'),
  aspects: require('../../templates/partials/aspects.html.mustache'),
  recommendations: require('../../templates/partials/recommendations.html.mustache'),
  starRecommendations: require('../../templates/partials/stars.html.mustache'),
  tripAdvisorRecommendations: require('../../templates/partials/trip_advisor_recommendations.html.mustache'),
  tripAdvisorTips: require('../../templates/partials/trip_advisor_tips.html.mustache'),
  grouponTips: require('../../templates/partials/groupon_tips.html.mustache')
};

require('groupon-iframe-login');

require('./login.coffee');

require('./expandUGC.coffee');

aspectStatsPresenter = require('./aspect-stats-presenter.coffee');

paginationPresenter = require('./pagination-presenter.coffee');

defaults = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).defaults;

STRINGS = require('../../translations.json');

tipWidgetI18n = I18n.scoped();

tipWidgetI18n.translations = defaults({}, STRINGS[I18n.locale], tipWidgetI18n.translations);

if (window.tipWidget == null) {
  window.tipWidget = {};
}

tipWidget.init = function(payload, done) {
  if (done == null) {
    done = function() {};
  }
  $(window).load(function() {
    return new Groupon.TipWidget(payload);
  });
  return done();
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.substr(1);
};

Groupon.TipWidget = (function() {
  function TipWidget(arg) {
    var fiveStarParam, initialLoad, paginationIndex, url;
    this.rootUrl = arg.rootUrl, this.csrf = arg.csrf;
    this.flagTip = bind(this.flagTip, this);
    this.unlikeTip = bind(this.unlikeTip, this);
    this.likeTip = bind(this.likeTip, this);
    this.tipsPerPage = $('.tip-widget-data').data().tipsPerPage;
    this.orderBy = $('.tip-widget-data').data().orderBy;
    this.merchantId = $('.tip-widget-data').data().merchantId;
    this.placeIds = $('.tip-widget-data').data().placeIds;
    this.clientId = $('.tip-widget-data').data().clientId;
    this.$tipWidget = $('.tip-widget');
    this.locale = $('.tip-widget-data').data().locale;
    this.country = $('.tip-widget-data').data().country;
    this.fiveStarRatings = $('.tip-widget-data').data().fiveStarRatings;
    if (this.fiveStarRatings !== true) {
      this.fiveStarRatings = null;
      fiveStarParam = '';
    } else {
      fiveStarParam = "&showFiveStarRatings=" + this.fiveStarRatings;
    }
    this.currentAspect = '';
    this.templates = TEMPLATES;
    this.i18n = tipWidgetI18n;
    paginationIndex = 0;
    url = this.rootUrl + "/tip_widget/tips/" + this.merchantId + "?limit=" + this.tipsPerPage + "&orderBy=" + this.orderBy + fiveStarParam;
    initialLoad = true;
    this.getTips(paginationIndex, url, null, initialLoad);
    this.initBindings();
  }

  TipWidget.prototype.initBindings = function() {
    this.setEndorsementClickHandlers($('.tip-widget-tips .like'), $('.tip-widget-tips .unlike'));
    this.setDropdownChangeEvent($('.tip-sort-dropdown'));
    return GIG.Tooltip.reloadBindings('.tip-sort-container');
  };

  TipWidget.prototype.getTips = function(paginationIndex, url, aspectStats, initialLoad) {
    return $.ajax({
      url: url,
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      success: (function(_this) {
        return function(res) {
          var $tipWidgetLink, answers, html, linkText, templateData, tipsExist, totalPages, totalTips, tripAdvisor;
          answers = res.answers, totalPages = res.totalPages, totalTips = res.totalTips, linkText = res.linkText, tripAdvisor = res.tripAdvisor;
          if (initialLoad != null) {
            if (!((answers != null ? answers.length : void 0) > 0)) {
              return null;
            }
            $tipWidgetLink = $('.tip-widget-link');
            $tipWidgetLink.find('.tip-widget-tips-link').text("(" + linkText + ")");
            if (_this.fiveStarRatings === true) {
              $tipWidgetLink.addClass('five-star-recommendations');
            } else if (tripAdvisor == null) {
              $tipWidgetLink.addClass('classic-recommendations');
            }
            $tipWidgetLink.addClass('visible');
            $tipWidgetLink.show();
            _this.getRecommendations(tripAdvisor);
            if (tripAdvisor == null) {
              if (_this.placeIds === "") {
                _this.placeIds = _.compact(_.uniq(_.pluck(answers, 'placeId'))).toString();
              }
              if (_this.placeIds !== "") {
                _this.getAspects();
              }
            }
            _this.$tipWidget.addClass('show');
          }
          if (((answers != null ? answers.length : void 0) != null) && answers.length > 0) {
            tipsExist = true;
          }
          templateData = {
            i18n: _this.i18n.translations.modules.translations,
            tipsExist: tipsExist,
            pages: totalPages,
            showFiveStarRatings: _this.fiveStarRatings
          };
          if (tripAdvisor != null) {
            templateData['tripAdvisorTips'] = answers;
          } else {
            templateData['loadedTips'] = answers;
          }
          html = _this.templates.tips.render(templateData, {
            endorsements: TEMPLATES.endorsements,
            groupon_tips: TEMPLATES.grouponTips,
            trip_advisor_tips: TEMPLATES.tripAdvisorTips
          });
          $('.tips-template').html(html);
          _this.setEndorsementClickHandlers($('.tip-widget .like'), $('.tip-widget .unlike'));
          _this.setReportClickHandlers($('.tip-widget .tip-report'));
          UGC.ExpandTipsHandler.setTAExpandClicks();
          if (_this.tipsPerPage >= 10) {
            $('html, body').animate({
              scrollTop: _this.$tipWidget.offset().top - 10
            }, 100);
          }
          return _this.setPaginationLinks(paginationIndex, totalPages);
        };
      })(this)
    });
  };

  TipWidget.prototype.getAspects = function() {
    return $.ajax({
      url: this.rootUrl + "/tip_widget/aspects/" + this.placeIds,
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      success: (function(_this) {
        return function(res) {
          var html, templateData;
          if (res == null) {
            return OptimizeSuite.TrackingHub.add("tip-widget-aspect-null-response", {
              "placeIds": _this.placeIds
            });
          } else {
            if (!(res.length > 0)) {
              return;
            }
            templateData = {
              aspectExists: true,
              loadedAspects: res,
              i18n: _this.i18n.translations.modules.translations
            };
            html = _this.templates.aspects.render(templateData);
            $('.aspects-template').html(html);
            return _this.setAspectClickHandlers();
          }
        };
      })(this)
    });
  };

  TipWidget.prototype.getRecommendations = function(tripAdvisor) {
    return $.ajax({
      url: this.rootUrl + "/tip_widget/recommendations",
      data: {
        id: this.merchantId,
        locale: this.locale,
        country: this.country,
        client_id: this.clientId,
        showFiveStarRatings: this.fiveStarRatings
      },
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      success: (function(_this) {
        return function(res) {
          var html, ref, templateData;
          if (((ref = res.recommendations) != null ? ref.showToUser : void 0) !== true) {
            return;
          }
          templateData = {
            recommendations: res,
            i18n: _this.i18n.translations.modules.translations
          };
          if (tripAdvisor != null) {
            html = _this.templates.tripAdvisorRecommendations.render(templateData);
          } else if (_this.fiveStarRatings === true) {
            html = _this.templates.starRecommendations.render(templateData);
          } else {
            html = _this.templates.recommendations.render(templateData);
          }
          return $('.tips-recommendations-container').html(html);
        };
      })(this)
    });
  };

  TipWidget.prototype.likeTip = function(e) {
    var consumerId, obj, tipId;
    tipId = $(e.target).data().tipId;
    consumerId = $('.tip-widget-data').data().consumerId;
    obj = {
      consumerId: consumerId,
      _csrf: this.csrf
    };
    return $.ajax({
      url: this.rootUrl + "/tip_widget/" + tipId + "/like",
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      dataType: 'json',
      success: (function(_this) {
        return function(res) {
          var $endorsement, $link, $report, $thanks, html, ref, templateData;
          if (res.error === "login-required") {
            UGC.JsonResponseHandler.loginRequired(res);
          }
          templateData = {
            likes: res.likes,
            endorsed: ((ref = res.userAction) != null ? ref.action : void 0) === "like",
            id: res.id,
            i18n: _this.i18n.translations.modules.translations
          };
          html = _this.templates.endorsements.render(templateData);
          $endorsement = $(".tip-endorsement[data-tip-id=" + res.id + "]");
          $endorsement.html(html);
          $link = $endorsement.find('.unlike');
          $report = $endorsement.find('.tip-report');
          $thanks = $endorsement.find('.tip-thanks');
          $thanks.fadeIn(1000, function() {
            return $thanks.fadeOut(1000, function() {});
          });
          _this.setEndorsementClickHandlers(null, $link);
          return _this.setReportClickHandlers($report);
        };
      })(this),
      error: function(res) {
        return UGC.JsonResponseHandler.loginRequired(res);
      }
    });
  };

  TipWidget.prototype.unlikeTip = function(e) {
    var consumerId, obj, tipId;
    tipId = $(e.target).data().tipId;
    consumerId = $('.tip-widget-data').data().consumerId;
    obj = {
      consumerId: consumerId,
      _csrf: this.csrf
    };
    return $.ajax({
      url: this.rootUrl + "/tip_widget/" + tipId + "/unlike",
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      dataType: 'json',
      success: (function(_this) {
        return function(res) {
          var $endorsement, $link, $report, html, ref, templateData;
          if (res.error === "login-required") {
            UGC.JsonResponseHandler.loginRequired(res);
          }
          templateData = {
            likes: res.likes,
            endorsed: ((ref = res.userAction) != null ? ref.action : void 0) === "like",
            id: res.id,
            i18n: _this.i18n.translations.modules.translations
          };
          html = _this.templates.endorsements.render(templateData);
          $endorsement = $(".tip-endorsement[data-tip-id=" + res.id + "]");
          $endorsement.html(html);
          $link = $endorsement.find('.like');
          $report = $endorsement.find('.tip-report');
          _this.setEndorsementClickHandlers($link, null);
          return _this.setReportClickHandlers($report);
        };
      })(this),
      error: function(res) {
        return UGC.JsonResponseHandler.loginRequired(res);
      }
    });
  };

  TipWidget.prototype.flagTip = function(e) {
    var consumerId, obj, tipId;
    tipId = $(e.target).data().tipId;
    consumerId = $('.tip-widget-data').data().consumerId;
    obj = {
      consumerId: consumerId,
      _csrf: this.csrf
    };
    return $.ajax({
      url: this.rootUrl + "/tip_widget/" + tipId + "/flag",
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      dataType: 'json',
      success: function(res) {
        var $endorsement, $tip, $tipNumberSpan, newTipNumber, numberTips;
        if (res.error === "login-required") {
          UGC.JsonResponseHandler.loginRequired(res);
        }
        $endorsement = $(".tip-endorsement[data-tip-id=" + res.id + "]");
        $tip = $endorsement.parents('.tip-item');
        $tip.remove();
        $tipNumberSpan = $('.tips-title .number-tips');
        numberTips = $tipNumberSpan.html();
        newTipNumber = parseInt(numberTips) - 1;
        return $tipNumberSpan.html(newTipNumber);
      },
      error: function(res) {
        return UGC.JsonResponseHandler.loginRequired(res);
      }
    });
  };

  TipWidget.prototype.setPaginationLinks = function(paginationIndex, totalPages) {
    var html, templateData;
    if (totalPages == null) {
      return $('.tip-pagination').html('');
    }
    templateData = paginationPresenter.getPageNumbers(paginationIndex, totalPages);
    templateData['i18n'] = this.i18n.translations.modules.translations;
    html = this.templates.pagination.render(templateData, {
      endorsements: TEMPLATES.pagination
    });
    $('.tip-pagination').html(html);
    return this.setPaginationClickHandlers();
  };

  TipWidget.prototype.setEndorsementClickHandlers = function($likes, $dislikes) {
    if ($likes != null) {
      $likes.on('click', (function(_this) {
        return function(e) {
          return _this.likeTip(e);
        };
      })(this));
    }
    return $dislikes != null ? $dislikes.on('click', (function(_this) {
      return function(e) {
        return _this.unlikeTip(e);
      };
    })(this)) : void 0;
  };

  TipWidget.prototype.getAspectQuery = function() {
    if (this.currentAspect !== '') {
      return "&aspect=" + this.currentAspect;
    } else {
      return "";
    }
  };

  TipWidget.prototype.setPaginationClickHandlers = function() {
    return $('.tip-pagination-link').on('click', (function(_this) {
      return function(e) {
        var aspectQuery, aspectStats, aspectStatsPresent, offset, paginationIndex, ref, ref1, url;
        paginationIndex = $(e.target).data().paginationindex;
        offset = paginationIndex * _this.tipsPerPage;
        aspectQuery = _this.getAspectQuery();
        url = _this.rootUrl + "/tip_widget/tips/" + _this.merchantId + "?offset=" + offset + "&limit=" + _this.tipsPerPage + "&orderBy=" + _this.orderBy + aspectQuery;
        aspectStats = (ref = $('.aspect.active')) != null ? (ref1 = ref.data()) != null ? ref1.aspectobj : void 0 : void 0;
        if ((aspectStats != null ? aspectStats.aspect_text : void 0) != null) {
          aspectStatsPresent = aspectStatsPresenter.getAspectSummaryContent(aspectStats, _this.i18n);
        }
        return _this.getTips(paginationIndex, url, aspectStatsPresent);
      };
    })(this));
  };

  TipWidget.prototype.setAspectClickHandlers = function() {
    return $('.tip-widget .aspect').on('click', (function(_this) {
      return function(e) {
        var aspect, aspectQuery, aspectStats, aspectStatsPresent, offset, paginationIndex, url;
        paginationIndex = 0;
        offset = 0;
        $('.aspect').removeClass('active');
        $(e.target).addClass('active');
        aspect = $(e.target).data().aspecttext;
        _this.currentAspect = aspect !== 'all' ? aspect : '';
        aspectStats = $('.aspect.active').data().aspectobj;
        if (aspectStats.aspect_text != null) {
          aspectStatsPresent = aspectStatsPresenter.getAspectSummaryContent(aspectStats, _this.i18n);
        }
        aspectQuery = _this.getAspectQuery();
        url = _this.rootUrl + "/tip_widget/tips/" + _this.merchantId + "?offset=" + offset + "&limit=" + _this.tipsPerPage + "&orderBy=" + _this.orderBy + aspectQuery;
        _this.getTips(paginationIndex, url, aspectStatsPresent);
        return _this.setPaginationClickHandlers();
      };
    })(this));
  };

  TipWidget.prototype.setReportClickHandlers = function($reports) {
    return $reports.on('click', (function(_this) {
      return function(e) {
        return _this.flagTip(e);
      };
    })(this));
  };

  TipWidget.prototype.setDropdownChangeEvent = function() {
    return $('.tip-dropdown li').on('click', (function(_this) {
      return function(e) {
        var $element, aspectQuery, paginationIndex, text, url;
        $('.tip-dropdown li').removeClass('selected');
        $element = $(e.target);
        $element.addClass('selected');
        aspectQuery = _this.getAspectQuery();
        _this.orderBy = $element.data().value;
        text = $element.text();
        paginationIndex = 0;
        url = _this.rootUrl + "/tip_widget/tips/" + _this.merchantId + "?limit=" + _this.tipsPerPage + "&orderBy=" + _this.orderBy + aspectQuery;
        _this.getTips(paginationIndex, url, null, null);
        return $('.tip-tooltip-text').text(text);
      };
    })(this));
  };

  return TipWidget;

})();


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../templates/main.html.mustache":236,"../../templates/partials/aspects.html.mustache":237,"../../templates/partials/endorsements.html.mustache":238,"../../templates/partials/groupon_tips.html.mustache":239,"../../templates/partials/pagination.html.mustache":240,"../../templates/partials/recommendations.html.mustache":241,"../../templates/partials/stars.html.mustache":242,"../../templates/partials/tips.html.mustache":243,"../../templates/partials/trip_advisor_recommendations.html.mustache":244,"../../templates/partials/trip_advisor_tips.html.mustache":245,"../../translations.json":246,"./aspect-stats-presenter.coffee":226,"./expandUGC.coffee":227,"./login.coffee":228,"./pagination-presenter.coffee":229,"groupon-iframe-login":231}],231:[function(require,module,exports){
var TEMPLATES;

TEMPLATES = {
  modal: require('../modal.html.mustache')
};

window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  getTemplate: function(args) {
    return TEMPLATES.modal.render(args);
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref, ref1, ref2;
    if (path == null) {
      path = window.location.href;
    }
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    return (ref = frames[this.iframeName]) != null ? (ref1 = ref.IframeLogin) != null ? (ref2 = ref1.iframeView) != null ? typeof ref2.resetHeight === "function" ? ref2.resetHeight() : void 0 : void 0 : void 0 : void 0;
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  module.exports = IframeLogin;
}



},{"../modal.html.mustache":232}],232:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("authenticated",c,p,1),c,p,1,0,0,"")){t.b("  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">");t.b("\n" + i);t.b("    <div class=\"modal-body\">");t.b("\n" + i);t.b("      <a class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("      <iframe name=\"modal-login\" src=\"");t.b(t.v(t.f("iframeSrc",c,p,0)));t.b("\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{^ authenticated }}\n  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">\n    <div class=\"modal-body\">\n      <a class=\"close-modal icon-x\"></a>\n      <iframe name=\"modal-login\" src=\"{{ iframeSrc }}\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>\n    </div>\n  </div>\n{{/ authenticated }}\n", Hogan);
},{"hogan.js":234}],233:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],234:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":233,"./template":235}],235:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],236:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<script>");_.b("\n" + i);_.b("  tipWidget = window.tipWidget || {};");_.b("\n" + i);_.b("  tipWidget.csrf = '");_.b(_.v(_.f("csrfToken",c,p,0)));_.b("';");_.b("\n" + i);_.b("</script>");_.b("\n" + i);_.b("\n" + i);_.b("<section id=\"all-tips\" class=\"tip-widget\" data-bhw=\"UgcTipWidget\">");_.b("\n" + i);_.b("  <div data-bhw=\"UgcTipWidgetViewport\" data-bh-viewport=\"respect\">");_.b("\n" + i);_.b("\n" + i);_.b("    <div class=\"tips-title-container\">");_.b("\n" + i);_.b("      <h2 class=\"tips-title\">");_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("tripAdvisor",c,p,1),c,p,0,323,370,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          ");_.b(_.v(_.d("i18n.reviewsTripAdvisor",c,p,0)));_.b("\n");});c.pop();}_.b("\n" + i);if(!_.s(_.f("tripAdvisor",c,p,1),c,p,1,0,0,"")){_.b("\n" + i);if(_.s(_.f("showFiveStarRatings",c,p,1),c,p,0,448,494,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("            ");_.b(_.v(_.d("i18n.fiveStarTitle",c,p,0)));_.b("\n");});c.pop();}_.b("\n" + i);if(!_.s(_.f("showFiveStarRatings",c,p,1),c,p,1,0,0,"")){_.b("            <span class=\"number-tips\">");_.b(_.v(_.f("numberTips",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("            ");if(_.s(_.f("singularTip",c,p,1),c,p,0,643,655,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.v(_.d("i18n.tip",c,p,0)));});c.pop();}if(!_.s(_.f("singularTip",c,p,1),c,p,1,0,0,"")){_.b(_.v(_.d("i18n.tips",c,p,0)));};_.b("\n");};};_.b("\n" + i);_.b("      </h2>");_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("\n" + i);_.b("  <div class=\"tips-recommendations-container\"></div>");_.b("\n" + i);_.b("\n" + i);_.b("\n" + i);if(!_.s(_.f("tripAdvisor",c,p,1),c,p,1,0,0,"")){_.b(_.rp("dropdown",c,p,"    "));_.b("\n" + i);_.b("    <div class=\"aspects-template\">");_.b("\n" + i);_.b(_.rp("aspects",c,p,"      "));_.b("    </div>");_.b("\n");};_.b("\n" + i);if(_.s(_.f("tripAdvisor",c,p,1),c,p,0,1000,1037,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.rp("trip_advisor_histogram",c,p,"    "));});c.pop();}_.b("\n" + i);_.b("  <div style=\"clear:both\"></div>");_.b("\n" + i);_.b("\n" + i);_.b("\n" + i);_.b("  <div class=\"tips-template\">");_.b("\n" + i);_.b(_.rp("tips",c,p,"    "));_.b("  </div>");_.b("\n" + i);_.b("\n" + i);_.b("  <div class=\"tip-pagination\"></div>");_.b("\n" + i);_.b("\n" + i);_.b("  ");if(_.s(_.f("showHr",c,p,1),c,p,0,1197,1201,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<hr>");});c.pop();}_.b("\n" + i);_.b("\n" + i);_.b("  </div>");_.b("\n" + i);_.b("</section>");_.b("\n" + i);_.b("\n" + i);_.b("<div class= \"tip-widget-data\" data-merchant-id=\"");_.b(_.v(_.f("merchantId",c,p,0)));_.b("\"  data-client-id=\"");_.b(_.v(_.f("clientId",c,p,0)));_.b("\"  data-place-ids=\"");_.b(_.v(_.f("placeIds",c,p,0)));_.b("\" ");if(_.s(_.f("consumerId",c,p,1),c,p,0,1376,1409,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("data-consumer-id=\"");_.b(_.v(_.f("consumerId",c,p,0)));_.b("\"");});c.pop();}_.b(" data-locale=\"");_.b(_.v(_.f("locale",c,p,0)));_.b("\" data-country=\"");_.b(_.v(_.f("country",c,p,0)));_.b("\" data-pages=\"");_.b(_.v(_.f("pages",c,p,0)));_.b("\" data-tips-per-page=\"");_.b(_.v(_.f("tipsPerPage",c,p,0)));_.b("\" data-order-by=\"");_.b(_.v(_.f("orderBy",c,p,0)));_.b("\" data-five-star-ratings=\"");_.b(_.v(_.f("showFiveStarRatings",c,p,0)));_.b("\"></div>");_.b("\n" + i);_.b("\n" + i);_.b("<div class=\"tip-widget-iframe-login\"></div>");_.b("\n");return _.fl();;},"<script>\n  tipWidget = window.tipWidget || {};\n  tipWidget.csrf = '{{csrfToken}}';\n</script>\n\n<section id=\"all-tips\" class=\"tip-widget\" data-bhw=\"UgcTipWidget\">\n  <div data-bhw=\"UgcTipWidgetViewport\" data-bh-viewport=\"respect\">\n\n    <div class=\"tips-title-container\">\n      <h2 class=\"tips-title\">\n\n        {{#tripAdvisor}}\n          {{i18n.reviewsTripAdvisor}}\n        {{/tripAdvisor}}\n\n        {{^tripAdvisor}}\n\n          {{#showFiveStarRatings}}\n            {{i18n.fiveStarTitle}}\n          {{/showFiveStarRatings}}\n\n          {{^showFiveStarRatings}}\n            <span class=\"number-tips\">{{numberTips}}</span>\n            {{#singularTip}}{{i18n.tip}}{{/singularTip}}{{^singularTip}}{{i18n.tips}}{{/singularTip}}\n          {{/showFiveStarRatings}}\n        {{/tripAdvisor}}\n\n      </h2>\n  </div>\n\n  <div class=\"tips-recommendations-container\"></div>\n\n\n  {{^tripAdvisor}}\n    {{> dropdown }}\n\n    <div class=\"aspects-template\">\n      {{> aspects }}\n    </div>\n  {{/tripAdvisor}}\n\n  {{#tripAdvisor}}\n    {{> trip_advisor_histogram }}\n  {{/tripAdvisor}}\n\n  <div style=\"clear:both\"></div>\n\n\n  <div class=\"tips-template\">\n    {{> tips }}\n  </div>\n\n  <div class=\"tip-pagination\"></div>\n\n  {{#showHr}}<hr>{{/showHr}}\n\n  </div>\n</section>\n\n<div class= \"tip-widget-data\" data-merchant-id=\"{{merchantId}}\"  data-client-id=\"{{clientId}}\"  data-place-ids=\"{{placeIds}}\" {{#consumerId}}data-consumer-id=\"{{consumerId}}\"{{/consumerId}} data-locale=\"{{locale}}\" data-country=\"{{country}}\" data-pages=\"{{pages}}\" data-tips-per-page=\"{{tipsPerPage}}\" data-order-by=\"{{orderBy}}\" data-five-star-ratings=\"{{showFiveStarRatings}}\"></div>\n\n<div class=\"tip-widget-iframe-login\"></div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],237:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("aspectExists",c,p,1),c,p,0,17,364,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"aspects\">");_.b("\n" + i);if(_.s(_.f("loadedAspects",c,p,1),c,p,0,64,336,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <div class=\"aspect ");if(_.s(_.f("active",c,p,1),c,p,0,101,107,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("active");});c.pop();}_.b(" ");if(!_.s(_.f("positiveAspect",c,p,1),c,p,1,0,0,"")){_.b("negative");};_.b("\"");_.b("\n" + i);_.b("           data-aspecttext=\"");_.b(_.v(_.f("aspect_text",c,p,0)));_.b("\"");_.b("\n" + i);_.b("           data-aspectobj=\"");_.b(_.v(_.f("aspectObj",c,p,0)));_.b("\"");_.b("\n" + i);_.b("           data-bhc=\"aspectLink:");_.b(_.v(_.f("aspect_text",c,p,0)));_.b("\"");_.b("\n" + i);_.b("      >");_.b(_.v(_.f("aspect_text",c,p,0)));_.b("</div>");_.b("\n");});c.pop();}_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{#aspectExists}}\n  <div class=\"aspects\">\n    {{#loadedAspects}}\n      <div class=\"aspect {{#active}}active{{/active}} {{^positiveAspect}}negative{{/positiveAspect}}\"\n           data-aspecttext=\"{{aspect_text}}\"\n           data-aspectobj=\"{{aspectObj}}\"\n           data-bhc=\"aspectLink:{{aspect_text}}\"\n      >{{aspect_text}}</div>\n    {{/loadedAspects}}\n  </div>\n{{/aspectExists}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],238:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<p>");_.b("\n" + i);_.b("  <a");_.b("\n" + i);_.b("    ");if(_.s(_.f("endorsed",c,p,1),c,p,0,26,81,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("class=\"unlike\"  data-bhc='tipHelpful:undendorse-");_.b(_.v(_.f("id",c,p,0)));_.b("'");});c.pop();}_.b("\n" + i);_.b("    ");if(!_.s(_.f("endorsed",c,p,1),c,p,1,0,0,"")){_.b("class=\"like\" data-bhc='tipHelpful:endorse-");_.b(_.v(_.f("id",c,p,0)));_.b("'");};_.b("\n" + i);_.b("    data-tip-id=\"");_.b(_.v(_.f("id",c,p,0)));_.b("\" data-login-required=\"true\"");_.b("\n" + i);_.b("  >");_.b(_.v(_.d("i18n.helpful",c,p,0)));if(!_.s(_.f("likes",c,p,1),c,p,1,0,0,"")){_.b("?");};if(_.s(_.f("likes",c,p,1),c,p,0,277,289,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" (");_.b(_.v(_.f("likes",c,p,0)));_.b(")");});c.pop();}_.b("</a>");_.b("\n" + i);_.b("  ");if(_.s(_.f("endorsed",c,p,1),c,p,0,319,366,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<span class=\"tip-thanks\">");_.b(_.v(_.d("i18n.thanks",c,p,0)));_.b("</span>");});c.pop();}_.b("\n" + i);_.b("</p>");_.b("\n");return _.fl();;},"<p>\n  <a\n    {{#endorsed}}class=\"unlike\"  data-bhc='tipHelpful:undendorse-{{id}}'{{/endorsed}}\n    {{^endorsed}}class=\"like\" data-bhc='tipHelpful:endorse-{{id}}'{{/endorsed}}\n    data-tip-id=\"{{id}}\" data-login-required=\"true\"\n  >{{i18n.helpful}}{{^likes}}?{{/likes}}{{#likes}} ({{likes}}){{/likes}}</a>\n  {{#endorsed}}<span class=\"tip-thanks\">{{i18n.thanks}}</span>{{/endorsed}}\n</p>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],239:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("loadedTips",c,p,1),c,p,0,15,903,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"tip-item classic-tip\">");_.b("\n" + i);_.b("\n" + i);if(!_.s(_.f("showFiveStarRatings",c,p,1),c,p,1,0,0,"")){_.b("      <div class=\"circle\">");_.b("\n" + i);_.b("        ");if(!_.s(_.f("negativeSentiment",c,p,1),c,p,1,0,0,"")){_.b("<span class=\"tip-widget-icon icon-thumbs-up\"></span>");};_.b("\n" + i);_.b("        ");if(_.s(_.f("negativeSentiment",c,p,1),c,p,0,247,301,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<span class=\"tip-widget-icon icon-thumbs-down\"></span>");});c.pop();}_.b("\n" + i);_.b("      </div>");_.b("\n");};_.b("\n" + i);_.b("    <div class=\"tip-body\">");_.b("\n" + i);_.b("      <div class=\"tip-text ellipsis\">");_.b("\n" + i);_.b("        ");_.b(_.t(_.f("text",c,p,0)));_.b("\n" + i);_.b("      </div>");_.b("\n" + i);_.b("\n" + i);_.b("      <div class=\"user-text\">");_.b("\n" + i);if(_.s(_.f("name",c,p,1),c,p,0,514,591,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          <span class=\"tips-reviewer-name\">");_.b(_.v(_.f("name",c,p,0)));_.b("</span> &middot;");_.b("\n");});c.pop();}_.b("        <span class=\"tips-reviewed-date\">");_.b(_.v(_.f("displayDate",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("        ");if(_.s(_.f("verified",c,p,1),c,p,0,686,713,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(" &middot; ");_.b(_.v(_.d("i18n.verified",c,p,0)));});c.pop();}_.b("\n" + i);_.b("\n" + i);_.b("      </div>");_.b("\n" + i);_.b("      <div class=\"tip-endorsement\" data-tip-id=\"");_.b(_.v(_.f("id",c,p,0)));_.b("\">");_.b("\n" + i);if(!_.s(_.f("hideEndorsements",c,p,1),c,p,1,0,0,"")){_.b(_.rp("endorsements",c,p,""));};_.b("      </div>");_.b("\n" + i);_.b("\n" + i);_.b("    </div>");_.b("\n" + i);_.b("\n" + i);_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{#loadedTips}}\n  <div class=\"tip-item classic-tip\">\n\n    {{^ showFiveStarRatings }}\n      <div class=\"circle\">\n        {{^negativeSentiment}}<span class=\"tip-widget-icon icon-thumbs-up\"></span>{{/negativeSentiment}}\n        {{#negativeSentiment}}<span class=\"tip-widget-icon icon-thumbs-down\"></span>{{/negativeSentiment}}\n      </div>\n    {{/ showFiveStarRatings }}\n\n    <div class=\"tip-body\">\n      <div class=\"tip-text ellipsis\">\n        {{{text}}}\n      </div>\n\n      <div class=\"user-text\">\n        {{#name}}\n          <span class=\"tips-reviewer-name\">{{name}}</span> &middot;\n        {{/name}}\n        <span class=\"tips-reviewed-date\">{{displayDate}}</span>\n        {{#verified}} &middot; {{i18n.verified}}{{/verified}}\n\n      </div>\n      <div class=\"tip-endorsement\" data-tip-id=\"{{id}}\">\n        {{^hideEndorsements}}{{> endorsements }}{{/hideEndorsements}}\n      </div>\n\n    </div>\n\n  </div>\n{{/loadedTips}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],240:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<ul class=\"tip-pagination-links\">");_.b("\n" + i);_.b("  <li>");_.b("\n" + i);_.b("    <a class='tip-pagination-link prev-link ");if(_.s(_.f("prevLinkDisabled",c,p,1),c,p,0,106,114,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("disabled");});c.pop();}_.b("' data-bhc='tipPagination:prevlink' data-paginationindex=");_.b(_.v(_.f("prevIndex",c,p,0)));_.b(">");_.b(_.v(_.d("i18n.previous",c,p,0)));_.b("</a>");_.b("\n" + i);_.b("  </li>");_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("paginationSlots",c,p,1),c,p,0,259,487,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("    <li>");_.b("\n" + i);_.b("      ");if(_.s(_.f("url",c,p,1),c,p,0,283,435,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("<a class=\"tip-pagination-link number ");if(_.s(_.f("current",c,p,1),c,p,0,332,338,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("active");});c.pop();}_.b("\" data-bhc=\"tipPagination:link");_.b(_.v(_.f("text",c,p,0)));_.b("\" data-paginationindex=\"");_.b(_.v(_.f("index",c,p,0)));_.b("\">");_.b(_.v(_.f("text",c,p,0)));_.b("</a>");});c.pop();}_.b("\n" + i);_.b("      ");if(!_.s(_.f("url",c,p,1),c,p,1,0,0,"")){_.b(_.v(_.f("text",c,p,0)));};_.b("\n" + i);_.b("    </li>");_.b("\n");});c.pop();}_.b("\n" + i);_.b("  <li>");_.b("\n" + i);_.b("    <a class='tip-pagination-link next-link ");if(_.s(_.f("nextLinkDisabled",c,p,1),c,p,0,581,589,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("disabled");});c.pop();}_.b("' data-bhc='tipPagination:nextlink' data-paginationindex=");_.b(_.v(_.f("nextIndex",c,p,0)));_.b(">");_.b(_.v(_.d("i18n.next",c,p,0)));_.b("</a>");_.b("\n" + i);_.b("  </li>");_.b("\n" + i);_.b("</ul>");_.b("\n");return _.fl();;},"<ul class=\"tip-pagination-links\">\n  <li>\n    <a class='tip-pagination-link prev-link {{#prevLinkDisabled}}disabled{{/prevLinkDisabled}}' data-bhc='tipPagination:prevlink' data-paginationindex={{prevIndex}}>{{i18n.previous}}</a>\n  </li>\n\n  {{#paginationSlots}}\n    <li>\n      {{#url}}<a class=\"tip-pagination-link number {{#current}}active{{/current}}\" data-bhc=\"tipPagination:link{{text}}\" data-paginationindex=\"{{index}}\">{{text}}</a>{{/url}}\n      {{^url}}{{text}}{{/url}}\n    </li>\n  {{/paginationSlots}}\n\n  <li>\n    <a class='tip-pagination-link next-link {{#nextLinkDisabled}}disabled{{/nextLinkDisabled}}' data-bhc='tipPagination:nextlink' data-paginationindex={{nextIndex}}>{{i18n.next}}</a>\n  </li>\n</ul>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],241:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("recommendations",c,p,1),c,p,0,22,496,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <h3 class=\"classic-recommendations\" ");if(_.s(_.f("showItemProps",c,p,1),c,p,0,81,162,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("itemprop=\"aggregateRating\" itemscope itemtype=\"http://schema.org/AggregateRating\"");});c.pop();}_.b(">");_.b("\n" + i);if(_.s(_.f("showItemProps",c,p,1),c,p,0,208,383,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <meta itemprop=\"ratingCount\" content=\"");_.b(_.v(_.f("total",c,p,0)));_.b("\">");_.b("\n" + i);_.b("      <meta itemprop=\"ratingValue\" content=\"");_.b(_.v(_.f("percentage",c,p,0)));_.b("\">");_.b("\n" + i);_.b("      <meta itemprop=\"bestRating\" content=\"100\">");_.b("\n");});c.pop();}_.b("    <span class=\"icon-thumbs-up tip-widget-icon\"></span> ");_.b(_.t(_.f("recommendationText",c,p,0)));_.b("\n" + i);_.b("  </h3>");_.b("\n");});c.pop();}return _.fl();;},"{{# recommendations }}\n  <h3 class=\"classic-recommendations\" {{# showItemProps }}itemprop=\"aggregateRating\" itemscope itemtype=\"http://schema.org/AggregateRating\"{{/ showItemProps }}>\n    {{# showItemProps }}\n      <meta itemprop=\"ratingCount\" content=\"{{ total }}\">\n      <meta itemprop=\"ratingValue\" content=\"{{ percentage }}\">\n      <meta itemprop=\"bestRating\" content=\"100\">\n    {{/ showItemProps }}\n    <span class=\"icon-thumbs-up tip-widget-icon\"></span> {{{ recommendationText }}}\n  </h3>\n{{/ recommendations }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],242:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("recommendations",c,p,1),c,p,0,22,603,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <h3 class=\"ugc-star-ratings\" ");if(_.s(_.f("showItemProps",c,p,1),c,p,0,74,155,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("itemprop=\"aggregateRating\" itemscope itemtype=\"http://schema.org/AggregateRating\"");});c.pop();}_.b(">");_.b("\n" + i);if(_.s(_.f("showItemProps",c,p,1),c,p,0,201,376,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("      <meta itemprop=\"ratingCount\" content=\"");_.b(_.v(_.f("total",c,p,0)));_.b("\">");_.b("\n" + i);_.b("      <meta itemprop=\"ratingValue\" content=\"");_.b(_.v(_.f("percentage",c,p,0)));_.b("\">");_.b("\n" + i);_.b("      <meta itemprop=\"bestRating\" content=\"100\">");_.b("\n");});c.pop();}_.b("    <ul class=\"product-reviews-rating\">");_.b("\n" + i);if(_.s(_.f("stars",c,p,1),c,p,0,455,514,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("        <li class=\"icon-star-filled\">");_.b(_.t(_.d(".",c,p,0)));_.b("</li>");_.b("\n");});c.pop();}_.b("    </ul>");_.b("\n" + i);_.b("    <span class=\"star-rating-text\">");_.b(_.v(_.f("ratingsText",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("  </h3>");_.b("\n");});c.pop();}return _.fl();;},"{{# recommendations }}\n  <h3 class=\"ugc-star-ratings\" {{# showItemProps }}itemprop=\"aggregateRating\" itemscope itemtype=\"http://schema.org/AggregateRating\"{{/ showItemProps }}>\n    {{# showItemProps }}\n      <meta itemprop=\"ratingCount\" content=\"{{ total }}\">\n      <meta itemprop=\"ratingValue\" content=\"{{ percentage }}\">\n      <meta itemprop=\"bestRating\" content=\"100\">\n    {{/ showItemProps }}\n    <ul class=\"product-reviews-rating\">\n      {{# stars }}\n        <li class=\"icon-star-filled\">{{{ . }}}</li>\n      {{/ stars }}\n    </ul>\n    <span class=\"star-rating-text\">{{ratingsText}}</span>\n  </h3>\n{{/ recommendations }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],243:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");_.b("<div class=\"tip-widget-tips ");if(_.s(_.f("touch",c,p,1),c,p,0,38,59,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("tips-mobile-container");});c.pop();}_.b("\">");_.b("\n" + i);_.b(_.rp("groupon_tips",c,p,"  "));_.b(_.rp("trip_advisor_tips",c,p,"  "));_.b("</div>");_.b("\n");return _.fl();;},"<div class=\"tip-widget-tips {{#touch}}tips-mobile-container{{/touch}}\">\n  {{> groupon_tips }}\n  {{> trip_advisor_tips }}\n</div>\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],244:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("recommendations",c,p,1),c,p,0,22,445,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"tip-widget-rating ta-rating-container\">");_.b("\n" + i);_.b("    <img class=\"ta-owl-icon sleepy-load\" data-original=\"//img.grouponcdn.com/asset/h7bPaJRB3c3gn5g5itSZ/SU-180x125\" src=\"//img.grouponcdn.com/asset/h7bPaJRB3c3gn5g5itSZ/SU-180x125\">");_.b("\n" + i);_.b("    <div class=\"ta-reviews-visual-rating ta-review-sprite-");_.b(_.v(_.f("ratingSpriteNumber",c,p,0)));_.b("\"></div>");_.b("\n" + i);_.b("      <span class=\"ta-collective-reviews-summary\">");_.b("\n" + i);_.b("       ");_.b(_.v(_.f("ratingsText",c,p,0)));_.b("\n" + i);_.b("      </span>");_.b("\n" + i);_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{# recommendations }}\n  <div class=\"tip-widget-rating ta-rating-container\">\n    <img class=\"ta-owl-icon sleepy-load\" data-original=\"//img.grouponcdn.com/asset/h7bPaJRB3c3gn5g5itSZ/SU-180x125\" src=\"//img.grouponcdn.com/asset/h7bPaJRB3c3gn5g5itSZ/SU-180x125\">\n    <div class=\"ta-reviews-visual-rating ta-review-sprite-{{ratingSpriteNumber}}\"></div>\n      <span class=\"ta-collective-reviews-summary\">\n       {{ratingsText}}\n      </span>\n  </div>\n{{/ recommendations }}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],245:[function(require,module,exports){
var H = require('hogan.js'); var T = H.Template;var t = new T(function(c,p,i){var _=this;_.b(i=i||"");if(_.s(_.f("tripAdvisorTips",c,p,1),c,p,0,20,909,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("  <div class=\"tip-item ta-review\">");_.b("\n" + i);_.b("    <div class=\"ta-profile-image\">");_.b("\n" + i);_.b("      <img src=\"");_.b(_.v(_.d("user.profileImageUrl",c,p,0)));_.b("\" />");_.b("\n" + i);_.b("    </div>");_.b("\n" + i);_.b("\n" + i);_.b("\n" + i);_.b("    <div class=\"tip-body\">");_.b("\n" + i);_.b("\n" + i);_.b("\n" + i);_.b("      <div class=\"ta-user-text\">");_.b("\n" + i);_.b("        <div class=\"ta-reviews-visual-rating ta-review-sprite-");_.b(_.v(_.f("ratingSpriteNumber",c,p,0)));_.b("\"></div>");_.b("\n" + i);_.b("        <span class=\"ta-username\">");if(_.s(_.d("user.maskedName",c,p,1),c,p,0,360,379,"{{ }}")){_.rs(c,p,function(c,p,_){_.b(_.v(_.d("user.maskedName",c,p,0)));});c.pop();}_.b("</span>");_.b("\n" + i);_.b("        <span class=\"ta-display-date\">");_.b(_.v(_.f("displayDate",c,p,0)));_.b("</span>");_.b("\n" + i);_.b("      </div>");_.b("\n" + i);_.b("\n" + i);_.b("      <div class=\"ta-title\">\"");_.b(_.v(_.f("title",c,p,0)));_.b("\"</div>");_.b("\n" + i);_.b("\n" + i);_.b("      <div class=\"tip-text ellipsis\" data-text=\"");_.b(_.v(_.f("text",c,p,0)));_.b("\">");_.b("\n" + i);_.b("\n" + i);if(_.s(_.f("showReadMore",c,p,1),c,p,0,620,659,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          ");_.b(_.v(_.f("truncatedText",c,p,0)));_.b("\n");});c.pop();}if(!_.s(_.f("showReadMore",c,p,1),c,p,1,0,0,"")){_.b("          ");_.b(_.v(_.f("text",c,p,0)));_.b("\n");};if(_.s(_.f("showReadMore",c,p,1),c,p,0,783,854,"{{ }}")){_.rs(c,p,function(c,p,_){_.b("          <span class=\"ta-show-more\">");_.b(_.v(_.d("i18n.readMore",c,p,0)));_.b("</span>");_.b("\n");});c.pop();}_.b("\n" + i);_.b("      </div>");_.b("\n" + i);_.b("    </div>");_.b("\n" + i);_.b("\n" + i);_.b("  </div>");_.b("\n");});c.pop();}return _.fl();;},"{{#tripAdvisorTips}}\n  <div class=\"tip-item ta-review\">\n    <div class=\"ta-profile-image\">\n      <img src=\"{{user.profileImageUrl}}\" />\n    </div>\n\n\n    <div class=\"tip-body\">\n\n\n      <div class=\"ta-user-text\">\n        <div class=\"ta-reviews-visual-rating ta-review-sprite-{{ ratingSpriteNumber }}\"></div>\n        <span class=\"ta-username\">{{#user.maskedName}}{{user.maskedName}}{{/user.maskedName}}</span>\n        <span class=\"ta-display-date\">{{displayDate}}</span>\n      </div>\n\n      <div class=\"ta-title\">\"{{ title }}\"</div>\n\n      <div class=\"tip-text ellipsis\" data-text=\"{{ text }}\">\n\n        {{# showReadMore }}\n          {{ truncatedText }}\n        {{/ showReadMore }}\n        {{^ showReadMore }}\n          {{ text }}\n        {{/ showReadMore }}\n        {{# showReadMore }}\n          <span class=\"ta-show-more\">{{i18n.readMore}}</span>\n        {{/ showReadMore }}\n\n      </div>\n    </div>\n\n  </div>\n{{/tripAdvisorTips}}\n",H,{});module.exports = {  render: function () { return t.render.apply(t, arguments); },  r: function () { return t.r.apply(t, arguments); },  ri: function () { return t.ri.apply(t, arguments); }};
},{"hogan.js":248}],246:[function(require,module,exports){
module.exports={"en":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"}}},"de_DE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} Kunden empfehlen","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} empfehlen","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"es_ES":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"fr_FR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}des {{total}} clients Groupon recommandent ce deal","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}sur {{total}} le recommandent","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"it_IT":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}} di {{total}} clienti Groupon lo consigliano","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}di {{total}} lo consigliano","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"iw_IL":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"ILS"}},"nl_NL":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"aanbevolen door {{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}van {{total}} klanten","recommendationShort":"aanbevolen door {{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}van {{total}}","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤ #,##0.00-","percent":"#,##0%"},"defaultCurrency":"EUR"}},"pl_PL":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}z {{total}} Klientów Groupon poleca","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}z {{total}} rekomendowanych.","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.## ¤;(#,##0.## ¤)","percent":"#,##0%"},"defaultCurrency":"PLN"}},"pt_PT":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"ar_AE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"da_DK":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","DKK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"DKK"}},"el_GR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"e","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_HK":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_ID":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","IDR":"Rs."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"IDR"}},"en_US":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"USD"}},"en_ZA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","ZAR":"R"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"ZAR"}},"fi_FI":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"epäluku","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"id_ID":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","IDR":"Rs."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"IDR"}},"ja_JP":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"￥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##","percent":"#,##0%"},"defaultCurrency":"JPY"}},"no_NO":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","NOK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"NOK"}},"ru_RU":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"не число","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","RUB":"р."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"RUB"}},"sv_SE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"×10^","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"¤¤¤","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","SEK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"SEK"}},"th_TH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"THB"}},"tr_TR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"TL","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"%#,##0"},"defaultCurrency":"TRY"}},"zh_HK":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_GB":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"GBP"}},"es_MX":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"MXN"}},"pt_BR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"BRL"}},"de_AT":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} Kunden empfehlen","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} empfehlen","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"de_CH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} Kunden empfehlen","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}von {{total}} empfehlen","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤-#,##0.00","percent":"#,##0 %"},"defaultCurrency":"CHF"}},"en_CA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"CAD"}},"en_PH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"PHP"}},"fr_BE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}des {{total}} clients Groupon recommandent ce deal","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}sur {{total}} le recommandent","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"fr_CA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}des {{total}} clients Groupon recommandent ce deal","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}sur {{total}} le recommandent","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"CAD"}},"fr_CH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}des {{total}} clients Groupon recommandent ce deal","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}sur {{total}} le recommandent","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤-#,##0.00","percent":"#,##0 %"},"defaultCurrency":"CHF"}},"fr_MA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}des {{total}} clients Groupon recommandent ce deal","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}sur {{total}} le recommandent","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","MAD":"Dhs"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.## ¤;(#,##0.## ¤)","percent":"#,##0 %"},"defaultCurrency":"MAD"}},"nl_BE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"Aanbevolen door {{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}} van {{total}} Groupon-klanten","recommendationShort":"aanbevolen door {{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}van {{total}}","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"ru_UA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"не число","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","RUB":"р."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"UAH"}},"zh_TW":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00;(¤#,##0.00)","percent":"#,##0%"},"defaultCurrency":"TWD"}},"en_AE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"en_AU":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"AUD"}},"en_CH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"CHF"}},"en_IE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_IN":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##,##0.###","currency":"¤ #,##,##0.00","percent":"#,##,##0%"},"defaultCurrency":"INR"}},"en_MY":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","MYR":"RM"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"MYR"}},"en_NZ":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"NZD"}},"en_SG":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"S$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"SGD"}},"en_TH":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} customers recommend\n","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}of {{total}} recommend","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"THB"}},"es_AR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"ARS"}},"es_CO":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##","percent":"#,##0%"},"defaultCurrency":"COP"}},"es_PE":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","PEN":"S/."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"PEN"}},"es_CL":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##;¤-#,##0.##","percent":"#,##0%"},"defaultCurrency":"CLP"}},"es_PR":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"USD"}},"es_PA":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","PAB":"B/."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"USD"}},"es_UY":{"modules":{"translations":{"adjective":"{{adjective}} {{aspect}}","aspect":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentSymbol}}{{percentClose}} were {{sentiment}} about the {{aspectOpen}}{{aspect}}{{aspectClose}}","aspectNegative":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","aspectPositive":"{{percentOpen}}{{numOpen}}{{percentage}}{{numClose}}{{percentClose}}% {{spanClose}}were positive about the {{aspect}}","buzzed":"Most buzzed about","fiveStarTitle":"Customer Reviews","helpful":"Helpful","histogram":{"1":"Terrible","2":"Poor","3":"Average","4":"Very Good","5":"Excellent"},"next":"Next","noTipsAspect":"There are no tips found for this aspect","previous":"Previous","ratingsText":"{{numberRatings}} Ratings","readMore":"Read More","recommendation":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} clientes de Groupon aconsejan","recommendationShort":"{{percentOpen}}{{numOpen}}{{percentage}}{{spanClose}}% {{spanClose}}de {{total}} lo recomiendan","reviews":"{{numberTips}} Tips","reviewsText":"Reviews","reviewsTripAdvisor":"Reviews From Trip Advisor","sortBy":"Sort by:","sortByGroupon":"Most Relevant","sortByHelpful":"Most Helpful","sortByRecent":"Most Recent","sortReviewsBy":"Sort Reviews by","starRatingsLinkText":"{{numberRatings}} Reviews","thanks":"Thanks!","tip":"Tip","tips":"Tips","verified":"Verified"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"UYU"}}}
},{}],247:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      tagTypes = {
        '#': 1, '^': 2, '/': 3,  '!': 4, '>': 5,
        '<': 6, '=': 7, '_v': 8, '{': 9, '&': 10
      };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push(new String(buf));
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (tokens[j].tag && tagTypes[tokens[j].tag] < tagTypes['_v']) ||
          (!tokens[j].tag && tokens[j].match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (!tokens[j].tag) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = tagTypes[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - ctag.length : i + otag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        token = null;

    while (tokens.length > 0) {
      token = tokens.shift();
      if (token.tag == '#' || token.tag == '^' || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
        instructions.push(token);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else {
        instructions.push(token);
      }
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  Hogan.generate = function (tree, text, options) {
    var code = 'var _=this;_.b(i=i||"");' + walk(tree) + 'return _.fl();';
    if (options.asString) {
      return 'function(c,p,i){' + code + ';}';
    }

    return new Hogan.Template(new Function('c', 'p', 'i', code), text, Hogan, options);
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function walk(tree) {
    var code = '';
    for (var i = 0, l = tree.length; i < l; i++) {
      var tag = tree[i].tag;
      if (tag == '#') {
        code += section(tree[i].nodes, tree[i].n, chooseMethod(tree[i].n),
                        tree[i].i, tree[i].end, tree[i].otag + " " + tree[i].ctag);
      } else if (tag == '^') {
        code += invertedSection(tree[i].nodes, tree[i].n,
                                chooseMethod(tree[i].n));
      } else if (tag == '<' || tag == '>') {
        code += partial(tree[i]);
      } else if (tag == '{' || tag == '&') {
        code += tripleStache(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag == '\n') {
        code += text('"\\n"' + (tree.length-1 == i ? '' : ' + i'));
      } else if (tag == '_v') {
        code += variable(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag === undefined) {
        code += text('"' + esc(tree[i]) + '"');
      }
    }
    return code;
  }

  function section(nodes, id, method, start, end, tags) {
    return 'if(_.s(_.' + method + '("' + esc(id) + '",c,p,1),' +
           'c,p,0,' + start + ',' + end + ',"' + tags + '")){' +
           '_.rs(c,p,' +
           'function(c,p,_){' +
           walk(nodes) +
           '});c.pop();}';
  }

  function invertedSection(nodes, id, method) {
    return 'if(!_.s(_.' + method + '("' + esc(id) + '",c,p,1),c,p,1,0,0,"")){' +
           walk(nodes) +
           '};';
  }

  function partial(tok) {
    return '_.b(_.rp("' +  esc(tok.n) + '",c,p,"' + (tok.indent || '') + '"));';
  }

  function tripleStache(id, method) {
    return '_.b(_.t(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function variable(id, method) {
    return '_.b(_.v(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function text(id) {
    return '_.b(' + id + ');';
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  },

  Hogan.cache = {};

  Hogan.compile = function(text, options) {
    // options
    //
    // asString: false (default)
    //
    // sectionTags: [{o: '_foo', c: 'foo'}]
    // An array of object with o and c fields that indicate names for custom
    // section tags. The example above allows parsing of {{_foo}}{{/foo}}.
    //
    // delimiters: A string that overrides the default delimiters.
    // Example: "<% %>"
    //
    options = options || {};

    var key = text + '||' + !!options.asString;

    var t = this.cache[key];

    if (t) {
      return t;
    }

    t = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = t;
  };
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],248:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
module.exports = Hogan; 
},{"./compiler":247,"./template":249}],249:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan, useArrayBuffer) {
  Hogan.Template = function (renderFunc, text, compiler, options) {
    this.r = renderFunc || this.r;
    this.c = compiler;
    this.options = options;
    this.text = text || '';
    this.buf = (useArrayBuffer) ? [] : '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // tries to find a partial in the curent scope and render it
    rp: function(name, context, partials, indent) {
      var partial = partials[name];

      if (!partial) {
        return '';
      }

      if (this.c && typeof partial == 'string') {
        partial = this.c.compile(partial, this.options);
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ls(val, ctx, partials, inverted, start, end, tags);
      }

      pass = (val === '') || !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        return ctx[ctx.length - 1];
      }

      for (var i = 1; i < names.length; i++) {
        if (val && typeof val == 'object' && names[i] in val) {
          cx = val;
          val = val[names[i]];
        } else {
          val = '';
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.lv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        if (v && typeof v == 'object' && key in v) {
          val = v[key];
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.lv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ho: function(val, cx, partials, text, tags) {
      var compiler = this.c;
      var options = this.options;
      options.delimiters = tags;
      var text = val.call(cx, text);
      text = (text == null) ? String(text) : text.toString();
      this.b(compiler.compile(text, options).render(cx, partials));
      return false;
    },

    // template result buffering
    b: (useArrayBuffer) ? function(s) { this.buf.push(s); } :
                          function(s) { this.buf += s; },
    fl: (useArrayBuffer) ? function() { var r = this.buf.join(''); this.buf = []; return r; } :
                           function() { var r = this.buf; this.buf = ''; return r; },

    // lambda replace section
    ls: function(val, ctx, partials, inverted, start, end, tags) {
      var cx = ctx[ctx.length - 1],
          t = null;

      if (!inverted && this.c && val.length > 0) {
        return this.ho(val, cx, partials, this.text.substring(start, end), tags);
      }

      t = val.call(cx);

      if (typeof t == 'function') {
        if (inverted) {
          return true;
        } else if (this.c) {
          return this.ho(t, cx, partials, this.text.substring(start, end), tags);
        }
      }

      return t;
    },

    // lambda replace variable
    lv: function(val, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = val.call(cx);

      if (typeof result == 'function') {
        result = coerceToString(result.call(cx));
        if (this.c && ~result.indexOf("{\u007B")) {
          return this.c.compile(result, this.options).render(cx, partials);
        }
      }

      return coerceToString(result);
    }

  };

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos =/\'/g,
      rQuot = /\"/g,
      hChars =/[&<>\"\']/;


  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp,'&amp;')
        .replace(rLt,'&lt;')
        .replace(rGt,'&gt;')
        .replace(rApos,'&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);


},{}],250:[function(require,module,exports){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var MagicEventBus;
  MagicEventBus = function () {
    function MagicEventBus() {
      this.handlers = {};
      this.statuses = {};
    }
    MagicEventBus.prototype.board = function (eventName, callback, errorHandler) {
      var position;
      if (null != this.handlers[eventName])
        this.handlers[eventName];
      else
        this.handlers[eventName] = [];
      position = this._pushHandler(eventName, callback, errorHandler);
      return function (this$) {
        return function (zIndex) {
          return this$.handlers[eventName][position].zIndex = zIndex;
        };
      }(this);
    };
    MagicEventBus.prototype.go = function (eventName, eventElement) {
      var handler, sortedHandlers;
      if (!(null != this.handlers[eventName]))
        return false;
      this.statuses[eventName] = 'going';
      sortedHandlers = this.handlers[eventName].slice().sort(function (a, b) {
        return (a.zIndex || 0) - (b.zIndex || 0);
      });
      for (var i$ = 0, length$ = sortedHandlers.length; i$ < length$; ++i$) {
        handler = sortedHandlers[i$];
        if (this.statuses[eventName] === 'stopTheBus')
          break;
        this._callback(eventName, handler, eventElement);
      }
      return this.statuses[eventName] = 'stopped';
    };
    MagicEventBus.prototype._callback = function (eventName, param$, eventElement) {
      var cache$, callback, errorHandler, results;
      {
        cache$ = param$;
        callback = cache$.callback;
        errorHandler = cache$.errorHandler;
      }
      results = function () {
        var error;
        try {
          return callback(eventElement);
        } catch (e$) {
          error = e$;
          if ('undefined' !== typeof TrackingHub && null != TrackingHub)
            TrackingHub.add('MagicEventBus ' + eventName + ' Error', { error: error });
          if ('function' === typeof errorHandler)
            return errorHandler();
        }
      }.call(this);
      if (null != results ? results.stopTheBus : void 0)
        return this.statuses[eventName] = 'stopTheBus';
    };
    MagicEventBus.prototype._pushHandler = function (eventName, callback, errorHandler) {
      this.handlers[eventName].push({
        callback: callback,
        errorHandler: errorHandler
      });
      return this.handlers[eventName].length - 1;
    };
    return MagicEventBus;
  }();
  if ('undefined' !== typeof window && null != window)
    window.MagicEventBus = MagicEventBus;
  if ('undefined' !== typeof module && null != module)
    module.exports = MagicEventBus;
}.call(this);

},{}],251:[function(require,module,exports){
//! moment-timezone.js
//! version : 0.4.1
//! author : Tim Wood
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else if (typeof exports === 'object') {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	if (moment.tz !== undefined) {
		logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		return moment;
	}

	var VERSION = "0.4.1",
		zones = {},
		links = {},
		names = {},

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name    : data[0],
			abbrs   : mapIndices(data[1].split(' '), indices),
			offsets : mapIndices(offsets, indices),
			untils  : untils
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name    = unpacked.name;
			this.abbrs   = unpacked.abbrs;
			this.untils  = unpacked.untils;
			this.offsets = unpacked.offsets;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			name = packed[i].split('|')[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));

},{"moment":252}],252:[function(require,module,exports){
//! moment.js
//! version : 2.11.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')$', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')$', 'i');
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             if (this.isValid() && other.isValid()) {
                 return other < this ? this : other;
             } else {
                 return valid__createInvalid();
             }
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this > +localInput;
        } else {
            return +localInput < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this < +localInput;
        } else {
            return +this.clone().endOf(units) < +localInput;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return +this === +localInput;
        } else {
            inputMs = +localInput;
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // JSON.stringify(new Date(NaN)) === 'null'
        return this.isValid() ? this.toISOString() : 'null';
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        // console.log("got", weekYear, week, weekday, "set", date.toISOString());
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = local__createLocal([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = getSet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = getSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto._months           = defaultLocaleMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto._monthsRegex      = defaultMonthsRegex;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.11.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],253:[function(require,module,exports){
var CountdownTimerView, FourPackCarouselView, FullWidthCarousel, GoodsCarouselView, ResponsiveCarouselView, RightRailView, VideoWidgetView, base,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FourPackCarouselView = (function(superClass) {
  extend(FourPackCarouselView, superClass);

  function FourPackCarouselView() {
    return FourPackCarouselView.__super__.constructor.apply(this, arguments);
  }

  FourPackCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  FourPackCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.currentPosition = 0;
    this.currentPage = 1;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.visibleCards = 4;
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  FourPackCarouselView.prototype._buildNavigation = function() {
    var i, lastPage, page, ref;
    lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards);
    for (page = i = 1, ref = lastPage; 1 <= ref ? i <= ref : i >= ref; page = 1 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "'></li>");
    }
    return this.$('.page-1').addClass('active');
  };

  FourPackCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  FourPackCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    this.currentPage -= 1;
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    this.currentPage += 1;
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards > this.maxPosition) {
      return this.animate(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  FourPackCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  FourPackCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  FourPackCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  FourPackCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * 239)
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * 239)
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  FourPackCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return FourPackCarouselView;

})(Backbone.View);

RightRailView = (function(superClass) {
  extend(RightRailView, superClass);

  function RightRailView() {
    this.setFixPoint = bind(this.setFixPoint, this);
    this.shouldFix = bind(this.shouldFix, this);
    this.atBottom = bind(this.atBottom, this);
    this.floatView = bind(this.floatView, this);
    return RightRailView.__super__.constructor.apply(this, arguments);
  }

  RightRailView.prototype.initialize = function() {
    this.container = $(window);
    this.document = $(document);
    this.header = $(".header");
    this.banner = $(".in-app-msg-banner");
    this.bannerCloseBtn = $(".in-app-msg-banner .hide-link");
    this.footer = $(".footer-i18n");
    this.fixedTopMargin = 50;
    this.fixPoint = 0;
    this.setFixPoint();
    this.floatView();
    this.container.scroll(this.floatView);
    return this.bannerCloseBtn.click(this.setFixPoint);
  };

  RightRailView.prototype.floatView = function() {
    this.$el.removeClass('fixed top bottom');
    if (this.shouldFix()) {
      return this.$el.addClass('fixed');
    } else if (this.atBottom()) {
      return this.$el.addClass('bottom');
    } else {
      return this.$el.addClass('top');
    }
  };

  RightRailView.prototype.atBottom = function() {
    return this.container.scrollTop() + this.$el.outerHeight() + this.fixedTopMargin > this.document.height() - this.footer.outerHeight();
  };

  RightRailView.prototype.shouldFix = function() {
    return this.container.scrollTop() > this.fixPoint && !this.atBottom();
  };

  RightRailView.prototype.setFixPoint = function() {
    return this.fixPoint = this.header.position().top + this.outerHeightWithMargin(this.header) + this.outerHeightWithMargin(this.banner) - this.fixedTopMargin;
  };

  RightRailView.prototype.outerHeightWithMargin = function(element) {
    if (!element.is(':visible')) {
      return 0;
    }
    return element.outerHeight(true);
  };

  return RightRailView;

})(Backbone.View);

VideoWidgetView = (function(superClass) {
  extend(VideoWidgetView, superClass);

  function VideoWidgetView() {
    this.resetVideoPlayer = bind(this.resetVideoPlayer, this);
    this.onCreate = bind(this.onCreate, this);
    return VideoWidgetView.__super__.constructor.apply(this, arguments);
  }

  VideoWidgetView.prototype.events = {
    'click .image-container': 'playVideo'
  };

  VideoWidgetView.videoIsloaded = false;

  VideoWidgetView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.video = this.$('.video-container');
    this.imageContainer = this.$('.image-container');
    this.previewImageAndPlayButton = this.$('.image-container img');
    this.videoId = this.video.data('video-id');
    if (!this.videoIsloaded) {
      return this.loadVideoPlayer();
    }
  };

  VideoWidgetView.prototype.onCreate = function(player) {
    return player.subscribe('played', 'myPage', this.resetVideoPlayer);
  };

  VideoWidgetView.prototype.resetVideoPlayer = function() {
    this.imageContainer.removeClass('hidden');
    this.previewImageAndPlayButton.animate({
      opacity: 0.8,
      duration: 100
    });
    return this.videoPlayer.seek(0);
  };

  VideoWidgetView.prototype.fetchVideoPlayer = function() {
    return OO.ready((function(_this) {
      return function() {
        var options;
        options = {
          flashParams: {
            hide: 'info,endscreen'
          },
          onCreate: _this.onCreate
        };
        return _this.videoPlayer = OO.Player.create('ooyala-player', _this.videoId, options);
      };
    })(this));
  };

  VideoWidgetView.prototype.loadVideoPlayer = function() {
    var script;
    script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388";
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          this.videoIsloaded = true;
        }
      };
    } else {
      script.onload = function() {
        this.videoIsloaded = true;
      };
    }
    $("head").append(script);
  };

  VideoWidgetView.prototype.playVideo = function() {
    if (!this.videoPlayer) {
      this.fetchVideoPlayer();
    }
    this.videoPlayer.play();
    this.imageContainer.addClass('hidden');
    return this.previewImageAndPlayButton.css({
      opacity: 0
    });
  };

  return VideoWidgetView;

})(Backbone.View);

CountdownTimerView = (function(superClass) {
  extend(CountdownTimerView, superClass);

  function CountdownTimerView() {
    this.getNewTimeStamp = bind(this.getNewTimeStamp, this);
    this.updateCountdown = bind(this.updateCountdown, this);
    return CountdownTimerView.__super__.constructor.apply(this, arguments);
  }

  CountdownTimerView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.offerEndTime = $('.steals-timer').data('offer-end-time');
    this.tick = 1000;
    this.getNewTimeStamp();
    return this.updateCountdown();
  };

  CountdownTimerView.prototype.updateCountdown = function() {
    return setInterval(this.getNewTimeStamp, this.tick);
  };

  CountdownTimerView.prototype.timeRemaining = function(timeRemainingMilliseconds) {
    var days, hours, millisecondsLeft, minutes, seconds;
    if (timeRemainingMilliseconds == null) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
    millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
    hours = Math.floor(millisecondsLeft / (1000 * 3600));
    millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
    minutes = Math.floor(millisecondsLeft / (1000 * 60));
    millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
    seconds = Math.floor(millisecondsLeft / 1000);
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };

  CountdownTimerView.prototype.millisRemaining = function(endTime) {
    var millsRemaining, rightNow;
    if (endTime == null) {
      return 0;
    }
    rightNow = new Date().getTime();
    millsRemaining = endTime - rightNow;
    if (millsRemaining < 0) {
      return 0;
    } else {
      return millsRemaining;
    }
  };

  CountdownTimerView.prototype.countdownTimestamp = function(timeLeft) {
    var hh, mm, ss;
    hh = this.addLeadingZero(timeLeft.hours);
    mm = this.addLeadingZero(timeLeft.minutes);
    ss = this.addLeadingZero(timeLeft.seconds);
    return " " + hh + ":" + mm + ":" + ss;
  };

  CountdownTimerView.prototype.addLeadingZero = function(number) {
    if (number < 0) {
      return;
    }
    if (number < 10) {
      return "0" + number;
    } else {
      return "" + number;
    }
  };

  CountdownTimerView.prototype.getNewTimeStamp = function() {
    var endTime, millisLeft, newTimeStamp, ref;
    if (((ref = this.offerEndTime) != null ? ref.length : void 0) < 1) {
      this.offerEndTime = this.getEndOfDayTime();
    }
    endTime = Date.parse(this.offerEndTime);
    millisLeft = this.millisRemaining(endTime);
    newTimeStamp = this.countdownTimestamp(this.timeRemaining(millisLeft));
    return this.$el.html(newTimeStamp);
  };

  CountdownTimerView.prototype.getEndOfDayTime = function() {
    var date;
    date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  };

  return CountdownTimerView;

})(Backbone.View);

GoodsCarouselView = (function(superClass) {
  extend(GoodsCarouselView, superClass);

  function GoodsCarouselView() {
    this.start = bind(this.start, this);
    return GoodsCarouselView.__super__.constructor.apply(this, arguments);
  }

  GoodsCarouselView.prototype.events = {
    "click .goods-carousel-navbar .icon-arrow-left-large": "slideLeft",
    "click .goods-carousel-navbar .icon-arrow-right-large": "slideRight",
    "click .goods-carousel-navbar .icon-circle": "navigateToNavItem"
  };

  GoodsCarouselView.prototype.initialize = function() {
    this.interval = 6000;
    this.size = this.$(".carousel-slide").length;
    this.fadeDuration = 20;
    if (this.size > 1) {
      this.position = 1;
      this.$slides = this.$('.carousel-slide');
      this.$navs = this.$('.goods-carousel-navbar .icon-circle');
      return setTimeout(this.start, this.interval);
    }
  };

  GoodsCarouselView.prototype.slideLeft = function() {
    this.stop();
    return this.slide('left');
  };

  GoodsCarouselView.prototype.slideRight = function() {
    this.stop();
    return this.slide();
  };

  GoodsCarouselView.prototype.navigateToNavItem = function(e) {
    var position;
    position = $(e.currentTarget).data('position');
    this.stop();
    return this.updateCarousel(position);
  };

  GoodsCarouselView.prototype.start = function() {
    this.slide();
    return this.slider = setTimeout(this.start, this.interval);
  };

  GoodsCarouselView.prototype.stop = function() {
    return window.clearTimeout(this.slider);
  };

  GoodsCarouselView.prototype.slide = function(direction) {
    if (direction == null) {
      direction = 'right';
    }
    return this.updateCarousel(this.nextPosition(direction));
  };

  GoodsCarouselView.prototype.nextPosition = function(direction) {
    if (direction === 'right') {
      if (this.position < this.size) {
        return this.position + 1;
      } else {
        return 1;
      }
    } else {
      if (this.position > 1) {
        return this.position - 1;
      } else {
        return this.size;
      }
    }
  };

  GoodsCarouselView.prototype.updateCarousel = function(nextPosition) {
    if (this.position === nextPosition) {
      return;
    }
    this.updateSlide(nextPosition);
    this.updateNav(nextPosition);
    return this.position = nextPosition;
  };

  GoodsCarouselView.prototype.updateSlide = function(nextPosition) {
    var currentSlide, nextSlide;
    currentSlide = this.$slides.filter('.current-slide');
    nextSlide = this.$slides.filter("[data-position='" + nextPosition + "']");
    currentSlide.fadeTo(this.fadeDuration, 0);
    currentSlide.hide().removeClass("current-slide");
    return nextSlide.show().fadeTo(this.fadeDuration, 1).addClass("current-slide");
  };

  GoodsCarouselView.prototype.updateNav = function(nextPosition) {
    var currentNav, nextNav;
    currentNav = this.$navs.filter('.current-slide');
    nextNav = this.$navs.filter("[data-position='" + nextPosition + "']");
    currentNav.removeClass("current-slide");
    return nextNav.addClass("current-slide");
  };

  return GoodsCarouselView;

})(Backbone.View);

FullWidthCarousel = (function(superClass) {
  extend(FullWidthCarousel, superClass);

  function FullWidthCarousel() {
    this._setGutters = bind(this._setGutters, this);
    return FullWidthCarousel.__super__.constructor.apply(this, arguments);
  }

  FullWidthCarousel.prototype.events = {
    'click .full-width-carousel-prev': 'triggerPrev',
    'click .full-width-carousel-next': 'triggerNext',
    'click .full-width-carousel-dot': 'triggerNavDot'
  };

  FullWidthCarousel.prototype.initialize = function() {
    this.$listbox = this.$el.find('[role=listbox]');
    this.pixelsToMove = this._pixelsToMove();
    this.centeredViewportLeft = this.$listbox.css('left');
    this._initalizeGutters();
    this._animationDuration = 200;
    this._numberNavDots = this.$el.find('.full-width-carousel-dot').length;
    this._lazyLoadAllImages();
    return this._updateSelectedDeals();
  };

  FullWidthCarousel.prototype._lazyLoadAllImages = function() {
    var container;
    container = this.$('.full-width-carousel-container');
    return this.$('.lazy-load').lazyload({
      container: container,
      threshold: this.$listbox.width()
    });
  };

  FullWidthCarousel.prototype.triggerNavDot = function(event) {
    var newPosition, oldPosition;
    event.preventDefault();
    newPosition = $(event.currentTarget).data('index');
    oldPosition = this.$el.find('.full-width-carousel-dot-selected').data('index');
    this._updateNavDotSelected(newPosition);
    switch (false) {
      case !(oldPosition < newPosition):
        return this._moveRight(newPosition - oldPosition);
      case !(newPosition < oldPosition):
        return this._moveLeft(oldPosition - newPosition);
    }
  };

  FullWidthCarousel.prototype.triggerNext = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected + 1);
    this._updateNavDotSelected(newPosition);
    return this._moveRight();
  };

  FullWidthCarousel.prototype.triggerPrev = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected - 1);
    this._updateNavDotSelected(newPosition);
    return this._moveLeft();
  };

  FullWidthCarousel.prototype._initalizeGutters = function() {
    var throttledGutters;
    throttledGutters = _.throttle(this._setGutters, 300);
    throttledGutters();
    return $(window).on("resize", throttledGutters);
  };

  FullWidthCarousel.prototype._setGutters = function() {
    return $(".full-width-carousel-viewport").css("left", this._gutterWidth());
  };

  FullWidthCarousel.prototype._gutterWidth = function() {
    var carouselViewport, carouselViewportWidth, windowWidth;
    windowWidth = $(window).width();
    carouselViewport = this.$el.find(".full-width-carousel-viewport");
    carouselViewportWidth = carouselViewport.width();
    return (windowWidth - carouselViewportWidth) / 2;
  };

  FullWidthCarousel.prototype._wrapPosition = function(index) {
    return (index + this._numberNavDots) % this._numberNavDots;
  };

  FullWidthCarousel.prototype._moveRight = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(0, 3);
    this.$listbox.append($images);
    this.$listbox.css('left', -960);
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveRight(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(-this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._moveLeft = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(-3);
    this.$listbox.prepend($images);
    this.$listbox.css('left', -(960 * 3));
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveLeft(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._transition = function(movePixels, nextAnimation) {
    var completionCallback;
    completionCallback = (function(_this) {
      return function() {
        if (nextAnimation) {
          nextAnimation();
        }
        return _this._updateSelectedDeals();
      };
    })(this);
    return this.$listbox.stop().animate({
      left: "+=" + movePixels
    }, {
      easing: 'linear',
      duration: this._animationDuration,
      complete: completionCallback
    });
  };

  FullWidthCarousel.prototype._updateSelectedDeals = function() {
    var items;
    items = this.$listbox.find('.full-width-carousel-item');
    items.removeClass('full-width-carousel-item-selected');
    return items.slice(6, 9).addClass('full-width-carousel-item-selected');
  };

  FullWidthCarousel.prototype._pixelsToMove = function() {
    var activeItems, fullWidthItemFinalWidth, includeMargin;
    activeItems = 3;
    includeMargin = true;
    fullWidthItemFinalWidth = $(".full-width-carousel-item").first().outerWidth(includeMargin);
    return fullWidthItemFinalWidth * activeItems;
  };

  FullWidthCarousel.prototype._updateNavDotSelected = function(indexToSelect) {
    this.$el.find('.full-width-carousel-dot').removeClass('full-width-carousel-dot-selected');
    return this.$el.find(".full-width-carousel-dot[data-index=" + indexToSelect + "]").addClass('full-width-carousel-dot-selected');
  };

  return FullWidthCarousel;

})(Backbone.View);

ResponsiveCarouselView = (function(superClass) {
  extend(ResponsiveCarouselView, superClass);

  function ResponsiveCarouselView() {
    this.recalculate = bind(this.recalculate, this);
    return ResponsiveCarouselView.__super__.constructor.apply(this, arguments);
  }

  ResponsiveCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  ResponsiveCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.$header = this.$('.section-head');
    this.containerWidth = this.$el.outerWidth();
    this.currentPosition = 0;
    this.currentPage = 0;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.gap = 70;
    this.cardSize = 240;
    this.mainContentWidth = 960;
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    $(window).resize(this, this.recalculate);
    this._alignTitle();
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  ResponsiveCarouselView.prototype._buildNavigation = function() {
    var i, page, ref;
    this.lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards) - 1;
    for (page = i = 0, ref = this.lastPage; 0 <= ref ? i <= ref : i >= ref; page = 0 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "' data-page='" + page + "' data-bhc='control:circle" + page + "'></li>");
    }
    $('.page-count').on('click', (function(_this) {
      return function(e) {
        _this.currentPage = $(e.currentTarget).data('page');
        if (_this.currentPage === _this.lastPage) {
          return _this.animateLastRight(_this.maxPosition - (_this.visibleCards - 1));
        } else {
          return _this.animate(_this.currentPage * _this.visibleCards);
        }
      };
    })(this));
    return this._calculateCurrentPage();
  };

  ResponsiveCarouselView.prototype._calculateCurrentPage = function() {
    this.currentPage = Math.floor(this.currentPosition / this.visibleCards);
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.currentPage === this.lastPage) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    }
  };

  ResponsiveCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  ResponsiveCarouselView.prototype._alignTitle = function() {
    if (this.containerWidth > this.mainContentWidth) {
      return this.$header.css({
        'margin-left': Math.floor((this.containerWidth - this.mainContentWidth) / 2)
      });
    }
  };

  ResponsiveCarouselView.prototype.recalculate = function() {
    this.containerWidth = this.$el.outerWidth();
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    this._alignTitle();
    this.$pagesList.empty();
    return this._buildNavigation();
  };

  ResponsiveCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage > 0) {
      this.currentPage -= 1;
    }
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage < this.lastPage) {
      this.currentPage += 1;
    }
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards >= this.maxPosition) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  ResponsiveCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  ResponsiveCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  ResponsiveCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  ResponsiveCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.gap
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.gap
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.animateLastRight = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return ResponsiveCarouselView;

})(Backbone.View);

if (window.WLS == null) {
  window.WLS = {};
}

if ((base = window.WLS).Views == null) {
  base.Views = {};
}

window.WLS.Views.FourPackCarousel = FourPackCarouselView;

window.WLS.Views.RightRail = RightRailView;

window.WLS.Views.VideoWidget = VideoWidgetView;

window.WLS.Views.CountdownTimer = CountdownTimerView;

window.WLS.Views.GoodsCarouselView = GoodsCarouselView;

window.WLS.Views.FullWidthCarousel = FullWidthCarousel;

window.WLS.Views.ResponsiveCarousel = ResponsiveCarouselView;

WLS.init = function($el) {
  if ($el == null) {
    $el = $(document.body);
  }
  $el.find('.right-rail').each(function(index, el) {
    return new WLS.Views.RightRail({
      el: el
    });
  });
  $el.find('.carousel-widget').each(function(index, el) {
    return new WLS.Views.FourPackCarousel({
      el: el
    });
  });
  $el.find('.video-widget').each(function(index, el) {
    return new WLS.Views.VideoWidget({
      el: el
    });
  });
  $el.find('.steals-timer').each(function(index, el) {
    return new WLS.Views.CountdownTimer({
      el: el
    });
  });
  $el.find('.goods-carousel').each(function(index, el) {
    return new WLS.Views.GoodsCarouselView({
      el: el
    });
  });
  $('.full-width-carousel').each(function(index, el) {
    return new WLS.Views.FullWidthCarousel({
      el: el
    });
  });
  return $el.find('.responsive-carousel-widget').each(function(index, el) {
    return new WLS.Views.ResponsiveCarousel({
      el: el
    });
  });
};

$(window).load(function() {
  return WLS.init();
});



},{}]},{},[3])

